(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
class $570b200a0ab2fa65$export$2e2bcd8739ae039 {
    constructor(config){
        this._parseConfig(config);
        this._setGlobal();
        this._setVerbosity();
        this.callbacks = [];
        this.localeFile = {};
    }
    static async create(config) {
        const i18n = new $570b200a0ab2fa65$export$2e2bcd8739ae039(config);
        await i18n._loadFile();
        return i18n;
    }
    _parseConfig(config) {
        this.config = {
            language: config.language || 'de',
            path: config.path || '/locales',
            extension: config.extension || '.json',
            setGlobal: config.setGlobal !== false,
            verbose: config.verbose !== false
        };
    }
    _setGlobal() {
        if (this.config.setGlobal) window.__ = this.__.bind(this);
    }
    _setVerbosity() {
        this._logger = {
            info: ()=>{},
            error: ()=>{},
            warn: ()=>{},
            log: ()=>{}
        };
        if (this.config.verbose) this._logger = console;
    }
    async _loadFile() {
        try {
            const response = await fetch(`${this.config.path}/${this.config.language}${this.config.extension}`);
            if (!response.ok) throw new Error('File not found');
            this.localeFile = await response.json();
            this._logger.info('[browser-i18n] File loaded successfully.');
        } catch (err) {
            this._logger.error('[browser-i18n] Cannot load file:', err);
            if (this.config.language !== 'de') {
                this._logger.warn('[browser-i18n] Falling back to Deutsch.');
                this.config.language = 'de';
                await this._loadFile();
            }
        }
    }
    __(text, ...args) {
        let translated = this.localeFile[text];
        if (translated === undefined) {
            this._logger.log(`Missing translation in '${this.config.language}${this.config.extension}', add:\n"${text}": "${text}"`);
            translated = text; // fallback to original
        }
        return args.length > 0 ? console.log(translated, args) : translated;
    }
}


let $f4b2e904c7318400$export$a7357cdd1f0b0168;
(async ()=>{
    const locale = window.location.search.split("=")[1] || "de";
    const i18nInstance = await (0, $570b200a0ab2fa65$export$2e2bcd8739ae039).create({
        path: "/locales",
        language: locale,
        extension: ".json"
    });
    $f4b2e904c7318400$export$a7357cdd1f0b0168 = i18nInstance;
})();


function $2058487f4462c174$export$ddb7ed2d1bc6bc80() {
    const customerNumberGroup = document.getElementById("customerNumberGroup");
    const customerDetailsGroup = document.getElementById("customerDetailsGroup");
    const hasNoCustomerNumberCheckbox = document.getElementById("hasNoCustomerNumber");
    const inputs = customerDetailsGroup.querySelectorAll("input");
    if (hasNoCustomerNumberCheckbox.checked) {
        customerNumberGroup.classList.add("hidden");
        customerDetailsGroup.classList.remove("hidden");
        document.getElementById("customerNumber").value = "";
        document.getElementById("customerNumber").removeAttribute("required");
        inputs.forEach((input)=>{
            if (input.id === "customerCompanyEmail") return;
            input.value = "";
            input.setAttribute("required", "true");
        });
    } else {
        customerNumberGroup.classList.remove("hidden");
        customerDetailsGroup.classList.add("hidden");
        inputs.forEach((input)=>{
            input.value = "";
            input.removeAttribute("required");
        });
        customerNumberGroup.querySelectorAll('input').forEach((input)=>{
            input.setAttribute("required", "true");
        });
    }
}
function $2058487f4462c174$export$f89084e6f067bb43(error, form) {
    if (!error) return console.log('no error');
    if (!error.details) {
        $2058487f4462c174$export$6ba40ea41de383a1(error.message, 'error');
        return;
    }
    $2058487f4462c174$export$6ba40ea41de383a1("Eingabefehler - bitte \xfcberpr\xfcfen Sie die markierten Felder und versuchen Sie es erneut.", 'error');
    error.details.forEach((err)=>{
        let allFields;
        const [_, category, __, field] = err.path;
        const selectors = [
            `[name^="${category}\\["][name$="\\]\\[${field}\\]\\["][name$="\\]"]`,
            `[name*="${err.path.slice(-1)}"]`,
            '.' + err.context.key,
            '#' + err.context.label
        ];
        for (const selector of selectors){
            allFields = form.querySelectorAll(selector);
            if (allFields.length) break;
        }
        const fildsArray = Array.from(allFields)?.filter((input)=>input && !input.disabled && !input.closest('.item')?.querySelector('.article-select')?.disabled);
        const emptyFields = fildsArray?.filter((f)=>!f?.value);
        console.log(err.path[0], emptyFields.length);
        if (emptyFields?.length) {
            emptyFields.forEach((emptyField)=>{
                const errorElement = emptyField.closest('.form-group')?.querySelector('.error') || emptyField.querySelector(':scope > .error') || $2058487f4462c174$var$createErrorElement(emptyField);
                if (err.path[0].startsWith('appointment')) console.log('errorElement', emptyField.closest('.form-group'));
                errorElement.textContent = (0, $f4b2e904c7318400$export$a7357cdd1f0b0168).__(err.message);
                errorElement.classList.add('error');
            });
            return;
        }
        if (fildsArray?.length) fildsArray.forEach((targetField)=>{
            const errorElement = targetField.closest('.form-group')?.querySelector('.error') || targetField.querySelector(':scope > .error') || $2058487f4462c174$var$createErrorElement(targetField);
            errorElement.textContent = (0, $f4b2e904c7318400$export$a7357cdd1f0b0168).__(err.message);
            errorElement.classList.add('error');
        });
    });
}
function $2058487f4462c174$export$38846aa76e518e23(localStorageItem = 'formData') {
    const saved = localStorage.getItem(localStorageItem);
    if (saved) {
        const data = JSON.parse(saved);
        for(let key in data){
            if (key == "receiptUpload") continue;
            const el = document.querySelector(`[name="${key}"]`);
            if (el) el.value = data[key];
        }
        localStorage.removeItem(localStorageItem);
    }
}
function $2058487f4462c174$var$createErrorElement(field) {
    const div = document.createElement('div');
    div.className = 'error';
    field.closest('.form-group')?.appendChild(div);
    return div;
}
function $2058487f4462c174$export$d6c15b4620d0d3d1(form) {
    const formMessageDiv = document.getElementById('form-message');
    const errorMessages = form.querySelectorAll('.error');
    errorMessages.forEach((error)=>error.textContent = '');
    formMessageDiv.classList.remove('error');
    formMessageDiv.textContent = '';
}
function $2058487f4462c174$export$221247ffea612dd5(button) {
    const deviceList = button.closest('.devices');
    if (!deviceList) return;
    button.addEventListener('click', function() {
        const items = deviceList.querySelectorAll('.item');
        if (items.length <= 1) {
            alert("You must have at least one device.");
            return;
        }
        // Get the index of the item being removed
        const item = this.closest('.item');
        const indexMatch = item.querySelector('[name^="indoorstations["], [name^="outdoorstations["], [name^="controlUnits["], [name^="others["]')?.name.match(/\[(\d+)\]/);
        const index = indexMatch ? parseInt(indexMatch[1]) : null;
        item.remove();
        // Reindex remaining items if we found an index
        if (index !== null) {
            const categories = [
                'indoorstations',
                'outdoorstations',
                'controlUnits',
                'others'
            ];
            categories.forEach((category)=>{
                deviceList.querySelectorAll(`[name^="${category}["]`).forEach((el)=>{
                    const currentIndex = parseInt(el.name.match(/\[(\d+)\]/)[1]);
                    if (currentIndex > index) el.name = el.name.replace(/\[(\d+)\]/, `[${currentIndex - 1}]`);
                });
            });
        }
    });
}
function $2058487f4462c174$export$31ba9235d680870() {
    const formMessageDiv = document.getElementById('form-message');
    formMessageDiv.classList.add('hidden');
    formMessageDiv.textContent = '';
}
function $2058487f4462c174$export$6ba40ea41de383a1(message, type = 'error') {
    const formMessageDiv = document.getElementById('form-message');
    if (!formMessageDiv) return;
    // Clear to ensure re-announcement even for repeated content
    formMessageDiv.textContent = '';
    // Variant classes
    formMessageDiv.className = `form-message ${type}`;
    // Build content
    const icon = document.createElement('span');
    icon.className = 'icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = type === 'success' ? `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" width="24" height="24">
         <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
         <path d="M22 4 12 14.01l-3-3"/>
       </svg>` : `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" width="24" height="24">
         <circle cx="12" cy="12" r="10"></circle>
         <line x1="12" y1="8" x2="12" y2="12"></line>
         <line x1="12" y1="16" x2="12" y2="16"></line>
       </svg>`;
    const content = document.createElement('div');
    const title = document.createElement('p');
    title.className = 'title';
    title.textContent = type === 'success' ? "Vielen Dank f\xfcr den Auftrag!" : 'Es ist ein Fehler aufgetreten';
    const text = document.createElement('p');
    text.className = 'text';
    text.innerHTML = message;
    content.appendChild(title);
    content.appendChild(text);
    formMessageDiv.appendChild(icon);
    formMessageDiv.appendChild(content);
    // Reveal and announce
    formMessageDiv.classList.remove('hidden');
    formMessageDiv.classList.add('show');
}
function $2058487f4462c174$export$b8ea446e31178845() {
    const submitButton1 = document.querySelector('.submit-button');
    const loadingMessage = document.getElementById('loadingMessage');
    $2058487f4462c174$export$31ba9235d680870();
    submitButton1.disabled = true;
    submitButton1.classList.add('running');
    loadingMessage.classList.remove('hidden');
}
function $2058487f4462c174$export$80775798c6eb9d34() {
    const loadingMessage = document.getElementById('loadingMessage');
    loadingMessage.classList.add('hidden');
    submitButton.classList.remove('running');
    submitButton.disabled = false;
}
async function $2058487f4462c174$export$97a0d29fe9cc5b08(body, url) {
    const finalFormData = new FormData();
    finalFormData.append('jsonData', body);
    const fileInput = document.getElementById('receiptUpload');
    if (fileInput.files.length > 0) finalFormData.append('receiptUpload', fileInput.files[0]);
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: finalFormData
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('An error occurred:', error);
        return {
            success: false,
            message: error.message
        };
    } finally{
        $2058487f4462c174$export$80775798c6eb9d34();
    }
}
function $2058487f4462c174$export$9643fd7297feaaf5(formData) {
    const data = Object.fromEntries(Array.from(formData?.entries())?.filter(([key, value])=>{
        const match = key.startsWith('outdoorstations') || key.startsWith('indoorstations') || key.startsWith('others') || key.startsWith('controlUnits') || key.startsWith('receiptUpload');
        key.startsWith('receiptUpload');
        if (match) return false;
        return true;
    }).map(([key, value])=>{
        if (key.startsWith('customer')) return [
            key,
            value.trim() || ''
        ];
        if (key.startsWith('building')) return [
            key,
            value.trim() || ''
        ];
        if (value === 'on') return [
            key,
            true
        ];
        return [
            key,
            value
        ];
    }));
    data.devices = {
        indoorstations: $2058487f4462c174$var$processDevices(formData, 'indoorstations'),
        outdoorstations: $2058487f4462c174$var$processDevices(formData, 'outdoorstations'),
        controlUnits: $2058487f4462c174$var$processDevices(formData, 'controlUnits'),
        others: $2058487f4462c174$var$processDevices(formData, 'others')
    };
    return data;
}
const $2058487f4462c174$var$processDevices = (formData, prefix)=>{
    const grouped = {};
    const result = [];
    for (const [fullKey, value] of formData.entries()){
        const match = fullKey.match(new RegExp(`${prefix}\\[(\\d+)\\]\\[([^\\]]+)\\](?:\\[(\\d+)\\])?`));
        if (!match) continue;
        const [_, index, field, arrayIndex] = match;
        if (!grouped[index]) grouped[index] = {};
        const device = grouped[index];
        // Convert quantity to number if applicable
        if (field === 'quantity') {
            device.quantity = parseInt(value, 10);
            continue;
        }
        // Handle nested objects like location[floor]
        const isArrayField = typeof arrayIndex !== 'undefined';
        if (isArrayField) {
            if (!device[field]) device[field] = [];
            const i = parseInt(arrayIndex, 10);
            device[field][i] = value;
        } else device[field] = value;
    }
    // Expand quantity into separate device entries
    for (const device of Object.values(grouped)){
        const quantity = device.quantity || 1;
        for(let i = 0; i < quantity; i++){
            const entry = {};
            for (const [key, value] of Object.entries(device)){
                if (key === 'floor' || key === 'apartment') continue;
                else if (Array.isArray(value)) entry[key] = value[i] || '';
                else if (key !== 'quantity') entry[key] = value;
            }
            // Handle location specially if it's in array form
            if (device.floor || device.apartment) entry.location = {
                floor: device.floor && device.floor[i] || '',
                apartment: device.apartment && device.apartment[i] || ''
            };
            if (entry.articleNumber) result.push(entry);
        }
    }
    return result;
};
function $2058487f4462c174$export$5f87a80a990db1a0() {
    document.getElementById('receiptUpload').addEventListener('change', function(e) {
        const fileNameDisplay = document.querySelector('.file-name');
        if (this.files.length > 0 && this.files[0].size) {
            fileNameDisplay.textContent = this.files[0].name;
            fileNameDisplay.style.color = '#111827';
        } else {
            fileNameDisplay.textContent = 'No file selected';
            fileNameDisplay.style.color = '#6b7280';
        }
    });
}


var $c35973a388b615f1$exports = {};
function $c35973a388b615f1$var$setDatePickerLimits() {
    const datePickers = document.getElementsByClassName("datepicker");
    const minDaysInAdvance = 3;
    const maxDaysInAdvance = 28;
    $c35973a388b615f1$var$setMinMaxDate(datePickers, minDaysInAdvance, maxDaysInAdvance);
}
function $c35973a388b615f1$var$getDate(days1) {
    let date;
    if (days1 !== undefined) date = new Date(Date.now() + days1 * 86400000);
    else date = new Date();
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60000);
    return date.toISOString().split("T")[0];
}
function $c35973a388b615f1$var$isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday = 0, Saturday = 6
}
function $c35973a388b615f1$var$getValidDate(date) {
    while($c35973a388b615f1$var$isWeekend(date))date.setDate(date.getDate() + 1);
    const hour = date.getHours();
    if (hour < 8 || hour > 17) {
        if (hour < 8) date.setHours(8);
        else date.setHours(17);
    }
    return date;
}
function $c35973a388b615f1$var$setMinMaxDate(datePickers, minDaysInAdvance, maxDaysInAdvance) {
    let maxDate = new Date(Date.now() + maxDaysInAdvance * 86400000);
    let minDate = new Date(Date.now() + minDaysInAdvance * 86400000);
    maxDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    for(let i = 0; i < datePickers.length; i++){
        datePickers[i].min = $c35973a388b615f1$var$getValidDate(minDate).toISOString().slice(0, 16);
        datePickers[i].max = $c35973a388b615f1$var$getValidDate(maxDate).toISOString().slice(0, 16);
    }
}
function $c35973a388b615f1$var$setDateListenr() {
    $c35973a388b615f1$var$setDatePickerLimits();
    const datePickers = document.getElementsByClassName("datepicker");
    for(let i = 0; i < datePickers.length; i++)datePickers[i].addEventListener("input", function(e) {
        let date = $c35973a388b615f1$var$getValidDate(new Date(e.target.value));
        date.setHours(date.getHours() + 2);
        datePickers[i].value = date.toISOString().slice(0, 16);
    });
}
function $c35973a388b615f1$var$toLocalISOString(date) {
    const offset = date.getTimezoneOffset();
    const offsetAbs = Math.abs(offset);
    const localDate = new Date(date.getTime() - offset * 60000);
    return `${localDate.toISOString().slice(0, -1)}${offset > 0 ? '-' : '+'}${String(Math.floor(offsetAbs / 60)).padStart(2, '0')}:${String(offsetAbs % 60).padStart(2, '0')}`;
}
function $c35973a388b615f1$var$disableWeekends() {
    const datePickers = document.getElementsByClassName("datepicker");
    let date = new Date(Date.now() + days * 86400000);
    for(let i = 0; i < datePickers.length; i++)datePickers[i].addEventListener("input", function() {
        if ($c35973a388b615f1$var$isWeekend(new Date(this.value))) this.value = "";
    });
}
$c35973a388b615f1$exports = {
    getDate: $c35973a388b615f1$var$getDate,
    setDateListenr: $c35973a388b615f1$var$setDateListenr
};


class $056aae7d860a8ad9$export$6c178f1eacc8aa12 {
    /**
     * prefix: id prefix of the address fields; `customer` finds customerPostalCode, customerCity,
     * customerStreet, customerHouseNumber and customer-street-suggestions. An empty prefix finds
     * postalCode, city, street, houseNumber and street-suggestions.
     * isActive: false while the API does not cover the address (OpenPLZ: Germany only); the fields
     * then stay plain inputs. Call release() when it turns false.
     */ constructor(prefix, { isActive: isActive = ()=>true } = {}){
        const id = (name)=>prefix ? prefix + name : name[0].toLowerCase() + name.slice(1);
        this.prefix = prefix;
        this.isActive = isActive;
        this.apiFailed = false;
        this.postalInput = document.getElementById(id('PostalCode'));
        this.cityInput = document.getElementById(id('City'));
        this.streetInput = document.getElementById(id('Street'));
        this.houseInput = document.getElementById(id('HouseNumber'));
        this.streetSuggestions = document.getElementById(prefix ? `${prefix}-street-suggestions` : 'street-suggestions');
        // NEW - use existing error divs
        this.postalStatus = this.postalInput.parentElement.querySelector('.error');
        this.cityStatus = this.cityInput.parentElement.querySelector('.error');
        this.streetStatus = this.streetInput.parentElement.querySelector('.error');
        this.houseStatus = this.houseInput.parentElement.querySelector('.error');
        this.openplzUrl = 'https://openplzapi.org/de';
        this.currentStreetSuggestions = [];
        this.highlightedIndex = -1;
        this.searchTimeout = null;
        this.validatedData = {
            postal: null,
            city: null,
            street: null,
            house: null,
            isValidated: false
        };
        this.init();
    }
    init() {
        // Postal code validation
        this.postalInput.addEventListener('input', (e)=>{
            if (this.isActive()) this.handlePostalInput(e.target.value);
        });
        this.postalInput.addEventListener('blur', (e)=>{
            if (this.isActive()) this.validatePostalCode(e.target.value);
        });
        // Street autocomplete; after an API failure the address is typed without suggestions
        this.streetInput.addEventListener('input', (e)=>{
            if (this.isActive() && !this.apiFailed) this.handleStreetInput(e.target.value);
        });
        this.streetInput.addEventListener('keydown', (e)=>{
            this.handleStreetKeyNavigation(e);
        });
        // this.streetInput.addEventListener('blur', () => {
        //     setTimeout(() => this.hideStreetSuggestions(), 150);
        // });
        // House number validation
        let houseNumberTimeout = null;
        this.houseInput.addEventListener('input', (e)=>{
            if (houseNumberTimeout) clearTimeout(houseNumberTimeout);
            houseNumberTimeout = setTimeout(()=>{
                if (this.isActive() && !this.apiFailed) this.validateHouseNumber(e.target.value);
            }, 500);
        });
        this.streetSuggestions.addEventListener('click', (e)=>{
            e.stopPropagation(); // Prevents event from bubbling up to document
        });
        // Close suggestions when clicking outside
        document.addEventListener('click', (e)=>{
            if (!e.target.closest('.autocomplete-container')) this.hideStreetSuggestions();
        });
    }
    updateValidationState() {
        this.validatedData.isValidated = !!(this.validatedData.postal && this.validatedData.city && this.validatedData.street && this.validatedData.house !== null);
    }
    handlePostalInput(value) {
        this.apiFailed = false;
        // Reset dependent fields if postal code changes
        if (value.length < 5) this.resetDependentFields();
        // Auto-validate when 5 digits entered
        if (value.length === 5) this.validatePostalCode(value);
        else this.setFieldStatus(this.postalInput, this.postalStatus, 'info', '5-stellige Postleitzahl eingeben');
    }
    async validatePostalCode(postalCode) {
        if (!/^\d{5}$/.test(postalCode)) {
            this.setFieldStatus(this.postalInput, this.postalStatus, 'error', "Ung\xfcltiges Postleitzahlenformat");
            return;
        }
        this.setFieldStatus(this.postalInput, this.postalStatus, 'info', "Wird \xfcberpr\xfcft...");
        try {
            // Use OpenPLZ API to get localities for postal code
            const response = await fetch(`${this.openplzUrl}/Localities?postalCode=${postalCode}`, {
                headers: {
                    'accept': 'application/json'
                }
            });
            if (!response.ok) throw new Error('API request failed');
            const data = await response.json();
            if (!data || data.length === 0) {
                this.setFieldStatus(this.postalInput, this.postalStatus, 'error', 'Postleitzahl nicht gefunden');
                return;
            }
            // Get unique cities for this postal code
            const cities = [
                ...new Set(data.map((item)=>item.name))
            ].sort();
            if (cities.length === 1) {
                // Single city - auto-fill it
                const city = cities[0];
                this.cityInput.value = city;
                this.validatedData.postal = postalCode;
                this.validatedData.city = city;
                this.setFieldStatus(this.postalInput, this.postalStatus, 'success', "\u2713 G\xfcltige Postleitzahl");
                this.setFieldStatus(this.cityInput, this.cityStatus, 'success', `\u{2713} Automatisch ausgef\xfcllt: ${city}`);
                // Enable street input
                this.streetInput.disabled = false;
                this.cityInput.disabled = false;
                this.houseInput.disabled = false;
                this.streetInput.focus();
            } else {
                // Multiple cities - let user choose
                this.cityInput.readOnly = false;
                this.cityInput.value = cities[0]; // Set first as default
                this.validatedData.postal = postalCode;
                this.validatedData.city = cities;
                this.setFieldStatus(this.postalInput, this.postalStatus, 'success', "\u2713 G\xfcltige Postleitzahl");
                this.setFieldStatus(this.cityInput, this.cityStatus, 'success', `\u{2713} Auto-filled: ${cities[0]} (${cities.length} cities available)`);
                // Create dropdown for city selection if needed
                this.createCityDropdown(cities);
                // Enable street input
                this.streetInput.disabled = false;
                this.cityInput.disabled = false;
            }
        } catch (error) {
            console.error('Postal validation error:', error);
            // Without the API the address can still be typed in.
            this.release();
            this.apiFailed = true;
            this.setFieldStatus(this.postalInput, this.postalStatus, 'info', "Pr\xfcfung nicht m\xf6glich, bitte Adresse selbst eingeben");
        }
    }
    /** Makes every address field editable again and clears suggestions and status messages. */ release() {
        this.cityInput.readOnly = false;
        this.streetInput.disabled = false;
        this.houseInput.disabled = false;
        this.currentStreetSuggestions = [];
        this.hideStreetSuggestions();
        this.setFieldStatus(this.postalInput, this.postalStatus, '', '');
        this.setFieldStatus(this.cityInput, this.cityStatus, '', '');
        this.setFieldStatus(this.streetInput, this.streetStatus, '', '');
        this.setFieldStatus(this.houseInput, this.houseStatus, '', '');
    }
    createCityDropdown(cities) {
        // Simple approach - add a small note showing available cities
        if (cities.length > 1) {
            const otherCities = cities.slice(1).join(', ');
            this.setFieldStatus(this.cityInput, this.cityStatus, 'info', `Andere St\xe4dte: ${otherCities}`);
        }
    }
    // Step 2: Street autocomplete using OpenPLZ
    handleStreetInput(value) {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.highlightedIndex = -1;
        if (!this.validatedData.postal || !this.validatedData.city) {
            this.setFieldStatus(this.streetInput, this.streetStatus, 'error', 'Geben Sie zuerst die Postleitzahl ein');
            return;
        }
        if (value.length < 3) {
            this.hideStreetSuggestions();
            this.setFieldStatus(this.streetInput, this.streetStatus, 'info', "Geben Sie den Stra\xdfennamen ein...");
            return;
        }
        this.showStreetLoading();
        this.searchTimeout = setTimeout(()=>{
            this.searchStreets(value);
        }, 500);
    }
    async searchStreets(streetName) {
        try {
            // Search for streets using OpenPLZ API with postal code and locality filters
            const response = await fetch(`${this.openplzUrl}/Streets?name=${encodeURIComponent(streetName)}&postalCode=${this.validatedData.postal}&locality=${encodeURIComponent(this.validatedData.city)}`, {
                headers: {
                    'accept': 'application/json'
                }
            });
            if (!response.ok) throw new Error('Street search failed');
            const data = await response.json();
            if (!data || data.length === 0) {
                // Try broader search without exact locality match
                const fallbackResponse = await fetch(`${this.openplzUrl}/Streets?name=${encodeURIComponent(streetName)}&postalCode=${this.validatedData.postal}`, {
                    headers: {
                        'accept': 'application/json'
                    }
                });
                if (fallbackResponse.ok) {
                    const fallbackData = await fallbackResponse.json();
                    if (fallbackData && fallbackData.length > 0) this.processStreetResults(fallbackData);
                    else // No results found - offer manual entry
                    this.displayManualEntryOption(streetName);
                } else // Show manual entry option
                this.displayManualEntryOption(streetName);
                return;
            }
            this.processStreetResults(data);
        } catch (error) {
            console.error('Street search error:', error);
            this.setFieldStatus(this.streetInput, this.streetStatus, 'error', 'Stra en-Suche fehlgeschlagen');
        }
    }
    processStreetResults(streets) {
        // Remove duplicates and sort
        const uniqueStreets = streets.filter((street, index, self)=>index === self.findIndex((s)=>s.name === street.name && s.locality === street.locality)).sort((a, b)=>a.name.localeCompare(b.name)).slice(0, 8); // Limit results
        this.currentStreetSuggestions = uniqueStreets.map((street)=>({
                name: street.name,
                display: street.name,
                secondary: `${street.postalCode} ${street.locality}`,
                data: street
            }));
        this.displayStreetSuggestions(this.currentStreetSuggestions);
    }
    displayManualEntryOption(streetName) {
        this.currentStreetSuggestions = [
            {
                name: streetName,
                display: `${streetName}`,
                secondary: "Keine Ergebnisse \u2013 klicken Sie, um die Stra\xdfe manuell einzugeben",
                isManualEntry: true
            }
        ];
        this.displayStreetSuggestions(this.currentStreetSuggestions);
    // this.setFieldStatus(this.streetInput, this.streetStatus, 'info', 'Nichts gefunden – Sie können die Straße selbst eingeben');
    }
    displayStreetSuggestions(streets) {
        if (streets.length === 0) {
            this.streetSuggestions.innerHTML = '<div class="no-results">Keine Stra\xdfen gefunden</div>';
            this.streetSuggestions.style.display = 'block';
            return;
        }
        const html = streets.map((street, index)=>`
            <div class="suggestion-item" data-index="${index}">
                <div class="suggestion-main">${this.escapeHtml(street.display)}</div>
                <div class="suggestion-secondary">${this.escapeHtml(street.secondary)}</div>
            </div>
        `).join('');
        this.streetSuggestions.innerHTML = html;
        this.streetSuggestions.querySelectorAll('.suggestion-item').forEach((item, index)=>{
            item.addEventListener('click', ()=>{
                this.selectStreet(index);
            });
        });
        this.streetSuggestions.style.display = 'block';
    }
    selectStreet(index) {
        if (index < 0 || index >= this.currentStreetSuggestions.length) return;
        const street = this.currentStreetSuggestions[index];
        this.streetInput.value = street.name;
        this.validatedData.street = street.name;
        // Handle manual entry (no data object)
        if (street.isManualEntry) this.setFieldStatus(this.streetInput, this.streetStatus, 'success', "Stra\xdfe manuell eingegeben");
        else if (street.data) {
            // Handle API result with data
            if (street.data.locality !== this.validatedData.city) {
                this.cityInput.value = street.data.locality;
                this.validatedData.city = street.data.locality;
                this.setFieldStatus(this.cityInput, this.cityStatus, 'success', `\u{2713} Aktualisiert auf: ${street.data.locality}`);
            }
            this.setFieldStatus(this.streetInput, this.streetStatus, 'success', "Stra\xdfe erfolgreich ausgew\xe4hlt");
        }
        this.hideStreetSuggestions();
        this.houseInput.disabled = false;
        this.houseInput.focus();
    }
    handleStreetKeyNavigation(e) {
        if (!this.currentStreetSuggestions.length) return;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                this.highlightedIndex = Math.min(this.highlightedIndex + 1, this.currentStreetSuggestions.length - 1);
                this.updateStreetHighlight();
                break;
            case 'ArrowUp':
                e.preventDefault();
                this.highlightedIndex = Math.max(this.highlightedIndex - 1, -1);
                this.updateStreetHighlight();
                break;
            case 'Enter':
                e.preventDefault();
                if (this.highlightedIndex >= 0) this.selectStreet(this.highlightedIndex);
                break;
            case 'Escape':
                this.hideStreetSuggestions();
                break;
        }
    }
    updateStreetHighlight() {
        const items = this.streetSuggestions.querySelectorAll('.suggestion-item');
        items.forEach((item, index)=>{
            item.classList.toggle('highlighted', index === this.highlightedIndex);
        });
    }
    // Updated house number validation method
    async validateHouseNumber(value) {
        if (!value.trim()) {
            this.setFieldStatus(this.houseInput, this.houseStatus, 'error');
            this.validatedData.house = '';
            return;
        }
        const houseNumber = value.trim();
        // Basic format validation first
        if (!/^[1-9]\d*(?:[ -]?(?:[a-zA-Z]+|[1-9]\d*))?$/.test(houseNumber)) {
            this.setFieldStatus(this.houseInput, this.houseStatus, 'error', "Ung\xfcltiges Format");
            this.validatedData.house = null;
            return;
        }
        // Show loading state
        this.setFieldStatus(this.houseInput, this.houseStatus, 'info', "Hausnummer wird \xfcberpr\xfcft...");
        this.setFieldStatus(this.houseInput, this.houseStatus, 'success', `Format g\xfcltig`);
        this.validatedData.house = houseNumber;
        this.hideStreetSuggestions();
        this.updateValidationState();
    }
    // Final validation using OpenPLZ (basic check)
    async validateCompleteAddress() {
        if (!this.isFormComplete()) return;
        this.result.textContent = 'Adresse wird validiert...';
        this.result.className = 'result-display info';
        try {
            // Verify the street still exists in the postal code
            const response = await fetch(`${this.openplzUrl}/Streets?name=${encodeURIComponent(this.validatedData.street)}&postalCode=${this.validatedData.postal}&locality=${encodeURIComponent(this.validatedData.city)}`, {
                headers: {
                    'accept': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                if (data && data.length > 0) {
                    const fullAddress = `${this.validatedData.street} ${this.validatedData.house || ''}, ${this.validatedData.postal} ${this.validatedData.city}`.trim().replace(', ,', ',');
                    this.result.innerHTML = `
                        <strong>\u{2713} Adresse erfolgreich validiert!</strong><br>
                        <strong>Adresse:</strong> ${fullAddress}<br>
                        <strong>Verifiziert:</strong> Stra\xdfe vorhanden im Postleitzahlen-Datenbank
                    `;
                    this.result.className = 'result-display success';
                    // Dispatch custom event
                    document.dispatchEvent(new CustomEvent('addressValidated', {
                        detail: {
                            ...this.validatedData,
                            fullAddress: fullAddress
                        }
                    }));
                } else {
                    this.result.textContent = "\u26A0\uFE0F Stra\xdfe nicht gefunden im Postleitzahlen-Bereich";
                    this.result.className = 'result-display error';
                }
            } else throw new Error('Validation request failed');
        } catch (error) {
            console.error('Final validation error:', error);
            this.result.textContent = "\u274C Finale Validierung fehlgeschlagen";
            this.result.className = 'result-display error';
        }
    }
    setFieldStatus(input, statusEl, type, message) {
        // Clear existing classes
        input.classList.remove('valid', 'invalid', 'error');
        statusEl.className = type; // Reset to base class
        // Set message
        statusEl.textContent = message;
        // Add appropriate styling
        if (type === 'success') input.classList.add('valid');
        else if (type === 'error') input.classList.add('error');
        else statusEl.style.color = ''; // Reset color
    }
    resetDependentFields() {
        this.cityInput.value = '';
        this.streetInput.value = '';
        this.houseInput.value = '';
        this.cityInput.readOnly = true;
        this.streetInput.disabled = true;
        this.houseInput.disabled = true;
        this.setFieldStatus(this.cityInput, this.cityStatus, '', '');
        this.setFieldStatus(this.streetInput, this.streetStatus, '', '');
        this.setFieldStatus(this.houseInput, this.houseStatus, '', '');
        this.hideStreetSuggestions();
        this.validatedData = {
            postal: null,
            city: null,
            street: null,
            house: null
        };
    }
    isFormComplete() {
        return this.validatedData.postal && this.validatedData.city && this.validatedData.street;
    }
    showStreetLoading() {
        this.streetSuggestions.innerHTML = '<div class="loading">Suche Stra\xdfen...</div>';
        this.streetSuggestions.style.display = 'block';
    }
    hideStreetSuggestions() {
        this.streetSuggestions.style.display = 'none';
        this.highlightedIndex = -1;
    }
    clearForm() {
        this.postalInput.value = '';
        this.resetDependentFields();
        this.setFieldStatus(this.postalInput, this.postalStatus, '', '');
    }
    resetAllFields() {
        this.clearForm();
        this.validatedData = {
            postal: null,
            city: null,
            street: null,
            house: null
        };
    }
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}


const $bc85c065a3e6298f$var$sidebar = document.querySelector(".sidebar");
document.addEventListener('DOMContentLoaded', ()=>{
    const currentPath = window.location.pathname;
    const links = document.querySelectorAll('.sidebar-links a');
    console.log(currentPath);
    console.log(links);
    links.forEach((link)=>{
        if (link.getAttribute('href') == currentPath) {
            console.log(link.getAttribute('href'));
            link.parentElement.classList.add('active');
        }
    });
});


var $3827fbd00b732338$exports = {};
var $f427e7b00f0901b4$exports = {};
!function(e, t) {
    $f427e7b00f0901b4$exports = t();
}(self, ()=>{
    var e, t;
    return e = {
        2115 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(1728), i = r(2950), o = r(2130), l = r(9415), c = r(3541), u = r(8013), f = r(2062), m = r(9017), h = r(6162), p = r(5844), d = r(8529), g = r(125), y = r(1190), b = r(6220), _ = {
                Base: class {
                    constructor(e){
                        this.type = e, this.$_root = null, this._definition = {}, this._reset();
                    }
                    _reset() {
                        this._ids = new p.Ids, this._preferences = null, this._refs = new d.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                            ruleset: null,
                            whens: {}
                        };
                    }
                    describe() {
                        return s("function" == typeof m.describe, "Manifest functionality disabled"), m.describe(this);
                    }
                    allow(...e) {
                        return l.verifyFlat(e, "allow"), this._values(e, "_valids");
                    }
                    alter(e) {
                        s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                        const t = this.clone();
                        t.$_terms.alterations = t.$_terms.alterations || [];
                        for(const r in e){
                            const n = e[r];
                            s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                target: r,
                                adjuster: n
                            });
                        }
                        return t.$_temp.ruleset = !1, t;
                    }
                    artifact(e) {
                        return s(void 0 !== e, "Artifact cannot be undefined"), s(!this._cache, "Cannot set an artifact with a rule cache"), this.$_setFlag("artifact", e);
                    }
                    cast(e) {
                        return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                    }
                    default(e, t) {
                        return this._default("default", e, t);
                    }
                    description(e) {
                        return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                    }
                    empty(e) {
                        const t = this.clone();
                        return void 0 !== e && (e = t.$_compile(e, {
                            override: !1
                        })), t.$_setFlag("empty", e, {
                            clone: !1
                        });
                    }
                    error(e) {
                        return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                    }
                    example(e, t = {}) {
                        return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                            "override"
                        ]), this._inner("examples", e, {
                            single: !0,
                            override: t.override
                        });
                    }
                    external(e, t) {
                        return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                            method: e,
                            description: t
                        }, {
                            single: !0
                        });
                    }
                    failover(e, t) {
                        return this._default("failover", e, t);
                    }
                    forbidden() {
                        return this.presence("forbidden");
                    }
                    id(e) {
                        return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                    }
                    invalid(...e) {
                        return this._values(e, "_invalids");
                    }
                    label(e) {
                        return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                    }
                    meta(e) {
                        return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                            single: !0
                        });
                    }
                    note(...e) {
                        s(e.length, "Missing notes");
                        for (const t of e)s(t && "string" == typeof t, "Notes must be non-empty strings");
                        return this._inner("notes", e);
                    }
                    only(e = !0) {
                        return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                    }
                    optional() {
                        return this.presence("optional");
                    }
                    prefs(e) {
                        s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                        const t = this.clone();
                        return t._preferences = l.preferences(t._preferences, e), t;
                    }
                    presence(e) {
                        return s([
                            "optional",
                            "required",
                            "forbidden"
                        ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                    }
                    raw(e = !0) {
                        return this.$_setFlag("result", e ? "raw" : void 0);
                    }
                    result(e) {
                        return s([
                            "raw",
                            "strip"
                        ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                    }
                    required() {
                        return this.presence("required");
                    }
                    strict(e) {
                        const t = this.clone(), r = void 0 !== e && !e;
                        return t._preferences = l.preferences(t._preferences, {
                            convert: r
                        }), t;
                    }
                    strip(e = !0) {
                        return this.$_setFlag("result", e ? "strip" : void 0);
                    }
                    tag(...e) {
                        s(e.length, "Missing tags");
                        for (const t of e)s(t && "string" == typeof t, "Tags must be non-empty strings");
                        return this._inner("tags", e);
                    }
                    unit(e) {
                        return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                    }
                    valid(...e) {
                        l.verifyFlat(e, "valid");
                        const t = this.allow(...e);
                        return t.$_setFlag("only", !!t._valids, {
                            clone: !1
                        }), t;
                    }
                    when(e, t) {
                        const r = this.clone();
                        r.$_terms.whens || (r.$_terms.whens = []);
                        const n = c.when(r, e, t);
                        if (![
                            "any",
                            "link"
                        ].includes(r.type)) {
                            const e = n.is ? [
                                n
                            ] : n.switch;
                            for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                        }
                        return r.$_terms.whens.push(n), r.$_mutateRebuild();
                    }
                    cache(e) {
                        s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache"), s(void 0 === this._flags.artifact, "Cannot cache a rule with an artifact");
                        const t = this.clone();
                        return t._cache = e || o.provider.provision(), t.$_temp.ruleset = !1, t;
                    }
                    clone() {
                        const e = Object.create(Object.getPrototypeOf(this));
                        return this._assign(e);
                    }
                    concat(e) {
                        s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                        let t = this.clone();
                        if ("any" === this.type && "any" !== e.type) {
                            const r = e.clone();
                            for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                            t = r;
                        }
                        t._ids.concat(e._ids), t._refs.register(e, d.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                        for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                        for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                        if (t._flags.empty && e._flags.empty) {
                            t._flags.empty = t._flags.empty.concat(e._flags.empty);
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else if (e._flags.empty) {
                            t._flags.empty = e._flags.empty;
                            const r = Object.assign({}, e._flags);
                            delete r.empty, i(t._flags, r);
                        } else i(t._flags, e._flags);
                        for(const r in e.$_terms){
                            const s = e.$_terms[r];
                            s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                        }
                        return this.$_root._tracer && this.$_root._tracer._combine(t, [
                            this,
                            e
                        ]), t.$_mutateRebuild();
                    }
                    extend(e) {
                        return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                    }
                    extract(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                    }
                    fork(e, t) {
                        s(!this._inRuleset(), "Cannot fork inside a ruleset");
                        let r = this;
                        for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                        return r.$_temp.ruleset = !1, r;
                    }
                    rule(e) {
                        const t = this._definition;
                        l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                        const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                        s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                        const a = this.clone();
                        for(let i = r; i < a._rules.length; ++i){
                            const r = a._rules[i], o = n(r);
                            for(const n in e)t.modifiers[n](o, e[n]), s(o.name === r.name, "Cannot change rule name");
                            a._rules[i] = o, a._singleRules.get(o.name) === r && a._singleRules.set(o.name, o);
                        }
                        return a.$_temp.ruleset = !1, a.$_mutateRebuild();
                    }
                    get ruleset() {
                        s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                        const e = this.clone();
                        return e.$_temp.ruleset = e._rules.length, e;
                    }
                    get $() {
                        return this.ruleset;
                    }
                    tailor(e) {
                        e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                        let t = this;
                        if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                        return t = t.$_modify({
                            each: (t)=>t.tailor(e),
                            ref: !1
                        }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                    }
                    tracer() {
                        return g.location ? g.location(this) : this;
                    }
                    validate(e, t) {
                        return y.entry(e, this, t);
                    }
                    validateAsync(e, t) {
                        return y.entryAsync(e, this, t);
                    }
                    $_addRule(e) {
                        "string" == typeof e && (e = {
                            name: e
                        }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                        for(const t in e)s("_" !== t[0], "Cannot set private rule properties");
                        const t = Object.assign({}, e);
                        t._resolve = [], t.method = t.method || t.name;
                        const r = this._definition.rules[t.method], n = t.args;
                        s(r, "Unknown rule", t.method);
                        const a = this.clone();
                        if (n) {
                            s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                            for(const e in n){
                                let i = n[e];
                                if (r.argsByName) {
                                    const o = r.argsByName.get(e);
                                    if (o.ref && l.isResolvable(i)) t._resolve.push(e), a.$_mutateRegister(i);
                                    else if (o.normalize && (i = o.normalize(i), n[e] = i), o.assert) {
                                        const t = l.validateArg(i, e, o);
                                        s(!t, t, "or reference");
                                    }
                                }
                                void 0 !== i ? n[e] = i : delete n[e];
                            }
                        }
                        return r.multi || (a._ruleRemove(t.name, {
                            clone: !1
                        }), a._singleRules.set(t.name, t)), !1 === a.$_temp.ruleset && (a.$_temp.ruleset = null), r.priority ? a._rules.unshift(t) : a._rules.push(t), a;
                    }
                    $_compile(e, t) {
                        return c.schema(this.$_root, e, t);
                    }
                    $_createError(e, t, r, s, n, a = {}) {
                        const i = !1 !== a.flags ? this._flags : {}, o = a.messages ? h.merge(this._definition.messages, a.messages) : this._definition.messages;
                        return new u.Report(e, t, r, i, o, s, n);
                    }
                    $_getFlag(e) {
                        return this._flags[e];
                    }
                    $_getRule(e) {
                        return this._singleRules.get(e);
                    }
                    $_mapLabels(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                    }
                    $_match(e, t, r, s) {
                        (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                        const n = !y.validate(e, this, t, r, s).errors;
                        return t.restore(), n;
                    }
                    $_modify(e) {
                        return l.assertOptions(e, [
                            "each",
                            "once",
                            "ref",
                            "schema"
                        ]), p.schema(this, e) || this;
                    }
                    $_mutateRebuild() {
                        return s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset(), this.$_modify({
                            each: (e, { source: t, name: r, path: s, key: n })=>{
                                const a = this._definition[t][r] && this._definition[t][r].register;
                                !1 !== a && this.$_mutateRegister(e, {
                                    family: a,
                                    key: n
                                });
                            }
                        }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                    }
                    $_mutateRegister(e, { family: t, key: r } = {}) {
                        this._refs.register(e, t), this._ids.register(e, {
                            key: r
                        });
                    }
                    $_property(e) {
                        return this._definition.properties[e];
                    }
                    $_reach(e) {
                        return this._ids.reach(e);
                    }
                    $_rootReferences() {
                        return this._refs.roots();
                    }
                    $_setFlag(e, t, r = {}) {
                        s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                        const n = this._definition.flags[e] || {};
                        if (a(t, n.default) && (t = void 0), a(t, this._flags[e])) return this;
                        const i = !1 !== r.clone ? this.clone() : this;
                        return void 0 !== t ? (i._flags[e] = t, i.$_mutateRegister(t)) : delete i._flags[e], "_" !== e[0] && (i.$_temp.ruleset = !1), i;
                    }
                    $_parent(e, ...t) {
                        return this[e][l.symbols.parent].call(this, ...t);
                    }
                    $_validate(e, t, r) {
                        return y.validate(e, this, t, r);
                    }
                    _assign(e) {
                        e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                            shallow: !0
                        }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                        for(const t in this.$_terms)e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                        e.$_super = {};
                        for(const t in this.$_super)e.$_super[t] = this._super[t].bind(e);
                        return e;
                    }
                    _bare() {
                        const e = this.clone();
                        e._reset();
                        const t = e._definition.terms;
                        for(const r in t){
                            const s = t[r];
                            e.$_terms[r] = s.init;
                        }
                        return e.$_mutateRebuild();
                    }
                    _default(e, t, r = {}) {
                        return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                            [l.symbols.literal]: !0,
                            literal: t
                        }), this.$_setFlag(e, t);
                    }
                    _generate(e, t, r) {
                        if (!this.$_terms.whens) return {
                            schema: this
                        };
                        const s = [], n = [];
                        for(let a = 0; a < this.$_terms.whens.length; ++a){
                            const i = this.$_terms.whens[a];
                            if (i.concat) {
                                s.push(i.concat), n.push(`${a}.concat`);
                                continue;
                            }
                            const o = i.ref ? i.ref.resolve(e, t, r) : e, l = i.is ? [
                                i
                            ] : i.switch, c = n.length;
                            for(let c = 0; c < l.length; ++c){
                                const { is: u, then: f, otherwise: m } = l[c], h = `${a}${i.switch ? "." + c : ""}`;
                                if (u.$_match(o, t.nest(u, `${h}.is`), r)) {
                                    if (f) {
                                        const a = t.localize([
                                            ...t.path,
                                            `${h}.then`
                                        ], t.ancestors, t.schemas), { schema: i, id: o } = f._generate(e, a, r);
                                        s.push(i), n.push(`${h}.then${o ? `(${o})` : ""}`);
                                        break;
                                    }
                                } else if (m) {
                                    const a = t.localize([
                                        ...t.path,
                                        `${h}.otherwise`
                                    ], t.ancestors, t.schemas), { schema: i, id: o } = m._generate(e, a, r);
                                    s.push(i), n.push(`${h}.otherwise${o ? `(${o})` : ""}`);
                                    break;
                                }
                            }
                            if (i.break && n.length > c) break;
                        }
                        const a = n.join(", ");
                        if (t.mainstay.tracer.debug(t, "rule", "when", a), !a) return {
                            schema: this
                        };
                        if (!t.mainstay.tracer.active && this.$_temp.whens[a]) return {
                            schema: this.$_temp.whens[a],
                            id: a
                        };
                        let i = this;
                        this._definition.generate && (i = this._definition.generate(this, e, t, r));
                        for (const e of s)i = i.concat(e);
                        return this.$_root._tracer && this.$_root._tracer._combine(i, [
                            this,
                            ...s
                        ]), this.$_temp.whens[a] = i, {
                            schema: i,
                            id: a
                        };
                    }
                    _inner(e, t, r = {}) {
                        s(!this._inRuleset(), `Cannot set ${e} inside a ruleset`);
                        const n = this.clone();
                        return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                    }
                    _inRuleset() {
                        return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                    }
                    _ruleRemove(e, t = {}) {
                        if (!this._singleRules.has(e)) return this;
                        const r = !1 !== t.clone ? this.clone() : this;
                        r._singleRules.delete(e);
                        const s = [];
                        for(let t = 0; t < r._rules.length; ++t){
                            const n = r._rules[t];
                            n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                        }
                        return r._rules = s, r;
                    }
                    _values(e, t) {
                        l.verifyFlat(e, t.slice(1, -1));
                        const r = this.clone(), n = e[0] === l.symbols.override;
                        if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                        n && r[t].override();
                        for (const n of e){
                            s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                            const e = "_invalids" === t ? "_valids" : "_invalids";
                            r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                        }
                        return r;
                    }
                }
            };
            _.Base.prototype[l.symbols.any] = {
                version: l.version,
                compile: c.compile,
                root: "$_root"
            }, _.Base.prototype.isImmutable = !0, _.Base.prototype.deny = _.Base.prototype.invalid, _.Base.prototype.disallow = _.Base.prototype.invalid, _.Base.prototype.equal = _.Base.prototype.valid, _.Base.prototype.exist = _.Base.prototype.required, _.Base.prototype.not = _.Base.prototype.invalid, _.Base.prototype.options = _.Base.prototype.prefs, _.Base.prototype.preferences = _.Base.prototype.prefs, e.exports = new _.Base;
        },
        2130 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(9415), i = {
                max: 1e3,
                supported: new Set([
                    "undefined",
                    "boolean",
                    "number",
                    "string"
                ])
            };
            t.provider = {
                provision: (e)=>new i.Cache(e)
            }, i.Cache = class {
                constructor(e = {}){
                    a.assertOptions(e, [
                        "max"
                    ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || i.max, this._map = new Map, this._list = new i.List;
                }
                get length() {
                    return this._map.size;
                }
                set(e, t) {
                    if (null !== e && !i.supported.has(typeof e)) return;
                    let r = this._map.get(e);
                    if (r) return r.value = t, void this._list.first(r);
                    r = this._list.unshift({
                        key: e,
                        value: t
                    }), this._map.set(e, r), this._compact();
                }
                get(e) {
                    const t = this._map.get(e);
                    if (t) return this._list.first(t), n(t.value);
                }
                _compact() {
                    if (this._map.size > this._max) {
                        const e = this._list.pop();
                        this._map.delete(e.key);
                    }
                }
            }, i.List = class {
                constructor(){
                    this.tail = null, this.head = null;
                }
                unshift(e) {
                    return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                }
                first(e) {
                    e !== this.head && (this._remove(e), this.unshift(e));
                }
                pop() {
                    return this._remove(this.tail);
                }
                _remove(e) {
                    const { next: t, prev: r } = e;
                    return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                }
            };
        },
        9415 (e, t, r) {
            "use strict";
            const s = r(914), n = r(3660), a = r(6913);
            let i, o;
            const l = {
                isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
            };
            t.version = a.version, t.defaults = {
                abortEarly: !0,
                allowUnknown: !1,
                artifacts: !1,
                cache: !0,
                context: null,
                convert: !0,
                dateFormat: "iso",
                errors: {
                    escapeHtml: !1,
                    label: "path",
                    language: null,
                    render: !0,
                    stack: !1,
                    wrap: {
                        label: '"',
                        array: "[]"
                    }
                },
                externals: !0,
                messages: {},
                nonEnumerables: !1,
                noDefaults: !1,
                presence: "optional",
                skipFunctions: !1,
                stripUnknown: !1,
                warnings: !1
            }, t.symbols = {
                any: Symbol.for("@hapi/joi/schema"),
                arraySingle: Symbol("arraySingle"),
                deepDefault: Symbol("deepDefault"),
                errors: Symbol("errors"),
                literal: Symbol("literal"),
                override: Symbol("override"),
                parent: Symbol("parent"),
                prefs: Symbol("prefs"),
                ref: Symbol("ref"),
                template: Symbol("template"),
                values: Symbol("values")
            }, t.assertOptions = function(e, t, r = "Options") {
                s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                const n = Object.keys(e).filter((e)=>!t.includes(e));
                s(0 === n.length, `${r} contain unknown keys: ${n}`);
            }, t.checkPreferences = function(e) {
                o = o || r(1688);
                const t = o.preferences.validate(e);
                if (t.error) throw new n([
                    t.error.details[0].message
                ]);
            }, t.compare = function(e, t, r) {
                switch(r){
                    case "=":
                        return e === t;
                    case ">":
                        return e > t;
                    case "<":
                        return e < t;
                    case ">=":
                        return e >= t;
                    case "<=":
                        return e <= t;
                }
            }, t.default = function(e, t) {
                return void 0 === e ? t : e;
            }, t.isIsoDate = function(e) {
                return l.isoDate.test(e);
            }, t.isNumber = function(e) {
                return "number" == typeof e && !isNaN(e);
            }, t.isResolvable = function(e) {
                return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
            }, t.isSchema = function(e, r = {}) {
                const n = e && e[t.symbols.any];
                return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
            }, t.isValues = function(e) {
                return e[t.symbols.values];
            }, t.limit = function(e) {
                return Number.isSafeInteger(e) && e >= 0;
            }, t.preferences = function(e, s) {
                i = i || r(6162), e = e || {}, s = s || {};
                const n = Object.assign({}, e, s);
                return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = i.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
            }, t.tryWithPath = function(e, t, r = {}) {
                try {
                    return e();
                } catch (e) {
                    throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = `${e.message} (${e.path})`), e;
                }
            }, t.validateArg = function(e, r, { assert: s, message: n }) {
                if (t.isSchema(s)) {
                    const t = s.validate(e);
                    if (!t.error) return;
                    return t.error.message;
                }
                if (!s(e)) return r ? `${r} ${n}` : n;
            }, t.verifyFlat = function(e, t) {
                for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
            };
        },
        3541 (e, t, r) {
            "use strict";
            const s = r(914), n = r(9415), a = r(8529), i = {};
            t.schema = function(e, t, r = {}) {
                n.assertOptions(r, [
                    "appendPath",
                    "override"
                ]);
                try {
                    return i.schema(e, t, r);
                } catch (e) {
                    throw r.appendPath && void 0 !== e.path && (e.message = `${e.message} (${e.path})`), e;
                }
            }, i.schema = function(e, t, r) {
                s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                const a = (t, ...s)=>!1 !== r.override ? t.valid(e.override, ...s) : t.valid(...s);
                if (i.simple(t)) return a(e, t);
                if ("function" == typeof t) return e.custom(t);
                if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return a(e, t);
                if (n.isSchema(t)) return t;
                if (Array.isArray(t)) {
                    for (const r of t)if (!i.simple(r)) return e.alternatives().try(...t);
                    return a(e, ...t);
                }
                return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? a(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
            }, t.ref = function(e, t) {
                return a.isRef(e) ? e : a.create(e, t);
            }, t.compile = function(e, r, a = {}) {
                n.assertOptions(a, [
                    "legacy"
                ]);
                const o = r && r[n.symbols.any];
                if (o) return s(a.legacy || o.version === n.version, "Cannot mix different versions of joi schemas:", o.version, n.version), r;
                if ("object" != typeof r || !a.legacy) return t.schema(e, r, {
                    appendPath: !0
                });
                const l = i.walk(r);
                return l ? l.compile(l.root, r) : t.schema(e, r, {
                    appendPath: !0
                });
            }, i.walk = function(e) {
                if ("object" != typeof e) return null;
                if (Array.isArray(e)) {
                    for (const t of e){
                        const e = i.walk(t);
                        if (e) return e;
                    }
                    return null;
                }
                const t = e[n.symbols.any];
                if (t) return {
                    root: e[t.root],
                    compile: t.compile
                };
                s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                for(const t in e){
                    const r = i.walk(e[t]);
                    if (r) return r;
                }
                return null;
            }, i.simple = function(e) {
                return null === e || [
                    "boolean",
                    "string",
                    "number"
                ].includes(typeof e);
            }, t.when = function(e, r, o) {
                if (void 0 === o && (s(r && "object" == typeof r, "Missing options"), o = r, r = a.create(".")), Array.isArray(o) && (o = {
                    switch: o
                }), n.assertOptions(o, [
                    "is",
                    "not",
                    "then",
                    "otherwise",
                    "switch",
                    "break"
                ]), n.isSchema(r)) return s(void 0 === o.is, '"is" can not be used with a schema condition'), s(void 0 === o.not, '"not" can not be used with a schema condition'), s(void 0 === o.switch, '"switch" can not be used with a schema condition'), i.condition(e, {
                    is: r,
                    then: o.then,
                    otherwise: o.otherwise,
                    break: o.break
                });
                if (s(a.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === o.not || void 0 === o.is, 'Cannot combine "is" with "not"'), void 0 === o.switch) {
                    let l = o;
                    void 0 !== o.not && (l = {
                        is: o.not,
                        then: o.otherwise,
                        otherwise: o.then,
                        break: o.break
                    });
                    let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                    return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === o.is || a.isRef(o.is) || n.isSchema(o.is) || (c = c.required()), i.condition(e, {
                        ref: t.ref(r),
                        is: c,
                        then: l.then,
                        otherwise: l.otherwise,
                        break: l.break
                    });
                }
                s(Array.isArray(o.switch), '"switch" must be an array'), s(void 0 === o.is, 'Cannot combine "switch" with "is"'), s(void 0 === o.not, 'Cannot combine "switch" with "not"'), s(void 0 === o.then, 'Cannot combine "switch" with "then"');
                const l = {
                    ref: t.ref(r),
                    switch: [],
                    break: o.break
                };
                for(let t = 0; t < o.switch.length; ++t){
                    const r = o.switch[t], i = t === o.switch.length - 1;
                    n.assertOptions(r, i ? [
                        "is",
                        "then",
                        "otherwise"
                    ] : [
                        "is",
                        "then"
                    ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                    const c = {
                        is: e.$_compile(r.is),
                        then: e.$_compile(r.then)
                    };
                    if (a.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), i) {
                        s(void 0 === o.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                        const t = void 0 !== o.otherwise ? o.otherwise : r.otherwise;
                        void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                    }
                    l.switch.push(c);
                }
                return l;
            }, i.condition = function(e, t) {
                for (const r of [
                    "then",
                    "otherwise"
                ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                return t;
            };
        },
        8013 (e, t, r) {
            "use strict";
            const s = r(554), n = r(9415), a = r(1532);
            t.Report = class {
                constructor(e, r, s, n, a, i, o){
                    if (this.code = e, this.flags = n, this.messages = a, this.path = i.path, this.prefs = o, this.state = i, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                        const e = this.path[this.path.length - 1];
                        "object" != typeof e && (this.local.key = e);
                    }
                }
                _setTemplate(e) {
                    if (this.template = e, !this.flags.label && 0 === this.path.length) {
                        const e = this._template(this.template, "root");
                        e && (this.local.label = e);
                    }
                }
                toString() {
                    if (this.message) return this.message;
                    const e = this.code;
                    if (!this.prefs.errors.render) return this.code;
                    const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                    return void 0 === t ? `Error code "${e}" is not defined, your custom type is missing the correct messages definition` : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                        errors: this.prefs.errors,
                        messages: [
                            this.prefs.messages,
                            this.messages
                        ]
                    }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                }
                _template(e, r) {
                    return t.template(this.value, e, r || this.code, this.state, this.prefs);
                }
            }, t.path = function(e) {
                let t = "";
                for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += `[${r}]`);
                return t;
            }, t.template = function(e, t, r, s, i) {
                if (!t) return;
                if (a.isTemplate(t)) return "root" !== r ? t : null;
                let o = i.errors.language;
                if (n.isResolvable(o) && (o = o.resolve(e, s, i)), o && t[o]) {
                    if (void 0 !== t[o][r]) return t[o][r];
                    if (void 0 !== t[o]["*"]) return t[o]["*"];
                }
                return t[r] ? t[r] : t["*"];
            }, t.label = function(e, r, s, n) {
                if (!s.errors.label) return "";
                if (e.label) return e.label;
                let a = r.path;
                "key" === s.errors.label && r.path.length > 1 && (a = r.path.slice(-1));
                return t.path(a) || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
            }, t.process = function(e, r, s) {
                if (!e) return null;
                const { override: n, message: a, details: i } = t.details(e);
                if (n) return n;
                if (s.errors.stack) return new t.ValidationError(a, i, r);
                const o = Error.stackTraceLimit;
                Error.stackTraceLimit = 0;
                const l = new t.ValidationError(a, i, r);
                return Error.stackTraceLimit = o, l;
            }, t.details = function(e, t = {}) {
                let r = [];
                const s = [];
                for (const n of e){
                    if (n instanceof Error) {
                        if (!1 !== t.override) return {
                            override: n
                        };
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            type: "override",
                            context: {
                                error: n
                            }
                        });
                        continue;
                    }
                    const e = n.toString();
                    r.push(e), s.push({
                        message: e,
                        path: n.path.filter((e)=>"object" != typeof e),
                        type: n.code,
                        context: n.local
                    });
                }
                return r.length > 1 && (r = [
                    ...new Set(r)
                ]), {
                    message: r.join(". "),
                    details: s
                };
            }, t.ValidationError = class extends Error {
                constructor(e, t, r){
                    super(e), this._original = r, this.details = t;
                }
                static isError(e) {
                    return e instanceof t.ValidationError;
                }
            }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
        },
        2062 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(9415), i = r(6162), o = {};
            t.type = function(e, t) {
                const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                delete u.base, l._definition = u;
                const f = r._definition || {};
                u.messages = i.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                const m = Object.assign({}, f.terms);
                if (u.terms) for(const e in u.terms){
                    const t = u.terms[e];
                    s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, m[e] = t;
                }
                u.terms = m, u.args || (u.args = f.args), u.prepare = o.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                    method: u.coerce
                }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                    method: u.coerce.method,
                    from: [].concat(u.coerce.from)
                })), u.coerce = o.coerce(u.coerce, f.coerce), u.validate = o.validate(u.validate, f.validate);
                const h = Object.assign({}, f.rules);
                if (u.rules) for(const e in u.rules){
                    const t = u.rules[e];
                    s("object" == typeof t, "Invalid rule definition for", u.type, e);
                    let r = t.method;
                    if (void 0 === r && (r = function() {
                        return this.$_addRule(e);
                    }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!h[e], "Rule conflict in", u.type, e), h[e] = t, t.alias) {
                        const e = [].concat(t.alias);
                        for (const r of e)l[r] = t.method;
                    }
                    t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                            name: e
                        }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), a.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                }
                u.rules = h;
                const p = Object.assign({}, f.modifiers);
                if (u.modifiers) for(const e in u.modifiers){
                    s(!l[e], "Rule conflict in", u.type, e);
                    const t = u.modifiers[e];
                    s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                    const r = function(t) {
                        return this.rule({
                            [e]: t
                        });
                    };
                    l[e] = r, p[e] = t;
                }
                if (u.modifiers = p, u.overrides) {
                    l._super = r, c.$_super = {};
                    for(const e in u.overrides)s(r[e], "Cannot override missing", e), u.overrides[e][a.symbols.parent] = r[e], c.$_super[e] = r[e].bind(c);
                    Object.assign(l, u.overrides);
                }
                u.cast = Object.assign({}, f.cast, u.cast);
                const d = Object.assign({}, f.manifest, u.manifest);
                return d.build = o.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = d, u.rebuild = o.rebuild(u.rebuild, f.rebuild), c;
            }, o.build = function(e, t) {
                return e && t ? function(r, s) {
                    return t(e(r, s), s);
                } : e || t;
            }, o.coerce = function(e, t) {
                return e && t ? {
                    from: e.from && t.from ? [
                        ...new Set([
                            ...e.from,
                            ...t.from
                        ])
                    ] : null,
                    method (r, s) {
                        let n;
                        if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        if (!e.from || e.from.includes(typeof r)) {
                            const t = e.method(r, s);
                            if (t) return t;
                        }
                        return n;
                    }
                } : e || t;
            }, o.prepare = function(e, t) {
                return e && t ? function(r, s) {
                    const n = e(r, s);
                    if (n) {
                        if (n.errors || void 0 === n.value) return n;
                        r = n.value;
                    }
                    return t(r, s) || n;
                } : e || t;
            }, o.rebuild = function(e, t) {
                return e && t ? function(r) {
                    t(r), e(r);
                } : e || t;
            }, o.validate = function(e, t) {
                return e && t ? function(r, s) {
                    const n = t(r, s);
                    if (n) {
                        if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                        r = n.value;
                    }
                    return e(r, s) || n;
                } : e || t;
            };
        },
        1100 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(2130), i = r(9415), o = r(3541), l = r(8013), c = r(2062), u = r(9017), f = r(8529), m = r(1532), h = r(125);
            let p;
            const d = {
                types: {
                    alternatives: r(4972),
                    any: r(680),
                    array: r(2591),
                    boolean: r(6186),
                    date: r(2588),
                    function: r(4840),
                    link: r(9556),
                    number: r(4709),
                    object: r(7487),
                    string: r(9033),
                    symbol: r(5008)
                },
                aliases: {
                    alt: "alternatives",
                    bool: "boolean",
                    func: "function"
                },
                root: function() {
                    const e = {
                        _types: new Set(Object.keys(d.types))
                    };
                    for (const t of e._types)e[t] = function(...e) {
                        return s(!e.length || [
                            "alternatives",
                            "link",
                            "object"
                        ].includes(t), "The", t, "type does not allow arguments"), d.generate(this, d.types[t], e);
                    };
                    for (const t of [
                        "allow",
                        "custom",
                        "disallow",
                        "equal",
                        "exist",
                        "forbidden",
                        "invalid",
                        "not",
                        "only",
                        "optional",
                        "options",
                        "prefs",
                        "preferences",
                        "required",
                        "strip",
                        "valid",
                        "when"
                    ])e[t] = function(...e) {
                        return this.any()[t](...e);
                    };
                    Object.assign(e, d.methods);
                    for(const t in d.aliases){
                        const r = d.aliases[t];
                        e[t] = e[r];
                    }
                    return e.x = e.expression, h.setup && h.setup(e), e;
                }
            };
            d.methods = {
                ValidationError: l.ValidationError,
                version: i.version,
                cache: a.provider,
                assert (e, t, ...r) {
                    d.assert(e, t, !0, r);
                },
                attempt: (e, t, ...r)=>d.assert(e, t, !1, r),
                build (e) {
                    return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                },
                checkPreferences (e) {
                    i.checkPreferences(e);
                },
                compile (e, t) {
                    return o.compile(this, e, t);
                },
                defaults (e) {
                    s("function" == typeof e, "modifier must be a function");
                    const t = Object.assign({}, this);
                    for (const r of t._types){
                        const n = e(t[r]());
                        s(i.isSchema(n), "modifier must return a valid schema object"), t[r] = function(...e) {
                            return d.generate(this, n, e);
                        };
                    }
                    return t;
                },
                expression: (...e)=>new m(...e),
                extend (...e) {
                    i.verifyFlat(e, "extend"), p = p || r(1688), s(e.length, "You need to provide at least one extension"), this.assert(e, p.extensions);
                    const t = Object.assign({}, this);
                    t._types = new Set(t._types);
                    for (let r of e){
                        "function" == typeof r && (r = r(t)), this.assert(r, p.extension);
                        const e = d.expandExtension(r, t);
                        for (const r of e){
                            s(void 0 === t[r.type] || t._types.has(r.type), "Cannot override name", r.type);
                            const e = r.base || this.any(), n = c.type(e, r);
                            t._types.add(r.type), t[r.type] = function(...e) {
                                return d.generate(this, n, e);
                            };
                        }
                    }
                    return t;
                },
                isError: l.ValidationError.isError,
                isExpression: m.isTemplate,
                isRef: f.isRef,
                isSchema: i.isSchema,
                in: (...e)=>f.in(...e),
                override: i.symbols.override,
                ref: (...e)=>f.create(...e),
                types () {
                    const e = {};
                    for (const t of this._types)e[t] = this[t]();
                    for(const t in d.aliases)e[t] = this[t]();
                    return e;
                }
            }, d.assert = function(e, t, r, s) {
                const a = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, o = null !== a ? s[1] : s[0], c = t.validate(e, i.preferences({
                    errors: {
                        stack: !0
                    }
                }, o || {}));
                let u = c.error;
                if (!u) return c.value;
                if (a instanceof Error) throw a;
                const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                throw u instanceof l.ValidationError == 0 && (u = n(u)), u.message = a ? `${a} ${f}` : f, u;
            }, d.generate = function(e, t, r) {
                return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
            }, d.expandExtension = function(e, t) {
                if ("string" == typeof e.type) return [
                    e
                ];
                const r = [];
                for (const s of t._types)if (e.type.test(s)) {
                    const n = Object.assign({}, e);
                    n.type = s, n.base = t[s](), r.push(n);
                }
                return r;
            }, e.exports = d.root();
        },
        6162 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(1532);
            t.compile = function(e, t) {
                if ("string" == typeof e) return s(!t, "Cannot set single message string"), new a(e);
                if (a.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                for(let r in e){
                    const n = e[r];
                    if ("root" === r || a.isTemplate(n)) {
                        s("__proto__" !== r, "Cannot use __proto__ as a message code"), t[r] = n;
                        continue;
                    }
                    if ("string" == typeof n) {
                        s("__proto__" !== r, "Cannot use __proto__ as a message code"), t[r] = new a(n);
                        continue;
                    }
                    s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                    const i = r;
                    s("__proto__" !== i, "Cannot use __proto__ as a language");
                    const o = Object.prototype.hasOwnProperty.call(t, i) ? t[i] : {};
                    for(r in t[i] = o, n){
                        const e = n[r];
                        s("__proto__" !== r, "Cannot use __proto__ as a message code"), "root" === r || a.isTemplate(e) ? o[r] = e : (s("string" == typeof e, "Invalid message for", r, "in", i), o[r] = new a(e));
                    }
                }
                return t;
            }, t.decompile = function(e) {
                const t = {};
                for(let r in e){
                    const s = e[r];
                    if ("root" === r) {
                        t.root = s;
                        continue;
                    }
                    if (a.isTemplate(s)) {
                        t[r] = s.describe({
                            compact: !0
                        });
                        continue;
                    }
                    const n = r;
                    for(r in t[n] = {}, s){
                        const e = s[r];
                        "root" !== r ? t[n][r] = e.describe({
                            compact: !0
                        }) : t[n].root = e;
                    }
                }
                return t;
            }, t.merge = function(e, r) {
                if (!e) return t.compile(r);
                if (!r) return e;
                if ("string" == typeof r) return new a(r);
                if (a.isTemplate(r)) return r;
                const i = n(e);
                for(let e in r){
                    const t = r[e];
                    if ("root" === e || a.isTemplate(t)) {
                        s("__proto__" !== e, "Cannot use __proto__ as a message code"), i[e] = t;
                        continue;
                    }
                    if ("string" == typeof t) {
                        s("__proto__" !== e, "Cannot use __proto__ as a message code"), i[e] = new a(t);
                        continue;
                    }
                    s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                    const n = e;
                    s("__proto__" !== n, "Cannot use __proto__ as a language");
                    const o = Object.prototype.hasOwnProperty.call(i, n) ? i[n] : {};
                    for(e in i[n] = o, t){
                        const r = t[e];
                        s("__proto__" !== e, "Cannot use __proto__ as a message code"), "root" === e || a.isTemplate(r) ? o[e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), o[e] = new a(r));
                    }
                }
                return i;
            };
        },
        5844 (e, t, r) {
            "use strict";
            const s = r(914), n = r(9415), a = r(8529), i = {};
            t.Ids = i.Ids = class {
                constructor(){
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                clone() {
                    const e = new i.Ids;
                    return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
                }
                concat(e) {
                    e._schemaChain && (this._schemaChain = !0);
                    for (const [t, r] of e._byId.entries())s(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                    for (const [t, r] of e._byKey.entries())s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                }
                fork(e, t, r) {
                    const a = this._collect(e);
                    a.push({
                        schema: r
                    });
                    const o = a.shift();
                    let l = {
                        id: o.id,
                        schema: t(o.schema)
                    };
                    s(n.isSchema(l.schema), "adjuster function failed to return a joi schema type");
                    for (const e of a)l = {
                        id: e.id,
                        schema: i.fork(e.schema, l.id, l.schema)
                    };
                    return l.schema;
                }
                labels(e, t = []) {
                    const r = e[0], s = this._get(r);
                    if (!s) return [
                        ...t,
                        ...e
                    ].join(".");
                    const n = e.slice(1);
                    return t = [
                        ...t,
                        s.schema._flags.label || r
                    ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                }
                reach(e, t = []) {
                    const r = e[0], n = this._get(r);
                    s(n, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join("."));
                    const a = e.slice(1);
                    return a.length ? n.schema._ids.reach(a, [
                        ...t,
                        r
                    ]) : n.schema;
                }
                register(e, { key: t } = {}) {
                    if (!e || !n.isSchema(e)) return;
                    (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                    const r = e._flags.id;
                    if (r) {
                        const t = this._byId.get(r);
                        s(!t || t.schema === e, "Cannot add different schemas with the same id:", r), s(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                            schema: e,
                            id: r
                        });
                    }
                    t && (s(!this._byKey.has(t), "Schema already contains key:", t), s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                        schema: e,
                        id: t
                    }));
                }
                reset() {
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                _collect(e, t = [], r = []) {
                    const n = e[0], a = this._get(n);
                    s(a, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join(".")), r = [
                        a,
                        ...r
                    ];
                    const i = e.slice(1);
                    return i.length ? a.schema._ids._collect(i, [
                        ...t,
                        n
                    ], r) : r;
                }
                _get(e) {
                    return this._byId.get(e) || this._byKey.get(e);
                }
            }, i.fork = function(e, r, s) {
                const n = t.schema(e, {
                    each: (e, { key: t })=>{
                        if (r === (e._flags.id || t)) return s;
                    },
                    ref: !1
                });
                return n ? n.$_mutateRebuild() : e;
            }, t.schema = function(e, t) {
                let r;
                for(const s in e._flags){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e._flags[s], {
                        source: "flags",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                }
                for(let s = 0; s < e._rules.length; ++s){
                    const n = e._rules[s], a = i.scan(n.args, {
                        source: "rules",
                        name: n.name
                    }, t);
                    if (void 0 !== a) {
                        r = r || e.clone();
                        const t = Object.assign({}, n);
                        t.args = a, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                    }
                }
                for(const s in e.$_terms){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e.$_terms[s], {
                        source: "terms",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                }
                return r;
            }, i.scan = function(e, t, r, s, o) {
                const l = s || [];
                if (null === e || "object" != typeof e) return;
                let c;
                if (Array.isArray(e)) {
                    for(let s = 0; s < e.length; ++s){
                        const n = "terms" === t.source && "keys" === t.name && e[s].key, a = i.scan(e[s], t, r, [
                            s,
                            ...l
                        ], n);
                        void 0 !== a && (c = c || e.slice(), c[s] = a);
                    }
                    return c;
                }
                if (!1 !== r.schema && n.isSchema(e) || !1 !== r.ref && a.isRef(e)) {
                    const s = r.each(e, {
                        ...t,
                        path: l,
                        key: o
                    });
                    if (s === e) return;
                    return s;
                }
                for(const s in e){
                    if ("_" === s[0]) continue;
                    const n = i.scan(e[s], t, r, [
                        s,
                        ...l
                    ], o);
                    void 0 !== n && (c = c || Object.assign({}, e), c[s] = n);
                }
                return c;
            };
        },
        8529 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(9441), i = r(9415);
            let o;
            const l = {
                symbol: Symbol("ref"),
                defaults: {
                    adjust: null,
                    in: !1,
                    iterables: null,
                    map: null,
                    separator: ".",
                    type: "value"
                }
            };
            t.create = function(e, t = {}) {
                s("string" == typeof e, "Invalid reference key:", e), i.assertOptions(t, [
                    "adjust",
                    "ancestor",
                    "in",
                    "iterables",
                    "map",
                    "prefix",
                    "render",
                    "separator"
                ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                const r = Object.assign({}, l.defaults, t);
                delete r.prefix;
                const n = r.separator, a = l.context(e, n, t.prefix);
                if (r.type = a.type, e = a.key, "value" === r.type) {
                    if (a.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                    else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                    else {
                        const [t, s] = l.ancestor(e, n);
                        s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                    }
                }
                return r.path = n ? null === e ? [] : e.split(n) : [
                    e
                ], new l.Ref(r);
            }, t.in = function(e, r = {}) {
                return t.create(e, {
                    ...r,
                    in: !0
                });
            }, t.isRef = function(e) {
                return !!e && !!e[i.symbols.ref];
            }, l.Ref = class {
                constructor(e){
                    s("object" == typeof e, "Invalid reference construction"), i.assertOptions(e, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "path",
                        "render",
                        "separator",
                        "type",
                        "depth",
                        "key",
                        "root",
                        "display"
                    ]), s([
                        !1,
                        void 0
                    ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                }
                resolve(e, t, r, n, a = {}) {
                    return s(!this.in || a.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, a) : "local" === this.type ? this._resolve(n, t, a) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, a) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, a)) : this._resolve(e, t, a);
                }
                _resolve(e, t, r) {
                    let s;
                    if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = a(e, this.path, {
                        iterables: this.iterables,
                        functions: !0
                    })), this.adjust && (s = this.adjust(s)), this.map) {
                        const e = this.map.get(s);
                        void 0 !== e && (s = e);
                    }
                    return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                }
                toString() {
                    return this.display;
                }
                absolute(e) {
                    return [
                        ...e.path.slice(0, -this.ancestor),
                        ...this.path
                    ];
                }
                clone() {
                    return new l.Ref(this);
                }
                describe() {
                    const e = {
                        path: this.path
                    };
                    "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                        ...this.map
                    ]);
                    for (const t of [
                        "adjust",
                        "iterables",
                        "render"
                    ])null !== this[t] && void 0 !== this[t] && (e[t] = this[t]);
                    return !1 !== this.in && (e.in = !0), {
                        ref: e
                    };
                }
                updateDisplay() {
                    const e = null !== this.key ? this.key : "";
                    if ("value" !== this.type) return void (this.display = `ref:${this.type}:${e}`);
                    if (!this.separator) return void (this.display = `ref:${e}`);
                    if (!this.ancestor) return void (this.display = `ref:${this.separator}${e}`);
                    if ("root" === this.ancestor) return void (this.display = `ref:root:${e}`);
                    if (1 === this.ancestor) return void (this.display = `ref:${e || ".."}`);
                    const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                    this.display = `ref:${t}${e || ""}`;
                }
            }, l.Ref.prototype[i.symbols.ref] = !0, t.build = function(e) {
                return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
            }, l.context = function(e, t, r = {}) {
                if (e = e.trim(), r) {
                    const s = void 0 === r.global ? "$" : r.global;
                    if (s !== t && e.startsWith(s)) return {
                        key: e.slice(s.length),
                        type: "global"
                    };
                    const n = void 0 === r.local ? "#" : r.local;
                    if (n !== t && e.startsWith(n)) return {
                        key: e.slice(n.length),
                        type: "local"
                    };
                    const a = void 0 === r.root ? "/" : r.root;
                    if (a !== t && e.startsWith(a)) return {
                        key: e.slice(a.length),
                        type: "value",
                        root: !0
                    };
                }
                return {
                    key: e,
                    type: "value"
                };
            }, l.ancestor = function(e, t) {
                if (!t) return [
                    1,
                    0
                ];
                if (e[0] !== t) return [
                    1,
                    0
                ];
                if (e[1] !== t) return [
                    0,
                    1
                ];
                let r = 2;
                for(; e[r] === t;)++r;
                return [
                    r - 1,
                    r
                ];
            }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                constructor(){
                    this.refs = [];
                }
                register(e, s) {
                    if (e) {
                        if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                        else if (i.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                            ancestor: t.ancestor - s,
                            root: t.root
                        });
                        else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                            ancestor: e.ancestor - s,
                            root: e.root
                        }), o = o || r(1532), o.isTemplate(e) && this.register(e.refs(), s);
                    }
                }
                get length() {
                    return this.refs.length;
                }
                clone() {
                    const e = new t.Manager;
                    return e.refs = n(this.refs), e;
                }
                reset() {
                    this.refs = [];
                }
                roots() {
                    return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                }
            };
        },
        1688 (e, t, r) {
            "use strict";
            const s = r(1100), n = {};
            n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                allowUnknown: s.boolean(),
                abortEarly: s.boolean(),
                artifacts: s.boolean(),
                cache: s.boolean(),
                context: s.object(),
                convert: s.boolean(),
                dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                debug: s.boolean(),
                errors: {
                    escapeHtml: s.boolean(),
                    label: s.valid("path", "key", !1),
                    language: [
                        s.string(),
                        s.object().ref()
                    ],
                    render: s.boolean(),
                    stack: s.boolean(),
                    wrap: {
                        label: n.wrap,
                        array: n.wrap,
                        string: n.wrap
                    }
                },
                externals: s.boolean(),
                messages: s.object(),
                noDefaults: s.boolean(),
                nonEnumerables: s.boolean(),
                presence: s.valid("required", "optional", "forbidden"),
                skipFunctions: s.boolean(),
                stripUnknown: s.object({
                    arrays: s.boolean(),
                    objects: s.boolean()
                }).or("arrays", "objects").allow(!0, !1),
                warnings: s.boolean()
            }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
                alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                args: s.array().items(s.string(), s.object({
                    name: s.string().pattern(n.nameRx).required(),
                    ref: s.boolean(),
                    assert: s.alternatives([
                        s.function(),
                        s.object().schema()
                    ]).conditional("ref", {
                        is: !0,
                        then: s.required()
                    }),
                    normalize: s.function(),
                    message: s.string().when("assert", {
                        is: s.function(),
                        then: s.required()
                    })
                })),
                convert: s.boolean(),
                manifest: s.boolean(),
                method: s.function().allow(!1),
                multi: s.boolean(),
                validate: s.function()
            }), t.extension = s.object({
                type: s.alternatives([
                    s.string(),
                    s.object().regex()
                ]).required(),
                args: s.function(),
                cast: s.object().pattern(n.nameRx, s.object({
                    from: s.function().maxArity(1).required(),
                    to: s.function().minArity(1).maxArity(2).required()
                })),
                base: s.object().schema().when("type", {
                    is: s.object().regex(),
                    then: s.forbidden()
                }),
                coerce: [
                    s.function().maxArity(3),
                    s.object({
                        method: s.function().maxArity(3).required(),
                        from: s.array().items(s.string()).single()
                    })
                ],
                flags: s.object().pattern(n.nameRx, s.object({
                    setter: s.string(),
                    default: s.any()
                })),
                manifest: {
                    build: s.function().arity(2)
                },
                messages: [
                    s.object(),
                    s.string()
                ],
                modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                overrides: s.object().pattern(n.nameRx, s.function()),
                prepare: s.function().maxArity(3),
                rebuild: s.function().arity(1),
                rules: s.object().pattern(n.nameRx, n.rule),
                terms: s.object().pattern(n.nameRx, s.object({
                    init: s.array().allow(null).required(),
                    manifest: s.object().pattern(/.+/, [
                        s.valid("schema", "single"),
                        s.object({
                            mapped: s.object({
                                from: s.string().required(),
                                to: s.string().required()
                            }).required()
                        })
                    ])
                })),
                validate: s.function().maxArity(3)
            }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                buffer: s.object({
                    buffer: s.string()
                }),
                func: s.object({
                    function: s.function().required(),
                    options: {
                        literal: !0
                    }
                }),
                override: s.object({
                    override: !0
                }),
                ref: s.object({
                    ref: s.object({
                        type: s.valid("value", "global", "local"),
                        path: s.array().required(),
                        separator: s.string().length(1).allow(!1),
                        ancestor: s.number().min(0).integer().allow("root"),
                        map: s.array().items(s.array().length(2)).min(1),
                        adjust: s.function(),
                        iterables: s.boolean(),
                        in: s.boolean(),
                        render: s.boolean()
                    }).required()
                }),
                regex: s.object({
                    regex: s.string().min(3)
                }),
                special: s.object({
                    special: s.valid("deep").required()
                }),
                template: s.object({
                    template: s.string().required(),
                    options: s.object()
                }),
                value: s.object({
                    value: s.alternatives([
                        s.object(),
                        s.array()
                    ]).required()
                })
            }, n.desc.entity = s.alternatives([
                s.array().items(s.link("...")),
                s.boolean(),
                s.function(),
                s.number(),
                s.string(),
                n.desc.buffer,
                n.desc.func,
                n.desc.ref,
                n.desc.regex,
                n.desc.special,
                n.desc.template,
                n.desc.value,
                s.link("/")
            ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                s.string(),
                n.desc.template,
                s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template
                ])
            ]), t.description = s.object({
                type: s.string().required(),
                flags: s.object({
                    cast: s.string(),
                    default: s.any(),
                    description: s.string(),
                    empty: s.link("/"),
                    failover: n.desc.entity,
                    id: s.string(),
                    label: s.string(),
                    only: !0,
                    presence: [
                        "optional",
                        "required",
                        "forbidden"
                    ],
                    result: [
                        "raw",
                        "strip"
                    ],
                    strip: s.boolean(),
                    unit: s.string()
                }).unknown(),
                preferences: {
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    artifacts: s.boolean(),
                    cache: s.boolean(),
                    convert: s.boolean(),
                    dateFormat: [
                        "date",
                        "iso",
                        "string",
                        "time",
                        "utc"
                    ],
                    errors: {
                        escapeHtml: s.boolean(),
                        label: [
                            "path",
                            "key"
                        ],
                        language: [
                            s.string(),
                            n.desc.ref
                        ],
                        wrap: {
                            label: n.wrap,
                            array: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: n.desc.messages,
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: [
                        "required",
                        "optional",
                        "forbidden"
                    ],
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                },
                allow: n.desc.values,
                invalid: n.desc.values,
                rules: s.array().min(1).items({
                    name: s.string().required(),
                    args: s.object().min(1),
                    keep: s.boolean(),
                    message: [
                        s.string(),
                        n.desc.messages
                    ],
                    warn: s.boolean()
                }),
                keys: s.object().pattern(/.*/, s.link("/")),
                link: n.desc.ref
            }).pattern(/^[a-z]\w*$/, s.any());
        },
        4957 (e, t, r) {
            "use strict";
            const s = r(6179), n = r(9441), a = r(9415), i = {
                value: Symbol("value")
            };
            e.exports = i.State = class {
                constructor(e, t, r){
                    this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                }
                localize(e, t = null, r = null) {
                    const s = new i.State(e, t, this);
                    return r && s.schemas && (s.schemas = [
                        i.schemas(r),
                        ...s.schemas
                    ]), s;
                }
                nest(e, t) {
                    const r = new i.State(this.path, this.ancestors, this);
                    return r.schemas = r.schemas && [
                        i.schemas(e),
                        ...r.schemas
                    ], r.debug = t, r;
                }
                shadow(e, t) {
                    this.mainstay.shadow = this.mainstay.shadow || new i.Shadow, this.mainstay.shadow.set(this.path, e, t);
                }
                snapshot() {
                    this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
                }
                restore() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
                }
                commit() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.commit();
                }
            }, i.schemas = function(e) {
                return a.isSchema(e) ? {
                    schema: e
                } : e;
            }, i.Shadow = class {
                constructor(){
                    this._values = null;
                }
                set(e, t, r) {
                    if (!e.length) return;
                    if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                    this._values = this._values || new Map;
                    let s = this._values;
                    for(let t = 0; t < e.length; ++t){
                        const r = e[t];
                        let n = s.get(r);
                        n || (n = new Map, s.set(r, n)), s = n;
                    }
                    s[i.value] = t;
                }
                get(e) {
                    const t = this.node(e);
                    if (t) return t[i.value];
                }
                node(e) {
                    if (this._values) return n(this._values, e, {
                        iterables: !0
                    });
                }
                override(e, t) {
                    if (!this._values) return;
                    const r = e.slice(0, -1), s = e[e.length - 1], a = n(this._values, r, {
                        iterables: !0
                    });
                    t ? a.set(s, t) : a && a.delete(s);
                }
            };
        },
        1532 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(7222), i = r(3982), o = r(9415), l = r(8013), c = r(8529), u = {
                symbol: Symbol("template"),
                opens: new Array(1e3).join("\0"),
                closes: new Array(1e3).join(""),
                dateFormat: {
                    date: Date.prototype.toDateString,
                    iso: Date.prototype.toISOString,
                    string: Date.prototype.toString,
                    time: Date.prototype.toTimeString,
                    utc: Date.prototype.toUTCString
                }
            };
            e.exports = u.Template = class {
                constructor(e, t){
                    if (s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, t) {
                        const { functions: e, ...r } = t;
                        this._settings = Object.keys(r).length ? n(r) : void 0, this._functions = e, this._functions && (s(Object.keys(this._functions).every((e)=>"string" == typeof e), "Functions keys must be strings"), s(Object.values(this._functions).every((e)=>"function" == typeof e), "Functions values must be functions"));
                    } else this._settings = void 0, this._functions = void 0;
                    this._parse();
                }
                _parse() {
                    if (!this.source.includes("{")) return;
                    const e = u.encode(this.source), t = u.split(e);
                    let r = !1;
                    const s = [], n = t.shift();
                    n && s.push(n);
                    for (const e of t){
                        const t = "{" !== e[0], n = t ? "}" : "}}", a = e.indexOf(n);
                        if (-1 === a || "{" === e[1]) {
                            s.push(`{${u.decode(e)}`);
                            continue;
                        }
                        let i = e.slice(t ? 0 : 1, a);
                        const o = ":" === i[0];
                        o && (i = i.slice(1));
                        const l = this._ref(u.decode(i), {
                            raw: t,
                            wrapped: o
                        });
                        s.push(l), "string" != typeof l && (r = !0);
                        const c = e.slice(a + n.length);
                        c && s.push(u.decode(c));
                    }
                    r ? this._template = s : this.rendered = s.join("");
                }
                static date(e, t) {
                    return u.dateFormat[t.dateFormat].call(e);
                }
                describe(e = {}) {
                    if (!this._settings && e.compact) return this.source;
                    const t = {
                        template: this.source
                    };
                    return this._settings && (t.options = this._settings), this._functions && (t.functions = this._functions), t;
                }
                static build(e) {
                    return new u.Template(e.template, e.options || e.functions ? {
                        ...e.options,
                        functions: e.functions
                    } : void 0);
                }
                isDynamic() {
                    return !!this._template;
                }
                static isTemplate(e) {
                    return !!e && !!e[o.symbols.template];
                }
                refs() {
                    if (!this._template) return;
                    const e = [];
                    for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                    return e;
                }
                resolve(e, t, r, s) {
                    return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                }
                _part(e, ...t) {
                    return e.ref ? e.ref.resolve(...t) : e.formula.evaluate(t);
                }
                render(e, t, r, s, n = {}) {
                    if (!this.isDynamic()) return this.rendered;
                    const i = [];
                    for (const o of this._template)if ("string" == typeof o) i.push(o);
                    else {
                        const l = this._part(o, e, t, r, s, n), c = u.stringify(l, e, t, r, s, n);
                        if (void 0 !== c) {
                            const e = o.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : a(c);
                            i.push(u.wrap(e, o.wrapped && r.errors.wrap.label));
                        }
                    }
                    return i.join("");
                }
                _ref(e, { raw: t, wrapped: r }) {
                    const s = [], n = (e)=>{
                        const t = c.create(e, this._settings);
                        return s.push(t), (e)=>{
                            const r = t.resolve(...e);
                            return void 0 !== r ? r : null;
                        };
                    };
                    try {
                        const t = this._functions ? {
                            ...u.functions,
                            ...this._functions
                        } : u.functions;
                        var a = new i.Parser(e, {
                            reference: n,
                            functions: t,
                            constants: u.constants
                        });
                    } catch (t) {
                        throw t.message = `Invalid template variable "${e}" fails due to: ${t.message}`, t;
                    }
                    if (a.single) {
                        if ("reference" === a.single.type) {
                            const e = s[0];
                            return {
                                ref: e,
                                raw: t,
                                refs: s,
                                wrapped: r || "local" === e.type && "label" === e.key
                            };
                        }
                        return u.stringify(a.single.value);
                    }
                    return {
                        formula: a,
                        raw: t,
                        refs: s
                    };
                }
                toString() {
                    return this.source;
                }
            }, u.Template.prototype[o.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
            }, u.decode = function(e) {
                return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
            }, u.split = function(e) {
                const t = [];
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e[s];
                    if ("{" === n) {
                        let n = "";
                        for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                        t.push(r), r = n;
                    } else r += n;
                }
                return t.push(r), t;
            }, u.wrap = function(e, t) {
                return t ? 1 === t.length ? `${t}${e}${t}` : `${t[0]}${e}${t[1]}` : e;
            }, u.stringify = function(e, t, r, s, n, a = {}) {
                const i = typeof e, o = s && s.errors && s.errors.wrap || {};
                let l = !1;
                if (c.isRef(e) && e.render && (l = e.in, e = e.resolve(t, r, s, n, {
                    in: e.in,
                    ...a
                })), null === e) return "null";
                if ("string" === i) return u.wrap(e, a.arrayItems && o.string);
                if ("number" === i || "function" === i || "symbol" === i) return e.toString();
                if ("object" !== i) return JSON.stringify(e);
                if (e instanceof Date) return u.Template.date(e, s);
                if (e instanceof Map) {
                    const t = [];
                    for (const [r, s] of e.entries())t.push(`${r.toString()} -> ${s.toString()}`);
                    e = t;
                }
                if (!Array.isArray(e)) return e.toString();
                const f = [];
                for (const i of e)f.push(u.stringify(i, t, r, s, n, {
                    arrayItems: !0,
                    ...a
                }));
                return u.wrap(f.join(", "), !l && o.array);
            }, u.constants = {
                true: !0,
                false: !1,
                null: null,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5
            }, u.functions = {
                if: (e, t, r)=>e ? t : r,
                length: (e)=>"string" == typeof e ? e.length : e && "object" == typeof e ? Array.isArray(e) ? e.length : Object.keys(e).length : null,
                msg (e) {
                    const [t, r, s, n, a] = this, i = a.messages;
                    if (!i) return "";
                    const o = l.template(t, i[0], e, r, s) || l.template(t, i[1], e, r, s);
                    return o ? o.render(t, r, s, n, a) : "";
                },
                number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
            };
        },
        4972 (e, t, r) {
            "use strict";
            const s = r(914), n = r(2950), a = r(680), i = r(9415), o = r(3541), l = r(8013), c = r(8529), u = {};
            e.exports = a.extend({
                type: "alternatives",
                flags: {
                    match: {
                        default: "any"
                    }
                },
                terms: {
                    matches: {
                        init: [],
                        register: c.toSibling
                    }
                },
                args: (e, ...t)=>1 === t.length && Array.isArray(t[0]) ? e.try(...t[0]) : e.try(...t),
                validate (e, t) {
                    const { schema: r, error: s, state: a, prefs: i } = t;
                    if (r._flags.match) {
                        const t = [], o = [];
                        for(let s = 0; s < r.$_terms.matches.length; ++s){
                            const n = r.$_terms.matches[s], l = a.nest(n.schema, `match.${s}`);
                            l.snapshot();
                            const c = n.schema.$_validate(e, l, i);
                            c.errors ? (o.push(c.errors), l.restore()) : (t.push(c.value), l.commit());
                        }
                        if (0 === t.length) return {
                            errors: s("alternatives.any", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        if ("one" === r._flags.match) return 1 === t.length ? {
                            value: t[0]
                        } : {
                            errors: s("alternatives.one")
                        };
                        if (t.length !== r.$_terms.matches.length) return {
                            errors: s("alternatives.all", {
                                details: o.map((e)=>l.details(e, {
                                        override: !1
                                    }))
                            })
                        };
                        const c = (e)=>e.$_terms.matches.some((e)=>"object" === e.schema.type || "alternatives" === e.schema.type && c(e.schema));
                        return c(r) ? {
                            value: t.reduce((e, t)=>n(e, t, {
                                    mergeArrays: !1
                                }))
                        } : {
                            value: t[t.length - 1]
                        };
                    }
                    const o = [];
                    for(let t = 0; t < r.$_terms.matches.length; ++t){
                        const s = r.$_terms.matches[t];
                        if (s.schema) {
                            const r = a.nest(s.schema, `match.${t}`);
                            r.snapshot();
                            const n = s.schema.$_validate(e, r, i);
                            if (!n.errors) return r.commit(), n;
                            r.restore(), o.push({
                                schema: s.schema,
                                reports: n.errors
                            });
                            continue;
                        }
                        const n = s.ref ? s.ref.resolve(e, a, i) : e, l = s.is ? [
                            s
                        ] : s.switch;
                        for(let r = 0; r < l.length; ++r){
                            const o = l[r], { is: c, then: u, otherwise: f } = o, m = `match.${t}${s.switch ? "." + r : ""}`;
                            if (c.$_match(n, a.nest(c, `${m}.is`), i)) {
                                if (u) return u.$_validate(e, a.nest(u, `${m}.then`), i);
                            } else if (f) return f.$_validate(e, a.nest(f, `${m}.otherwise`), i);
                        }
                    }
                    return u.errors(o, t);
                },
                rules: {
                    conditional: {
                        method (e, t) {
                            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                            const r = this.clone(), n = o.when(r, e, t), a = n.is ? [
                                n
                            ] : n.switch;
                            for (const e of a)if (e.then && e.otherwise) {
                                r.$_setFlag("_endedSwitch", !0, {
                                    clone: !1
                                });
                                break;
                            }
                            return r.$_terms.matches.push(n), r.$_mutateRebuild();
                        }
                    },
                    match: {
                        method (e) {
                            if (s([
                                "any",
                                "one",
                                "all"
                            ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                            return this.$_setFlag("match", e);
                        }
                    },
                    try: {
                        method (...e) {
                            s(e.length, "Missing alternative schemas"), i.verifyFlat(e, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                            const t = this.clone();
                            for (const r of e)t.$_terms.matches.push({
                                schema: t.$_compile(r)
                            });
                            return t.$_mutateRebuild();
                        }
                    }
                },
                overrides: {
                    label (e) {
                        return this.$_parent("label", e).$_modify({
                            each: (t, r)=>"is" !== r.path[0] && "string" != typeof t._flags.label ? t.label(e) : void 0,
                            ref: !1
                        });
                    }
                },
                rebuild (e) {
                    e.$_modify({
                        each: (t)=>{
                            i.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                clone: !1
                            });
                        }
                    });
                },
                manifest: {
                    build (e, t) {
                        if (t.matches) for (const r of t.matches){
                            const { schema: t, ref: s, is: n, not: a, then: i, otherwise: o } = r;
                            e = t ? e.try(t) : s ? e.conditional(s, {
                                is: n,
                                then: i,
                                not: a,
                                otherwise: o,
                                switch: r.switch
                            }) : e.conditional(n, {
                                then: i,
                                otherwise: o
                            });
                        }
                        return e;
                    }
                },
                messages: {
                    "alternatives.all": "{{#label}} does not match all of the required types",
                    "alternatives.any": "{{#label}} does not match any of the allowed types",
                    "alternatives.match": "{{#label}} does not match any of the allowed types",
                    "alternatives.one": "{{#label}} matches more than one allowed type",
                    "alternatives.types": "{{#label}} must be one of {{#types}}"
                }
            }), u.errors = function(e, { error: t, state: r }) {
                if (!e.length) return {
                    errors: t("alternatives.any")
                };
                if (1 === e.length) return {
                    errors: e[0].reports
                };
                const s = new Set, n = [];
                for (const { reports: a, schema: i } of e){
                    if (a.length > 1) return u.unmatched(e, t);
                    const o = a[0];
                    if (o instanceof l.Report == 0) return u.unmatched(e, t);
                    if (o.state.path.length !== r.path.length) {
                        n.push({
                            type: i.type,
                            report: o
                        });
                        continue;
                    }
                    if ("any.only" === o.code) {
                        for (const e of o.local.valids)s.add(e);
                        continue;
                    }
                    const [c, f] = o.code.split(".");
                    "base" !== f ? n.push({
                        type: i.type,
                        report: o
                    }) : "object.base" === o.code ? s.add(o.local.type) : s.add(c);
                }
                return n.length ? 1 === n.length ? {
                    errors: n[0].report
                } : u.unmatched(e, t) : {
                    errors: t("alternatives.types", {
                        types: [
                            ...s
                        ]
                    })
                };
            }, u.unmatched = function(e, t) {
                const r = [];
                for (const t of e)r.push(...t.reports);
                return {
                    errors: t("alternatives.match", l.details(r, {
                        override: !1
                    }))
                };
            };
        },
        680 (e, t, r) {
            "use strict";
            const s = r(914), n = r(2115), a = r(9415), i = r(6162);
            e.exports = n.extend({
                type: "any",
                flags: {
                    only: {
                        default: !1
                    }
                },
                terms: {
                    alterations: {
                        init: null
                    },
                    examples: {
                        init: null
                    },
                    externals: {
                        init: null
                    },
                    metas: {
                        init: []
                    },
                    notes: {
                        init: []
                    },
                    shared: {
                        init: null
                    },
                    tags: {
                        init: []
                    },
                    whens: {
                        init: null
                    }
                },
                rules: {
                    custom: {
                        method (e, t) {
                            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                name: "custom",
                                args: {
                                    method: e,
                                    description: t
                                }
                            });
                        },
                        validate (e, t, { method: r }) {
                            try {
                                return r(e, t);
                            } catch (e) {
                                return t.error("any.custom", {
                                    error: e
                                });
                            }
                        },
                        args: [
                            "method",
                            "description"
                        ],
                        multi: !0
                    },
                    messages: {
                        method (e) {
                            return this.prefs({
                                messages: e
                            });
                        }
                    },
                    shared: {
                        method (e) {
                            s(a.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                            const t = this.clone();
                            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                        }
                    },
                    warning: {
                        method (e, t) {
                            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                name: "warning",
                                args: {
                                    code: e,
                                    local: t
                                },
                                warn: !0
                            });
                        },
                        validate: (e, t, { code: r, local: s })=>t.error(r, s),
                        args: [
                            "code",
                            "local"
                        ],
                        multi: !0
                    }
                },
                modifiers: {
                    keep (e, t = !0) {
                        e.keep = t;
                    },
                    message (e, t) {
                        e.message = i.compile(t);
                    },
                    warn (e, t = !0) {
                        e.warn = t;
                    }
                },
                manifest: {
                    build (e, t) {
                        for(const r in t){
                            const s = t[r];
                            if ([
                                "examples",
                                "externals",
                                "metas",
                                "notes",
                                "tags"
                            ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                            else {
                                if ("alterations" === r) {
                                    const t = {};
                                    for (const { target: e, adjuster: r } of s)t[e] = r;
                                    e = e.alter(t);
                                    continue;
                                }
                                if ("whens" !== r) {
                                    if ("shared" === r) for (const t of s)e = e.shared(t);
                                } else for (const t of s){
                                    const { ref: r, is: s, not: n, then: a, otherwise: i, concat: o } = t;
                                    e = o ? e.concat(o) : r ? e.when(r, {
                                        is: s,
                                        not: n,
                                        then: a,
                                        otherwise: i,
                                        switch: t.switch,
                                        break: t.break
                                    }) : e.when(s, {
                                        then: a,
                                        otherwise: i,
                                        break: t.break
                                    });
                                }
                            }
                        }
                        return e;
                    }
                },
                messages: {
                    "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                    "any.default": "{{#label}} threw an error when running default method",
                    "any.failover": "{{#label}} threw an error when running failover method",
                    "any.invalid": "{{#label}} contains an invalid value",
                    "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                    "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
                    "any.required": "{{#label}} is required",
                    "any.unknown": "{{#label}} is not allowed"
                }
            });
        },
        2591 (e, t, r) {
            "use strict";
            const s = r(914), n = r(1728), a = r(9441), i = r(680), o = r(9415), l = r(3541), c = {};
            e.exports = i.extend({
                type: "array",
                flags: {
                    single: {
                        default: !1
                    },
                    sparse: {
                        default: !1
                    }
                },
                terms: {
                    items: {
                        init: [],
                        manifest: "schema"
                    },
                    ordered: {
                        init: [],
                        manifest: "schema"
                    },
                    _exclusions: {
                        init: []
                    },
                    _inclusions: {
                        init: []
                    },
                    _requireds: {
                        init: []
                    }
                },
                coerce: {
                    from: "object",
                    method (e, { schema: t, state: r, prefs: s }) {
                        if (!Array.isArray(e)) return;
                        const n = t.$_getRule("sort");
                        return n ? c.sort(t, e, n.args.options, r, s) : void 0;
                    }
                },
                validate (e, { schema: t, error: r }) {
                    if (!Array.isArray(e)) {
                        if (t._flags.single) {
                            const t = [
                                e
                            ];
                            return t[o.symbols.arraySingle] = !0, {
                                value: t
                            };
                        }
                        return {
                            errors: r("array.base")
                        };
                    }
                    if (t.$_getRule("items") || t.$_terms.externals) return {
                        value: e.slice()
                    };
                },
                rules: {
                    has: {
                        method (e) {
                            e = this.$_compile(e, {
                                appendPath: !0
                            });
                            const t = this.$_addRule({
                                name: "has",
                                args: {
                                    schema: e
                                }
                            });
                            return t.$_mutateRegister(e), t;
                        },
                        validate (e, { state: t, prefs: r, error: s }, { schema: n }) {
                            const a = [
                                e,
                                ...t.ancestors
                            ];
                            for(let s = 0; s < e.length; ++s){
                                const i = t.localize([
                                    ...t.path,
                                    s
                                ], a, n);
                                if (n.$_match(e[s], i, r)) return e;
                            }
                            const i = n._flags.label;
                            return i ? s("array.hasKnown", {
                                patternLabel: i
                            }) : s("array.hasUnknown", null);
                        },
                        multi: !0
                    },
                    items: {
                        method (...e) {
                            o.verifyFlat(e, "items");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = o.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                t.$_terms.items.push(s);
                            }
                            return t.$_mutateRebuild();
                        },
                        validate (e, { schema: t, error: r, state: s, prefs: n, errorsArray: a }) {
                            const i = t.$_terms._requireds.slice(), l = t.$_terms.ordered.slice(), u = [
                                ...t.$_terms._inclusions,
                                ...i
                            ], f = !e[o.symbols.arraySingle];
                            delete e[o.symbols.arraySingle];
                            const m = a();
                            let h = e.length;
                            for(let a = 0; a < h; ++a){
                                const o = e[a];
                                let p = !1, d = !1;
                                const g = f ? a : new Number(a), y = [
                                    ...s.path,
                                    g
                                ];
                                if (!t._flags.sparse && void 0 === o) {
                                    if (m.push(r("array.sparse", {
                                        key: g,
                                        path: y,
                                        pos: a,
                                        value: void 0
                                    }, s.localize(y))), n.abortEarly) return m;
                                    l.shift();
                                    continue;
                                }
                                const b = [
                                    e,
                                    ...s.ancestors
                                ];
                                for (const e of t.$_terms._exclusions)if (e.$_match(o, s.localize(y, b, e), n, {
                                    presence: "ignore"
                                })) {
                                    if (m.push(r("array.excludes", {
                                        pos: a,
                                        value: o
                                    }, s.localize(y))), n.abortEarly) return m;
                                    p = !0, l.shift();
                                    break;
                                }
                                if (p) continue;
                                if (t.$_terms.ordered.length) {
                                    if (l.length) {
                                        const i = l.shift(), u = i.$_validate(o, s.localize(y, b, i), n);
                                        if (u.errors) {
                                            if (m.push(...u.errors), n.abortEarly) return m;
                                        } else if ("strip" === i._flags.result) c.fastSplice(e, a), --a, --h;
                                        else {
                                            if (!t._flags.sparse && void 0 === u.value) {
                                                if (m.push(r("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: a,
                                                    value: void 0
                                                }, s.localize(y))), n.abortEarly) return m;
                                                continue;
                                            }
                                            e[a] = u.value;
                                        }
                                        continue;
                                    }
                                    if (!t.$_terms.items.length) {
                                        if (m.push(r("array.orderedLength", {
                                            pos: a,
                                            limit: t.$_terms.ordered.length
                                        })), n.abortEarly) return m;
                                        break;
                                    }
                                }
                                const _ = [];
                                let v = i.length;
                                for(let l = 0; l < v; ++l){
                                    const u = s.localize(y, b, i[l]);
                                    u.snapshot();
                                    const f = i[l].$_validate(o, u, n);
                                    if (_[l] = f, !f.errors) {
                                        if (u.commit(), e[a] = f.value, d = !0, c.fastSplice(i, l), --l, --v, !t._flags.sparse && void 0 === f.value && (m.push(r("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: a,
                                            value: void 0
                                        }, s.localize(y))), n.abortEarly)) return m;
                                        break;
                                    }
                                    u.restore();
                                }
                                if (d) continue;
                                const w = n.stripUnknown && !!n.stripUnknown.arrays || !1;
                                v = u.length;
                                for (const l of u){
                                    let u;
                                    const f = i.indexOf(l);
                                    if (-1 !== f) u = _[f];
                                    else {
                                        const i = s.localize(y, b, l);
                                        if (i.snapshot(), u = l.$_validate(o, i, n), !u.errors) {
                                            i.commit(), "strip" === l._flags.result ? (c.fastSplice(e, a), --a, --h) : t._flags.sparse || void 0 !== u.value ? e[a] = u.value : (m.push(r("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: a,
                                                value: void 0
                                            }, s.localize(y))), p = !0), d = !0;
                                            break;
                                        }
                                        i.restore();
                                    }
                                    if (1 === v) {
                                        if (w) {
                                            c.fastSplice(e, a), --a, --h, d = !0;
                                            break;
                                        }
                                        if (m.push(...u.errors), n.abortEarly) return m;
                                        p = !0;
                                        break;
                                    }
                                }
                                if (!p && (t.$_terms._inclusions.length || t.$_terms._requireds.length) && !d) {
                                    if (w) {
                                        c.fastSplice(e, a), --a, --h;
                                        continue;
                                    }
                                    if (m.push(r("array.includes", {
                                        pos: a,
                                        value: o
                                    }, s.localize(y))), n.abortEarly) return m;
                                }
                            }
                            return i.length && c.fillMissedErrors(t, m, i, e, s, n), l.length && (c.fillOrderedErrors(t, m, l, e, s, n), m.length || c.fillDefault(l, e, s, n)), m.length ? m : e;
                        },
                        priority: !0,
                        manifest: !1
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>o.compare(e.length, r, n) ? e : t.error("array." + s, {
                                limit: a.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: o.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    ordered: {
                        method (...e) {
                            o.verifyFlat(e, "ordered");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = o.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                c.validateSingle(s, t), t.$_mutateRegister(s), t.$_terms.ordered.push(s);
                            }
                            return t.$_mutateRebuild();
                        }
                    },
                    single: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                        }
                    },
                    sort: {
                        method (e = {}) {
                            o.assertOptions(e, [
                                "by",
                                "order"
                            ]);
                            const t = {
                                order: e.order || "ascending"
                            };
                            return e.by && (t.by = l.ref(e.by, {
                                ancestor: 0
                            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                name: "sort",
                                args: {
                                    options: t
                                }
                            });
                        },
                        validate (e, { error: t, state: r, prefs: s, schema: n }, { options: a }) {
                            const { value: i, errors: o } = c.sort(n, e, a, r, s);
                            if (o) return o;
                            for(let r = 0; r < e.length; ++r)if (e[r] !== i[r]) return t("array.sort", {
                                order: a.order,
                                by: a.by ? a.by.key : "value"
                            });
                            return e;
                        },
                        convert: !0
                    },
                    sparse: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                clone: !1
                            });
                        }
                    },
                    unique: {
                        method (e, t = {}) {
                            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), o.assertOptions(t, [
                                "ignoreUndefined",
                                "separator"
                            ]);
                            const r = {
                                name: "unique",
                                args: {
                                    options: t,
                                    comparator: e
                                }
                            };
                            if (e) {
                                if ("string" == typeof e) {
                                    const s = o.default(t.separator, ".");
                                    r.path = s ? e.split(s) : [
                                        e
                                    ];
                                } else r.comparator = e;
                            }
                            return this.$_addRule(r);
                        },
                        validate (e, { state: t, error: r, schema: i }, { comparator: o, options: l }, { comparator: c, path: u }) {
                            const f = {
                                string: Object.create(null),
                                number: Object.create(null),
                                undefined: Object.create(null),
                                boolean: Object.create(null),
                                bigint: Object.create(null),
                                object: new Map,
                                function: new Map,
                                custom: new Map
                            }, m = c || n, h = l.ignoreUndefined;
                            for(let n = 0; n < e.length; ++n){
                                const i = u ? a(e[n], u) : e[n], l = c ? f.custom : f[typeof i];
                                if (s(l, "Failed to find unique map container for type", typeof i), l instanceof Map) {
                                    const s = l.entries();
                                    let a;
                                    for(; !(a = s.next()).done;)if (m(a.value[0], i)) {
                                        const s = t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]), i = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: a.value[1],
                                            dupeValue: e[a.value[1]]
                                        };
                                        return u && (i.path = o), r("array.unique", i, s);
                                    }
                                    l.set(i, n);
                                } else {
                                    if ((!h || void 0 !== i) && void 0 !== l[i]) {
                                        const s = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: l[i],
                                            dupeValue: e[l[i]]
                                        };
                                        return u && (s.path = o), r("array.unique", s, t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]));
                                    }
                                    l[i] = n;
                                }
                            }
                            return e;
                        },
                        args: [
                            "comparator",
                            "options"
                        ],
                        multi: !0
                    }
                },
                cast: {
                    set: {
                        from: Array.isArray,
                        to: (e, t)=>new Set(e)
                    }
                },
                rebuild (e) {
                    e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                    for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                    for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                },
                manifest: {
                    build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                },
                messages: {
                    "array.base": "{{#label}} must be an array",
                    "array.excludes": "{{#label}} contains an excluded value",
                    "array.hasKnown": "{{#label}} does not contain at least one required match for type {:#patternLabel}",
                    "array.hasUnknown": "{{#label}} does not contain at least one required match",
                    "array.includes": "{{#label}} does not match any of the allowed types",
                    "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                    "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                    "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                    "array.length": "{{#label}} must contain {{#limit}} items",
                    "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                    "array.min": "{{#label}} must contain at least {{#limit}} items",
                    "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                    "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                    "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                    "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                    "array.sparse": "{{#label}} must not be a sparse array item",
                    "array.unique": "{{#label}} contains a duplicate value"
                }
            }), c.fillMissedErrors = function(e, t, r, s, n, a) {
                const i = [];
                let o = 0;
                for (const e of r){
                    const t = e._flags.label;
                    t ? i.push(t) : ++o;
                }
                i.length ? o ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                    knownMisses: i,
                    unknownMisses: o
                }, n, a)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                    knownMisses: i
                }, n, a)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                    unknownMisses: o
                }, n, a));
            }, c.fillOrderedErrors = function(e, t, r, s, n, a) {
                const i = [];
                for (const e of r)"required" === e._flags.presence && i.push(e);
                i.length && c.fillMissedErrors(e, t, i, s, n, a);
            }, c.fillDefault = function(e, t, r, s) {
                const n = [];
                let a = !0;
                for(let i = e.length - 1; i >= 0; --i){
                    const o = e[i], l = [
                        t,
                        ...r.ancestors
                    ], c = o.$_validate(void 0, r.localize(r.path, l, o), s).value;
                    if (a) {
                        if (void 0 === c) continue;
                        a = !1;
                    }
                    n.unshift(c);
                }
                n.length && t.push(...n);
            }, c.fastSplice = function(e, t) {
                let r = t;
                for(; r < e.length;)e[r++] = e[r];
                --e.length;
            }, c.validateSingle = function(e, t) {
                ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                    clone: !1
                }));
            }, c.sort = function(e, t, r, s, n) {
                const a = "ascending" === r.order ? 1 : -1, i = -1 * a, o = a, l = (l, u)=>{
                    let f = c.compare(l, u, i, o);
                    if (null !== f) return f;
                    if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, i, o), null !== f) return f;
                    const m = typeof l;
                    if (m !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                    if ("number" !== m && "string" !== m) throw e.$_createError("array.sort.unsupported", t, {
                        type: m
                    }, s, n);
                    return "number" === m ? (l - u) * a : l < u ? i : o;
                };
                try {
                    return {
                        value: t.slice().sort(l)
                    };
                } catch (e) {
                    return {
                        errors: e
                    };
                }
            }, c.compare = function(e, t, r, s) {
                return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
            };
        },
        6186 (e, t, r) {
            "use strict";
            const s = r(914), n = r(680), a = r(9415), i = r(6220), o = {
                isBool: function(e) {
                    return "boolean" == typeof e;
                }
            };
            e.exports = n.extend({
                type: "boolean",
                flags: {
                    sensitive: {
                        default: !1
                    }
                },
                terms: {
                    falsy: {
                        init: null,
                        manifest: "values"
                    },
                    truthy: {
                        init: null,
                        manifest: "values"
                    }
                },
                coerce (e, { schema: t }) {
                    if ("boolean" != typeof e) {
                        if ("string" == typeof e) {
                            const r = t._flags.sensitive ? e : e.toLowerCase();
                            e = "true" === r || "false" !== r && e;
                        }
                        return "boolean" != typeof e && (e = t.$_terms.truthy && t.$_terms.truthy.has(e, null, null, !t._flags.sensitive) || (!t.$_terms.falsy || !t.$_terms.falsy.has(e, null, null, !t._flags.sensitive)) && e), {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("boolean" != typeof e) return {
                        value: e,
                        errors: t("boolean.base")
                    };
                },
                rules: {
                    truthy: {
                        method (...e) {
                            a.verifyFlat(e, "truthy");
                            const t = this.clone();
                            t.$_terms.truthy = t.$_terms.truthy || new i;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call truthy with undefined"), t.$_terms.truthy.add(n);
                            }
                            return t;
                        }
                    },
                    falsy: {
                        method (...e) {
                            a.verifyFlat(e, "falsy");
                            const t = this.clone();
                            t.$_terms.falsy = t.$_terms.falsy || new i;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call falsy with undefined"), t.$_terms.falsy.add(n);
                            }
                            return t;
                        }
                    },
                    sensitive: {
                        method (e = !0) {
                            return this.$_setFlag("sensitive", e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isBool,
                        to: (e, t)=>e ? 1 : 0
                    },
                    string: {
                        from: o.isBool,
                        to: (e, t)=>e ? "true" : "false"
                    }
                },
                manifest: {
                    build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                },
                messages: {
                    "boolean.base": "{{#label}} must be a boolean"
                }
            });
        },
        2588 (e, t, r) {
            "use strict";
            const s = r(914), n = r(680), a = r(9415), i = r(1532), o = {
                isDate: function(e) {
                    return e instanceof Date;
                }
            };
            e.exports = n.extend({
                type: "date",
                coerce: {
                    from: [
                        "number",
                        "string"
                    ],
                    method: (e, { schema: t })=>({
                            value: o.parse(e, t._flags.format) || e
                        })
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e instanceof Date && !isNaN(e.getTime())) return;
                    const n = t._flags.format;
                    return s.convert && n && "string" == typeof e ? {
                        value: e,
                        errors: r("date.format", {
                            format: n
                        })
                    } : {
                        value: e,
                        errors: r("date.base")
                    };
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, { date: r }, { name: s, operator: n, args: i }) {
                            const o = "now" === r ? Date.now() : r.getTime();
                            return a.compare(e.getTime(), o, n) ? e : t.error("date." + s, {
                                limit: i.date,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "date",
                                ref: !0,
                                normalize: (e)=>"now" === e ? e : o.parse(e),
                                assert: (e)=>null !== e,
                                message: "must have a valid date format"
                            }
                        ]
                    },
                    format: {
                        method (e) {
                            return s([
                                "iso",
                                "javascript",
                                "unix"
                            ].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                        }
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    iso: {
                        method () {
                            return this.format("iso");
                        }
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    timestamp: {
                        method (e = "javascript") {
                            return s([
                                "javascript",
                                "unix"
                            ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: o.isDate,
                        to: (e, t)=>e.getTime()
                    },
                    string: {
                        from: o.isDate,
                        to: (e, { prefs: t })=>i.date(e, t)
                    }
                },
                messages: {
                    "date.base": "{{#label}} must be a valid date",
                    "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                    "date.greater": "{{#label}} must be greater than {{:#limit}}",
                    "date.less": "{{#label}} must be less than {{:#limit}}",
                    "date.max": "{{#label}} must be less than or equal to {{:#limit}}",
                    "date.min": "{{#label}} must be greater than or equal to {{:#limit}}",
                    "date.format.iso": "ISO 8601 date",
                    "date.format.javascript": "timestamp or number of milliseconds",
                    "date.format.unix": "timestamp or number of seconds"
                }
            }), o.parse = function(e, t) {
                if (e instanceof Date) return e;
                if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                if (/^\s*$/.test(e)) return null;
                if ("iso" === t) return a.isIsoDate(e) ? o.date(e.toString()) : null;
                const r = e;
                if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                    if ("javascript" === t) return o.date(1 * e);
                    if ("unix" === t) return o.date(1e3 * e);
                    if ("string" == typeof r) return null;
                }
                return o.date(e);
            }, o.date = function(e) {
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t;
            };
        },
        4840 (e, t, r) {
            "use strict";
            const s = r(914), n = r(2888);
            e.exports = n.extend({
                type: "function",
                properties: {
                    typeof: "function"
                },
                rules: {
                    arity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "arity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length === r ? e : t.error("function.arity", {
                                n: r
                            })
                    },
                    class: {
                        method () {
                            return this.$_addRule("class");
                        },
                        validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                value: e
                            })
                    },
                    minArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                name: "minArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length >= r ? e : t.error("function.minArity", {
                                n: r
                            })
                    },
                    maxArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "maxArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length <= r ? e : t.error("function.maxArity", {
                                n: r
                            })
                    }
                },
                messages: {
                    "function.arity": "{{#label}} must have an arity of {{#n}}",
                    "function.class": "{{#label}} must be a class",
                    "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                    "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                }
            });
        },
        2888 (e, t, r) {
            "use strict";
            const s = r(389), n = r(914), a = r(6179), i = r(7180), o = r(680), l = r(9415), c = r(3541), u = r(8013), f = r(8529), m = r(1532), h = {
                renameDefaults: {
                    alias: !1,
                    multiple: !1,
                    override: !1
                }
            };
            e.exports = o.extend({
                type: "_keys",
                properties: {
                    typeof: "object"
                },
                flags: {
                    unknown: {
                        default: void 0
                    }
                },
                terms: {
                    dependencies: {
                        init: null
                    },
                    keys: {
                        init: null,
                        manifest: {
                            mapped: {
                                from: "schema",
                                to: "key"
                            }
                        }
                    },
                    patterns: {
                        init: null
                    },
                    renames: {
                        init: null
                    }
                },
                args: (e, t)=>e.keys(t),
                validate (e, { schema: t, error: r, state: s, prefs: n }) {
                    if (!e || typeof e !== t.$_property("typeof") || Array.isArray(e)) return {
                        value: e,
                        errors: r("object.base", {
                            type: t.$_property("typeof")
                        })
                    };
                    if (!(t.$_terms.renames || t.$_terms.dependencies || t.$_terms.keys || t.$_terms.patterns || t.$_terms.externals)) return;
                    e = h.clone(e, n);
                    const a = [];
                    if (t.$_terms.renames && !h.rename(t, e, s, n, a)) return {
                        value: e,
                        errors: a
                    };
                    if (!t.$_terms.keys && !t.$_terms.patterns && !t.$_terms.dependencies) return {
                        value: e,
                        errors: a
                    };
                    const i = new Set(Object.keys(e));
                    if (t.$_terms.keys) {
                        const r = [
                            e,
                            ...s.ancestors
                        ];
                        for (const o of t.$_terms.keys){
                            const t = o.key, l = e[t];
                            i.delete(t);
                            const c = s.localize([
                                ...s.path,
                                t
                            ], r, o), u = o.schema.$_validate(l, c, n);
                            if (u.errors) {
                                if (n.abortEarly) return {
                                    value: e,
                                    errors: u.errors
                                };
                                void 0 !== u.value && (e[t] = u.value), a.push(...u.errors);
                            } else "strip" === o.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[t] : void 0 !== u.value && (e[t] = u.value);
                        }
                    }
                    if (i.size || t._flags._hasPatternMatch) {
                        const r = h.unknown(t, e, i, a, s, n);
                        if (r) return r;
                    }
                    if (t.$_terms.dependencies) for (const r of t.$_terms.dependencies){
                        if (null !== r.key && !1 === h.isPresent(r.options)(r.key.resolve(e, s, n, null, {
                            shadow: !1
                        }))) continue;
                        const i = h.dependencies[r.rel](t, r, e, s, n);
                        if (i) {
                            const r = t.$_createError(i.code, e, i.context, s, n);
                            if (n.abortEarly) return {
                                value: e,
                                errors: r
                            };
                            a.push(r);
                        }
                    }
                    return {
                        value: e,
                        errors: a
                    };
                },
                rules: {
                    and: {
                        method (...e) {
                            return l.verifyFlat(e, "and"), h.dependency(this, "and", null, e);
                        }
                    },
                    append: {
                        method (e) {
                            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                        }
                    },
                    assert: {
                        method (e, t, r) {
                            m.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const s = this.$_addRule({
                                name: "assert",
                                args: {
                                    subject: e,
                                    schema: t,
                                    message: r
                                }
                            });
                            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                        },
                        validate (e, { error: t, prefs: r, state: s }, { subject: n, schema: a, message: i }) {
                            const o = n.resolve(e, s, r), l = f.isRef(n) ? n.absolute(s) : [];
                            return a.$_match(o, s.localize(l, [
                                e,
                                ...s.ancestors
                            ], a), r) ? e : t("object.assert", {
                                subject: n,
                                message: i
                            });
                        },
                        args: [
                            "subject",
                            "schema",
                            "message"
                        ],
                        multi: !0
                    },
                    instance: {
                        method (e, t) {
                            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                name: "instance",
                                args: {
                                    constructor: e,
                                    name: t
                                }
                            });
                        },
                        validate: (e, t, { constructor: r, name: s })=>e instanceof r ? e : t.error("object.instance", {
                                type: s,
                                value: e
                            }),
                        args: [
                            "constructor",
                            "name"
                        ]
                    },
                    keys: {
                        method (e) {
                            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                            const t = this.clone();
                            if (e) {
                                if (Object.keys(e).length) {
                                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new h.Keys;
                                    for(const r in e)l.tryWithPath(()=>t.$_terms.keys.push({
                                            key: r,
                                            schema: this.$_compile(e[r])
                                        }), r);
                                } else t.$_terms.keys = new h.Keys;
                            } else t.$_terms.keys = null;
                            return t.$_mutateRebuild();
                        }
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>l.compare(Object.keys(e).length, r, n) ? e : t.error("object." + s, {
                                limit: a.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: l.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    nand: {
                        method (...e) {
                            return l.verifyFlat(e, "nand"), h.dependency(this, "nand", null, e);
                        }
                    },
                    or: {
                        method (...e) {
                            return l.verifyFlat(e, "or"), h.dependency(this, "or", null, e);
                        }
                    },
                    oxor: {
                        method (...e) {
                            return h.dependency(this, "oxor", null, e);
                        }
                    },
                    pattern: {
                        method (e, t, r = {}) {
                            const s = e instanceof RegExp;
                            s || (e = this.$_compile(e, {
                                appendPath: !0
                            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                "fallthrough",
                                "matches"
                            ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const a = this.clone();
                            a.$_terms.patterns = a.$_terms.patterns || [];
                            const i = {
                                [s ? "regex" : "schema"]: e,
                                rule: t
                            };
                            return r.matches && (i.matches = this.$_compile(r.matches), "array" !== i.matches.type && (i.matches = i.matches.$_root.array().items(i.matches)), a.$_mutateRegister(i.matches), a.$_setFlag("_hasPatternMatch", !0, {
                                clone: !1
                            })), r.fallthrough && (i.fallthrough = !0), a.$_terms.patterns.push(i), a.$_mutateRegister(t), a;
                        }
                    },
                    ref: {
                        method () {
                            return this.$_addRule("ref");
                        },
                        validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                value: e
                            })
                    },
                    regex: {
                        method () {
                            return this.$_addRule("regex");
                        },
                        validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                value: e
                            })
                    },
                    rename: {
                        method (e, t, r = {}) {
                            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof m, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                "alias",
                                "ignoreUndefined",
                                "override",
                                "multiple"
                            ]);
                            const a = this.clone();
                            a.$_terms.renames = a.$_terms.renames || [];
                            for (const t of a.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                            return t instanceof m && a.$_mutateRegister(t), a.$_terms.renames.push({
                                from: e,
                                to: t,
                                options: s(h.renameDefaults, r)
                            }), a;
                        }
                    },
                    schema: {
                        method (e = "any") {
                            return this.$_addRule({
                                name: "schema",
                                args: {
                                    type: e
                                }
                            });
                        },
                        validate: (e, t, { type: r })=>!l.isSchema(e) || "any" !== r && e.type !== r ? t.error("object.schema", {
                                type: r
                            }) : e
                    },
                    unknown: {
                        method (e) {
                            return this.$_setFlag("unknown", !1 !== e);
                        }
                    },
                    with: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "with", e, t, r);
                        }
                    },
                    without: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "without", e, t, r);
                        }
                    },
                    xor: {
                        method (...e) {
                            return l.verifyFlat(e, "xor"), h.dependency(this, "xor", null, e);
                        }
                    }
                },
                overrides: {
                    default (e, t) {
                        return void 0 === e && (e = l.symbols.deepDefault), this.$_parent("default", e, t);
                    }
                },
                rebuild (e) {
                    if (e.$_terms.keys) {
                        const t = new i.Sorter;
                        for (const r of e.$_terms.keys)l.tryWithPath(()=>t.add(r, {
                                after: r.schema.$_rootReferences(),
                                group: r.key
                            }), r.key);
                        e.$_terms.keys = new h.Keys(...t.nodes);
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: a } of t.dependencies)e = h.dependency(e, r, s, n, a);
                        if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: a, matches: i } of t.patterns)e = e.pattern(r || s, n, {
                            fallthrough: a,
                            matches: i
                        });
                        if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                        return e;
                    }
                },
                messages: {
                    "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                    "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                    "object.base": "{{#label}} must be of type {{#type}}",
                    "object.instance": "{{#label}} must be an instance of {{:#type}}",
                    "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                    "object.nand": "{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}",
                    "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                    "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                    "object.refType": "{{#label}} must be a Joi reference",
                    "object.regex": "{{#label}} must be a RegExp object",
                    "object.rename.multiple": "{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}",
                    "object.rename.override": "{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists",
                    "object.rename.proto": "{{#label}} cannot rename {{:#from}} because target {{:#to}} is a reserved key",
                    "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                    "object.unknown": "{{#label}} is not allowed",
                    "object.with": "{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}",
                    "object.without": "{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}",
                    "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                }
            }), h.clone = function(e, t) {
                if ("object" == typeof e) {
                    if (t.nonEnumerables) return a(e, {
                        shallow: !0
                    });
                    const r = Object.getPrototypeOf(e), s = Object.create(r);
                    return Object.assign(s, e), Object.getPrototypeOf(s) !== r && Object.setPrototypeOf(s, r), s;
                }
                const r = function(...t) {
                    return e.apply(this, t);
                };
                return r.prototype = a(e.prototype), Object.defineProperty(r, "name", {
                    value: e.name,
                    writable: !1
                }), Object.defineProperty(r, "length", {
                    value: e.length,
                    writable: !1
                }), Object.assign(r, e), r;
            }, h.dependency = function(e, t, r, s, a) {
                n(null === r || "string" == typeof r, t, "key must be a strings"), a || (a = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(a, [
                    "separator",
                    "isPresent"
                ]), s = [].concat(s);
                const i = l.default(a.separator, "."), o = [];
                for (const e of s)n("string" == typeof e, t, "peers must be strings"), o.push(c.ref(e, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                null !== r && (r = c.ref(r, {
                    separator: i,
                    ancestor: 0,
                    prefix: !1
                }));
                const u = e.clone();
                return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new h.Dependency(t, r, o, s, a)), u;
            }, h.dependencies = {
                and (e, t, r, s, n) {
                    const a = [], i = [], o = t.peers.length, l = h.isPresent(t.options);
                    for (const e of t.peers)!1 === l(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) ? a.push(e.key) : i.push(e.key);
                    if (a.length !== o && i.length !== o) return {
                        code: "object.and",
                        context: {
                            present: i,
                            presentWithLabels: h.keysToLabels(e, i),
                            missing: a,
                            missingWithLabels: h.keysToLabels(e, a)
                        }
                    };
                },
                nand (e, t, r, s, n) {
                    const a = [], i = h.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (a.length !== t.peers.length) return;
                    const o = t.paths[0], l = t.paths.slice(1);
                    return {
                        code: "object.nand",
                        context: {
                            main: o,
                            mainWithLabel: h.keysToLabels(e, o),
                            peers: l,
                            peersWithLabels: h.keysToLabels(e, l)
                        }
                    };
                },
                or (e, t, r, s, n) {
                    const a = h.isPresent(t.options);
                    for (const e of t.peers)if (a(e.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return;
                    return {
                        code: "object.missing",
                        context: {
                            peers: t.paths,
                            peersWithLabels: h.keysToLabels(e, t.paths)
                        }
                    };
                },
                oxor (e, t, r, s, n) {
                    const a = [], i = h.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (!a.length || 1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return o.present = a, o.presentWithLabels = h.keysToLabels(e, a), {
                        code: "object.oxor",
                        context: o
                    };
                },
                with (e, t, r, s, n) {
                    const a = h.isPresent(t.options);
                    for (const i of t.peers)if (!1 === a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.with",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: h.keysToLabels(e, i.key)
                        }
                    };
                },
                without (e, t, r, s, n) {
                    const a = h.isPresent(t.options);
                    for (const i of t.peers)if (a(i.resolve(r, s, n, null, {
                        shadow: !1
                    }))) return {
                        code: "object.without",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: i.key,
                            peerWithLabel: h.keysToLabels(e, i.key)
                        }
                    };
                },
                xor (e, t, r, s, n) {
                    const a = [], i = h.isPresent(t.options);
                    for (const e of t.peers)i(e.resolve(r, s, n, null, {
                        shadow: !1
                    })) && a.push(e.key);
                    if (1 === a.length) return;
                    const o = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return 0 === a.length ? {
                        code: "object.missing",
                        context: o
                    } : (o.present = a, o.presentWithLabels = h.keysToLabels(e, a), {
                        code: "object.xor",
                        context: o
                    });
                }
            }, h.keysToLabels = function(e, t) {
                return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
            }, h.isPresent = function(e) {
                return "function" == typeof e.isPresent ? e.isPresent : (e)=>void 0 !== e;
            }, h.rename = function(e, t, r, s, n) {
                const a = Object.create(null);
                for (const i of e.$_terms.renames){
                    const o = [], l = "string" != typeof i.from;
                    if (l) for(const e in t){
                        if (void 0 === t[e] && i.options.ignoreUndefined) continue;
                        if (e === i.to) continue;
                        const r = i.from.exec(e);
                        r && o.push({
                            from: e,
                            to: i.to,
                            match: r
                        });
                    }
                    else !Object.prototype.hasOwnProperty.call(t, i.from) || void 0 === t[i.from] && i.options.ignoreUndefined || o.push(i);
                    for (const c of o){
                        const o = c.from;
                        let u = c.to;
                        if (u instanceof m && (u = u.render(t, r, s, c.match)), o !== u) {
                            if (!i.options.multiple && a[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if (Object.prototype.hasOwnProperty.call(t, u) && !i.options.override && !a[u] && (n.push(e.$_createError("object.rename.override", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if ("__proto__" !== u) void 0 === t[o] ? delete t[u] : t[u] = t[o], a[u] = !0, i.options.alias || delete t[o];
                            else if (n.push(e.$_createError("object.rename.proto", t, {
                                from: o,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly) return !1;
                        }
                    }
                }
                return !0;
            }, h.unknown = function(e, t, r, s, n, a) {
                if (e.$_terms.patterns) {
                    let i = !1;
                    const o = e.$_terms.patterns.map((e)=>{
                        if (e.matches) return i = !0, [];
                    }), l = [
                        t,
                        ...n.ancestors
                    ];
                    for (const i of r){
                        const c = t[i], u = [
                            ...n.path,
                            i
                        ];
                        for(let f = 0; f < e.$_terms.patterns.length; ++f){
                            const m = e.$_terms.patterns[f];
                            if (m.regex) {
                                const e = m.regex.test(i);
                                if (n.mainstay.tracer.debug(n, "rule", `pattern.${f}`, e ? "pass" : "error"), !e) continue;
                            } else if (!m.schema.$_match(i, n.nest(m.schema, `pattern.${f}`), a)) continue;
                            r.delete(i);
                            const h = n.localize(u, l, {
                                schema: m.rule,
                                key: i
                            }), p = m.rule.$_validate(c, h, a);
                            if (p.errors) {
                                if (a.abortEarly) return {
                                    value: t,
                                    errors: p.errors
                                };
                                s.push(...p.errors);
                            }
                            if (m.matches && o[f].push(i), t[i] = p.value, !m.fallthrough) break;
                        }
                    }
                    if (i) for(let r = 0; r < o.length; ++r){
                        const i = o[r];
                        if (!i) continue;
                        const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), m = c.$_validate(i, f, a);
                        if (m.errors) {
                            const r = u.details(m.errors, {
                                override: !1
                            });
                            r.matches = i;
                            const o = e.$_createError("object.pattern.match", t, r, n, a);
                            if (a.abortEarly) return {
                                value: t,
                                errors: o
                            };
                            s.push(o);
                        }
                    }
                }
                if (r.size && (e.$_terms.keys || e.$_terms.patterns)) {
                    if (a.stripUnknown && void 0 === e._flags.unknown || a.skipFunctions) {
                        const e = !(!a.stripUnknown || !0 !== a.stripUnknown && !a.stripUnknown.objects);
                        for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                    }
                    if (!l.default(e._flags.unknown, a.allowUnknown)) for (const i of r){
                        const r = n.localize([
                            ...n.path,
                            i
                        ], []), o = e.$_createError("object.unknown", t[i], {
                            child: i
                        }, r, a, {
                            flags: !1
                        });
                        if (a.abortEarly) return {
                            value: t,
                            errors: o
                        };
                        s.push(o);
                    }
                }
            }, h.Dependency = class {
                constructor(e, t, r, s, n){
                    this.rel = e, this.key = t, this.peers = r, this.paths = s, this.options = n;
                }
                describe() {
                    const e = {
                        rel: this.rel,
                        peers: this.paths
                    };
                    return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                        ...e.options,
                        separator: this.peers[0].separator
                    }), this.options.isPresent && (e.options = {
                        ...e.options,
                        isPresent: this.options.isPresent
                    }), e;
                }
            }, h.Keys = class extends Array {
                concat(e) {
                    const t = this.slice(), r = new Map;
                    for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                    for (const s of e){
                        const e = s.key, n = r.get(e);
                        void 0 !== n ? t[n] = {
                            key: e,
                            schema: t[n].schema.concat(s.schema)
                        } : t.push(s);
                    }
                    return t;
                }
            };
        },
        9556 (e, t, r) {
            "use strict";
            const s = r(914), n = r(680), a = r(9415), i = r(3541), o = r(8013), l = {};
            e.exports = n.extend({
                type: "link",
                properties: {
                    schemaChain: !0
                },
                terms: {
                    link: {
                        init: null,
                        manifest: "single",
                        register: !1
                    }
                },
                args: (e, t)=>e.ref(t),
                validate (e, { schema: t, state: r, prefs: n, error: a }) {
                    s(t.$_terms.link, "Uninitialized link schema");
                    const i = l.generate(t, e, r, n), o = t.$_terms.link[0].ref;
                    try {
                        return i.$_validate(e, r.nest(i, `link:${o.display}:${i.type}`), n);
                    } catch (t) {
                        if (!(t instanceof RangeError)) throw t;
                        return {
                            value: e,
                            errors: a("link.depth")
                        };
                    }
                },
                generate: (e, t, r, s)=>l.generate(e, t, r, s),
                rules: {
                    ref: {
                        method (e) {
                            s(!this.$_terms.link, "Cannot reinitialize schema"), e = i.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                            const t = this.clone();
                            return t.$_terms.link = [
                                {
                                    ref: e
                                }
                            ], t;
                        }
                    },
                    relative: {
                        method (e = !0) {
                            return this.$_setFlag("relative", e);
                        }
                    }
                },
                overrides: {
                    concat (e) {
                        s(this.$_terms.link, "Uninitialized link schema"), s(a.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                        const t = this.clone();
                        return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                            concat: e
                        }), t.$_mutateRebuild();
                    }
                },
                messages: {
                    "link.depth": "{{#label}} exceeds maximum recursion depth supported by the runtime"
                },
                manifest: {
                    build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                }
            }), l.generate = function(e, t, r, s) {
                let n = r.mainstay.links.get(e);
                if (n) return n._generate(t, r, s).schema;
                const a = e.$_terms.link[0].ref, { perspective: i, path: o } = l.perspective(a, r);
                l.assert(i, "which is outside of schema boundaries", a, e, r, s);
                try {
                    n = o.length ? i.$_reach(o) : i;
                } catch (t) {
                    l.assert(!1, "to non-existing schema", a, e, r, s);
                }
                return l.assert("link" !== n.type, "which is another link", a, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
            }, l.perspective = function(e, t) {
                if ("local" === e.type) {
                    for (const { schema: r, key: s } of t.schemas){
                        if ((r._flags.id || s) === e.path[0]) return {
                            perspective: r,
                            path: e.path.slice(1)
                        };
                        if (r.$_terms.shared) {
                            for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                perspective: t,
                                path: e.path.slice(1)
                            };
                        }
                    }
                    return {
                        perspective: null,
                        path: null
                    };
                }
                return "root" === e.ancestor ? {
                    perspective: t.schemas[t.schemas.length - 1].schema,
                    path: e.path
                } : {
                    perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                    path: e.path
                };
            }, l.assert = function(e, t, r, n, a, i) {
                e || s(!1, `"${o.label(n._flags, a, i)}" contains link reference "${r.display}" ${t}`);
            };
        },
        4709 (e, t, r) {
            "use strict";
            const s = r(914), n = r(680), a = r(9415), i = {
                numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/,
                exponentialPartRegex: /[eE][+-]?\d+$/,
                leadingSignAndZerosRegex: /^[+-]?(0*)?/,
                dotRegex: /\./,
                trailingZerosRegex: /0+$/,
                decimalPlaces (e) {
                    const t = e.toString(), r = t.indexOf("."), s = t.indexOf("e");
                    return (r < 0 ? 0 : (s < 0 ? t.length : s) - r - 1) + (s < 0 ? 0 : Math.max(0, -parseInt(t.slice(s + 1))));
                }
            };
            e.exports = n.extend({
                type: "number",
                flags: {
                    unsafe: {
                        default: !1
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, error: r }) {
                        if (!e.match(i.numberRx)) return;
                        e = e.trim();
                        const s = {
                            value: parseFloat(e)
                        };
                        if (0 === s.value && (s.value = 0), !t._flags.unsafe) {
                            if (e.match(/e/i)) {
                                if (i.extractSignificantDigits(e) !== i.extractSignificantDigits(String(s.value))) return s.errors = r("number.unsafe"), s;
                            } else {
                                const t = s.value.toString();
                                if (t.match(/e/i)) return s;
                                if (t !== i.normalizeDecimal(e)) return s.errors = r("number.unsafe"), s;
                            }
                        }
                        return s;
                    }
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e === 1 / 0 || e === -1 / 0) return {
                        value: e,
                        errors: r("number.infinity")
                    };
                    if (!a.isNumber(e)) return {
                        value: e,
                        errors: r("number.base")
                    };
                    const n = {
                        value: e
                    };
                    if (s.convert) {
                        const e = t.$_getRule("precision");
                        if (e) {
                            const t = Math.pow(10, e.args.limit);
                            n.value = Math.round(n.value * t) / t;
                        }
                    }
                    return 0 === n.value && (n.value = 0), !t._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (n.errors = r("number.unsafe")), n;
                },
                rules: {
                    compare: {
                        method: !1,
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: i })=>a.compare(e, r, n) ? e : t.error("number." + s, {
                                limit: i.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: a.isNumber,
                                message: "must be a number"
                            }
                        ]
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    integer: {
                        method () {
                            return this.$_addRule("integer");
                        },
                        validate: (e, t)=>Math.trunc(e) - e === 0 ? e : t.error("number.integer")
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    multiple: {
                        method (e) {
                            const t = "number" == typeof e ? i.decimalPlaces(e) : null, r = Math.pow(10, t);
                            return this.$_addRule({
                                name: "multiple",
                                args: {
                                    base: e,
                                    baseDecimalPlace: t,
                                    pfactor: r
                                }
                            });
                        },
                        validate: (e, t, { base: r, baseDecimalPlace: s, pfactor: n }, a)=>i.decimalPlaces(e) > s ? t.error("number.multiple", {
                                multiple: a.args.base,
                                value: e
                            }) : Math.round(n * e) % Math.round(n * r) === 0 ? e : t.error("number.multiple", {
                                multiple: a.args.base,
                                value: e
                            }),
                        args: [
                            {
                                name: "base",
                                ref: !0,
                                assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                message: "must be a positive number"
                            },
                            "baseDecimalPlace",
                            "pfactor"
                        ],
                        multi: !0
                    },
                    negative: {
                        method () {
                            return this.sign("negative");
                        }
                    },
                    port: {
                        method () {
                            return this.$_addRule("port");
                        },
                        validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
                    },
                    positive: {
                        method () {
                            return this.sign("positive");
                        }
                    },
                    precision: {
                        method (e) {
                            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                name: "precision",
                                args: {
                                    limit: e
                                }
                            });
                        },
                        validate (e, t, { limit: r }) {
                            const s = e.toString().match(i.precisionRx);
                            return Math.max((s[1] ? s[1].length : 0) - (s[2] ? parseInt(s[2], 10) : 0), 0) <= r ? e : t.error("number.precision", {
                                limit: r,
                                value: e
                            });
                        },
                        convert: !0
                    },
                    sign: {
                        method (e) {
                            return s([
                                "negative",
                                "positive"
                            ].includes(e), "Invalid sign", e), this.$_addRule({
                                name: "sign",
                                args: {
                                    sign: e
                                }
                            });
                        },
                        validate: (e, t, { sign: r })=>"negative" === r && e < 0 || "positive" === r && e > 0 ? e : t.error(`number.${r}`)
                    },
                    unsafe: {
                        method (e = !0) {
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                        }
                    }
                },
                cast: {
                    string: {
                        from: (e)=>"number" == typeof e,
                        to: (e, t)=>e.toString()
                    }
                },
                messages: {
                    "number.base": "{{#label}} must be a number",
                    "number.greater": "{{#label}} must be greater than {{#limit}}",
                    "number.infinity": "{{#label}} cannot be infinity",
                    "number.integer": "{{#label}} must be an integer",
                    "number.less": "{{#label}} must be less than {{#limit}}",
                    "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                    "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
                    "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                    "number.negative": "{{#label}} must be a negative number",
                    "number.port": "{{#label}} must be a valid port",
                    "number.positive": "{{#label}} must be a positive number",
                    "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                    "number.unsafe": "{{#label}} must be a safe number"
                }
            }), i.extractSignificantDigits = function(e) {
                return e.replace(i.exponentialPartRegex, "").replace(i.dotRegex, "").replace(i.trailingZerosRegex, "").replace(i.leadingSignAndZerosRegex, "");
            }, i.normalizeDecimal = function(e) {
                return (e = e.replace(/^\+/, "").replace(/\.0*$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([0-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
            };
        },
        7487 (e, t, r) {
            "use strict";
            const s = r(2888);
            e.exports = s.extend({
                type: "object",
                cast: {
                    map: {
                        from: (e)=>e && "object" == typeof e,
                        to: (e, t)=>new Map(Object.entries(e))
                    }
                }
            });
        },
        9033 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6358), a = r(7728), i = r(6991), o = r(4836), l = r(486), c = r(5882), u = r(680), f = r(9415), m = {
                tlds: l instanceof Set && {
                    tlds: {
                        allow: l,
                        deny: null
                    }
                },
                base64Regex: {
                    true: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                    },
                    false: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                    }
                },
                dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                hexRegex: {
                    withPrefix: /^0x[0-9a-f]+$/i,
                    withOptionalPrefix: /^(?:0x)?[0-9a-f]+$/i,
                    withoutPrefix: /^[0-9a-f]+$/i
                },
                ipRegex: i.regex({
                    cidr: "forbidden"
                }).regex,
                isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                guidBrackets: {
                    "{": "}",
                    "[": "]",
                    "(": ")",
                    "": ""
                },
                guidVersions: {
                    uuidv1: "1",
                    uuidv2: "2",
                    uuidv3: "3",
                    uuidv4: "4",
                    uuidv5: "5",
                    uuidv6: "6",
                    uuidv7: "7",
                    uuidv8: "8"
                },
                guidSeparators: new Set([
                    void 0,
                    !0,
                    !1,
                    "-",
                    ":"
                ]),
                normalizationForms: [
                    "NFC",
                    "NFD",
                    "NFKC",
                    "NFKD"
                ]
            };
            e.exports = u.extend({
                type: "string",
                flags: {
                    insensitive: {
                        default: !1
                    },
                    truncate: {
                        default: !1
                    }
                },
                terms: {
                    replacements: {
                        init: null
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, state: r, prefs: s }) {
                        const n = t.$_getRule("normalize");
                        n && (e = e.normalize(n.args.form));
                        const a = t.$_getRule("case");
                        a && (e = "upper" === a.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                        const i = t.$_getRule("trim");
                        if (i && i.args.enabled && (e = e.trim()), t.$_terms.replacements) for (const r of t.$_terms.replacements)e = e.replace(r.pattern, r.replacement);
                        const o = t.$_getRule("hex");
                        if (o && o.args.options.byteAligned && e.length % 2 != 0 && (e = `0${e}`), t.$_getRule("isoDate")) {
                            const t = m.isoDate(e);
                            t && (e = t);
                        }
                        if (t._flags.truncate) {
                            const n = t.$_getRule("max");
                            if (n) {
                                let a = n.args.limit;
                                if (f.isResolvable(a) && (a = a.resolve(e, r, s), !f.limit(a))) return {
                                    value: e,
                                    errors: t.$_createError("any.ref", a, {
                                        ref: n.args.limit,
                                        arg: "limit",
                                        reason: "must be a positive integer"
                                    }, r, s)
                                };
                                e = e.slice(0, a);
                            }
                        }
                        return {
                            value: e
                        };
                    }
                },
                validate (e, { schema: t, error: r }) {
                    if ("string" != typeof e) return {
                        value: e,
                        errors: r("string.base")
                    };
                    if ("" === e) {
                        const s = t.$_getRule("min");
                        if (s && 0 === s.args.limit) return;
                        return {
                            value: e,
                            errors: r("string.empty")
                        };
                    }
                },
                rules: {
                    alphanum: {
                        method () {
                            return this.$_addRule("alphanum");
                        },
                        validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                    },
                    base64: {
                        method (e = {}) {
                            return f.assertOptions(e, [
                                "paddingRequired",
                                "urlSafe"
                            ]), e = {
                                urlSafe: !1,
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), s("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                name: "base64",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>m.base64Regex[r.paddingRequired][r.urlSafe].test(e) ? e : t.error("string.base64")
                    },
                    case: {
                        method (e) {
                            return s([
                                "lower",
                                "upper"
                            ].includes(e), "Invalid case:", e), this.$_addRule({
                                name: "case",
                                args: {
                                    direction: e
                                }
                            });
                        },
                        validate: (e, t, { direction: r })=>"lower" === r && e === e.toLocaleLowerCase() || "upper" === r && e === e.toLocaleUpperCase() ? e : t.error(`string.${r}case`),
                        convert: !0
                    },
                    creditCard: {
                        method () {
                            return this.$_addRule("creditCard");
                        },
                        validate (e, t) {
                            let r = e.length, s = 0, n = 1;
                            for(; r--;){
                                const t = e.charAt(r) * n;
                                s += t - 9 * (t > 9), n ^= 3;
                            }
                            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                        }
                    },
                    dataUri: {
                        method (e = {}) {
                            return f.assertOptions(e, [
                                "paddingRequired"
                            ]), e = {
                                paddingRequired: !0,
                                ...e
                            }, s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                name: "dataUri",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, { options: r }) {
                            const s = e.match(m.dataUriRegex);
                            if (s) {
                                if (!s[2]) return e;
                                if ("base64" !== s[2]) return e;
                                if (m.base64Regex[r.paddingRequired].false.test(s[3])) return e;
                            }
                            return t.error("string.dataUri");
                        }
                    },
                    domain: {
                        method (e) {
                            e && f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const t = m.addressOptions(e);
                            return this.$_addRule({
                                name: "domain",
                                args: {
                                    options: e
                                },
                                address: t
                            });
                        },
                        validate: (e, t, r, { address: s })=>n.isValid(e, s) ? e : t.error("string.domain")
                    },
                    email: {
                        method (e = {}) {
                            f.assertOptions(e, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "ignoreLength",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "multiple",
                                "separator",
                                "tlds"
                            ]), s(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                            const t = m.addressOptions(e), r = e.multiple ? new RegExp(`(?:(?<!\\s)\\s+)?[${e.separator ? o(e.separator) : ","}]\\s*`) : void 0;
                            return this.$_addRule({
                                name: "email",
                                args: {
                                    options: e
                                },
                                regex: r,
                                address: t
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, address: n }) {
                            const i = r.multiple ? e.split(s) : [
                                e
                            ], o = [];
                            for (const e of i)a.isValid(e, n) || o.push(e);
                            return o.length ? t.error("string.email", {
                                value: e,
                                invalids: o
                            }) : e;
                        }
                    },
                    guid: {
                        alias: "uuid",
                        method (e = {}) {
                            f.assertOptions(e, [
                                "version",
                                "separator"
                            ]);
                            let t = "";
                            if (e.version) {
                                const r = [].concat(e.version);
                                s(r.length >= 1, "version must have at least 1 valid version specified");
                                const n = new Set;
                                for(let e = 0; e < r.length; ++e){
                                    const a = r[e];
                                    s("string" == typeof a, "version at position " + e + " must be a string");
                                    const i = m.guidVersions[a.toLowerCase()];
                                    s(i, "version at position " + e + " must be one of " + Object.keys(m.guidVersions).join(", ")), s(!n.has(i), "version at position " + e + " must not be a duplicate"), t += i, n.add(i);
                                }
                            }
                            s(m.guidSeparators.has(e.separator), 'separator must be one of true, false, "-", or ":"');
                            const r = void 0 === e.separator ? "[:-]?" : !0 === e.separator ? "[:-]" : !1 === e.separator ? "[]?" : `\\${e.separator}`, n = new RegExp(`^([\\[{\\(]?)[0-9A-F]{8}(${r})[0-9A-F]{4}\\2?[${t || "0-9A-F"}][0-9A-F]{3}\\2?[${t ? "89AB" : "0-9A-F"}][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$`, "i");
                            return this.$_addRule({
                                name: "guid",
                                args: {
                                    options: e
                                },
                                regex: n
                            });
                        },
                        validate (e, t, r, { regex: s }) {
                            const n = s.exec(e);
                            return n ? m.guidBrackets[n[1]] !== n[n.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
                        }
                    },
                    hex: {
                        method (e = {}) {
                            return f.assertOptions(e, [
                                "byteAligned",
                                "prefix"
                            ]), e = {
                                byteAligned: !1,
                                prefix: !1,
                                ...e
                            }, s("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), s("boolean" == typeof e.prefix || "optional" === e.prefix, 'prefix must be boolean or "optional"'), this.$_addRule({
                                name: "hex",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>("optional" === r.prefix ? m.hexRegex.withOptionalPrefix : !0 === r.prefix ? m.hexRegex.withPrefix : m.hexRegex.withoutPrefix).test(e) ? r.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex")
                    },
                    hostname: {
                        method () {
                            return this.$_addRule("hostname");
                        },
                        validate: (e, t)=>n.isValid(e, {
                                minDomainSegments: 1
                            }) || m.ipRegex.test(e) ? e : t.error("string.hostname")
                    },
                    insensitive: {
                        method () {
                            return this.$_setFlag("insensitive", !0);
                        }
                    },
                    ip: {
                        method (e = {}) {
                            f.assertOptions(e, [
                                "cidr",
                                "version"
                            ]);
                            const { cidr: t, versions: r, regex: s } = i.regex(e), n = e.version ? r : void 0;
                            return this.$_addRule({
                                name: "ip",
                                args: {
                                    options: {
                                        cidr: t,
                                        version: n
                                    }
                                },
                                regex: s
                            });
                        },
                        validate: (e, t, { options: r }, { regex: s })=>s.test(e) ? e : r.version ? t.error("string.ipVersion", {
                                value: e,
                                cidr: r.cidr,
                                version: r.version
                            }) : t.error("string.ip", {
                                value: e,
                                cidr: r.cidr
                            })
                    },
                    isoDate: {
                        method () {
                            return this.$_addRule("isoDate");
                        },
                        validate: (e, { error: t })=>m.isoDate(e) ? e : t("string.isoDate")
                    },
                    isoDuration: {
                        method () {
                            return this.$_addRule("isoDuration");
                        },
                        validate: (e, t)=>m.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
                    },
                    length: {
                        method (e, t) {
                            return m.length(this, "length", e, "=", t);
                        },
                        validate (e, t, { limit: r, encoding: s }, { name: n, operator: a, args: i }) {
                            const o = !s && e.length;
                            return f.compare(o, r, a) ? e : t.error("string." + n, {
                                limit: i.limit,
                                value: e,
                                encoding: s
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: f.limit,
                                message: "must be a positive integer"
                            },
                            "encoding"
                        ]
                    },
                    lowercase: {
                        method () {
                            return this.case("lower");
                        }
                    },
                    max: {
                        method (e, t) {
                            return m.length(this, "max", e, "<=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    min: {
                        method (e, t) {
                            return m.length(this, "min", e, ">=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    normalize: {
                        method (e = "NFC") {
                            return s(m.normalizationForms.includes(e), "normalization form must be one of " + m.normalizationForms.join(", ")), this.$_addRule({
                                name: "normalize",
                                args: {
                                    form: e
                                }
                            });
                        },
                        validate: (e, { error: t }, { form: r })=>e === e.normalize(r) ? e : t("string.normalize", {
                                value: e,
                                form: r
                            }),
                        convert: !0
                    },
                    pattern: {
                        alias: "regex",
                        method (e, t = {}) {
                            s(e instanceof RegExp, "regex must be a RegExp"), s(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                name: t
                            }), f.assertOptions(t, [
                                "invert",
                                "name"
                            ]);
                            const r = [
                                "string.pattern",
                                t.invert ? ".invert" : "",
                                t.name ? ".name" : ".base"
                            ].join("");
                            return this.$_addRule({
                                name: "pattern",
                                args: {
                                    regex: e,
                                    options: t
                                },
                                errorCode: r
                            });
                        },
                        validate: (e, t, { regex: r, options: s }, { errorCode: n })=>r.test(e) ^ s.invert ? e : t.error(n, {
                                name: s.name,
                                regex: r,
                                value: e
                            }),
                        args: [
                            "regex",
                            "options"
                        ],
                        multi: !0
                    },
                    replace: {
                        method (e, t) {
                            "string" == typeof e && (e = new RegExp(o(e), "g")), s(e instanceof RegExp, "pattern must be a RegExp"), s("string" == typeof t, "replacement must be a String");
                            const r = this.clone();
                            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                pattern: e,
                                replacement: t
                            }), r;
                        }
                    },
                    token: {
                        method () {
                            return this.$_addRule("token");
                        },
                        validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token")
                    },
                    trim: {
                        method (e = !0) {
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                name: "trim",
                                args: {
                                    enabled: e
                                }
                            });
                        },
                        validate: (e, t, { enabled: r })=>r && e !== e.trim() ? t.error("string.trim") : e,
                        convert: !0
                    },
                    truncate: {
                        method (e = !0) {
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                        }
                    },
                    uppercase: {
                        method () {
                            return this.case("upper");
                        }
                    },
                    uri: {
                        method (e = {}) {
                            f.assertOptions(e, [
                                "allowRelative",
                                "allowQuerySquareBrackets",
                                "domain",
                                "relativeOnly",
                                "scheme",
                                "encodeUri"
                            ]), e.domain && f.assertOptions(e.domain, [
                                "allowFullyQualified",
                                "allowUnicode",
                                "maxDomainSegments",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const { regex: t, scheme: r } = c.regex(e), s = e.domain ? m.addressOptions(e.domain) : null;
                            return this.$_addRule({
                                name: "uri",
                                args: {
                                    options: e
                                },
                                regex: t,
                                domain: s,
                                scheme: r
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, domain: a, scheme: i }) {
                            if ([
                                "http:/",
                                "https:/"
                            ].includes(e)) return t.error("string.uri");
                            let o = s.exec(e);
                            if (!o && t.prefs.convert && r.encodeUri) {
                                const t = encodeURI(e);
                                o = s.exec(t), o && (e = t);
                            }
                            if (o) {
                                const s = o[1] || o[2];
                                return !a || r.allowRelative && !s || n.isValid(s, a) ? e : t.error("string.domain", {
                                    value: s
                                });
                            }
                            return r.relativeOnly ? t.error("string.uriRelativeOnly") : r.scheme ? t.error("string.uriCustomScheme", {
                                scheme: i,
                                value: e
                            }) : t.error("string.uri");
                        }
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                        return e;
                    }
                },
                messages: {
                    "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                    "string.base": "{{#label}} must be a string",
                    "string.base64": "{{#label}} must be a valid base64 string",
                    "string.creditCard": "{{#label}} must be a credit card",
                    "string.dataUri": "{{#label}} must be a valid dataUri string",
                    "string.domain": "{{#label}} must contain a valid domain name",
                    "string.email": "{{#label}} must be a valid email",
                    "string.empty": "{{#label}} is not allowed to be empty",
                    "string.guid": "{{#label}} must be a valid GUID",
                    "string.hex": "{{#label}} must only contain hexadecimal characters",
                    "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                    "string.hostname": "{{#label}} must be a valid hostname",
                    "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                    "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                    "string.isoDate": "{{#label}} must be in iso format",
                    "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                    "string.length": "{{#label}} length must be {{#limit}} characters long",
                    "string.lowercase": "{{#label}} must only contain lowercase characters",
                    "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                    "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                    "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                    "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                    "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
                    "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
                    "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
                    "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
                    "string.trim": "{{#label}} must not have leading or trailing whitespace",
                    "string.uri": "{{#label}} must be a valid uri",
                    "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                    "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                    "string.uppercase": "{{#label}} must only contain uppercase characters"
                }
            }), m.addressOptions = function(e) {
                if (!e) return m.tlds || e;
                if (s(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), s(void 0 === e.maxDomainSegments || Number.isSafeInteger(e.maxDomainSegments) && e.maxDomainSegments > 0, "maxDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                if (!0 === e.tlds || void 0 === e.tlds) return s(m.tlds, "Built-in TLD list disabled"), Object.assign({}, e, m.tlds);
                s("object" == typeof e.tlds, "tlds must be true, false, or an object");
                const t = e.tlds.deny;
                if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                    tlds: {
                        deny: new Set(t)
                    }
                })), s(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), s(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), m.validateTlds(e.tlds.deny, "tlds.deny"), e;
                const r = e.tlds.allow;
                return r ? !0 === r ? (s(m.tlds, "Built-in TLD list disabled"), Object.assign({}, e, m.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                    tlds: {
                        allow: new Set(r)
                    }
                })), s(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), m.validateTlds(e.tlds.allow, "tlds.allow"), e) : e;
            }, m.validateTlds = function(e, t) {
                for (const r of e)s(n.isValid(r, {
                    minDomainSegments: 1,
                    maxDomainSegments: 1
                }), `${t} must contain valid top level domain names`);
            }, m.isoDate = function(e) {
                if (!f.isIsoDate(e)) return null;
                /T.*[+-]\d\d$/.test(e) && (e += ":00");
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t.toISOString();
            }, m.length = function(e, t, r, n, a) {
                return s(!a || !1, "Invalid encoding:", a), e.$_addRule({
                    name: t,
                    method: "length",
                    args: {
                        limit: r,
                        encoding: a
                    },
                    operator: n
                });
            };
        },
        5008 (e, t, r) {
            "use strict";
            const s = r(914), n = r(680), a = {};
            a.Map = class extends Map {
                slice() {
                    return new a.Map(this);
                }
            }, e.exports = n.extend({
                type: "symbol",
                terms: {
                    map: {
                        init: new a.Map
                    }
                },
                coerce: {
                    method (e, { schema: t, error: r }) {
                        const s = t.$_terms.map.get(e);
                        return s && (e = s), t._flags.only && "symbol" != typeof e ? {
                            value: e,
                            errors: r("symbol.map", {
                                map: t.$_terms.map
                            })
                        } : {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("symbol" != typeof e) return {
                        value: e,
                        errors: t("symbol.base")
                    };
                },
                rules: {
                    map: {
                        method (e) {
                            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                            const t = this.clone(), r = [];
                            for (const n of e){
                                s(n && n[Symbol.iterator], "Entry must be an iterable");
                                const [e, a] = n;
                                s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof a, "Value must be a Symbol"), t.$_terms.map.set(e, a), r.push(a);
                            }
                            return t.valid(...r);
                        }
                    }
                },
                manifest: {
                    build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                },
                messages: {
                    "symbol.base": "{{#label}} must be a symbol",
                    "symbol.map": "{{#label}} must be one of {{#map}}"
                }
            });
        },
        1190 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(7806), i = r(9441), o = r(9415), l = r(8013), c = r(4957), u = {
                result: Symbol("result")
            };
            t.entry = function(e, t, r) {
                let n = o.defaults;
                r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), s(void 0 === r.artifacts, "Cannot override artifacts preference in synchronous validation"), n = o.preferences(o.defaults, r));
                const a = u.entry(e, t, n);
                s(!a.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                const i = {
                    value: a.value
                };
                return a.error && (i.error = a.error), a.mainstay.warnings.length && (i.warning = l.details(a.mainstay.warnings)), a.mainstay.debug && (i.debug = a.mainstay.debug), a.mainstay.artifacts && (i.artifacts = a.mainstay.artifacts), i;
            }, t.entryAsync = async function(e, t, r) {
                let s = o.defaults;
                r && (s = o.preferences(o.defaults, r));
                const n = u.entry(e, t, s), a = n.mainstay;
                if (n.error) throw a.debug && (n.error.debug = a.debug), n.error;
                if (a.externals.length) {
                    let t = n.value;
                    const c = [];
                    for (const n of a.externals){
                        const f = n.state.path, m = "link" === n.schema.type ? a.links.get(n.schema) : null;
                        let h, p, d = t;
                        const g = f.length ? [
                            t
                        ] : [], y = f.length ? i(e, f) : e;
                        if (f.length) {
                            h = f[f.length - 1];
                            let e = t;
                            for (const t of f.slice(0, -1))e = e[t], g.unshift(e);
                            p = g[0], d = p[h];
                        }
                        try {
                            const e = (e, t)=>(m || n.schema).$_createError(e, d, t, n.state, s), i = await n.method(d, {
                                schema: n.schema,
                                linked: m,
                                state: n.state,
                                prefs: r,
                                original: y,
                                error: e,
                                errorsArray: u.errorsArray,
                                warn: (e, t)=>a.warnings.push((m || n.schema).$_createError(e, d, t, n.state, s)),
                                message: (e, t)=>(m || n.schema).$_createError("external", d, t, n.state, s, {
                                        messages: e
                                    })
                            });
                            if (void 0 === i || i === d) continue;
                            if (i instanceof l.Report) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(i), s.abortEarly) break;
                                continue;
                            }
                            if (Array.isArray(i) && i[o.symbols.errors]) {
                                if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(...i), s.abortEarly) break;
                                continue;
                            }
                            p ? (a.tracer.value(n.state, "rule", d, i, "external"), p[h] = i) : (a.tracer.value(n.state, "rule", t, i, "external"), t = i);
                        } catch (e) {
                            throw s.errors.label && (e.message += ` (${n.label})`), e;
                        }
                    }
                    if (n.value = t, c.length) throw n.error = l.process(c, e, s), a.debug && (n.error.debug = a.debug), n.error;
                }
                if (!s.warnings && !s.debug && !s.artifacts) return n.value;
                const c = {
                    value: n.value
                };
                return a.warnings.length && (c.warning = l.details(a.warnings)), a.debug && (c.debug = a.debug), a.artifacts && (c.artifacts = a.artifacts), c;
            }, u.Mainstay = class {
                constructor(e, t, r){
                    this.externals = [], this.warnings = [], this.tracer = e, this.debug = t, this.links = r, this.shadow = null, this.artifacts = null, this._snapshots = [];
                }
                snapshot() {
                    this._snapshots.push({
                        externals: this.externals.slice(),
                        warnings: this.warnings.slice()
                    });
                }
                restore() {
                    const e = this._snapshots.pop();
                    this.externals = e.externals, this.warnings = e.warnings;
                }
                commit() {
                    this._snapshots.pop();
                }
            }, u.entry = function(e, r, s) {
                const { tracer: n, cleanup: a } = u.tracer(r, s), i = s.debug ? [] : null, o = r._ids._schemaChain ? new Map : null, f = new u.Mainstay(n, i, o), m = r._ids._schemaChain ? [
                    {
                        schema: r
                    }
                ] : null, h = new c([], [], {
                    mainstay: f,
                    schemas: m
                }), p = t.validate(e, r, h, s);
                a && r.$_root.untrace();
                const d = l.process(p.errors, e, s);
                return {
                    value: p.value,
                    error: d,
                    mainstay: f
                };
            }, u.tracer = function(e, t) {
                return e.$_root._tracer ? {
                    tracer: e.$_root._tracer._register(e)
                } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                    tracer: e.$_root.trace()._register(e),
                    cleanup: !0
                }) : {
                    tracer: u.ignore
                };
            }, t.validate = function(e, t, r, s, n = {}) {
                if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                    const s = t._cache.get(e);
                    if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                }
                const a = (n, a, i)=>t.$_createError(n, e, a, i || r, s), i = {
                    original: e,
                    prefs: s,
                    schema: t,
                    state: r,
                    error: a,
                    errorsArray: u.errorsArray,
                    warn: (e, t, s)=>r.mainstay.warnings.push(a(e, t, s)),
                    message: (n, a)=>t.$_createError("custom", e, a, r, s, {
                            messages: n
                        })
                };
                r.mainstay.tracer.entry(t, r);
                const l = t._definition;
                if (l.prepare && void 0 !== e && s.convert) {
                    const t = l.prepare(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                    const t = l.coerce.method(e, i);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
                        e = t.value;
                    }
                }
                const c = t._flags.empty;
                c && c.$_match(u.trim(e, t), r.nest(c), o.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? null : s.presence);
                if (void 0 === e) {
                    if ("forbidden" === f) return u.finalize(e, null, i);
                    if ("required" === f) return u.finalize(e, [
                        t.$_createError("any.required", e, null, r, s)
                    ], i);
                    if ("optional" === f) {
                        if (t._flags.default !== o.symbols.deepDefault) return u.finalize(e, null, i);
                        r.mainstay.tracer.value(r, "default", e, {}), e = {};
                    }
                } else if ("forbidden" === f) return u.finalize(e, [
                    t.$_createError("any.unknown", e, null, r, s)
                ], i);
                const m = [];
                if (t._valids) {
                    const n = t._valids.get(e, r, s, t._flags.insensitive);
                    if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, i);
                    if (t._flags.only) {
                        const n = t.$_createError("any.only", e, {
                            valids: t._valids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            n
                        ], i);
                        m.push(n);
                    }
                }
                if (t._invalids) {
                    const n = t._invalids.get(e, r, s, t._flags.insensitive);
                    if (n) {
                        r.mainstay.tracer.filter(t, r, "invalid", n);
                        const a = t.$_createError("any.invalid", e, {
                            invalids: t._invalids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            a
                        ], i);
                        m.push(a);
                    }
                }
                if (l.validate) {
                    const t = l.validate(e, i);
                    if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                        if (!Array.isArray(t.errors)) return m.push(t.errors), u.finalize(e, m, i);
                        if (t.errors.length) return m.push(...t.errors), u.finalize(e, m, i);
                    }
                }
                return t._rules.length ? u.rules(e, m, i) : u.finalize(e, m, i);
            }, u.rules = function(e, t, r) {
                const { schema: s, state: n, prefs: a } = r;
                for (const i of s._rules){
                    const l = s._definition.rules[i.method];
                    if (l.convert && a.convert) {
                        n.mainstay.tracer.log(s, n, "rule", i.name, "full");
                        continue;
                    }
                    let c, f = i.args;
                    if (i._resolve.length) {
                        f = Object.assign({}, f);
                        for (const t of i._resolve){
                            const r = l.argsByName.get(t), i = f[t].resolve(e, n, a), u = r.normalize ? r.normalize(i) : i, m = o.validateArg(u, null, r);
                            if (m) {
                                c = s.$_createError("any.ref", i, {
                                    arg: t,
                                    ref: f[t],
                                    reason: m
                                }, n, a);
                                break;
                            }
                            f[t] = u;
                        }
                    }
                    c = c || l.validate(e, r, f, i);
                    const m = u.rule(c, i);
                    if (m.errors) {
                        if (n.mainstay.tracer.log(s, n, "rule", i.name, "error"), i.warn) {
                            n.mainstay.warnings.push(...m.errors);
                            continue;
                        }
                        if (a.abortEarly) return u.finalize(e, m.errors, r);
                        t.push(...m.errors);
                    } else n.mainstay.tracer.log(s, n, "rule", i.name, "pass"), n.mainstay.tracer.value(n, "rule", e, m.value, i.name), e = m.value;
                }
                return u.finalize(e, t, r);
            }, u.rule = function(e, t) {
                return e instanceof l.Report ? (u.error(e, t), {
                    errors: [
                        e
                    ],
                    value: null
                }) : Array.isArray(e) && e[o.symbols.errors] ? (e.forEach((e)=>u.error(e, t)), {
                    errors: e,
                    value: null
                }) : {
                    errors: null,
                    value: e
                };
            }, u.error = function(e, t) {
                return t.message && e._setTemplate(t.message), e;
            }, u.finalize = function(e, t, r) {
                t = t || [];
                const { schema: n, state: a, prefs: i } = r;
                if (t.length) {
                    const s = u.default("failover", void 0, t, r);
                    void 0 !== s && (a.mainstay.tracer.value(a, "failover", e, s), e = s, t = []);
                }
                if (t.length && n._flags.error) {
                    if ("function" == typeof n._flags.error) {
                        t = n._flags.error(t), Array.isArray(t) || (t = [
                            t
                        ]);
                        for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                    } else t = [
                        n._flags.error
                    ];
                }
                if (void 0 === e) {
                    const s = u.default("default", e, t, r);
                    a.mainstay.tracer.value(a, "default", e, s), e = s;
                }
                if (n._flags.cast && void 0 !== e) {
                    const t = n._definition.cast[n._flags.cast];
                    if (t.from(e)) {
                        const s = t.to(e, r);
                        a.mainstay.tracer.value(a, "cast", e, s, n._flags.cast), e = s;
                    }
                }
                if (n.$_terms.externals && i.externals && !1 !== i._externals) for (const { method: e } of n.$_terms.externals)a.mainstay.externals.push({
                    method: e,
                    schema: n,
                    state: a,
                    label: l.label(n._flags, a, i)
                });
                const o = {
                    value: e,
                    errors: t.length ? t : null
                };
                return n._flags.result && (o.value = "strip" === n._flags.result ? void 0 : r.original, a.mainstay.tracer.value(a, n._flags.result, e, o.value), a.shadow(e, n._flags.result)), n._cache && !1 !== i.cache && !n._refs.length && n._cache.set(r.original, o), void 0 === e || o.errors || void 0 === n._flags.artifact || (a.mainstay.artifacts = a.mainstay.artifacts || new Map, a.mainstay.artifacts.has(n._flags.artifact) || a.mainstay.artifacts.set(n._flags.artifact, []), a.mainstay.artifacts.get(n._flags.artifact).push(a.path)), o;
            }, u.prefs = function(e, t) {
                const r = t === o.defaults;
                return r && e._preferences[o.symbols.prefs] ? e._preferences[o.symbols.prefs] : (t = o.preferences(t, e._preferences), r && (e._preferences[o.symbols.prefs] = t), t);
            }, u.default = function(e, t, r, s) {
                const { schema: a, state: i, prefs: l } = s, c = a._flags[e];
                if (l.noDefaults || void 0 === c) return t;
                if (i.mainstay.tracer.log(a, i, "rule", e, "full"), !c) return c;
                if ("function" == typeof c) {
                    const t = c.length ? [
                        n(i.ancestors[0]),
                        s
                    ] : [];
                    try {
                        return c(...t);
                    } catch (t) {
                        return void r.push(a.$_createError(`any.${e}`, null, {
                            error: t
                        }, i, l));
                    }
                }
                return "object" != typeof c ? c : c[o.symbols.literal] ? c.literal : o.isResolvable(c) ? c.resolve(t, i, l) : n(c);
            }, u.trim = function(e, t) {
                if ("string" != typeof e) return e;
                const r = t.$_getRule("trim");
                return r && r.args.enabled ? e.trim() : e;
            }, u.ignore = {
                active: !1,
                debug: a,
                entry: a,
                filter: a,
                log: a,
                resolve: a,
                value: a
            }, u.errorsArray = function() {
                const e = [];
                return e[o.symbols.errors] = !0, e;
            };
        },
        6220 (e, t, r) {
            "use strict";
            const s = r(914), n = r(1728), a = r(9415), i = {};
            e.exports = i.Values = class {
                constructor(e, t){
                    this._values = new Set(e), this._refs = new Set(t), this._lowercase = i.lowercases(e), this._override = !1;
                }
                get length() {
                    return this._values.size + this._refs.size;
                }
                add(e, t) {
                    a.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                }
                static merge(e, t, r) {
                    if (e = e || new i.Values, t) {
                        if (t._override) return t.clone();
                        for (const r of [
                            ...t._values,
                            ...t._refs
                        ])e.add(r);
                    }
                    if (r) for (const t of [
                        ...r._values,
                        ...r._refs
                    ])e.remove(t);
                    return e.length ? e : null;
                }
                remove(e) {
                    a.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                }
                has(e, t, r, s) {
                    return !!this.get(e, t, r, s);
                }
                get(e, t, r, s) {
                    if (!this.length) return !1;
                    if (this._values.has(e)) return {
                        value: e
                    };
                    if ("string" == typeof e && e && s) {
                        const t = this._lowercase.get(e.toLowerCase());
                        if (t) return {
                            value: t
                        };
                    }
                    if (!this._refs.size && "object" != typeof e) return !1;
                    if ("object" == typeof e) {
                        for (const t of this._values)if (n(t, e)) return {
                            value: t
                        };
                    }
                    if (t) for (const a of this._refs){
                        const i = a.resolve(e, t, r, null, {
                            in: !0
                        });
                        if (void 0 === i) continue;
                        const o = a.in && "object" == typeof i ? Array.isArray(i) ? i : Object.keys(i) : [
                            i
                        ];
                        for (const t of o)if (typeof t == typeof e) {
                            if (s && e && "string" == typeof e) {
                                if (t.toLowerCase() === e.toLowerCase()) return {
                                    value: t,
                                    ref: a
                                };
                            } else if (n(t, e)) return {
                                value: t,
                                ref: a
                            };
                        }
                    }
                    return !1;
                }
                override() {
                    this._override = !0;
                }
                values(e) {
                    if (e && e.display) {
                        const e = [];
                        for (const t of [
                            ...this._values,
                            ...this._refs
                        ])void 0 !== t && e.push(t);
                        return e;
                    }
                    return Array.from([
                        ...this._values,
                        ...this._refs
                    ]);
                }
                clone() {
                    const e = new i.Values(this._values, this._refs);
                    return e._override = this._override, e;
                }
                concat(e) {
                    s(!e._override, "Cannot concat override set of values");
                    const t = new i.Values([
                        ...this._values,
                        ...e._values
                    ], [
                        ...this._refs,
                        ...e._refs
                    ]);
                    return t._override = this._override, t;
                }
                describe() {
                    const e = [];
                    this._override && e.push({
                        override: !0
                    });
                    for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                        value: t
                    } : t);
                    for (const t of this._refs.values())e.push(t.describe());
                    return e;
                }
            }, i.Values.prototype[a.symbols.values] = !0, i.Values.prototype.slice = i.Values.prototype.clone, i.lowercases = function(e) {
                const t = new Map;
                if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                return t;
            };
        },
        389 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(2950), i = r(9441), o = {};
            e.exports = function(e, t, r = {}) {
                if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                if (r.shallow) return o.applyToDefaultsWithShallow(e, t, r);
                const i = n(e);
                if (!0 === t) return i;
                const l = void 0 !== r.nullOverride && r.nullOverride;
                return a(i, t, {
                    nullOverride: l,
                    mergeArrays: !1
                });
            }, o.applyToDefaultsWithShallow = function(e, t, r) {
                const l = r.shallow;
                s(Array.isArray(l), "Invalid keys");
                const c = new Map, u = !0 === t ? null : new Set;
                for (let r of l){
                    r = Array.isArray(r) ? r : r.split(".");
                    const s = i(e, r);
                    s && "object" == typeof s ? c.set(s, u && i(t, r) || s) : u && u.add(r);
                }
                const f = n(e, {}, c);
                if (!u) return f;
                for (const e of u)o.reachCopy(f, t, e);
                const m = void 0 !== r.nullOverride && r.nullOverride;
                return a(f, t, {
                    nullOverride: m,
                    mergeArrays: !1
                });
            }, o.reachCopy = function(e, t, r) {
                for (const e of r){
                    if (!(e in t)) return;
                    const r = t[e];
                    if ("object" != typeof r || null === r) return;
                    t = r;
                }
                const s = t;
                let n = e;
                for(let e = 0; e < r.length - 1; ++e){
                    const t = r[e];
                    "object" != typeof n[t] && (n[t] = {}), n = n[t];
                }
                n[r[r.length - 1]] = s;
            };
        },
        914 (e, t, r) {
            "use strict";
            const s = r(3660);
            e.exports = function(e, ...t) {
                if (!e) {
                    if (1 === t.length && t[0] instanceof Error) throw t[0];
                    throw new s(t);
                }
            };
        },
        6179 (e, t, r) {
            "use strict";
            const s = r(9441), n = r(1507), a = r(6399), i = {
                needsProtoHack: new Set([
                    n.set,
                    n.map,
                    n.weakSet,
                    n.weakMap
                ])
            };
            e.exports = i.clone = function(e, t = {}, r = null) {
                if ("object" != typeof e || null === e) return e;
                let s = i.clone, o = r;
                if (t.shallow) {
                    if (!0 !== t.shallow) return i.cloneWithShallow(e, t);
                    s = (e)=>e;
                } else if (o) {
                    const t = o.get(e);
                    if (t) return t;
                } else o = new Map;
                const l = n.getInternalProto(e);
                if (l === n.buffer) return !1;
                if (l === n.date) return new Date(e.getTime());
                if (l === n.regex) return new RegExp(e);
                const c = i.base(e, l, t);
                if (c === e) return e;
                if (o && o.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, o));
                else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, o));
                const u = a.keys(e, t);
                for (const r of u){
                    if ("__proto__" === r) continue;
                    if (l === n.array && "length" === r) {
                        c.length = e.length;
                        continue;
                    }
                    const a = Object.getOwnPropertyDescriptor(e, r);
                    a ? a.get || a.set ? Object.defineProperty(c, r, a) : a.enumerable ? c[r] = s(e[r], t, o) : Object.defineProperty(c, r, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    }) : Object.defineProperty(c, r, {
                        enumerable: !0,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, o)
                    });
                }
                return c;
            }, i.cloneWithShallow = function(e, t) {
                const r = t.shallow;
                (t = Object.assign({}, t)).shallow = !1;
                const n = new Map;
                for (const t of r){
                    const r = s(e, t);
                    "object" != typeof r && "function" != typeof r || n.set(r, r);
                }
                return i.clone(e, t, n);
            }, i.base = function(e, t, r) {
                if (!1 === r.prototype) return i.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                const s = Object.getPrototypeOf(e);
                if (s && s.isImmutable) return e;
                if (t === n.array) {
                    const e = [];
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                if (i.needsProtoHack.has(t)) {
                    const e = new s.constructor;
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                return Object.create(s);
            };
        },
        1728 (e, t, r) {
            "use strict";
            const s = r(1507), n = {
                mismatched: null
            };
            e.exports = function(e, t, r) {
                return r = Object.assign({
                    prototype: !0
                }, r), !!n.isDeepEqual(e, t, r, []);
            }, n.isDeepEqual = function(e, t, r, a) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                const i = typeof e;
                if (i !== typeof t) return !1;
                if (null === e || null === t) return !1;
                if ("function" === i) {
                    if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                } else if ("object" !== i) return e != e && t != t;
                const o = n.getSharedType(e, t, !!r.prototype);
                switch(o){
                    case s.buffer:
                        return !1;
                    case s.promise:
                        return e === t;
                    case s.regex:
                        return e.toString() === t.toString();
                    case n.mismatched:
                        return !1;
                }
                for(let r = a.length - 1; r >= 0; --r)if (a[r].isSame(e, t)) return !0;
                a.push(new n.SeenEntry(e, t));
                try {
                    return !!n.isDeepEqualObj(o, e, t, r, a);
                } finally{
                    a.pop();
                }
            }, n.getSharedType = function(e, t, r) {
                if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                const a = s.getInternalProto(e);
                return a !== s.getInternalProto(t) ? n.mismatched : a;
            }, n.valueOf = function(e) {
                const t = e.valueOf;
                if (void 0 === t) return e;
                try {
                    return t.call(e);
                } catch (e) {
                    return e;
                }
            }, n.hasOwnEnumerableProperty = function(e, t) {
                return Object.prototype.propertyIsEnumerable.call(e, t);
            }, n.isSetSimpleEqual = function(e, t) {
                for (const r of Set.prototype.values.call(e))if (!Set.prototype.has.call(t, r)) return !1;
                return !0;
            }, n.isDeepEqualObj = function(e, t, r, a, i) {
                const { isDeepEqual: o, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                if (e === s.array) {
                    if (!a.part) {
                        if (t.length !== r.length) return !1;
                        for(let e = 0; e < t.length; ++e)if (!o(t[e], r[e], a, i)) return !1;
                        return !0;
                    }
                    for (const e of t)for (const t of r)if (o(e, t, a, i)) return !0;
                } else if (e === s.set) {
                    if (t.size !== r.size) return !1;
                    if (!n.isSetSimpleEqual(t, r)) {
                        const e = new Set(Set.prototype.values.call(r));
                        for (const r of Set.prototype.values.call(t)){
                            if (e.delete(r)) continue;
                            let t = !1;
                            for (const s of e)if (o(r, s, a, i)) {
                                e.delete(s), t = !0;
                                break;
                            }
                            if (!t) return !1;
                        }
                    }
                } else if (e === s.map) {
                    if (t.size !== r.size) return !1;
                    for (const [e, s] of Map.prototype.entries.call(t)){
                        if (void 0 === s && !Map.prototype.has.call(r, e)) return !1;
                        if (!o(s, Map.prototype.get.call(r, e), a, i)) return !1;
                    }
                } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                const m = l(t), h = l(r);
                if ((t !== m || r !== h) && !o(m, h, a, i)) return !1;
                const p = u(t);
                if (!a.part && p.length !== u(r).length && !a.skip) return !1;
                let d = 0;
                for (const e of p)if (a.skip && a.skip.includes(e)) void 0 === r[e] && ++d;
                else {
                    if (!c(r, e)) return !1;
                    if (!o(t[e], r[e], a, i)) return !1;
                }
                if (!a.part && p.length - d !== u(r).length) return !1;
                if (!1 !== a.symbols) {
                    const e = f(t), s = new Set(f(r));
                    for (const n of e){
                        if (!a.skip || !a.skip.includes(n)) {
                            if (c(t, n)) {
                                if (!c(r, n)) return !1;
                                if (!o(t[n], r[n], a, i)) return !1;
                            } else if (c(r, n)) return !1;
                        }
                        s.delete(n);
                    }
                    for (const e of s)if (c(r, e)) return !1;
                }
                return !0;
            }, n.SeenEntry = class {
                constructor(e, t){
                    this.obj = e, this.ref = t;
                }
                isSame(e, t) {
                    return this.obj === e && this.ref === t;
                }
            };
        },
        3660 (e, t, r) {
            "use strict";
            const s = r(2227);
            e.exports = class extends Error {
                constructor(e){
                    super(e.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
                }
            };
        },
        7222 (e) {
            "use strict";
            const t = {};
            e.exports = function(e) {
                if (!e) return "";
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e.charCodeAt(s);
                    t.isSafe(n) ? r += e[s] : r += t.escapeHtmlChar(n);
                }
                return r;
            }, t.escapeHtmlChar = function(e) {
                return t.namedHtml.get(e) || (e >= 256 ? "&#" + e + ";" : `&#x${e.toString(16).padStart(2, "0")};`);
            }, t.isSafe = function(e) {
                return t.safeCharCodes.has(e);
            }, t.namedHtml = new Map([
                [
                    38,
                    "&amp;"
                ],
                [
                    60,
                    "&lt;"
                ],
                [
                    62,
                    "&gt;"
                ],
                [
                    34,
                    "&quot;"
                ],
                [
                    160,
                    "&nbsp;"
                ],
                [
                    162,
                    "&cent;"
                ],
                [
                    163,
                    "&pound;"
                ],
                [
                    164,
                    "&curren;"
                ],
                [
                    169,
                    "&copy;"
                ],
                [
                    174,
                    "&reg;"
                ]
            ]), t.safeCharCodes = function() {
                const e = new Set;
                for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && e.add(t);
                return e;
            }();
        },
        4836 (e) {
            "use strict";
            e.exports = function(e) {
                return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
            };
        },
        7806 (e) {
            "use strict";
            e.exports = function() {};
        },
        2950 (e, t, r) {
            "use strict";
            const s = r(914), n = r(6179), a = r(6399), i = {};
            e.exports = i.merge = function(e, t, r) {
                if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                if (r = Object.assign({
                    nullOverride: !0,
                    mergeArrays: !0
                }, r), Array.isArray(t)) {
                    s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                    for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                        symbols: r.symbols
                    }));
                    return e;
                }
                const o = a.keys(t, r);
                for(let s = 0; s < o.length; ++s){
                    const a = o[s];
                    if ("__proto__" === a || !Object.prototype.propertyIsEnumerable.call(t, a)) continue;
                    const l = t[a];
                    if (l && "object" == typeof l) {
                        if (e[a] === l) continue;
                        !e[a] || "object" != typeof e[a] || Array.isArray(e[a]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[a] = n(l, {
                            symbols: r.symbols
                        }) : i.merge(e[a], l, r);
                    } else (null != l || r.nullOverride) && (e[a] = l);
                }
                return e;
            };
        },
        9441 (e, t, r) {
            "use strict";
            const s = r(914), n = {};
            e.exports = function(e, t, r) {
                if (!1 === t || null == t) return e;
                "string" == typeof (r = r || {}) && (r = {
                    separator: r
                });
                const a = Array.isArray(t);
                s(!a || !r.separator, "Separator option is not valid for array-based chain");
                const i = a ? t : t.split(r.separator || ".");
                let o = e;
                for(let e = 0; e < i.length; ++e){
                    let a = i[e];
                    const l = r.iterables && n.iterables(o);
                    if (Array.isArray(o) || "set" === l) {
                        const e = Number(a);
                        Number.isInteger(e) && (a = e < 0 ? o.length + e : e);
                    }
                    if (!o || "function" == typeof o && !1 === r.functions || !l && void 0 === o[a]) {
                        s(!r.strict || e + 1 === i.length, "Missing segment", a, "in reach path ", t), s("object" == typeof o || !0 === r.functions || "function" != typeof o, "Invalid segment", a, "in reach path ", t), o = r.default;
                        break;
                    }
                    o = l ? "set" === l ? [
                        ...o
                    ][a] : o.get(a) : o[a];
                }
                return o;
            }, n.iterables = function(e) {
                return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
            };
        },
        2227 (e) {
            "use strict";
            e.exports = function(...e) {
                try {
                    return JSON.stringify(...e);
                } catch (e) {
                    return "[Cannot display object: " + e.message + "]";
                }
            };
        },
        1507 (e, t) {
            "use strict";
            const r = {};
            t = e.exports = {
                array: Array.prototype,
                buffer: !1,
                date: Date.prototype,
                error: Error.prototype,
                generic: Object.prototype,
                map: Map.prototype,
                promise: Promise.prototype,
                regex: RegExp.prototype,
                set: Set.prototype,
                weakMap: WeakMap.prototype,
                weakSet: WeakSet.prototype
            }, r.typeMap = new Map([
                [
                    "[object Error]",
                    t.error
                ],
                [
                    "[object Map]",
                    t.map
                ],
                [
                    "[object Promise]",
                    t.promise
                ],
                [
                    "[object Set]",
                    t.set
                ],
                [
                    "[object WeakMap]",
                    t.weakMap
                ],
                [
                    "[object WeakSet]",
                    t.weakSet
                ]
            ]), t.getInternalProto = function(e) {
                if (Array.isArray(e)) return t.array;
                if (e instanceof Date) return t.date;
                if (e instanceof RegExp) return t.regex;
                if (e instanceof Error) return t.error;
                const s = Object.prototype.toString.call(e);
                return r.typeMap.get(s) || t.generic;
            };
        },
        6399 (e, t) {
            "use strict";
            t.keys = function(e, t = {}) {
                return !1 !== t.symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
            };
        },
        7180 (e, t, r) {
            "use strict";
            const s = r(914), n = {};
            t.Sorter = class {
                constructor(){
                    this._items = [], this.nodes = [];
                }
                add(e, t) {
                    const r = [].concat((t = t || {}).before || []), n = [].concat(t.after || []), a = t.group || "?", i = t.sort || 0;
                    s(!r.includes(a), `Item cannot come before itself: ${a}`), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(a), `Item cannot come after itself: ${a}`), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e){
                        const e = {
                            seq: this._items.length,
                            sort: i,
                            before: r,
                            after: n,
                            group: a,
                            node: t
                        };
                        this._items.push(e);
                    }
                    if (!t.manual) {
                        const e = this._sort();
                        s(e, "item", "?" !== a ? `added into group ${a}` : "", "created a dependencies error");
                    }
                    return this.nodes;
                }
                merge(e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                    this._items.sort(n.mergeSort);
                    for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                    const t = this._sort();
                    return s(t, "merge created a dependencies error"), this.nodes;
                }
                sort() {
                    const e = this._sort();
                    return s(e, "sort created a dependencies error"), this.nodes;
                }
                _sort() {
                    const e = {}, t = Object.create(null), r = Object.create(null);
                    for (const s of this._items){
                        const n = s.seq, a = s.group;
                        r[a] = r[a] || [], r[a].push(n), e[n] = s.before;
                        for (const e of s.after)t[e] = t[e] || [], t[e].push(n);
                    }
                    for(const t in e){
                        const s = [];
                        for(const n in e[t]){
                            const a = e[t][n];
                            r[a] = r[a] || [], s.push(...r[a]);
                        }
                        e[t] = s;
                    }
                    for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                    const s = {};
                    for(const t in e){
                        const r = e[t];
                        for (const e of r)s[e] = s[e] || [], s[e].push(t);
                    }
                    const n = {}, a = [];
                    for(let e = 0; e < this._items.length; ++e){
                        let t = e;
                        if (s[e]) {
                            t = null;
                            for(let e = 0; e < this._items.length; ++e){
                                if (!0 === n[e]) continue;
                                s[e] || (s[e] = []);
                                const r = s[e].length;
                                let a = 0;
                                for(let t = 0; t < r; ++t)n[s[e][t]] && ++a;
                                if (a === r) {
                                    t = e;
                                    break;
                                }
                            }
                        }
                        null !== t && (n[t] = !0, a.push(t));
                    }
                    if (a.length !== this._items.length) return !1;
                    const i = {};
                    for (const e of this._items)i[e.seq] = e;
                    this._items = [], this.nodes = [];
                    for (const e of a){
                        const t = i[e];
                        this.nodes.push(t.node), this._items.push(t);
                    }
                    return !0;
                }
            }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
        },
        6358 (e, t, r) {
            "use strict";
            const s = r(5238), n = r(61), a = {
                minDomainSegments: 2,
                nonAsciiRx: /[^\x00-\x7f]/,
                domainControlRx: /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/,
                tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                URL: s.URL || URL
            };
            t.analyze = function(e, t = {}) {
                if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
                if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                if (e.length > 256) return n.code("DOMAIN_TOO_LONG");
                if (a.nonAsciiRx.test(e)) {
                    if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
                    e = e.normalize("NFC");
                }
                if (a.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
                e = a.punycode(e), t.allowFullyQualified && "." === e[e.length - 1] && (e = e.slice(0, -1));
                const r = t.minDomainSegments || a.minDomainSegments, s = e.split(".");
                if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
                if (t.maxDomainSegments && s.length > t.maxDomainSegments) return n.code("DOMAIN_SEGMENTS_COUNT_MAX");
                const i = t.tlds;
                if (i) {
                    const e = s[s.length - 1].toLowerCase();
                    if (i.deny && i.deny.has(e) || i.allow && !i.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
                }
                for(let e = 0; e < s.length; ++e){
                    const t = s[e];
                    if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
                    if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");
                    if (e < s.length - 1) {
                        if (!a.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
                    } else if (!a.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
                }
                return null;
            }, t.isValid = function(e, r) {
                return !t.analyze(e, r);
            }, a.punycode = function(e) {
                e.includes("%") && (e = e.replace(/%/g, "%25"));
                try {
                    return new a.URL(`http://${e}`).host;
                } catch (t) {
                    return e;
                }
            };
        },
        7728 (e, t, r) {
            "use strict";
            const s = r(8967), n = r(6358), a = r(61), i = {
                nonAsciiRx: /[^\x00-\x7f]/,
                encoder: new (s.TextEncoder || TextEncoder)
            };
            t.isValid = function(e, t) {
                return !i.email(e, t);
            }, i.email = function(e, t = {}) {
                if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                if (!e) return a.code("EMPTY_STRING");
                const r = !i.nonAsciiRx.test(e);
                if (!r) {
                    if (!1 === t.allowUnicode) return a.code("FORBIDDEN_UNICODE");
                    e = e.normalize("NFC");
                }
                const s = e.split("@");
                if (2 !== s.length) return s.length > 2 ? a.code("MULTIPLE_AT_CHAR") : a.code("MISSING_AT_CHAR");
                const [o, l] = s;
                if (!o) return a.code("EMPTY_LOCAL");
                if (!t.ignoreLength) {
                    if (e.length > 254) return a.code("ADDRESS_TOO_LONG");
                    if (i.encoder.encode(o).length > 64) return a.code("LOCAL_TOO_LONG");
                }
                return i.local(o, r) || n.analyze(l, t);
            }, i.local = function(e, t) {
                const r = e.split(".");
                for (const e of r){
                    if (!e.length) return a.code("EMPTY_LOCAL_SEGMENT");
                    if (t) {
                        if (!i.atextRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    } else for (const t of e){
                        if (i.atextRx.test(t)) continue;
                        const e = i.binary(t);
                        if (!i.atomRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
                    }
                }
            }, i.binary = function(e) {
                return Array.from(i.encoder.encode(e)).map((e)=>String.fromCharCode(e)).join("");
            }, i.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, i.atomRx = new RegExp([
                "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
            ].join("|"));
        },
        61 (e, t) {
            "use strict";
            t.F = {
                EMPTY_STRING: "Address must be a non-empty string",
                FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                MISSING_AT_CHAR: "Address must contain one @ character",
                EMPTY_LOCAL: "Address local part cannot be empty",
                ADDRESS_TOO_LONG: "Address too long",
                LOCAL_TOO_LONG: "Address local part too long",
                EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                DOMAIN_TOO_LONG: "Domain too long",
                DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                DOMAIN_SEGMENTS_COUNT_MAX: "Domain contains too many segments",
                DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
            }, t.code = function(e) {
                return {
                    code: e,
                    error: t.F[e]
                };
            };
        },
        6991 (e, t, r) {
            "use strict";
            const s = r(914), n = r(5882);
            t.regex = function(e = {}) {
                s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
                const t = e.cidr ? e.cidr.toLowerCase() : "optional";
                s([
                    "required",
                    "optional",
                    "forbidden"
                ].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                let r = e.version || [
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ];
                Array.isArray(r) || (r = [
                    r
                ]), s(r.length >= 1, "options.version must have at least 1 version specified");
                for(let e = 0; e < r.length; ++e)s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s([
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");
                r = Array.from(new Set(r));
                const a = `(?:${r.map((e)=>{
                    if ("forbidden" === t) return n.ip[e];
                    const r = `\\/${"ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr}`;
                    return "required" === t ? `${n.ip[e]}${r}` : `${n.ip[e]}(?:${r})?`;
                }).join("|")})`, i = new RegExp(`^${a}$`);
                return {
                    cidr: t,
                    versions: r,
                    regex: i,
                    raw: a
                };
            };
        },
        5882 (e, t, r) {
            "use strict";
            const s = r(914), n = r(4836), a = {
                generate: function() {
                    const e = {}, t = "\\dA-Fa-f", r = "[" + t + "]", s = "\\w-\\.~", n = "!\\$&'\\(\\)\\*\\+,;=", a = "%" + t, i = s + a + n + ":@", o = "[" + i + "]", l = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + l + "\\.){3}" + l;
                    const c = r + "{1,4}", u = "(?:" + c + ":" + c + "|" + e.ipv4address + ")", f = "(?:" + c + ":){6}" + u, m = "::(?:" + c + ":){5}" + u, h = "(?:" + c + ")?::(?:" + c + ":){4}" + u, p = "(?:(?:" + c + ":){0,1}" + c + ")?::(?:" + c + ":){3}" + u, d = "(?:(?:" + c + ":){0,2}" + c + ")?::(?:" + c + ":){2}" + u, g = "(?:(?:" + c + ":){0,3}" + c + ")?::" + c + ":" + u, y = "(?:(?:" + c + ":){0,4}" + c + ")?::" + u, b = "(?:(?:" + c + ":){0,5}" + c + ")?::" + c, _ = "(?:(?:" + c + ":){0,6}" + c + ")?::";
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + f + "|" + m + "|" + h + "|" + p + "|" + d + "|" + g + "|" + y + "|" + b + "|" + _ + ")", e.ipvFuture = "v" + r + "+\\.[" + s + n + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const v = "[" + s + a + n + ":]*", w = "[" + s + a + n + "]{1,255}", $ = "(?:\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]|" + e.ipv4address + "|" + w + ")", x = "(?:" + v + "@)?" + $ + "(?::\\d*)?", j = "(?:" + v + "@)?(" + $ + ")(?::\\d*)?", k = o + "*", R = o + "+", S = "(?:\\/" + k + ")*", A = "\\/(?:" + R + S + ")?", O = R + S, E = "[" + s + a + n + "@]+" + S, C = "(?:\\/\\/\\/" + k + S + ")";
                    return e.hierPart = "(?:(?:\\/\\/" + x + S + ")|" + A + "|" + O + "|" + C + ")", e.hierPartCapture = "(?:(?:\\/\\/" + j + S + ")|" + A + "|" + O + ")", e.relativeRef = "(?:(?:\\/\\/" + x + S + ")|" + A + "|" + E + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + j + S + ")|" + A + "|" + E + "|)", e.query = "[" + i + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + i + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + i + "\\/\\?]*", e;
                }
            };
            a.rfc3986 = a.generate(), t.ip = {
                v4Cidr: a.rfc3986.ipv4Cidr,
                v6Cidr: a.rfc3986.ipv6Cidr,
                ipv4: a.rfc3986.ipv4address,
                ipv6: a.rfc3986.ipv6address,
                ipvfuture: a.rfc3986.ipvFuture
            }, a.createRegex = function(e) {
                const t = a.rfc3986, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", i = e.domain ? t.relativeRefCapture : t.relativeRef;
                if (e.relativeOnly) return a.wrap(i + r);
                let o = "";
                if (e.scheme) {
                    s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                    const r = [].concat(e.scheme);
                    s(r.length >= 1, "scheme must have at least 1 scheme specified");
                    const a = [];
                    for(let e = 0; e < r.length; ++e){
                        const i = r[e];
                        s(i instanceof RegExp || "string" == typeof i, "scheme at position " + e + " must be a RegExp or String"), i instanceof RegExp ? a.push(i.source.toString()) : (s(t.schemeRegex.test(i), "scheme at position " + e + " must be a valid scheme"), a.push(n(i)));
                    }
                    o = a.join("|");
                }
                const l = "(?:" + (o ? "(?:" + o + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")", c = e.allowRelative ? "(?:" + l + "|" + i + ")" : l;
                return a.wrap(c + r, o);
            }, a.wrap = function(e, t) {
                return {
                    raw: e = `(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])${e}`,
                    regex: new RegExp(`^${e}$`),
                    scheme: t
                };
            }, a.uriRegex = a.createRegex({}), t.regex = function(e = {}) {
                return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? a.createRegex(e) : a.uriRegex;
            };
        },
        3982 (e, t) {
            "use strict";
            const r = {
                operators: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "<=",
                    ">",
                    ">=",
                    "==",
                    "!=",
                    "&&",
                    "||",
                    "??"
                ],
                operatorCharacters: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "=",
                    ">",
                    "&",
                    "|",
                    "?"
                ],
                operatorsOrder: [
                    [
                        "^"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "<",
                        "<=",
                        ">",
                        ">="
                    ],
                    [
                        "==",
                        "!="
                    ],
                    [
                        "&&"
                    ],
                    [
                        "||",
                        "??"
                    ]
                ],
                operatorsPrefix: [
                    "!",
                    "n"
                ],
                literals: {
                    '"': '"',
                    "`": "`",
                    "'": "'",
                    "[": "]"
                },
                numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/,
                tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                symbol: Symbol("formula"),
                settings: Symbol("settings")
            };
            t.Parser = class {
                constructor(e, t = {}){
                    if (!t[r.settings] && t.constants) for(const e in t.constants){
                        const r = t.constants[e];
                        if (null !== r && ![
                            "boolean",
                            "number",
                            "string"
                        ].includes(typeof r)) throw new Error(`Formula constant ${e} contains invalid ${typeof r} value type`);
                    }
                    this.settings = t[r.settings] ? t : Object.assign({
                        [r.settings]: !0,
                        constants: {},
                        functions: {}
                    }, t), this.single = null, this._parts = null, this._parse(e);
                }
                _parse(e) {
                    let s = [], n = "", a = 0, i = !1;
                    const o = (e)=>{
                        if (a) throw new Error("Formula missing closing parenthesis");
                        const o = s.length ? s[s.length - 1] : null;
                        if (i || n || e) {
                            if (o && "reference" === o.type && ")" === e) return o.type = "function", o.value = this._subFormula(n, o.value), void (n = "");
                            if (")" === e) {
                                const e = new t.Parser(n, this.settings);
                                s.push({
                                    type: "segment",
                                    value: e
                                });
                            } else if (i) {
                                if ("]" === i) return s.push({
                                    type: "reference",
                                    value: n
                                }), void (n = "");
                                s.push({
                                    type: "literal",
                                    value: n
                                });
                            } else if (r.operatorCharacters.includes(n)) o && "operator" === o.type && r.operators.includes(o.value + n) ? o.value += n : s.push({
                                type: "operator",
                                value: n
                            });
                            else if (n.match(r.numberRx)) s.push({
                                type: "constant",
                                value: parseFloat(n)
                            });
                            else if (void 0 !== this.settings.constants[n]) s.push({
                                type: "constant",
                                value: this.settings.constants[n]
                            });
                            else {
                                if (!n.match(r.tokenRx)) throw new Error(`Formula contains invalid token: ${n}`);
                                s.push({
                                    type: "reference",
                                    value: n
                                });
                            }
                            n = "";
                        }
                    };
                    for (const t of e)i ? t === i ? (o(), i = !1) : n += t : a ? "(" === t ? (n += t, ++a) : ")" === t ? (--a, a ? n += t : o(t)) : n += t : t in r.literals ? i = r.literals[t] : "(" === t ? (o(), ++a) : r.operatorCharacters.includes(t) ? (o(), n = t, o()) : " " !== t ? n += t : o();
                    o(), s = s.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== s[t - 1].type ? e : {
                            type: "operator",
                            value: "n"
                        });
                    let l = !1;
                    for (const e of s){
                        if ("operator" === e.type) {
                            if (r.operatorsPrefix.includes(e.value)) continue;
                            if (!l) throw new Error("Formula contains an operator in invalid position");
                            if (!r.operators.includes(e.value)) throw new Error(`Formula contains an unknown operator ${e.value}`);
                        } else if (l) throw new Error("Formula missing expected operator");
                        l = !l;
                    }
                    if (!l) throw new Error("Formula contains invalid trailing operator");
                    1 === s.length && [
                        "reference",
                        "literal",
                        "constant"
                    ].includes(s[0].type) && (this.single = {
                        type: "reference" === s[0].type ? "reference" : "value",
                        value: s[0].value
                    }), this._parts = s.map((e)=>{
                        if ("operator" === e.type) return r.operatorsPrefix.includes(e.value) ? e : e.value;
                        if ("reference" !== e.type) return e.value;
                        if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error(`Formula contains invalid reference ${e.value}`);
                        return this.settings.reference ? this.settings.reference(e.value) : r.reference(e.value);
                    });
                }
                _subFormula(e, s) {
                    const n = this.settings.functions[s];
                    if ("function" != typeof n) throw new Error(`Formula contains unknown function ${s}`);
                    let a = [];
                    if (e) {
                        let t = "", n = 0, i = !1;
                        const o = ()=>{
                            if (!t) throw new Error(`Formula contains function ${s} with invalid arguments ${e}`);
                            a.push(t), t = "";
                        };
                        for(let s = 0; s < e.length; ++s){
                            const a = e[s];
                            i ? (t += a, a === i && (i = !1)) : a in r.literals && !n ? (t += a, i = r.literals[a]) : "," !== a || n ? (t += a, "(" === a ? ++n : ")" === a && --n) : o();
                        }
                        o();
                    }
                    return a = a.map((e)=>new t.Parser(e, this.settings)), function(e) {
                        const t = [];
                        for (const r of a)t.push(r.evaluate(e));
                        return n.call(e, ...t);
                    };
                }
                evaluate(e) {
                    const t = this._parts.slice();
                    for(let s = t.length - 2; s >= 0; --s){
                        const n = t[s];
                        if (n && "operator" === n.type) {
                            const a = t[s + 1];
                            t.splice(s + 1, 1);
                            const i = r.evaluate(a, e);
                            t[s] = r.single(n.value, i);
                        }
                    }
                    return r.operatorsOrder.forEach((s)=>{
                        for(let n = 1; n < t.length - 1;)if (s.includes(t[n])) {
                            const s = t[n], a = r.evaluate(t[n - 1], e), i = r.evaluate(t[n + 1], e);
                            t.splice(n, 2);
                            const o = r.calculate(s, a, i);
                            t[n - 1] = 0 === o ? 0 : o;
                        } else n += 2;
                    }), r.evaluate(t[0], e);
                }
            }, t.Parser.prototype[r.symbol] = !0, r.reference = function(e) {
                return function(t) {
                    return t && void 0 !== t[e] ? t[e] : null;
                };
            }, r.evaluate = function(e, t) {
                return null === e ? null : "function" == typeof e ? e(t) : e[r.symbol] ? e.evaluate(t) : e;
            }, r.single = function(e, t) {
                if ("!" === e) return !t;
                const r = -t;
                return 0 === r ? 0 : r;
            }, r.calculate = function(e, t, s) {
                if ("??" === e) return r.exists(t) ? t : s;
                if ("string" == typeof t || "string" == typeof s) {
                    if ("+" === e) return (t = r.exists(t) ? t : "") + (r.exists(s) ? s : "");
                } else switch(e){
                    case "^":
                        return Math.pow(t, s);
                    case "*":
                        return t * s;
                    case "/":
                        return t / s;
                    case "%":
                        return t % s;
                    case "+":
                        return t + s;
                    case "-":
                        return t - s;
                }
                switch(e){
                    case "<":
                        return t < s;
                    case "<=":
                        return t <= s;
                    case ">":
                        return t > s;
                    case ">=":
                        return t >= s;
                    case "==":
                        return t === s;
                    case "!=":
                        return t !== s;
                    case "&&":
                        return t && s;
                    case "||":
                        return t || s;
                }
                return null;
            }, r.exists = function(e) {
                return null != e;
            };
        },
        486 () {},
        554 () {},
        9017 () {},
        125 () {},
        5238 () {},
        8967 () {},
        6913 (e) {
            "use strict";
            e.exports = JSON.parse('{"version":"17.13.9"}');
        }
    }, t = {}, function r(s) {
        var n = t[s];
        if (void 0 !== n) return n.exports;
        var a = t[s] = {
            exports: {}
        };
        return e[s](a, a.exports, r), a.exports;
    }(1100);
});


var $5eb679002f41e3c8$exports = {};

const $5eb679002f41e3c8$var$customerDataSchema = $f427e7b00f0901b4$exports.object({
    hasNoCustomerNumber: $f427e7b00f0901b4$exports.boolean().default(false).optional().messages({
        'boolean.base': 'errors.customer.hasNoNumber.boolean',
        'any.required': 'errors.customer.hasNoNumber.required'
    }),
    customerNumber: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.string().required().messages({
            'string.empty': 'errors.customer.number.required',
            'any.required': 'errors.customer.number.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    contactPersonPhone: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.contactPersonPhone.required',
            'any.required': 'errors.contactPersonPhone.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    }),
    contactPersonEmail: $f427e7b00f0901b4$exports.string().email({
        tlds: {
            allow: false
        }
    }).when('hasNoCustomerNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.contactPersonEmail.required',
            'string.email': 'errors.contactPersonEmail.invalid',
            'any.required': 'errors.contactPersonEmail.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    }),
    // Optional for private customers (apps that send customerType); required otherwise
    customerCompany: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.when('customerType', {
            is: 'private',
            then: $f427e7b00f0901b4$exports.allow('').optional(),
            otherwise: $f427e7b00f0901b4$exports.required().messages({
                'string.empty': 'errors.customer.company.required',
                'any.required': 'errors.customer.company.required'
            })
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerCompanyEmail: $f427e7b00f0901b4$exports.string().trim().email({
        tlds: {
            allow: false
        }
    }).allow('').optional(),
    customerName: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.name.required',
            'any.required': 'errors.customer.name.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerLastName: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.lastName.required',
            'any.required': 'errors.customer.lastName.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerStreet: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.street.required',
            'any.required': 'errors.customer.street.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerHouseNumber: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.houseNumber.required',
            'any.required': 'errors.customer.houseNumber.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerPostalCodeNumber: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.postalCode.required',
            'string.pattern.base': 'errors.customer.postalCode.invalid',
            'any.required': 'errors.customer.postalCode.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerCity: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.city.required',
            'any.required': 'errors.customer.city.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    }),
    customerMail: $f427e7b00f0901b4$exports.string().email({
        tlds: {
            allow: false
        }
    }).when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.mail.required',
            'string.email': 'errors.customer.mail.invalid',
            'any.required': 'errors.customer.mail.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().email({
            tlds: {
                allow: false
            }
        }).allow('').optional()
    }),
    customerPhone: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.customer.phone.required',
            'any.required': 'errors.customer.phone.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.string().trim().allow('').optional()
    })
});
$5eb679002f41e3c8$exports = $5eb679002f41e3c8$var$customerDataSchema;


var $779ca4e73b2f4474$exports = {};

const $779ca4e73b2f4474$var$buildingData = $f427e7b00f0901b4$exports.object({
    buildingStreet: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.building.street.required',
        'any.required': 'errors.building.street.required'
    }),
    buildingHouseNumber: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.building.houseNumber.required',
        'any.required': 'errors.building.houseNumber.required'
    }),
    buildingPostalCodeNumber: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.building.postalCode.required',
        'string.pattern.base': 'errors.building.postalCode.invalid',
        'any.required': 'errors.building.postalCode.required'
    }),
    buildingCity: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.building.city.required',
        'any.required': 'errors.building.city.required'
    }),
    buildingCountry: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.building.country.required',
        'any.required': 'errors.building.country.required'
    })
});
$779ca4e73b2f4474$exports = $779ca4e73b2f4474$var$buildingData;


var $3a96b40d46ed4e44$exports = {};
$3a96b40d46ed4e44$exports = JSON.parse("{\"indoorstations\":[\"ISW3030-0140\",\"ISW5030-0145\",\"ISW3330-0140\",\"ISW5010-0145\",\"ISW5031-0145\",\"ISW5033-0145\",\"ISW6031-0145\",\"ISW7030-0140\",\"ISH7030-0140\",\"ISW3130-0140\",\"CAI2000-0150\",\"CAI2000-0151\",\"CAI2000-0152\",\"CAI2000-0156\",\"CAI2001-0150\",\"CAI2002-0140\",\"CAI2010-0150\",\"CAI2010-0151\",\"CAI2010-0152\",\"CAI2010-0156\",\"CAI2300-0150\",\"CAI2300-0151\",\"CAI2300-0152\",\"CAI2300-0156\",\"IMM1100-0140\",\"IMM1110-0140\",\"IMM1300-0140\",\"IMM1310-0140\",\"IMM1500-0140\",\"IMM2100-0140\",\"IMM2110-0140\",\"IMM2300-0140\",\"IMM2310-0140\",\"ISH3030-0140\",\"ISH3130-0140\",\"ISH3230-0140\",\"ISH3240-0140\",\"ISW3230-0140\",\"IVH3222-0140\",\"IVH4222-0140\",\"IVH7510-0140\",\"IVW2221-0153\",\"IVW5110-0145\",\"IVW5111-0145\",\"IVW5211-0145\",\"IVW5411-0145\",\"IVW5511-0145\",\"IVW7510-0140\",\"IVW9000-0110\",\"IVW9020-0110\",\"IVW9030-0140\",\"IVW9110-0187\",\"ISW3231-0140\",\"ISW6010-0145\",\"IVW2221-0155\",\"210010657-00\",\"200049080-01\",\"200037008-00\",\"200040023-00\",\"200040116-00\",\"200049270-01\",\"200040578-00\",\"210005918-00\",\"IVW9110-0000\",\"IVW9110-RAL\",\"ISWM7000-0140\",\"ISHM7000-0140\",\"ISH7032-0140\",\"IVH7512-0140\",\"ISW7032-0140\",\"IVH7510-1140\",\"IVW7510-1140\",\"ISH7030-1140\",\"ISW7030-1140\",\"IVW7512-0140\",\"ISWM7200-0140\",\"CAI2000-1156\",\"ISW3340-0140\",\"CAI2400-0156\",\"CAI2500-0156\",\"IVW3012-0210\",\"CAI2400-0150\",\"IVW6521-0145\",\"IVW6511-0145\"],\"outdoorstations\":[\"ASA101000-0010\",\"ASA110101-0010\",\"ASA110103-0010\",\"ASA110104-0010\",\"ASA110206-0010\",\"ASA110208-0010\",\"ASA120210-0010\",\"ASA120212-0010\",\"ASA120214-0010\",\"ASA120216-0010\",\"ASA130218-0010\",\"ASA130220-0010\",\"ASA130222-0010\",\"ASA130224-0010\",\"ASB01010-0210\",\"ASB01010-0230\",\"ASB01020-0210\",\"ASB01020-0230\",\"ASB01030-0210\",\"ASB01030-0230\",\"ASB01040-0210\",\"ASB01040-0230\",\"ASB01050-0210\",\"ASB01050-0230\",\"ASB01060-0210\",\"ASB01060-0230\",\"ASB01070-0210\",\"ASB01070-0230\",\"ASB01080-0210\",\"ASB01080-0230\",\"ASB01090-0210\",\"ASB01090-0230\",\"ASB01100-0210\",\"ASB01100-0230\",\"ASB02080-0210\",\"ASB02080-0230\",\"ASB02100-0210\",\"ASB02100-0230\",\"ASB02120-0210\",\"ASB02120-0230\",\"ASB02140-0210\",\"ASB02140-0230\",\"ASB02160-0210\",\"ASB02160-0230\",\"ASB02180-0210\",\"ASB02180-0230\",\"ASB02200-0210\",\"ASB02200-0230\",\"ASB03120-0210\",\"ASB03120-0230\",\"ASB03150-0210\",\"ASB03150-0230\",\"ASB03180-0210\",\"ASB03180-0230\",\"ASB03210-0210\",\"ASB03210-0230\",\"ASB03240-0210\",\"ASB03240-0230\",\"ASB03270-0210\",\"ASB03270-0230\",\"ASB03300-0210\",\"ASB03300-0230\",\"ASD51010-0010\",\"ASE51040-0010\",\"ASE51060-0010\",\"ASE51080-0010\",\"ASE51100-0010\",\"ASE51120-0010\",\"ASE51140-0010\",\"ASE51160-0010\",\"ASI12000-0000\",\"ASI12010-0000\",\"ASI21000-0000\",\"ASI31000-0000\",\"ASI91000-0000\",\"ASN01010-0210\",\"ASN01010-0230\",\"ASN01040-0210\",\"ASU101100-0010\",\"ASU101200-0010\",\"ASU101300-0010\",\"ASX13001-0010\",\"ASX13002-0010\",\"ASX13003-0010\",\"ASX13004-0010\",\"ASX13005-0010\",\"ASX13006-0010\",\"AVA101000-0010\",\"AVA210101-0010\",\"AVA210102-0010\",\"AVA210103-0010\",\"AVA210104-0010\",\"AVA210106-0010\",\"AVA210108-0010\",\"AVA210206-0010\",\"AVA210208-0010\",\"AVA220210-0010\",\"AVA220212-0010\",\"AVA220214-0010\",\"AVA220216-0010\",\"AVA230218-0010\",\"AVA230220-0010\",\"AVA230222-0010\",\"AVA230224-0010\",\"AVA410101-0010\",\"AVA410102-0010\",\"AVA410103-0010\",\"AVA410104-0010\",\"AVA410206-0010\",\"AVA410208-0010\",\"AVA420210-0010\",\"AVA420212-0010\",\"AVA420214-0010\",\"AVA420216-0010\",\"AVA430218-0010\",\"AVA430220-0010\",\"AVA430222-0010\",\"AVA430224-0010\",\"AVB01010-0210\",\"AVB01010-0230\",\"AVB01020-0210\",\"AVB01020-0230\",\"AVB01030-0210\",\"AVB01030-0230\",\"AVB01040-0210\",\"AVB01040-0230\",\"AVB01050-0210\",\"AVB01050-0230\",\"AVB01060-0210\",\"AVB01060-0230\",\"AVB01070-0210\",\"AVB01070-0230\",\"AVB01080-0210\",\"AVB01080-0230\",\"AVB02080-0210\",\"AVB02080-0230\",\"AVB02100-0210\",\"AVB02100-0230\",\"AVB02120-0210\",\"AVB02120-0230\",\"AVB02140-0210\",\"AVB02140-0230\",\"AVB02160-0210\",\"AVB02160-0230\",\"AVB03120-0210\",\"AVB03120-0230\",\"AVB03150-0210\",\"AVB03150-0230\",\"AVB03180-0210\",\"AVB03180-0230\",\"AVB03210-0210\",\"AVB03210-0230\",\"AVB03240-0210\",\"AVB03240-0230\",\"AVC11010-0010\",\"AVC11020-0010\",\"AVC11030-0010\",\"AVC12010-0010\",\"AVC12020-0010\",\"AVC12030-0010\",\"AVD14013-0010\",\"AVD14013-0012\",\"AVD14013-0018\",\"AVD14023-0010\",\"AVD14023-0011\",\"AVD14023-0012\",\"AVD14023-0018\",\"AVD14033-0010\",\"AVD14033-0011\",\"AVD14033-0012\",\"AVD14033-0018\",\"AVD54013-0010\",\"AVD94010-0010\",\"AVD94020-0010\",\"AVD95040-0010\",\"AVD97010-0010\",\"AVD98040-0010\",\"AVE14043-0010\",\"AVE14043-0011\",\"AVE14043-0012\",\"AVE14043-0018\",\"AVE14063-0010\",\"AVE14063-0011\",\"AVE14063-0012\",\"AVE14063-0018\",\"AVE14083-0010\",\"AVE14083-0011\",\"AVE14083-0012\",\"AVE14083-0018\",\"AVE14103-0010\",\"AVE14103-0011\",\"AVE14103-0012\",\"AVE14103-0018\",\"AVE14123-0010\",\"AVE14123-0011\",\"AVE14123-0012\",\"AVE14123-0018\",\"AVE14143-0010\",\"AVE14143-0011\",\"AVE14143-0012\",\"AVE14143-0018\",\"AVE14163-0010\",\"AVE14163-0011\",\"AVE14163-0012\",\"AVE14163-0018\",\"AVE54043-0010\",\"AVE54063-0010\",\"AVE54083-0010\",\"AVE54103-0010\",\"AVE54123-0010\",\"AVU101100-0010\",\"AVU101200-0010\",\"AVU101300-0010\",\"AVU14010-0010\",\"AVU14010-0012\",\"AVU14010-0019\",\"AVU14010-0030\",\"AVU14020-0010\",\"AVU14020-0012\",\"AVU14020-0019\",\"AVU14020-0030\",\"AVU14030-0010\",\"AVU14030-0012\",\"AVU14030-0019\",\"AVU14030-0030\",\"AVU14040-0010\",\"AVU14040-0019\",\"AVU14040-0030\",\"AVU14050-0010\",\"AVU14050-0012\",\"AVU14050-0019\",\"AVU14050-0030\",\"AVU14060-0010\",\"AVU14060-0012\",\"AVU14060-0019\",\"AVU14060-0030\",\"AVU14070-0010\",\"AVU14070-0012\",\"AVU14070-0019\",\"AVU14070-0030\",\"AVU14080-0010\",\"AVU14080-0012\",\"AVU14080-0019\",\"AVU14080-0030\",\"AVU15080-0010\",\"AVU15080-0012\",\"AVU15080-0019\",\"AVU15080-0030\",\"AVU15100-0010\",\"AVU15100-0012\",\"AVU15100-0019\",\"AVU15100-0030\",\"AVU15120-0010\",\"AVU15120-0012\",\"AVU15120-0019\",\"AVU15120-0030\",\"AVU15140-0010\",\"AVU15140-0012\",\"AVU15140-0019\",\"AVU15140-0030\",\"AVU15160-0010\",\"AVU15160-0012\",\"AVU15160-0019\",\"AVU15160-0030\",\"AVU16120-0010\",\"AVU16120-0012\",\"AVU16120-0019\",\"AVU16120-0030\",\"AVU16150-0010\",\"AVU16150-0012\",\"AVU16150-0019\",\"AVU16150-0030\",\"AVU16180-0010\",\"AVU16180-0012\",\"AVU16180-0019\",\"AVU16180-0030\",\"AVU16210-0010\",\"AVU16210-0012\",\"AVU16210-0019\",\"AVU16210-0030\",\"AVU16240-0010\",\"AVU16240-0012\",\"AVU16240-0019\",\"AVU16240-0030\",\"AVU94010-0010\",\"ADA45015-0030\",\"ADA59010-0030\",\"ADA59080-0030\",\"ADA59210-0030\",\"ADA59280-0030\",\"ADI59010-0057\",\"ADI59080-0057\",\"ADI59210-0057\",\"ADI59280-0057\",\"ADU45015-0030\",\"ADU59010-0030\",\"ADU59080-0030\",\"ADU59210-0030\",\"ADU59280-0030\",\"AEA502000-0010\",\"AEA520208-0010\",\"AEA520212-0010\",\"AEA520216-0010\",\"AEA530216-0010\",\"AEA530220-0010\",\"AEA530224-0010\",\"AMI10105-0710\",\"AMI10105-0757\",\"AMI10300-0010\",\"AMI10300-0057\",\"AMI10410-0010\",\"AMI10410-0057\",\"AMI10510-0010\",\"AMI10510-0057\",\"AMI10620-0010\",\"AMI10620-0057\",\"AMI10700-0010\",\"AMI10700-0057\",\"AMI10800-0010\",\"AMI10800-0057\",\"AMI10911-0010\",\"AMI10911-0057\",\"AMI10912-0010\",\"AMI10912-0057\",\"AMI10913-0010\",\"AMI10913-0057\",\"AMI10914-0010\",\"AMI10914-0057\",\"AMI11000-0080\",\"AMI11110-0010\",\"AMI11110-0057\",\"AMI11200-0010\",\"AMI11200-0057\",\"AMI11300-0000\",\"AMI11400-0010\",\"AMI11400-0057\",\"AMI11603-0010\",\"AMI11603-0057\",\"AMI12300-0080\",\"AMI50-3001\",\"AMI50-3002\",\"AMI50-3003\",\"AMI50-3004\",\"AMI50-3005\",\"AMI50-3006\",\"AMI50-3007\",\"AMI50-3008\",\"AMI50-3010\",\"AMI50-3011\",\"AMI50-3012\",\"AMI50-3013\",\"AZC41000-0010\",\"AZC50000-0010\",\"AZF50000-0010\",\"AZF50000-0015\",\"BDA1000-000\",\"CAE1001-0150\",\"CAE1001-0151\",\"CAE1001-0156\",\"CAE1002-0150\",\"CAE1002-0151\",\"CAE1002-0156\",\"CAE1003-0150\",\"CAE1003-0151\",\"CAE1003-0156\",\"CAE3003-IP-0150\",\"CAE3003-IP-0156\",\"CAE3303-IP-0156\",\"CAE3403-IP-0150\",\"CAE3403-IP-0156\",\"KTU11051-0010\",\"M30U100000-0001\",\"M30U100000-0002\",\"M30U100000-0003\",\"M30U100000-0004\",\"M30U111000-0001\",\"M30U111000-0002\",\"M30U111000-0003\",\"M30U111100-0003\",\"M30U111111-0001\",\"M30U200000-0001\",\"M30U300000-0004\",\"M30U300000-0005\",\"M30U300000-0012\",\"M30U300000-0013\",\"M30U300000-0014\",\"M30U330000-0003\",\"M30U330000-0005\",\"M30U400000-0002\",\"M30U400000-0003\",\"M30U400000-0004\",\"M30U400000-0005\",\"M30U400000-0007\",\"M30U500000-0005\",\"M30U500000-0006\",\"M30U500000-0012\",\"M30U600000-0001\",\"M30U600000-0003\",\"NPAK01-EN\",\"PAK01-EN\",\"PAK01-EN/E\",\"PAK02-EN\",\"PAK02-EN/E\",\"PAK03-EN\",\"PAK03-EN/E\",\"PAK04-EN\",\"PAK04-EN/E\",\"PAK05-EN\",\"PAK05-EN/E\",\"PAK06-EN\",\"PAK06-EN/E\",\"PAK07-EN\",\"PAK07-EN/E\",\"PAK08-EN\",\"PAK08-EN/E\",\"PDS01-EB/04\",\"PDS01-EN/04\",\"PDS01-WS/04\",\"PDS02-EB/04\",\"PDS02-EN/04\",\"PDS02-WS/04\",\"PDS03-EB/04\",\"PDS03-EN/04\",\"PDS03-WS/04\",\"PDT04-EB/04\",\"PDT04-EN/04\",\"PDT04-WS/04\",\"PDT05-EB/04\",\"PDT05-EN/04\",\"PDT05-WS/04\",\"PES04-EB/04\",\"PES04-EN/04\",\"PES04-WS/04\",\"PES06-EB/04\",\"PES06-EN/04\",\"PES06-WS/04\",\"PES08-EB/04\",\"PES08-EN/04\",\"PES08-WS/04\",\"PES10-EB/04\",\"PES10-EN/04\",\"PES10-WS/04\",\"PES12-EB/04\",\"PES12-EN/04\",\"PES12-WS/04\",\"PES14-EB/04\",\"PES14-EN/04\",\"PES14-WS/04\",\"PES16-EB/04\",\"PES16-EN/04\",\"PES16-WS/04\",\"PES18-EB/04\",\"PES18-EN/04\",\"PES18-WS/04\",\"PES20-EB/04\",\"PES20-EN/04\",\"PES20-WS/04\",\"PET12-EB/04\",\"PET12-EN/04\",\"PET12-EN/E\",\"PET12-WS/04\",\"PET14-EB/04\",\"PET14-EN/04\",\"PET14-EN/E\",\"PET14-WS/04\",\"PET16-EB/04\",\"PET16-EN/04\",\"PET16-EN/E\",\"PET16-WS/04\",\"PET18-EB/04\",\"PET18-EN/04\",\"PET18-EN/E\",\"PET18-WS/04\",\"PET20-EB/04\",\"PET20-EN/04\",\"PET20-EN/E\",\"PET20-WS/04\",\"PET22-EB/04\",\"PET22-EN/04\",\"PET22-EN/E\",\"PET22-WS/04\",\"PET24-EB/04\",\"PET24-EN/04\",\"PET24-WS/04\",\"PET26-EB/04\",\"PET26-EN/04\",\"PET26-EN/E\",\"PET26-WS/04\",\"PET28-EB/04\",\"PET28-EN\",\"PET28-EN/04\",\"PET28-EN/E\",\"PET28-WS/04\",\"PSK01-EN\",\"PSK02-EN\",\"PUK01/1-EB\",\"PUK01/1-EN\",\"PUK01/1-EN/E\",\"PUK01/1-ES\",\"PUK01/1-WS\",\"PUK02/1-EB\",\"PUK02/1-EN\",\"PUK02/1-EN/E\",\"PUK02/1-ES\",\"PUK02/1-WS\",\"PUK03/1-EB\",\"PUK03/1-EN\",\"PUK03/1-EN/E\",\"PUK03/1-ES\",\"PUK03/1-WS\",\"PUK04/1-EB\",\"PUK04/1-EN\",\"PUK04/1-EN/E\",\"PUK04/1-ES\",\"PUK04/1-WS\",\"PUK05/1-EB\",\"PUK05/1-EN\",\"PUK05/1-EN/E\",\"PUK05/1-ES\",\"PUK05/1-WS\",\"PUK06/1-EN\",\"PUK06/1-EN/E\",\"PUK06/1-ES\",\"PUK06/1-WS\",\"PUK07/1-EN\",\"PUK07/1-EN/E\",\"PUK07/1-EN/P\",\"PUK07/1-ES\",\"PUK07/1-WS\",\"PUK08/1-EN\",\"PUK08/1-EN/E\",\"PUK08/1-ES\",\"PUK08/1-WS\",\"PUK08/2-EB\",\"PUK08/2-EN\",\"PUK08/2-EN/E\",\"PUK08/2-ES\",\"PUK08/2-WS\",\"PUK09/1-EB\",\"PUK09/1-EN\",\"PUK09/1-EN/E\",\"PUK09/1-ES\",\"PUK09/1-WS\",\"PUK10/1-EB\",\"PUK10/1-EN\",\"PUK10/1-EN/E\",\"PUK10/1-ES\",\"PUK10/1-WS\",\"PUK10/2-EN\",\"PUK10/2-EN/E\",\"PUK10/2-ES\",\"PUK10/2-WS\",\"PUK12/2-EB\",\"PUK12/2-EN\",\"PUK12/2-EN/E\",\"PUK12/2-ES\",\"PUK12/2-WS\",\"PUK12/3-EB\",\"PUK12/3-EN\",\"PUK12/3-EN/E\",\"PUK12/3-ES\",\"PUK12/3-WS\",\"PUK14/2-EB\",\"PUK14/2-EN\",\"PUK14/2-EN/E\",\"PUK14/2-ES\",\"PUK14/2-WS\",\"PUK15/3-EB\",\"PUK15/3-EN\",\"PUK15/3-EN/E\",\"PUK15/3-ES\",\"PUK15/3-WS\",\"PUK16/2-EB\",\"PUK16/2-EN\",\"PUK16/2-EN/E\",\"PUK16/2-ES\",\"PUK16/2-WS\",\"PUK18/2-EB\",\"PUK18/2-EN\",\"PUK18/2-EN/E\",\"PUK18/2-ES\",\"PUK18/2-WS\",\"PUK18/3-EB\",\"PUK18/3-EN\",\"PUK18/3-EN/E\",\"PUK18/3-ES\",\"PUK18/3-WS\",\"PUK20/2-EB\",\"PUK20/2-EN\",\"PUK20/2-EN/E\",\"PUK20/2-ES\",\"PUK20/2-WS\",\"PUK21/3-EB\",\"PUK21/3-EN\",\"PUK21/3-EN/E\",\"PUK21/3-ES\",\"PUK21/3-WS\",\"PUK24/3-EB\",\"PUK24/3-EN\",\"PUK24/3-EN/E\",\"PUK24/3-ES\",\"PUK24/3-WS\",\"PUK27/3-EB\",\"PUK27/3-EN\",\"PUK27/3-EN/E\",\"PUK27/3-ES\",\"PUK27/3-WS\",\"PUK30/3-EB\",\"PUK30/3-EN\",\"PUK30/3-EN/E\",\"PUK30/3-ES\",\"PUK30/3-WS\",\"VKR10-EB\",\"VKR10-EM\",\"VKR10-EN\",\"VKR10-ES\",\"VKR10-WS\",\"AVA630220-0010\",\"AVA620212-0010\",\"AVA620210-0010\",\"AVA610206-0010\",\"AVA610104-0010\",\"AVA610103-0010\",\"AVA630222-0010\",\"AVA630218-0010\",\"AVA620214-0010\",\"AVA620216-0010\",\"AVA610208-0010\",\"AVA610102-0010\",\"AVA630224-0010\",\"AVA610101-0010\",\"ADU64000-0030\",\"CAE2103-0156\",\"CAE2101-0150\",\"CAE2101-0151\",\"CAE2101-0156\",\"CAE2102-0150\",\"CAE2102-0151\",\"CAE2102-0156\",\"CAE2103-0150\",\"CAE2103-0151\",\"AMI12500-0010\",\"AVD14013-0011\",\"AVU14040-0012\",\"KTU11050-0010\",\"KTU11052-0010\",\"KTU11060-0010\",\"KTU11062-0010\",\"KTU11070-0010\",\"KTU11072-0010\",\"KTU11080-0010\",\"KTU11082-0010\",\"KTU11090-0010\",\"KTU11092-0010\",\"KTU11100-0010\",\"KTU11102-0010\",\"KTU11110-0010\",\"KTU11112-0010\",\"KTU11120-0010\",\"KTU11122-0010\",\"KTU12100-0010\",\"KTU12102-0010\",\"KTU12120-0010\",\"KTU12122-0010\",\"KTU12140-0010\",\"KTU12142-0010\",\"KTU12160-0010\",\"KTU12162-0010\",\"KTU12180-0010\",\"KTU12182-0010\",\"KTU12200-0010\",\"KTU12202-0010\",\"KTU13150-0010\",\"KTU13152-0010\",\"KTU13180-0010\",\"KTU13182-0010\",\"KTU13210-0010\",\"KTU13212-0010\",\"PFS08-EN\",\"PFS12-EN\",\"PFS16-EN\",\"PFS20-EN\",\"PFS24-EN\",\"PFS28-EN\",\"PFS32-EN\",\"PUK06/1-EB\",\"PUK07/1-EB\",\"PUK08/1-EB\",\"PUK10/2-EB\",\"BDA1000-001\",\"BDA1000-002\",\"ZAA2009-0030\",\"ZAA2010-0010\",\"AMI10200-0057\",\"AVN01010-0210\",\"ADU14031-0010\",\"ADU14033-0010\",\"ADU14041-0010\",\"ADU14043-0010\",\"ADU14131-0010\",\"ADU14143-0010\",\"ADU14233-0010\",\"ADU14133-0010\",\"ADU32112-0010\",\"ADU33112-0010\",\"ADU32013-0010\",\"ADU32013-0030\",\"ADU31013-0010\",\"ADU31013-0030\",\"ADU24113-0010\",\"ADU31214-0030\",\"ADU34114-0030\",\"ADU32213-0030\",\"ADU31113-0030\",\"ADU31212-0010\",\"ADU14141-0010\",\"ADU32114-0010\",\"ADU34013-0010\",\"ADU31213-0010\",\"ADU32114-0030\",\"ADU14243-0010\",\"ADU14241-0010\",\"ADU32113-0030\",\"ADU31212-0030\",\"ADU31214-0010\",\"ADU33112-0030\",\"ADU34112-0030\",\"ADU31114-0030\",\"ADU33213-0030\",\"ADU34012-0030\",\"ADU33113-0010\",\"ADU31112-0030\",\"ADU33113-0030\",\"ADU32012-0030\",\"ADU33012-0010\",\"ADU34114-0010\",\"ADU14111-0010\",\"ADU32113-0010\",\"ADU33114-0010\",\"ADU34112-0010\",\"ADU31014-0010\",\"ADU32014-0010\",\"ADU33014-0010\",\"ADU31213-0030\",\"ADU33114-0030\",\"ADU34113-0030\",\"ADU14211-0010\",\"ADU31113-0010\",\"ADU32042-0010\",\"ADU14011-0010\",\"ADU31114-0010\",\"ADU24043-0010\",\"ADU32112-0030\",\"ADU32014-0030\",\"ADU33212-0010\",\"ADU33212-0030\",\"ADU33214-0030\",\"ADU24143-0010\",\"ADU32214-0010\",\"ADU24243-0010\",\"ADU24233-0010\",\"ADU24133-0010\",\"ADU24033-0010\",\"ADU14113-0010\",\"ADU31112-0010\",\"ADU33013-0010\",\"ADU32213-0010\",\"ADU31012-0030\",\"ADU34113-0010\",\"ADU32212-0030\",\"ADU34012-0010\",\"ADU32214-0030\",\"ADU33213-0010\",\"ADU33214-0010\",\"ADU64200-0030\",\"ASA420212-0010\",\"ASA420216-0010\",\"ASA410104-0010\",\"ASA410103-0010\",\"ASA430224-0010\",\"ASA410101-0010\",\"ASA410108-0010\",\"ASA401000-0010\",\"ADU64205-0030\",\"ASA420210-0010\",\"ASA430218-0010\",\"ASA420214-0010\",\"ASA430222-0010\",\"ASA410102-0010\",\"ASA410106-0010\",\"ASA410206-0010\",\"ASA410208-0010\",\"ASA430220-0010\",\"AZC50000-0015\",\"CAE3100-IP-0150\",\"ASA110102-0010\",\"CAE3404-IP-0150\",\"CAE3404-IP-0156\",\"CAE3006-BUS-0150\",\"CAE3006-BUS-0156\",\"CAE3306-BUS-0156\",\"ASU600216-0030\",\"AVU600112-0030\",\"ASU600218-0030\",\"AVU600214-0030\",\"ASU600220-0030\",\"AVU600216-0030\",\"ASU600222-0030\",\"AVU600218-0030\",\"ASU600224-0030\",\"AVU600220-0030\",\"ASU600101-0030\",\"ASU600103-0030\",\"AVU600101-0030\",\"AVU600222-0030\",\"ASU600104-0030\",\"AVU600102-0030\",\"AVU600224-0030\",\"ASU600105-0030\",\"AVU600103-0030\",\"CAE3004-IP-0150\",\"CAE3004-IP-0156\",\"ASU600106-0030\",\"AVU600104-0030\",\"CAE3304-IP-0156\",\"AVU600105-0030\",\"ASU600102-0030\",\"ASU600108-0030\",\"AVU600106-0030\",\"ASU600109-0030\",\"AVU600107-0030\",\"ASU600110-0030\",\"AVU600108-0030\",\"ASU600111-0030\",\"AVU600109-0030\",\"ASU600112-0030\",\"AVU600110-0030\",\"ASU600214-0030\",\"AVU600111-0030\",\"PVKTU2T-IP-R9010\",\"CAE2101-1150\",\"ASU600110-0010\",\"ASU600107-0010\",\"ASU600216-0010\",\"AVU600112-0010\",\"AVU600216-0010\",\"ASU600214-0010\",\"AVU600107-0010\",\"ASU600109-0010\",\"PVKTU2T-IP-R7016\",\"AVU600106-0010\",\"AVU600104-0010\",\"AVU600218-0010\",\"AVU600222-0010\",\"ASU600111-0010\",\"AVU600108-0010\",\"AVU600110-0010\",\"ASU600102-0010\",\"AVU600103-0010\",\"PES20-EN/03\",\"ASU600218-0010\",\"ASU600224-0010\",\"ASU600103-0010\",\"AVU600224-0010\",\"AVU600105-0010\",\"ASU600220-0010\",\"ASU600222-0010\",\"ASU600101-0010\",\"ASU600104-0010\",\"ASU600108-0010\",\"AVU600109-0010\",\"AVU600214-0010\",\"AVU600220-0010\",\"AVE54XXX-XXXX-04A\",\"ASU600105-0010\",\"ASU600106-0010\",\"AVU600111-0010\",\"ASU600112-0010\",\"AVU600101-0010\",\"AVU600102-0010\",\"AVU400102-0030\",\"AVU400101-0030\",\"AVU400104-0030\",\"AVU400103-0030\",\"AVU400105-0030\",\"AVU400106-0030\",\"AVU400108-0030\",\"AVU400107-0030\",\"AVU400110-0030\",\"AVU400109-0030\",\"AVU400111-0030\",\"AVU400112-0030\",\"AVU400216-0030\",\"AVU400214-0030\",\"AVU400218-0030\",\"AVU400220-0030\",\"AVU400222-0030\",\"AVU400224-0030\",\"AVU400101-0010\",\"AVU400102-0010\",\"AVU400104-0010\",\"AVU400103-0010\",\"AVU400105-0010\",\"AVU400106-0010\",\"AVU400107-0010\",\"AVU400108-0010\",\"AVU400109-0010\",\"AVU400110-0010\",\"AVU400111-0010\",\"AVU400112-0010\",\"AVU400216-0010\",\"AVU400214-0010\",\"AVU400218-0010\",\"AVU400220-0010\",\"AVU400222-0010\",\"AVU400224-0010\",\"AVA610206-0019\",\"AVA610103-0017\",\"AVA630218-0017\",\"AVA610208-0019\",\"AVA610104-0017\",\"AVA630220-0017\",\"AVA620210-0019\",\"AVA610206-0017\",\"AVA630222-0017\",\"AVA620212-0019\",\"AVA610208-0017\",\"AVA630224-0017\",\"ASA120216-0017\",\"ASA130218-0017\",\"ASA130220-0017\",\"AVA620214-0019\",\"ASA130222-0017\",\"AVA620216-0019\",\"ASA130224-0017\",\"AVA630218-0019\",\"AVA620210-0017\",\"AVA610101-0019\",\"AVA630220-0019\",\"AVA620212-0017\",\"AVA610102-0019\",\"AVA630222-0019\",\"AVA610103-0019\",\"AVA630224-0019\",\"AVA620214-0017\",\"AVA610104-0019\",\"AVA610101-0017\",\"AVA620216-0017\",\"ASA110104-0019\",\"ASA110104-0017\",\"ASA110102-0019\",\"ASA120214-0017\",\"ASA110101-0017\",\"ASA110101-0019\",\"ASA110208-0017\",\"ASA110208-0019\",\"ASA120216-0019\",\"ASA120212-0017\",\"ASA120210-0019\",\"ASA130218-0019\",\"ASA130224-0019\",\"ASA110103-0019\",\"ASA130220-0019\",\"ASA110102-0017\",\"ASA110206-0017\",\"ASA120212-0019\",\"ASA120210-0017\",\"ASA110206-0019\",\"ASA120214-0019\",\"ASA110103-0017\",\"ASA130222-0019\",\"AMI10810-0010\",\"AMI10810-0057\",\"ADU64000-0130\",\"ADU64200-0130\",\"AVA610102-0017\",\"ASU600102-0019\",\"ASU600101-0019\",\"ASU600214-0017\",\"ASU600103-0017\",\"ASU600110-0017\",\"AVU600216-0019\",\"AVU600110-0019\",\"AVU600218-0019\",\"ASU600106-0017\",\"ASU600104-0019\",\"ASU600106-0019\",\"ASU600110-0019\",\"AVU600222-0017\",\"AVU600108-0017\",\"AVU600106-0017\",\"ASU600104-0017\",\"ASU600214-0019\",\"ASU600222-0019\",\"AVU600110-0017\",\"AVU600103-0017\",\"AVU600111-0019\",\"ASU600220-0017\",\"ASU600109-0019\",\"AVU600105-0017\",\"AVU600104-0017\",\"AVU600220-0017\",\"ASU600112-0017\",\"ASU600218-0017\",\"ASU600103-0019\",\"ASU600224-0017\",\"ASU600112-0019\",\"ASU600107-0019\",\"AVU600107-0017\",\"AVU600214-0017\",\"ASU600216-0019\",\"ASU600220-0019\",\"AVU600214-0019\",\"AVU600102-0019\",\"AVU600101-0019\",\"AVU600109-0019\",\"AVU600102-0017\",\"AVU600111-0017\",\"AVU600216-0017\",\"AVU600218-0017\",\"AVU600109-0017\",\"AVU600101-0017\",\"AVU600112-0017\",\"AVU600224-0017\",\"ASU600216-0017\",\"AVU600103-0019\",\"AVU600112-0019\",\"AVU600105-0019\",\"ASU600105-0017\",\"AVU600224-0019\",\"AVU600107-0019\",\"ASU600107-0017\",\"ASU600109-0017\",\"ASU600108-0017\",\"AVU600108-0019\",\"ASU600111-0017\",\"AVU600104-0019\",\"ASU600222-0017\",\"AVU600106-0019\",\"AVU600220-0019\",\"AVU600222-0019\",\"ASU600101-0017\",\"ASU600111-0019\",\"ASU600218-0019\",\"ASU600108-0019\",\"ASU600102-0017\",\"ASU600105-0019\",\"ASU600224-0019\",\"TPDS02-EN\",\"AVE54XXX-3011\",\"AVE14040-0010\"],\"controlUnits\":[\"BVS100-SG\",\"BVS20-SG\",\"BVS20-SG/02\",\"BVS30-SG\",\"NBV2600-0400\",\"NBV3200-0500\",\"NBV3210-0500\",\"NGV1011-0400\",\"NVV1000-0400\",\"NWV1000-0400\",\"PSG01-SG\",\"PSG02-SG\",\"VBVS05-SG/02\",\"VBVS30-SG\",\"VBVS05-SG\",\"NBV2600-3400\",\"BVS40-SG\"],\"Funktionserweiterung\":[\"BMN2-EB\",\"BRE2-EB\",\"BRE2-SG\",\"FAA1100-0600\",\"FAA1200-0400\",\"FAA1250-0400\",\"FBA4100-0119\",\"FBA4100-0210\",\"FBC2000-0400\",\"FBC3000-0600\",\"FBC3600-0400\",\"FBI4500-0100\",\"FBO1100-0400\",\"FBO1110-0400\",\"FBO1210-0400\",\"FBS1100-0900\",\"FBS1105-0900\",\"FFI0001-0000\",\"FFL0002-0000\",\"FFL0003-0000\",\"FFL0004-0000\",\"FFL1000-1\",\"FFL2100-0\",\"FIL1101-0140\",\"FIS1100-0600\",\"FNA1000-0400\",\"FVK1202-0\",\"FVK2200-0300\",\"FVK2201-0300\",\"FVK2202-0300\",\"FVK3210-0\",\"FVK3220-0\",\"FVK3230-0\",\"FVK3240-0\",\"FVK4224-0\",\"FVK4225-0\",\"FVU1200-0600\",\"FVU1210-0600\",\"FVU1401-0400\",\"FVW1001-0600\",\"FVW2000-0600\",\"FVW3030-0600\",\"FVW3040-0600\",\"FVY1200-0400\",\"FVY1200-0600\",\"FVY1400-0400\",\"FVY3200-0600\",\"PC1-I\",\"SK10-SG\",\"TOER2-EB\",\"TRE1-EB\",\"TRE2-EB\",\"VKA10-GH\",\"FAA1100-0400\",\"FBO1200-0400\",\"FBP2000-0000\",\"FFL0001-0000\",\"FFL2000-0\",\"FFL2200-0\",\"FIL5100-0145\",\"VSW05-SG\",\"FFL0005-0000\",\"FFL3000-0\",\"FFL3100-0\",\"FFL3200-0\",\"FEZ1000-0400\",\"FBI5100-0400\",\"FVK4215-0\",\"FAA3100-0300\",\"FFI0002-0000\",\"KBRE2-SG\"],\"Gateway\":[\"FBI1210-0\",\"FBI6119-0400\",\"FBI6121-0400\",\"FBI6122-0400\",\"FBI6123-0400\",\"FBI6124-0400\",\"FBI6132-0400\",\"FEW1000-0400\",\"FBI6126-0401\",\"FBI6127-0400\"],\"Zubehoer1\":[\"ZAM1101-0010\",\"ZAS1312-0010\",\"ZAS1334-0010\",\"ZAS1356-0010\",\"ZAU4001-0002\",\"ZIA5001-0145\",\"ZIA5003-0145\",\"ZIA5005-0145\",\"ZIA5006-0145\",\"ZIT3030-0010\",\"ZIT3222-0030\",\"ZIT5000-0030\"],\"others\":[]}");


const $c9681686203b10f0$export$2b64365476b332f1 = [
    "FFI0001-0000",
    "FFL0002-0000",
    "FFL0003-0000",
    "FFL0004-0000",
    "FFL1000-1",
    "FFL2100-0",
    "FIS1100-0600",
    "FNA1000-0400",
    "FVK1202-0",
    "FVK2200-0300",
    "FVK2201-0300",
    "FVK2202-0300",
    "FVK3210-0",
    "FVK3220-0",
    "FVK3230-0",
    "FVK3240-0",
    "FVK4224-0",
    "FVK4225-0",
    "VKA10-GH",
    "FFL0001-0000",
    "FFL2000-0",
    "FFL2200-0",
    "FIL5100-0145",
    "VSW05-SG",
    "FFL0005-0000",
    "FFL3000-0",
    "FFL3100-0",
    "FFL3200-0",
    "FVK4215-0",
    "FFI0002-0000",
    "KBRE2-SG",
    "ZAM1101-0010",
    "ZAS1312-0010",
    "ZAS1334-0010",
    "ZAS1356-0010",
    "ZAU4001-0002",
    "ZIA5001-0145",
    "ZIA5003-0145",
    "ZIA5005-0145",
    "ZIA5006-0145",
    "ZIT3030-0010",
    "ZIT3222-0030",
    "ZIT5000-0030"
];
const $c9681686203b10f0$var$allProducts = [
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).indoorstations,
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).outdoorstations,
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).controlUnits,
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).Gateway,
    ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).Funktionserweiterung
];
const $c9681686203b10f0$export$db6f6c0abdaf96e4 = $c9681686203b10f0$var$allProducts.filter((p)=>!$c9681686203b10f0$export$2b64365476b332f1.includes(p));


var $3827fbd00b732338$require$allProductsRequiringSerial = $c9681686203b10f0$export$db6f6c0abdaf96e4;
const $3827fbd00b732338$var$MIN_DAYS_IN_ADVANCE = 3;
const $3827fbd00b732338$var$appointmentSchema = $f427e7b00f0901b4$exports.date().greater('now').custom((value, helpers)=>{
    const day = value.getDay();
    // Normalize both dates to midnight (ignore time)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 3); // exactly 3 days from today
    const normalizedValue = new Date(value);
    normalizedValue.setHours(0, 0, 0, 0);
    // Check if at least 3 days in advance
    if (normalizedValue < minDate) return helpers.error('date.minAdvance');
    // Check if not Saturday (6) or Sunday (0)
    if (day === 0 || day === 6) return helpers.error('date.noWeekends');
    return value;
}).messages({
    'date.base': 'errors.date.invalid',
    'date.greater': 'errors.date.past',
    'date.minAdvance': 'errors.date.tooSoon',
    'date.noWeekends': 'errors.date.weekend'
});
const $3827fbd00b732338$var$defectiveDevicesSchema = $f427e7b00f0901b4$exports.object({
    articleNumber: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.articleNumber.required',
        'any.required': 'errors.articleNumber.required'
    }),
    serialNumber: $f427e7b00f0901b4$exports.string().trim().when('articleNumber', {
        // If articleNumber is one of the known options that DO require serial
        is: $f427e7b00f0901b4$exports.valid('', ...$3827fbd00b732338$require$allProductsRequiringSerial),
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.serial.required',
            'any.required': 'errors.serial.required'
        }),
        // Otherwise → no serial required
        otherwise: $f427e7b00f0901b4$exports.optional().allow('').strip()
    }),
    errorDescription: $f427e7b00f0901b4$exports.string().trim().required().messages({
        'string.empty': 'errors.errorDescription.required',
        'any.required': 'errors.errorDescription.required'
    })
});
// Billing address fields are only required when it differs from the order address
const $3827fbd00b732338$var$billingField = (label, extraRules = (schema)=>schema)=>$f427e7b00f0901b4$exports.string().trim().when('billingAddressDiffers', {
        is: true,
        then: extraRules($f427e7b00f0901b4$exports.string().trim().required()).messages({
            'string.empty': `errors.billing.${label}.required`,
            'string.pattern.base': `errors.billing.${label}.invalid`,
            'any.required': `errors.billing.${label}.required`
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    });
const $3827fbd00b732338$var$customerServiceSchemaExtra = $f427e7b00f0901b4$exports.object({
    // Customer type and VAT ID are only asked for new customers (no customer number)
    customerType: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: true,
        then: $f427e7b00f0901b4$exports.valid('private', 'business').required().messages({
            'any.only': 'errors.customerType.required',
            'string.empty': 'errors.customerType.required',
            'any.required': 'errors.customerType.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    }),
    vatId: $f427e7b00f0901b4$exports.string().trim().when('customerType', {
        is: 'business',
        then: $f427e7b00f0901b4$exports.string().trim().uppercase().pattern(/^DE\d{9}$/).required().messages({
            'string.empty': 'errors.vatId.required',
            'string.pattern.base': 'errors.vatId.invalid',
            'any.required': 'errors.vatId.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    }),
    billingAddressDiffers: $f427e7b00f0901b4$exports.boolean().default(false),
    billingName: $3827fbd00b732338$var$billingField('name'),
    billingStreet: $3827fbd00b732338$var$billingField('street'),
    billingHouseNumber: $3827fbd00b732338$var$billingField('houseNumber'),
    billingPostalCodeNumber: $3827fbd00b732338$var$billingField('postalCode', (schema)=>schema.pattern(/^\d{5}$/)),
    billingCity: $3827fbd00b732338$var$billingField('city'),
    invoiceEmail: $f427e7b00f0901b4$exports.string().trim().email({
        tlds: {
            allow: false
        }
    }).required().messages({
        'string.empty': 'errors.invoiceEmail.required',
        'string.email': 'errors.invoiceEmail.invalid',
        'any.required': 'errors.invoiceEmail.required'
    }),
    hasNoWarrantyNumber: $f427e7b00f0901b4$exports.boolean().default(false),
    dateOfPurchase: $f427e7b00f0901b4$exports.date().allow(''),
    receiptUpload: $f427e7b00f0901b4$exports.object({
        fieldname: $f427e7b00f0901b4$exports.string().required(),
        originalname: $f427e7b00f0901b4$exports.string().required(),
        encoding: $f427e7b00f0901b4$exports.string().required(),
        mimetype: $f427e7b00f0901b4$exports.string().required(),
        destination: $f427e7b00f0901b4$exports.string().allow('').optional(),
        size: $f427e7b00f0901b4$exports.number().positive().required()
    }),
    warrantyNumber: $f427e7b00f0901b4$exports.string().trim().when('hasNoWarrantyNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.warranty.number.required',
            'any.required': 'errors.warranty.number.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.optional().allow('')
    }),
    documentation: $f427e7b00f0901b4$exports.string().trim().when('hasNoWarrantyNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.optional().messages({
            'string.empty': 'errors.documentation.required',
            'any.required': 'errors.documentation.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.optional()
    }),
    guarantee: $f427e7b00f0901b4$exports.string().trim().when('hasNoWarrantyNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.optional().messages({
            'string.empty': 'errors.guarantee.required',
            'any.required': 'errors.guarantee.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.optional()
    }),
    installationDate: $f427e7b00f0901b4$exports.date().optional().allow(''),
    installer: $f427e7b00f0901b4$exports.string().trim().optional().allow(''),
    defectiveDeviceCount: $f427e7b00f0901b4$exports.number().integer().optional().allow('', null).default(0),
    // serviceType: Joi.string().trim().when('hasNoWarrantyNumber', {
    //   is: false,
    //   then: Joi.required().messages({
    //     'string.empty': 'errors.serviceType.required',
    //     'any.required': 'errors.serviceType.required'
    //   }),
    //   otherwise: Joi.optional()
    // }),
    onlineServiceType: $f427e7b00f0901b4$exports.string().trim().allow(''),
    asap: $f427e7b00f0901b4$exports.boolean().default(false),
    appointment1: $3827fbd00b732338$var$appointmentSchema.optional().allow(''),
    appointment2: $3827fbd00b732338$var$appointmentSchema.optional().allow(''),
    comments: $f427e7b00f0901b4$exports.string().trim().allow(''),
    contactPerson: $f427e7b00f0901b4$exports.string().trim().when('hasNoCustomerNumber', {
        is: false,
        then: $f427e7b00f0901b4$exports.required().messages({
            'string.empty': 'errors.contactPerson.required',
            'any.required': 'errors.contactPerson.required'
        }),
        otherwise: $f427e7b00f0901b4$exports.allow('').optional()
    }),
    errorDescription: $f427e7b00f0901b4$exports.string().min(20).required().messages({
        'string.empty': 'errors.errorDescription.required',
        'any.required': 'errors.errorDescription.required',
        'string.length': 'errors.errorDescription.length'
    }),
    Bauvorhaben: $f427e7b00f0901b4$exports.string().allow(''),
    devices: $f427e7b00f0901b4$exports.array().items($f427e7b00f0901b4$exports.object({
        articleNumber: $f427e7b00f0901b4$exports.string().trim().required().messages({
            'string.empty': 'errors.devices.articleNumber.required',
            'any.required': 'errors.devices.articleNumber.required'
        }),
        quantity: $f427e7b00f0901b4$exports.number().integer().min(1).required().messages({
            'number.base': 'errors.devices.quantity.invalid',
            'number.min': 'errors.devices.quantity.min'
        })
    })).optional(),
    defectiveDevices: $f427e7b00f0901b4$exports.array().items($3827fbd00b732338$var$defectiveDevicesSchema).optional()
}).options({
    abortEarly: false
});
const $3827fbd00b732338$var$customerServiceSchema = $3827fbd00b732338$var$customerServiceSchemaExtra.concat($5eb679002f41e3c8$exports).concat($779ca4e73b2f4474$exports);
$3827fbd00b732338$exports = $3827fbd00b732338$var$customerServiceSchema;



/*! choices.js v11.2.4 | © 2026 Josh Johnson | https://github.com/Choices-js/Choices#readme */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d58050833617f0b2$var$extendStatics = function(d, b) {
    $d58050833617f0b2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d58050833617f0b2$var$extendStatics(d, b);
};
function $d58050833617f0b2$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d58050833617f0b2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d58050833617f0b2$var$__assign = function() {
    $d58050833617f0b2$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d58050833617f0b2$var$__assign.apply(this, arguments);
};
function $d58050833617f0b2$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $d58050833617f0b2$var$ActionType = {
    ADD_CHOICE: 'ADD_CHOICE',
    REMOVE_CHOICE: 'REMOVE_CHOICE',
    FILTER_CHOICES: 'FILTER_CHOICES',
    ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
    CLEAR_CHOICES: 'CLEAR_CHOICES',
    ADD_GROUP: 'ADD_GROUP',
    ADD_ITEM: 'ADD_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM'
};
var $d58050833617f0b2$var$EventType = {
    showDropdown: 'showDropdown',
    hideDropdown: 'hideDropdown',
    change: 'change',
    choice: 'choice',
    search: 'search',
    addItem: 'addItem',
    removeItem: 'removeItem',
    highlightItem: 'highlightItem',
    highlightChoice: 'highlightChoice',
    unhighlightItem: 'unhighlightItem'
};
var $d58050833617f0b2$var$KeyCodeMap = {
    TAB_KEY: 9,
    SHIFT_KEY: 16,
    BACK_KEY: 46,
    DELETE_KEY: 8,
    ENTER_KEY: 13,
    A_KEY: 65,
    ESC_KEY: 27,
    UP_KEY: 38,
    DOWN_KEY: 40,
    PAGE_UP_KEY: 33,
    PAGE_DOWN_KEY: 34
};
var $d58050833617f0b2$var$ObjectsInConfig = [
    'fuseOptions',
    'classNames'
];
var $d58050833617f0b2$var$PassedElementTypes = {
    Text: 'text',
    SelectOne: 'select-one',
    SelectMultiple: 'select-multiple'
};
var $d58050833617f0b2$var$addChoice = function(choice) {
    return {
        type: $d58050833617f0b2$var$ActionType.ADD_CHOICE,
        choice: choice
    };
};
var $d58050833617f0b2$var$removeChoice = function(choice) {
    return {
        type: $d58050833617f0b2$var$ActionType.REMOVE_CHOICE,
        choice: choice
    };
};
var $d58050833617f0b2$var$filterChoices = function(results) {
    return {
        type: $d58050833617f0b2$var$ActionType.FILTER_CHOICES,
        results: results
    };
};
var $d58050833617f0b2$var$activateChoices = function(active) {
    return {
        type: $d58050833617f0b2$var$ActionType.ACTIVATE_CHOICES,
        active: active
    };
};
var $d58050833617f0b2$var$addGroup = function(group) {
    return {
        type: $d58050833617f0b2$var$ActionType.ADD_GROUP,
        group: group
    };
};
var $d58050833617f0b2$var$addItem = function(item) {
    return {
        type: $d58050833617f0b2$var$ActionType.ADD_ITEM,
        item: item
    };
};
var $d58050833617f0b2$var$removeItem$1 = function(item) {
    return {
        type: $d58050833617f0b2$var$ActionType.REMOVE_ITEM,
        item: item
    };
};
var $d58050833617f0b2$var$highlightItem = function(item, highlighted) {
    return {
        type: $d58050833617f0b2$var$ActionType.HIGHLIGHT_ITEM,
        item: item,
        highlighted: highlighted
    };
};
var $d58050833617f0b2$var$getRandomNumber = function(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
};
var $d58050833617f0b2$var$generateChars = function(length) {
    return Array.from({
        length: length
    }, function() {
        return $d58050833617f0b2$var$getRandomNumber(0, 36).toString(36);
    }).join('');
};
var $d58050833617f0b2$var$generateId = function(element, prefix) {
    var id = element.id || element.name && "".concat(element.name, "-").concat($d58050833617f0b2$var$generateChars(2)) || $d58050833617f0b2$var$generateChars(4);
    id = id.replace(/(:|\.|\[|\]|,)/g, '');
    id = "".concat(prefix, "-").concat(id);
    return id;
};
var $d58050833617f0b2$var$getAdjacentEl = function(startEl, selector, direction) {
    if (direction === void 0) direction = 1;
    var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
    var sibling = startEl[prop];
    while(sibling){
        if (sibling.matches(selector)) return sibling;
        sibling = sibling[prop];
    }
    return null;
};
var $d58050833617f0b2$var$isScrolledIntoView = function(element, parent, direction) {
    if (direction === void 0) direction = 1;
    var isVisible;
    if (direction > 0) // In view from bottom
    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
    else // In view from top
    isVisible = element.offsetTop >= parent.scrollTop;
    return isVisible;
};
var $d58050833617f0b2$var$sanitise = function(value) {
    if (typeof value !== 'string') {
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') {
            if ('raw' in value) return $d58050833617f0b2$var$sanitise(value.raw);
            if ('trusted' in value) return value.trusted;
        }
        return value;
    }
    return value.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/'/g, '&#039;').replace(/"/g, '&quot;');
};
var $d58050833617f0b2$var$strToEl = function() {
    var tmpEl = document.createElement('div');
    return function(str) {
        tmpEl.innerHTML = str.trim();
        var firstChild = tmpEl.children[0];
        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
        return firstChild;
    };
}();
var $d58050833617f0b2$var$resolveStringFunction = function(fn) {
    return typeof fn === 'function' ? fn() : fn;
};
var $d58050833617f0b2$var$unwrapStringForRaw = function(s) {
    if (typeof s === 'string') return s;
    if (typeof s === 'object') {
        if ('trusted' in s) return s.trusted;
        if ('raw' in s) return s.raw;
    }
    return '';
};
var $d58050833617f0b2$var$unwrapStringForEscaped = function(s) {
    if (typeof s === 'string') return s;
    if (typeof s === 'object') {
        if ('escaped' in s) return s.escaped;
        if ('trusted' in s) return s.trusted;
    }
    return '';
};
var $d58050833617f0b2$var$getChoiceForOutput = function(choice, keyCode) {
    return {
        id: choice.id,
        highlighted: choice.highlighted,
        labelClass: choice.labelClass,
        labelDescription: $d58050833617f0b2$var$unwrapStringForRaw(choice.labelDescription),
        customProperties: choice.customProperties,
        disabled: choice.disabled,
        active: choice.active,
        label: choice.label,
        placeholder: choice.placeholder,
        value: choice.value,
        groupValue: choice.group ? choice.group.label : undefined,
        element: choice.element,
        keyCode: keyCode
    };
};
var $d58050833617f0b2$var$resolveNoticeFunction = function(fn, value, item) {
    return typeof fn === 'function' ? fn($d58050833617f0b2$var$sanitise(value), $d58050833617f0b2$var$unwrapStringForRaw(value), item) : fn;
};
var $d58050833617f0b2$var$escapeForTemplate = function(allowHTML, s) {
    return allowHTML ? $d58050833617f0b2$var$unwrapStringForEscaped(s) : $d58050833617f0b2$var$sanitise(s);
};
var $d58050833617f0b2$var$setElementHtml = function(el, allowHtml, html) {
    el.innerHTML = $d58050833617f0b2$var$escapeForTemplate(allowHtml, html);
};
var $d58050833617f0b2$var$sortByAlpha = function(_a, _b) {
    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
    return $d58050833617f0b2$var$unwrapStringForRaw(label).localeCompare($d58050833617f0b2$var$unwrapStringForRaw(label2), [], {
        sensitivity: 'base',
        ignorePunctuation: true,
        numeric: true
    });
};
var $d58050833617f0b2$var$sortByRank = function(a, b) {
    return a.rank - b.rank;
};
var $d58050833617f0b2$var$dispatchEvent = function(element, type, customArgs) {
    if (customArgs === void 0) customArgs = null;
    var event = new CustomEvent(type, {
        detail: customArgs,
        bubbles: true,
        cancelable: true
    });
    return element.dispatchEvent(event);
};
/**
 * Returns an array of keys present on the first but missing on the second object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $d58050833617f0b2$var$diff = function(a, b) {
    var aKeys = Object.keys(a).sort();
    var bKeys = Object.keys(b).sort();
    return aKeys.filter(function(i) {
        return bKeys.indexOf(i) < 0;
    });
};
var $d58050833617f0b2$var$getClassNames = function(ClassNames) {
    return Array.isArray(ClassNames) ? ClassNames : [
        ClassNames
    ];
};
var $d58050833617f0b2$var$getClassNamesSelector = function(option) {
    if (option && Array.isArray(option)) return option.map(function(item) {
        return ".".concat(item);
    }).join('');
    return ".".concat(option);
};
var $d58050833617f0b2$var$addClassesToElement = function(element, className) {
    var _a;
    (_a = element.classList).add.apply(_a, $d58050833617f0b2$var$getClassNames(className));
};
var $d58050833617f0b2$var$removeClassesFromElement = function(element, className) {
    var _a;
    (_a = element.classList).remove.apply(_a, $d58050833617f0b2$var$getClassNames(className));
};
var $d58050833617f0b2$var$parseCustomProperties = function(customProperties) {
    if (typeof customProperties !== 'undefined') try {
        return JSON.parse(customProperties);
    } catch (e) {
        return customProperties;
    }
    return {};
};
var $d58050833617f0b2$var$updateClassList = function(item, add, remove) {
    var itemEl = item.itemEl;
    if (itemEl) {
        $d58050833617f0b2$var$removeClassesFromElement(itemEl, remove);
        $d58050833617f0b2$var$addClassesToElement(itemEl, add);
    }
};
var $d58050833617f0b2$var$Dropdown = /** @class */ function() {
    function Dropdown(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.isActive = false;
    }
    /**
     * Show dropdown to user by adding active state class
     */ Dropdown.prototype.show = function() {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.activeState);
        if (this.type !== $d58050833617f0b2$var$PassedElementTypes.Text) this.element.setAttribute('aria-expanded', 'true');
        this.isActive = true;
        return this;
    };
    /**
     * Hide dropdown from user
     */ Dropdown.prototype.hide = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.activeState);
        if (this.type !== $d58050833617f0b2$var$PassedElementTypes.Text) this.element.setAttribute('aria-expanded', 'false');
        this.isActive = false;
        return this;
    };
    return Dropdown;
}();
var $d58050833617f0b2$var$Container = /** @class */ function() {
    function Container(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
        this.element = element;
        this.classNames = classNames;
        this.type = type;
        this.position = position;
        this.isOpen = false;
        this.isFlipped = false;
        this.isDisabled = false;
        this.isLoading = false;
    }
    /**
     * Determine whether container should be flipped based on passed
     * dropdown position
     */ Container.prototype.shouldFlip = function(dropdownPos, dropdownHeight) {
        // If flip is enabled and the dropdown bottom position is
        // greater than the window height flip the dropdown.
        var shouldFlip = false;
        if (this.position === 'auto') shouldFlip = this.element.getBoundingClientRect().top - dropdownHeight >= 0 && !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
        else if (this.position === 'top') shouldFlip = true;
        return shouldFlip;
    };
    Container.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute('aria-activedescendant', activeDescendantID);
    };
    Container.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute('aria-activedescendant');
    };
    Container.prototype.open = function(dropdownPos, dropdownHeight) {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.openState);
        this.element.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
        if (this.shouldFlip(dropdownPos, dropdownHeight)) {
            $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.flippedState);
            this.isFlipped = true;
        }
    };
    Container.prototype.close = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.openState);
        this.element.setAttribute('aria-expanded', 'false');
        this.removeActiveDescendant();
        this.isOpen = false;
        // A dropdown flips if it does not have space within the page
        if (this.isFlipped) {
            $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.flippedState);
            this.isFlipped = false;
        }
    };
    Container.prototype.addFocusState = function() {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.focusState);
    };
    Container.prototype.removeFocusState = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.focusState);
    };
    Container.prototype.addInvalidState = function() {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.invalidState);
    };
    Container.prototype.removeInvalidState = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.invalidState);
    };
    Container.prototype.enable = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.disabledState);
        this.element.removeAttribute('aria-disabled');
        if (this.type === $d58050833617f0b2$var$PassedElementTypes.SelectOne) this.element.setAttribute('tabindex', '0');
        this.isDisabled = false;
    };
    Container.prototype.disable = function() {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.disabledState);
        this.element.setAttribute('aria-disabled', 'true');
        if (this.type === $d58050833617f0b2$var$PassedElementTypes.SelectOne) this.element.setAttribute('tabindex', '-1');
        this.isDisabled = true;
    };
    Container.prototype.wrap = function(element) {
        var el = this.element;
        var parentNode = element.parentNode;
        if (parentNode) {
            if (element.nextSibling) parentNode.insertBefore(el, element.nextSibling);
            else parentNode.appendChild(el);
        }
        el.appendChild(element);
    };
    Container.prototype.unwrap = function(element) {
        var el = this.element;
        var parentNode = el.parentNode;
        if (parentNode) {
            // Move passed element outside this element
            parentNode.insertBefore(element, el);
            // Remove this element
            parentNode.removeChild(el);
        }
    };
    Container.prototype.addLoadingState = function() {
        $d58050833617f0b2$var$addClassesToElement(this.element, this.classNames.loadingState);
        this.element.setAttribute('aria-busy', 'true');
        this.isLoading = true;
    };
    Container.prototype.removeLoadingState = function() {
        $d58050833617f0b2$var$removeClassesFromElement(this.element, this.classNames.loadingState);
        this.element.removeAttribute('aria-busy');
        this.isLoading = false;
    };
    return Container;
}();
var $d58050833617f0b2$var$Input = /** @class */ function() {
    function Input(_a) {
        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
        this.element = element;
        this.type = type;
        this.classNames = classNames;
        this.preventPaste = preventPaste;
        this.isFocussed = this.element.isEqualNode(document.activeElement);
        this.isDisabled = element.disabled;
        this._onPaste = this._onPaste.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
    }
    Object.defineProperty(Input.prototype, "placeholder", {
        set: function(placeholder) {
            this.element.placeholder = placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Input.prototype, "value", {
        get: function() {
            return this.element.value;
        },
        set: function(value) {
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    Input.prototype.addEventListeners = function() {
        var el = this.element;
        el.addEventListener('paste', this._onPaste);
        el.addEventListener('input', this._onInput, {
            passive: true
        });
        el.addEventListener('focus', this._onFocus, {
            passive: true
        });
        el.addEventListener('blur', this._onBlur, {
            passive: true
        });
    };
    Input.prototype.removeEventListeners = function() {
        var el = this.element;
        el.removeEventListener('input', this._onInput);
        el.removeEventListener('paste', this._onPaste);
        el.removeEventListener('focus', this._onFocus);
        el.removeEventListener('blur', this._onBlur);
    };
    Input.prototype.enable = function() {
        var el = this.element;
        el.removeAttribute('disabled');
        this.isDisabled = false;
    };
    Input.prototype.disable = function() {
        var el = this.element;
        el.setAttribute('disabled', '');
        this.isDisabled = true;
    };
    Input.prototype.focus = function() {
        if (!this.isFocussed) this.element.focus();
    };
    Input.prototype.blur = function() {
        if (this.isFocussed) this.element.blur();
    };
    Input.prototype.clear = function(setWidth) {
        if (setWidth === void 0) setWidth = true;
        this.element.value = '';
        if (setWidth) this.setWidth();
        return this;
    };
    /**
     * Set the correct input width based on placeholder value or input value.
     * Renders text into a hidden off-screen span that inherits the input's
     * CSS classes and measures its pixel width, then converts to `ch` units.
     * This correctly handles CJK, Hangul, fullwidth forms, emoji, and any
     * font — no hard-coded code-point ranges required.
     */ Input.prototype.setWidth = function() {
        var element = this.element;
        var value = element.value, placeholder = element.placeholder;
        var minWidth = 0;
        var width = 0;
        if (value || placeholder) {
            var e = document.createElement('span');
            e.style.position = 'absolute';
            e.style.visibility = 'hidden';
            e.style.whiteSpace = 'pre';
            e.style.height = 'auto';
            e.style.width = 'auto';
            e.style.minWidth = '1ch';
            $d58050833617f0b2$var$addClassesToElement(e, Array.from(element.classList));
            element.after(e);
            var chInPx = parseFloat(getComputedStyle(e).width);
            if (Number.isNaN(chInPx)) {
                minWidth = placeholder.length;
                width = value.length;
            } else {
                if (placeholder) {
                    e.innerText = placeholder;
                    minWidth = parseFloat(getComputedStyle(e).width) / chInPx;
                }
                if (value) {
                    e.innerText = value;
                    width = parseFloat(getComputedStyle(e).width) / chInPx;
                }
            }
            e.remove();
        }
        element.style.minWidth = "".concat(Math.ceil(minWidth) + 1, "ch");
        element.style.width = "".concat(Math.ceil(width) + 1, "ch");
    };
    Input.prototype.setActiveDescendant = function(activeDescendantID) {
        this.element.setAttribute('aria-activedescendant', activeDescendantID);
    };
    Input.prototype.removeActiveDescendant = function() {
        this.element.removeAttribute('aria-activedescendant');
    };
    Input.prototype._onInput = function() {
        if (this.type !== $d58050833617f0b2$var$PassedElementTypes.SelectOne) this.setWidth();
    };
    Input.prototype._onPaste = function(event) {
        if (this.preventPaste) event.preventDefault();
    };
    Input.prototype._onFocus = function() {
        this.isFocussed = true;
    };
    Input.prototype._onBlur = function() {
        this.isFocussed = false;
    };
    return Input;
}();
var $d58050833617f0b2$var$SCROLLING_SPEED = 4;
var $d58050833617f0b2$var$List = /** @class */ function() {
    function List(_a) {
        var element = _a.element;
        this.element = element;
        this.scrollPos = this.element.scrollTop;
        this.height = this.element.offsetHeight;
    }
    List.prototype.prepend = function(node) {
        var child = this.element.firstElementChild;
        if (child) this.element.insertBefore(node, child);
        else this.element.append(node);
    };
    List.prototype.scrollToTop = function() {
        this.element.scrollTop = 0;
    };
    List.prototype.scrollToChildElement = function(element, direction) {
        var _this = this;
        if (!element) return;
        var listHeight = this.element.offsetHeight;
        // Scroll position of dropdown
        var listScrollPosition = this.element.scrollTop + listHeight;
        var elementHeight = element.offsetHeight;
        // Distance from bottom of element to top of parent
        var elementPos = element.offsetTop + elementHeight;
        // Difference between the element and scroll position
        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
        requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    List.prototype._scrollDown = function(scrollPos, strength, destination) {
        var easing = (destination - scrollPos) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos + distance;
    };
    List.prototype._scrollUp = function(scrollPos, strength, destination) {
        var easing = (scrollPos - destination) / strength;
        var distance = easing > 1 ? easing : 1;
        this.element.scrollTop = scrollPos - distance;
    };
    List.prototype._animateScroll = function(destination, direction) {
        var _this = this;
        var strength = $d58050833617f0b2$var$SCROLLING_SPEED;
        var choiceListScrollTop = this.element.scrollTop;
        var continueAnimation = false;
        if (direction > 0) {
            this._scrollDown(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop < destination) continueAnimation = true;
        } else {
            this._scrollUp(choiceListScrollTop, strength, destination);
            if (choiceListScrollTop > destination) continueAnimation = true;
        }
        if (continueAnimation) requestAnimationFrame(function() {
            _this._animateScroll(destination, direction);
        });
    };
    return List;
}();
var $d58050833617f0b2$var$WrappedElement = /** @class */ function() {
    function WrappedElement(_a) {
        var element = _a.element, classNames = _a.classNames;
        this.element = element;
        this.classNames = classNames;
        this.isDisabled = false;
    }
    Object.defineProperty(WrappedElement.prototype, "isActive", {
        get: function() {
            return this.element.dataset.choice === 'active';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "dir", {
        get: function() {
            return this.element.dir;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedElement.prototype, "value", {
        get: function() {
            return this.element.value;
        },
        set: function(value) {
            this.element.setAttribute('value', value);
            this.element.value = value;
        },
        enumerable: false,
        configurable: true
    });
    WrappedElement.prototype.conceal = function() {
        var el = this.element;
        // Hide passed input
        $d58050833617f0b2$var$addClassesToElement(el, this.classNames.input);
        el.hidden = true;
        // Remove element from tab index
        el.tabIndex = -1;
        // Backup original styles if any
        var origStyle = el.getAttribute('style');
        if (origStyle) el.setAttribute('data-choice-orig-style', origStyle);
        el.setAttribute('data-choice', 'active');
    };
    WrappedElement.prototype.reveal = function() {
        var el = this.element;
        // Reinstate passed element
        $d58050833617f0b2$var$removeClassesFromElement(el, this.classNames.input);
        el.hidden = false;
        el.removeAttribute('tabindex');
        // Recover original styles if any
        var origStyle = el.getAttribute('data-choice-orig-style');
        if (origStyle) {
            el.removeAttribute('data-choice-orig-style');
            el.setAttribute('style', origStyle);
        } else el.removeAttribute('style');
        el.removeAttribute('data-choice');
    };
    WrappedElement.prototype.enable = function() {
        this.element.removeAttribute('disabled');
        this.element.disabled = false;
        this.isDisabled = false;
    };
    WrappedElement.prototype.disable = function() {
        this.element.setAttribute('disabled', '');
        this.element.disabled = true;
        this.isDisabled = true;
    };
    WrappedElement.prototype.triggerEvent = function(eventType, data) {
        $d58050833617f0b2$var$dispatchEvent(this.element, eventType, data || {});
    };
    return WrappedElement;
}();
var $d58050833617f0b2$var$WrappedInput = /** @class */ function(_super) {
    $d58050833617f0b2$var$__extends(WrappedInput, _super);
    function WrappedInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WrappedInput;
}($d58050833617f0b2$var$WrappedElement);
var $d58050833617f0b2$var$coerceBool = function(arg, defaultValue) {
    if (defaultValue === void 0) defaultValue = true;
    return typeof arg === 'undefined' ? defaultValue : !!arg;
};
var $d58050833617f0b2$var$stringToHtmlClass = function(input) {
    if (typeof input === 'string') // eslint-disable-next-line no-param-reassign
    input = input.split(' ').filter(function(s) {
        return s.length;
    });
    if (Array.isArray(input) && input.length) return input;
    return undefined;
};
var $d58050833617f0b2$var$mapInputToChoice = function(value, allowGroup, allowRawString) {
    if (allowRawString === void 0) allowRawString = true;
    if (typeof value === 'string') {
        var sanitisedValue = $d58050833617f0b2$var$sanitise(value);
        var userValue = allowRawString || sanitisedValue === value ? value : {
            escaped: sanitisedValue,
            raw: value
        };
        var result_1 = $d58050833617f0b2$var$mapInputToChoice({
            value: value,
            label: userValue,
            selected: true
        }, false);
        return result_1;
    }
    var groupOrChoice = value;
    if ('choices' in groupOrChoice) {
        if (!allowGroup) // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup
        throw new TypeError("optGroup is not allowed");
        var group = groupOrChoice;
        var choices = group.choices.map(function(e) {
            return $d58050833617f0b2$var$mapInputToChoice(e, false);
        });
        var result_2 = {
            id: 0,
            label: $d58050833617f0b2$var$unwrapStringForRaw(group.label) || group.value,
            active: !!choices.length,
            disabled: !!group.disabled,
            choices: choices
        };
        return result_2;
    }
    var choice = groupOrChoice;
    var result = {
        id: 0,
        group: null,
        score: 0,
        rank: 0,
        value: choice.value,
        label: choice.label || choice.value,
        active: $d58050833617f0b2$var$coerceBool(choice.active),
        selected: $d58050833617f0b2$var$coerceBool(choice.selected, false),
        disabled: $d58050833617f0b2$var$coerceBool(choice.disabled, false),
        placeholder: $d58050833617f0b2$var$coerceBool(choice.placeholder, false),
        highlighted: false,
        labelClass: $d58050833617f0b2$var$stringToHtmlClass(choice.labelClass),
        labelDescription: choice.labelDescription,
        customProperties: choice.customProperties
    };
    return result;
};
var $d58050833617f0b2$var$isHtmlInputElement = function(e) {
    return e.tagName === 'INPUT';
};
var $d58050833617f0b2$var$isHtmlSelectElement = function(e) {
    return e.tagName === 'SELECT';
};
var $d58050833617f0b2$var$isHtmlOption = function(e) {
    return e.tagName === 'OPTION';
};
var $d58050833617f0b2$var$isHtmlOptgroup = function(e) {
    return e.tagName === 'OPTGROUP';
};
var $d58050833617f0b2$var$WrappedSelect = /** @class */ function(_super) {
    $d58050833617f0b2$var$__extends(WrappedSelect, _super);
    function WrappedSelect(_a) {
        var element = _a.element, classNames = _a.classNames, template = _a.template, extractPlaceholder = _a.extractPlaceholder;
        var _this = _super.call(this, {
            element: element,
            classNames: classNames
        }) || this;
        _this.template = template;
        _this.extractPlaceholder = extractPlaceholder;
        return _this;
    }
    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
        get: function() {
            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
            this.element.querySelector('option[placeholder]');
        },
        enumerable: false,
        configurable: true
    });
    WrappedSelect.prototype.addOptions = function(choices) {
        var _this = this;
        var fragment = document.createDocumentFragment();
        choices.forEach(function(obj) {
            var choice = obj;
            if (choice.element) return;
            var option = _this.template(choice);
            fragment.appendChild(option);
            choice.element = option;
        });
        this.element.appendChild(fragment);
    };
    WrappedSelect.prototype.optionsAsChoices = function() {
        var _this = this;
        var choices = [];
        this.element.querySelectorAll(':scope > option, :scope > optgroup').forEach(function(e) {
            if ($d58050833617f0b2$var$isHtmlOption(e)) choices.push(_this._optionToChoice(e));
            else if ($d58050833617f0b2$var$isHtmlOptgroup(e)) choices.push(_this._optgroupToChoice(e));
        // todo: hr as empty optgroup, requires displaying empty opt-groups to be useful
        });
        return choices;
    };
    // eslint-disable-next-line class-methods-use-this
    WrappedSelect.prototype._optionToChoice = function(option) {
        // option.value returns the label if there is no value attribute, which can break legacy placeholder attribute support
        if (!option.hasAttribute('value') && option.hasAttribute('placeholder')) {
            option.setAttribute('value', '');
            option.value = '';
        }
        return {
            id: 0,
            group: null,
            score: 0,
            rank: 0,
            value: option.value,
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option
            // This attribute is text for the label indicating the meaning of the option. If the `label` attribute isn't defined, its value is that of the element text content (ie `innerText`).
            label: option.label,
            element: option,
            active: true,
            // this returns true if nothing is selected on initial load, which will break placeholder support
            selected: this.extractPlaceholder ? option.selected : option.hasAttribute('selected'),
            disabled: option.disabled,
            highlighted: false,
            placeholder: this.extractPlaceholder && (!option.value || option.hasAttribute('placeholder')),
            labelClass: typeof option.dataset.labelClass !== 'undefined' ? $d58050833617f0b2$var$stringToHtmlClass(option.dataset.labelClass) : undefined,
            labelDescription: typeof option.dataset.labelDescription !== 'undefined' ? {
                trusted: option.dataset.labelDescription
            } : undefined,
            customProperties: $d58050833617f0b2$var$parseCustomProperties(option.dataset.customProperties)
        };
    };
    WrappedSelect.prototype._optgroupToChoice = function(optgroup) {
        var _this = this;
        var options = optgroup.querySelectorAll('option');
        var choices = Array.from(options).map(function(option) {
            return _this._optionToChoice(option);
        });
        return {
            id: 0,
            label: optgroup.label || '',
            element: optgroup,
            active: !!choices.length,
            disabled: optgroup.disabled,
            choices: choices
        };
    };
    return WrappedSelect;
}($d58050833617f0b2$var$WrappedElement);
var $d58050833617f0b2$var$DEFAULT_CLASSNAMES = {
    containerOuter: [
        'choices'
    ],
    containerInner: [
        'choices__inner'
    ],
    input: [
        'choices__input'
    ],
    inputCloned: [
        'choices__input--cloned'
    ],
    list: [
        'choices__list'
    ],
    listItems: [
        'choices__list--multiple'
    ],
    listSingle: [
        'choices__list--single'
    ],
    listDropdown: [
        'choices__list--dropdown'
    ],
    item: [
        'choices__item'
    ],
    itemSelectable: [
        'choices__item--selectable'
    ],
    itemDisabled: [
        'choices__item--disabled'
    ],
    itemChoice: [
        'choices__item--choice'
    ],
    description: [
        'choices__description'
    ],
    placeholder: [
        'choices__placeholder'
    ],
    group: [
        'choices__group'
    ],
    groupHeading: [
        'choices__heading'
    ],
    button: [
        'choices__button'
    ],
    activeState: [
        'is-active'
    ],
    focusState: [
        'is-focused'
    ],
    openState: [
        'is-open'
    ],
    disabledState: [
        'is-disabled'
    ],
    highlightedState: [
        'is-highlighted'
    ],
    selectedState: [
        'is-selected'
    ],
    flippedState: [
        'is-flipped'
    ],
    loadingState: [
        'is-loading'
    ],
    invalidState: [
        'is-invalid'
    ],
    notice: [
        'choices__notice'
    ],
    addChoice: [
        'choices__item--selectable',
        'add-choice'
    ],
    noResults: [
        'has-no-results'
    ],
    noChoices: [
        'has-no-choices'
    ]
};
var $d58050833617f0b2$var$DEFAULT_CONFIG = {
    items: [],
    choices: [],
    silent: false,
    renderChoiceLimit: -1,
    maxItemCount: -1,
    closeDropdownOnSelect: 'auto',
    singleModeForMultiSelect: false,
    addChoices: false,
    addItems: true,
    addItemFilter: function(value) {
        return !!value && value !== '';
    },
    removeItems: true,
    removeItemButton: false,
    removeItemButtonAlignLeft: false,
    editItems: false,
    allowHTML: false,
    allowHtmlUserInput: false,
    duplicateItemsAllowed: true,
    delimiter: ',',
    paste: true,
    searchEnabled: true,
    searchChoices: true,
    searchDisabledChoices: false,
    searchFloor: 1,
    searchResultLimit: 4,
    searchFields: [
        'label',
        'value'
    ],
    position: 'auto',
    resetScrollPosition: true,
    shouldSort: true,
    shouldSortItems: false,
    sorter: $d58050833617f0b2$var$sortByAlpha,
    shadowRoot: null,
    placeholder: true,
    placeholderValue: null,
    searchPlaceholderValue: null,
    prependValue: null,
    appendValue: null,
    renderSelectedChoices: 'auto',
    searchRenderSelectedChoices: true,
    loadingText: 'Loading...',
    noResultsText: 'No results found',
    noChoicesText: 'No choices to choose from',
    itemSelectText: 'Press to select',
    uniqueItemText: 'Only unique values can be added',
    customAddItemText: 'Only values matching specific conditions can be added',
    addItemText: function(value) {
        return "Press Enter to add <b>\"".concat(value, "\"</b>");
    },
    removeItemIconText: function() {
        return "Remove item";
    },
    removeItemLabelText: function(value, _valueRaw, i) {
        return "Remove item: ".concat(i ? $d58050833617f0b2$var$sanitise(i.label) : value);
    },
    maxItemText: function(maxItemCount) {
        return "Only ".concat(maxItemCount, " values can be added");
    },
    valueComparer: function(value1, value2) {
        return value1 === value2;
    },
    fuseOptions: {
        includeScore: true
    },
    labelId: '',
    callbackOnInit: null,
    callbackOnCreateTemplates: null,
    classNames: $d58050833617f0b2$var$DEFAULT_CLASSNAMES,
    appendGroupInSearch: false
};
var $d58050833617f0b2$var$removeItem = function(item) {
    var itemEl = item.itemEl;
    if (itemEl) {
        itemEl.remove();
        item.itemEl = undefined;
    }
};
function $d58050833617f0b2$var$items(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $d58050833617f0b2$var$ActionType.ADD_ITEM:
            action.item.selected = true;
            var el = action.item.element;
            if (el) {
                el.selected = true;
                el.setAttribute('selected', '');
            }
            state.push(action.item);
            break;
        case $d58050833617f0b2$var$ActionType.REMOVE_ITEM:
            action.item.selected = false;
            var el = action.item.element;
            if (el) {
                el.selected = false;
                el.removeAttribute('selected');
                // For a select-one, if all options are deselected, the first item is selected. To set a black value, select.value needs to be set
                var select = el.parentElement;
                if (select && $d58050833617f0b2$var$isHtmlSelectElement(select) && select.type === $d58050833617f0b2$var$PassedElementTypes.SelectOne) select.value = '';
            }
            // this is mixing concerns, but this is *so much faster*
            $d58050833617f0b2$var$removeItem(action.item);
            state = state.filter(function(choice) {
                return choice.id !== action.item.id;
            });
            break;
        case $d58050833617f0b2$var$ActionType.REMOVE_CHOICE:
            $d58050833617f0b2$var$removeItem(action.choice);
            state = state.filter(function(item) {
                return item.id !== action.choice.id;
            });
            break;
        case $d58050833617f0b2$var$ActionType.HIGHLIGHT_ITEM:
            var highlighted = action.highlighted;
            var item = state.find(function(obj) {
                return obj.id === action.item.id;
            });
            if (item && item.highlighted !== highlighted) {
                item.highlighted = highlighted;
                if (context) $d58050833617f0b2$var$updateClassList(item, highlighted ? context.classNames.highlightedState : context.classNames.selectedState, highlighted ? context.classNames.selectedState : context.classNames.highlightedState);
            }
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
function $d58050833617f0b2$var$groups(s, action) {
    var state = s;
    var update = true;
    switch(action.type){
        case $d58050833617f0b2$var$ActionType.ADD_GROUP:
            state.push(action.group);
            break;
        case $d58050833617f0b2$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
/* eslint-disable */ function $d58050833617f0b2$var$choices(s, action, context) {
    var state = s;
    var update = true;
    switch(action.type){
        case $d58050833617f0b2$var$ActionType.ADD_CHOICE:
            state.push(action.choice);
            break;
        case $d58050833617f0b2$var$ActionType.REMOVE_CHOICE:
            action.choice.choiceEl = undefined;
            if (action.choice.group) action.choice.group.choices = action.choice.group.choices.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            state = state.filter(function(obj) {
                return obj.id !== action.choice.id;
            });
            break;
        case $d58050833617f0b2$var$ActionType.ADD_ITEM:
        case $d58050833617f0b2$var$ActionType.REMOVE_ITEM:
            action.item.choiceEl = undefined;
            break;
        case $d58050833617f0b2$var$ActionType.FILTER_CHOICES:
            // avoid O(n^2) algorithm complexity when searching/filtering choices
            var scoreLookup_1 = [];
            action.results.forEach(function(result) {
                scoreLookup_1[result.item.id] = result;
            });
            state.forEach(function(choice) {
                var result = scoreLookup_1[choice.id];
                if (result !== undefined) {
                    choice.score = result.score;
                    choice.rank = result.rank;
                    choice.active = true;
                } else {
                    choice.score = 0;
                    choice.rank = 0;
                    choice.active = false;
                }
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $d58050833617f0b2$var$ActionType.ACTIVATE_CHOICES:
            state.forEach(function(choice) {
                choice.active = action.active;
                if (context && context.appendGroupInSearch) choice.choiceEl = undefined;
            });
            break;
        case $d58050833617f0b2$var$ActionType.CLEAR_CHOICES:
            state = [];
            break;
        default:
            update = false;
            break;
    }
    return {
        state: state,
        update: update
    };
}
var $d58050833617f0b2$var$reducers = {
    groups: $d58050833617f0b2$var$groups,
    items: $d58050833617f0b2$var$items,
    choices: $d58050833617f0b2$var$choices
};
var $d58050833617f0b2$var$Store = /** @class */ function() {
    function Store(context) {
        this._state = this.defaultState;
        this._listeners = [];
        this._txn = 0;
        this._context = context;
    }
    Object.defineProperty(Store.prototype, "defaultState", {
        // eslint-disable-next-line class-methods-use-this
        get: function() {
            return {
                groups: [],
                items: [],
                choices: []
            };
        },
        enumerable: false,
        configurable: true
    });
    // eslint-disable-next-line class-methods-use-this
    Store.prototype.changeSet = function(init) {
        return {
            groups: init,
            items: init,
            choices: init
        };
    };
    Store.prototype.reset = function() {
        this._state = this.defaultState;
        var changes = this.changeSet(true);
        if (this._txn) this._changeSet = changes;
        else this._listeners.forEach(function(l) {
            return l(changes);
        });
    };
    Store.prototype.subscribe = function(onChange) {
        this._listeners.push(onChange);
        return this;
    };
    Store.prototype.dispatch = function(action) {
        var _this = this;
        var state = this._state;
        var hasChanges = false;
        var changes = this._changeSet || this.changeSet(false);
        Object.keys($d58050833617f0b2$var$reducers).forEach(function(key) {
            var stateUpdate = $d58050833617f0b2$var$reducers[key](state[key], action, _this._context);
            if (stateUpdate.update) {
                hasChanges = true;
                changes[key] = true;
                state[key] = stateUpdate.state;
            }
        });
        if (hasChanges) {
            if (this._txn) this._changeSet = changes;
            else this._listeners.forEach(function(l) {
                return l(changes);
            });
        }
    };
    Store.prototype.withTxn = function(func) {
        this._txn++;
        try {
            func();
        } finally{
            this._txn = Math.max(0, this._txn - 1);
            if (!this._txn) {
                var changeSet_1 = this._changeSet;
                if (changeSet_1) {
                    this._changeSet = undefined;
                    this._listeners.forEach(function(l) {
                        return l(changeSet_1);
                    });
                }
            }
        }
    };
    Object.defineProperty(Store.prototype, "state", {
        /**
         * Get store object
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "items", {
        /**
         * Get items from store
         */ get: function() {
            return this.state.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
        /**
         * Get highlighted items from store
         */ get: function() {
            return this.items.filter(function(item) {
                return item.active && item.highlighted;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "choices", {
        /**
         * Get choices from store
         */ get: function() {
            return this.state.choices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeChoices", {
        /**
         * Get active choices from store
         */ get: function() {
            return this.choices.filter(function(choice) {
                return choice.active;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "searchableChoices", {
        /**
         * Get choices that can be searched (excluding placeholders or disabled choices)
         */ get: function() {
            var context = this._context;
            return this.choices.filter(function(choice) {
                return !choice.placeholder && (context.searchDisabledChoices || !choice.disabled);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "groups", {
        /**
         * Get groups from store
         */ get: function() {
            return this.state.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "activeGroups", {
        /**
         * Get active groups from store
         */ get: function() {
            var _this = this;
            return this.state.groups.filter(function(group) {
                var isActive = group.active && !group.disabled;
                var hasActiveOptions = _this.state.choices.some(function(choice) {
                    return choice.active && !choice.disabled;
                });
                return isActive && hasActiveOptions;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.inTxn = function() {
        return this._txn > 0;
    };
    /**
     * Get single choice by it's ID
     */ Store.prototype.getChoiceById = function(id) {
        return this.activeChoices.find(function(choice) {
            return choice.id === id;
        });
    };
    /**
     * Get group by group id
     */ Store.prototype.getGroupById = function(id) {
        return this.groups.find(function(group) {
            return group.id === id;
        });
    };
    return Store;
}();
var $d58050833617f0b2$var$NoticeTypes = {
    noChoices: 'no-choices',
    noResults: 'no-results',
    addChoice: 'add-choice',
    generic: ''
};
function $d58050833617f0b2$var$_defineProperty(e, r, t) {
    return (r = $d58050833617f0b2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $d58050833617f0b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d58050833617f0b2$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d58050833617f0b2$var$ownKeys(Object(t), true).forEach(function(r) {
            $d58050833617f0b2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d58050833617f0b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d58050833617f0b2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d58050833617f0b2$var$_toPropertyKey(t) {
    var i = $d58050833617f0b2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $d58050833617f0b2$var$isArray(value) {
    return !Array.isArray ? $d58050833617f0b2$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
function $d58050833617f0b2$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -Infinity ? '-0' : result;
}
function $d58050833617f0b2$var$toString(value) {
    return value == null ? '' : $d58050833617f0b2$var$baseToString(value);
}
function $d58050833617f0b2$var$isString(value) {
    return typeof value === 'string';
}
function $d58050833617f0b2$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $d58050833617f0b2$var$isBoolean(value) {
    return value === true || value === false || $d58050833617f0b2$var$isObjectLike(value) && $d58050833617f0b2$var$getTag(value) == '[object Boolean]';
}
function $d58050833617f0b2$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $d58050833617f0b2$var$isObjectLike(value) {
    return $d58050833617f0b2$var$isObject(value) && value !== null;
}
function $d58050833617f0b2$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $d58050833617f0b2$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $d58050833617f0b2$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $d58050833617f0b2$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $d58050833617f0b2$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $d58050833617f0b2$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $d58050833617f0b2$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $d58050833617f0b2$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $d58050833617f0b2$var$hasOwn = Object.prototype.hasOwnProperty;
class $d58050833617f0b2$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $d58050833617f0b2$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $d58050833617f0b2$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($d58050833617f0b2$var$isString(key) || $d58050833617f0b2$var$isArray(key)) {
        src = key;
        path = $d58050833617f0b2$var$createKeyPath(key);
        id = $d58050833617f0b2$var$createKeyId(key);
    } else {
        if (!$d58050833617f0b2$var$hasOwn.call(key, 'name')) throw new Error($d58050833617f0b2$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($d58050833617f0b2$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($d58050833617f0b2$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $d58050833617f0b2$var$createKeyPath(name);
        id = $d58050833617f0b2$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $d58050833617f0b2$var$createKeyPath(key) {
    return $d58050833617f0b2$var$isArray(key) ? key : key.split('.');
}
function $d58050833617f0b2$var$createKeyId(key) {
    return $d58050833617f0b2$var$isArray(key) ? key.join('.') : key;
}
function $d58050833617f0b2$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$d58050833617f0b2$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$d58050833617f0b2$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($d58050833617f0b2$var$isString(value) || $d58050833617f0b2$var$isNumber(value) || $d58050833617f0b2$var$isBoolean(value))) list.push($d58050833617f0b2$var$toString(value));
            else if ($d58050833617f0b2$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $d58050833617f0b2$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $d58050833617f0b2$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $d58050833617f0b2$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $d58050833617f0b2$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $d58050833617f0b2$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $d58050833617f0b2$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $d58050833617f0b2$var$Config = $d58050833617f0b2$var$_objectSpread2($d58050833617f0b2$var$_objectSpread2($d58050833617f0b2$var$_objectSpread2($d58050833617f0b2$var$_objectSpread2({}, $d58050833617f0b2$var$BasicOptions), $d58050833617f0b2$var$MatchOptions), $d58050833617f0b2$var$FuzzyOptions), $d58050833617f0b2$var$AdvancedOptions);
const $d58050833617f0b2$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $d58050833617f0b2$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($d58050833617f0b2$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $d58050833617f0b2$var$FuseIndex {
    constructor({ getFn: getFn = $d58050833617f0b2$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d58050833617f0b2$var$Config.fieldNormWeight } = {}){
        this.norm = $d58050833617f0b2$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($d58050833617f0b2$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($d58050833617f0b2$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$d58050833617f0b2$var$isDefined(doc) || $d58050833617f0b2$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$d58050833617f0b2$var$isDefined(value)) return;
            if ($d58050833617f0b2$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$d58050833617f0b2$var$isDefined(value)) continue;
                    if ($d58050833617f0b2$var$isString(value) && !$d58050833617f0b2$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($d58050833617f0b2$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($d58050833617f0b2$var$isString(value) && !$d58050833617f0b2$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $d58050833617f0b2$var$createIndex(keys, docs, { getFn: getFn = $d58050833617f0b2$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d58050833617f0b2$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $d58050833617f0b2$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($d58050833617f0b2$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $d58050833617f0b2$var$parseIndex(data, { getFn: getFn = $d58050833617f0b2$var$Config.getFn, fieldNormWeight: fieldNormWeight = $d58050833617f0b2$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $d58050833617f0b2$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $d58050833617f0b2$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $d58050833617f0b2$var$Config.distance, ignoreLocation: ignoreLocation = $d58050833617f0b2$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $d58050833617f0b2$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $d58050833617f0b2$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $d58050833617f0b2$var$MAX_BITS = 32;
function $d58050833617f0b2$var$search(text, pattern, patternAlphabet, { location: location = $d58050833617f0b2$var$Config.location, distance: distance = $d58050833617f0b2$var$Config.distance, threshold: threshold = $d58050833617f0b2$var$Config.threshold, findAllMatches: findAllMatches = $d58050833617f0b2$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d58050833617f0b2$var$Config.minMatchCharLength, includeMatches: includeMatches = $d58050833617f0b2$var$Config.includeMatches, ignoreLocation: ignoreLocation = $d58050833617f0b2$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $d58050833617f0b2$var$MAX_BITS) throw new Error($d58050833617f0b2$var$PATTERN_LENGTH_TOO_LARGE($d58050833617f0b2$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $d58050833617f0b2$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $d58050833617f0b2$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $d58050833617f0b2$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $d58050833617f0b2$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $d58050833617f0b2$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $d58050833617f0b2$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $d58050833617f0b2$var$BitapSearch {
    constructor(pattern, { location: location = $d58050833617f0b2$var$Config.location, threshold: threshold = $d58050833617f0b2$var$Config.threshold, distance: distance = $d58050833617f0b2$var$Config.distance, includeMatches: includeMatches = $d58050833617f0b2$var$Config.includeMatches, findAllMatches: findAllMatches = $d58050833617f0b2$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d58050833617f0b2$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d58050833617f0b2$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d58050833617f0b2$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $d58050833617f0b2$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $d58050833617f0b2$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $d58050833617f0b2$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $d58050833617f0b2$var$MAX_BITS), i);
                i += $d58050833617f0b2$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $d58050833617f0b2$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $d58050833617f0b2$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $d58050833617f0b2$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $d58050833617f0b2$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $d58050833617f0b2$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $d58050833617f0b2$var$ExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $d58050833617f0b2$var$InverseExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $d58050833617f0b2$var$PrefixExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $d58050833617f0b2$var$InversePrefixExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $d58050833617f0b2$var$SuffixExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $d58050833617f0b2$var$InverseSuffixExactMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $d58050833617f0b2$var$FuzzyMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern, { location: location = $d58050833617f0b2$var$Config.location, threshold: threshold = $d58050833617f0b2$var$Config.threshold, distance: distance = $d58050833617f0b2$var$Config.distance, includeMatches: includeMatches = $d58050833617f0b2$var$Config.includeMatches, findAllMatches: findAllMatches = $d58050833617f0b2$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $d58050833617f0b2$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $d58050833617f0b2$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $d58050833617f0b2$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $d58050833617f0b2$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $d58050833617f0b2$var$IncludeMatch extends $d58050833617f0b2$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $d58050833617f0b2$var$searchers = [
    $d58050833617f0b2$var$ExactMatch,
    $d58050833617f0b2$var$IncludeMatch,
    $d58050833617f0b2$var$PrefixExactMatch,
    $d58050833617f0b2$var$InversePrefixExactMatch,
    $d58050833617f0b2$var$InverseSuffixExactMatch,
    $d58050833617f0b2$var$SuffixExactMatch,
    $d58050833617f0b2$var$InverseExactMatch,
    $d58050833617f0b2$var$FuzzyMatch
];
const $d58050833617f0b2$var$searchersLen = $d58050833617f0b2$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $d58050833617f0b2$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $d58050833617f0b2$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $d58050833617f0b2$var$parseQuery(pattern, options = {}) {
    return pattern.split($d58050833617f0b2$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($d58050833617f0b2$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $d58050833617f0b2$var$searchersLen){
                const searcher = $d58050833617f0b2$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $d58050833617f0b2$var$searchersLen){
                const searcher = $d58050833617f0b2$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $d58050833617f0b2$var$MultiMatchSet = new Set([
    $d58050833617f0b2$var$FuzzyMatch.type,
    $d58050833617f0b2$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $d58050833617f0b2$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $d58050833617f0b2$var$Config.isCaseSensitive, includeMatches: includeMatches = $d58050833617f0b2$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $d58050833617f0b2$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $d58050833617f0b2$var$Config.ignoreLocation, findAllMatches: findAllMatches = $d58050833617f0b2$var$Config.findAllMatches, location: location = $d58050833617f0b2$var$Config.location, threshold: threshold = $d58050833617f0b2$var$Config.threshold, distance: distance = $d58050833617f0b2$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $d58050833617f0b2$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($d58050833617f0b2$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $d58050833617f0b2$var$registeredSearchers = [];
function $d58050833617f0b2$var$register(...args) {
    $d58050833617f0b2$var$registeredSearchers.push(...args);
}
function $d58050833617f0b2$var$createSearcher(pattern, options) {
    for(let i = 0, len = $d58050833617f0b2$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $d58050833617f0b2$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $d58050833617f0b2$var$BitapSearch(pattern, options);
}
const $d58050833617f0b2$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $d58050833617f0b2$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $d58050833617f0b2$var$isExpression = (query)=>!!(query[$d58050833617f0b2$var$LogicalOperator.AND] || query[$d58050833617f0b2$var$LogicalOperator.OR]);
const $d58050833617f0b2$var$isPath = (query)=>!!query[$d58050833617f0b2$var$KeyType.PATH];
const $d58050833617f0b2$var$isLeaf = (query)=>!$d58050833617f0b2$var$isArray(query) && $d58050833617f0b2$var$isObject(query) && !$d58050833617f0b2$var$isExpression(query);
const $d58050833617f0b2$var$convertToExplicit = (query)=>({
        [$d58050833617f0b2$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $d58050833617f0b2$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $d58050833617f0b2$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$d58050833617f0b2$var$isExpression(query)) return next($d58050833617f0b2$var$convertToExplicit(query));
        if ($d58050833617f0b2$var$isLeaf(query)) {
            const key = isQueryPath ? query[$d58050833617f0b2$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$d58050833617f0b2$var$KeyType.PATTERN] : query[key];
            if (!$d58050833617f0b2$var$isString(pattern)) throw new Error($d58050833617f0b2$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $d58050833617f0b2$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $d58050833617f0b2$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($d58050833617f0b2$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$d58050833617f0b2$var$isExpression(query)) query = $d58050833617f0b2$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $d58050833617f0b2$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $d58050833617f0b2$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $d58050833617f0b2$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$d58050833617f0b2$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$d58050833617f0b2$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $d58050833617f0b2$var$transformScore(result, data) {
    data.score = result.score;
}
function $d58050833617f0b2$var$format(results, docs, { includeMatches: includeMatches = $d58050833617f0b2$var$Config.includeMatches, includeScore: includeScore = $d58050833617f0b2$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($d58050833617f0b2$var$transformMatches);
    if (includeScore) transformers.push($d58050833617f0b2$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $d58050833617f0b2$var$Fuse {
    constructor(docs, options = {}, index){
        this.options = $d58050833617f0b2$var$_objectSpread2($d58050833617f0b2$var$_objectSpread2({}, $d58050833617f0b2$var$Config), options);
        this.options.useExtendedSearch;
        this._keyStore = new $d58050833617f0b2$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $d58050833617f0b2$var$FuseIndex)) throw new Error($d58050833617f0b2$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $d58050833617f0b2$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$d58050833617f0b2$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $d58050833617f0b2$var$isString(query) ? $d58050833617f0b2$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $d58050833617f0b2$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($d58050833617f0b2$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $d58050833617f0b2$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $d58050833617f0b2$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d58050833617f0b2$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $d58050833617f0b2$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $d58050833617f0b2$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($d58050833617f0b2$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $d58050833617f0b2$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$d58050833617f0b2$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$d58050833617f0b2$var$isDefined(value)) return [];
        let matches = [];
        if ($d58050833617f0b2$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$d58050833617f0b2$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$d58050833617f0b2$var$Fuse.version = '7.0.0';
$d58050833617f0b2$var$Fuse.createIndex = $d58050833617f0b2$var$createIndex;
$d58050833617f0b2$var$Fuse.parseIndex = $d58050833617f0b2$var$parseIndex;
$d58050833617f0b2$var$Fuse.config = $d58050833617f0b2$var$Config;
$d58050833617f0b2$var$Fuse.parseQuery = $d58050833617f0b2$var$parse;
$d58050833617f0b2$var$register($d58050833617f0b2$var$ExtendedSearch);
var $d58050833617f0b2$var$SearchByFuse = /** @class */ function() {
    function SearchByFuse(config) {
        this._haystack = [];
        this._fuseOptions = $d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign({}, config.fuseOptions), {
            keys: $d58050833617f0b2$var$__spreadArray([], config.searchFields, true),
            includeMatches: true
        });
    }
    SearchByFuse.prototype.index = function(data) {
        this._haystack = data;
        if (this._fuse) this._fuse.setCollection(data);
    };
    SearchByFuse.prototype.reset = function() {
        this._haystack = [];
        this._fuse = undefined;
    };
    SearchByFuse.prototype.isEmptyIndex = function() {
        return !this._haystack.length;
    };
    SearchByFuse.prototype.search = function(needle) {
        if (!this._fuse) this._fuse = new $d58050833617f0b2$var$Fuse(this._haystack, this._fuseOptions);
        var results = this._fuse.search(needle);
        return results.map(function(value, i) {
            return {
                item: value.item,
                score: value.score || 0,
                rank: i + 1
            };
        });
    };
    return SearchByFuse;
}();
function $d58050833617f0b2$var$getSearcher(config) {
    return new $d58050833617f0b2$var$SearchByFuse(config);
}
/**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option.
 * `Choices.defaults.templates` allows access to the default template methods from `callbackOnCreateTemplates`
 */ var $d58050833617f0b2$var$isEmptyObject = function(obj) {
    // eslint-disable-next-line no-restricted-syntax
    for(var prop in obj){
        if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
    }
    return true;
};
var $d58050833617f0b2$var$assignCustomProperties = function(el, choice, withCustomProperties) {
    var dataset = el.dataset;
    var customProperties = choice.customProperties, labelClass = choice.labelClass, labelDescription = choice.labelDescription;
    if (labelClass) dataset.labelClass = $d58050833617f0b2$var$getClassNames(labelClass).join(' ');
    if (labelDescription) dataset.labelDescription = $d58050833617f0b2$var$unwrapStringForRaw(labelDescription);
    if (withCustomProperties && customProperties) {
        if (typeof customProperties === 'string') dataset.customProperties = customProperties;
        else if (typeof customProperties === 'object' && !$d58050833617f0b2$var$isEmptyObject(customProperties)) dataset.customProperties = JSON.stringify(customProperties);
    }
};
var $d58050833617f0b2$var$addAriaLabel = function(docRoot, id, element) {
    var label = id && docRoot.querySelector("label[for='".concat(id, "']"));
    var text = label && label.innerText;
    if (text) element.setAttribute('aria-label', text);
};
var $d58050833617f0b2$var$templates = {
    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
        var containerOuter = _a.classNames.containerOuter;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, containerOuter);
        div.dataset.type = passedElementType;
        if (dir) div.dir = dir;
        if (isSelectOneElement) div.tabIndex = 0;
        if (isSelectElement) {
            div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
            if (searchEnabled) div.setAttribute('aria-autocomplete', 'list');
            else if (!labelId) $d58050833617f0b2$var$addAriaLabel(this._docRoot, this.passedElement.element.id, div);
            div.setAttribute('aria-haspopup', 'true');
            div.setAttribute('aria-expanded', 'false');
        }
        if (labelId) div.setAttribute('aria-labelledby', labelId);
        return div;
    },
    containerInner: function(_a) {
        var containerInner = _a.classNames.containerInner;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, containerInner);
        return div;
    },
    itemList: function(_a, isSelectOneElement) {
        var searchEnabled = _a.searchEnabled, _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, list);
        $d58050833617f0b2$var$addClassesToElement(div, isSelectOneElement ? listSingle : listItems);
        if (this._isSelectElement && searchEnabled) div.setAttribute('role', 'listbox');
        return div;
    },
    placeholder: function(_a, value) {
        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, placeholder);
        $d58050833617f0b2$var$setElementHtml(div, allowHTML, value);
        return div;
    },
    item: function(_a, choice, removeItemButton) {
        var allowHTML = _a.allowHTML, removeItemButtonAlignLeft = _a.removeItemButtonAlignLeft, removeItemIconText = _a.removeItemIconText, removeItemLabelText = _a.removeItemLabelText, _b = _a.classNames, item = _b.item, button = _b.button, highlightedState = _b.highlightedState, itemSelectable = _b.itemSelectable, placeholder = _b.placeholder;
        var rawValue = $d58050833617f0b2$var$unwrapStringForRaw(choice.value);
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, item);
        if (choice.labelClass) {
            var spanLabel = document.createElement('span');
            $d58050833617f0b2$var$setElementHtml(spanLabel, allowHTML, choice.label);
            $d58050833617f0b2$var$addClassesToElement(spanLabel, choice.labelClass);
            div.appendChild(spanLabel);
        } else $d58050833617f0b2$var$setElementHtml(div, allowHTML, choice.label);
        div.dataset.item = '';
        div.dataset.id = choice.id;
        div.dataset.value = rawValue;
        $d58050833617f0b2$var$assignCustomProperties(div, choice, true);
        if (choice.disabled || this.containerOuter.isDisabled) div.setAttribute('aria-disabled', 'true');
        if (this._isSelectElement) {
            div.setAttribute('aria-selected', 'true');
            div.setAttribute('role', 'option');
        }
        if (choice.placeholder) {
            $d58050833617f0b2$var$addClassesToElement(div, placeholder);
            div.dataset.placeholder = '';
        }
        $d58050833617f0b2$var$addClassesToElement(div, choice.highlighted ? highlightedState : itemSelectable);
        if (removeItemButton) {
            if (choice.disabled) $d58050833617f0b2$var$removeClassesFromElement(div, itemSelectable);
            div.dataset.deletable = '';
            var removeButton = document.createElement('button');
            removeButton.type = 'button';
            $d58050833617f0b2$var$addClassesToElement(removeButton, button);
            var eventChoice = $d58050833617f0b2$var$getChoiceForOutput(choice);
            $d58050833617f0b2$var$setElementHtml(removeButton, true, $d58050833617f0b2$var$resolveNoticeFunction(removeItemIconText, choice.value, eventChoice));
            var REMOVE_ITEM_LABEL = $d58050833617f0b2$var$resolveNoticeFunction(removeItemLabelText, choice.value, eventChoice);
            if (REMOVE_ITEM_LABEL) removeButton.setAttribute('aria-label', REMOVE_ITEM_LABEL);
            removeButton.dataset.button = '';
            if (removeItemButtonAlignLeft) div.insertAdjacentElement('afterbegin', removeButton);
            else div.appendChild(removeButton);
        }
        return div;
    },
    choiceList: function(_a, isSelectOneElement) {
        var list = _a.classNames.list;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, list);
        if (!isSelectOneElement) div.setAttribute('aria-multiselectable', 'true');
        div.setAttribute('role', 'listbox');
        return div;
    },
    choiceGroup: function(_a, _b) {
        var allowHTML = _a.allowHTML, _c = _a.classNames, group = _c.group, groupHeading = _c.groupHeading, itemDisabled = _c.itemDisabled;
        var id = _b.id, label = _b.label, disabled = _b.disabled;
        var rawLabel = $d58050833617f0b2$var$unwrapStringForRaw(label);
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, group);
        if (disabled) $d58050833617f0b2$var$addClassesToElement(div, itemDisabled);
        div.setAttribute('role', 'group');
        div.dataset.group = '';
        div.dataset.id = id;
        div.dataset.value = rawLabel;
        if (disabled) div.setAttribute('aria-disabled', 'true');
        var heading = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(heading, groupHeading);
        $d58050833617f0b2$var$setElementHtml(heading, allowHTML, label || '');
        div.appendChild(heading);
        return div;
    },
    choice: function(_a, choice, selectText, groupName) {
        var allowHTML = _a.allowHTML, _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, itemSelectable = _b.itemSelectable, selectedState = _b.selectedState, itemDisabled = _b.itemDisabled, description = _b.description, placeholder = _b.placeholder;
        // eslint-disable-next-line prefer-destructuring
        var label = choice.label;
        var rawValue = $d58050833617f0b2$var$unwrapStringForRaw(choice.value);
        var div = document.createElement('div');
        div.id = choice.elementId;
        $d58050833617f0b2$var$addClassesToElement(div, item);
        $d58050833617f0b2$var$addClassesToElement(div, itemChoice);
        if (groupName && typeof label === 'string') {
            label = $d58050833617f0b2$var$escapeForTemplate(allowHTML, label);
            label += " (".concat(groupName, ")");
            label = {
                trusted: label
            };
        }
        var describedBy = div;
        if (choice.labelClass) {
            var spanLabel = document.createElement('span');
            $d58050833617f0b2$var$setElementHtml(spanLabel, allowHTML, label);
            $d58050833617f0b2$var$addClassesToElement(spanLabel, choice.labelClass);
            describedBy = spanLabel;
            div.appendChild(spanLabel);
        } else $d58050833617f0b2$var$setElementHtml(div, allowHTML, label);
        if (choice.labelDescription) {
            var descId = "".concat(choice.elementId, "-description");
            describedBy.setAttribute('aria-describedby', descId);
            var spanDesc = document.createElement('span');
            $d58050833617f0b2$var$setElementHtml(spanDesc, allowHTML, choice.labelDescription);
            spanDesc.id = descId;
            $d58050833617f0b2$var$addClassesToElement(spanDesc, description);
            div.appendChild(spanDesc);
        }
        if (choice.selected) $d58050833617f0b2$var$addClassesToElement(div, selectedState);
        if (choice.placeholder) $d58050833617f0b2$var$addClassesToElement(div, placeholder);
        div.setAttribute('role', choice.group ? 'treeitem' : 'option');
        div.dataset.choice = '';
        div.dataset.id = choice.id;
        div.dataset.value = rawValue;
        if (selectText) div.dataset.selectText = selectText;
        if (choice.group) div.dataset.groupId = "".concat(choice.group.id);
        $d58050833617f0b2$var$assignCustomProperties(div, choice, false);
        if (choice.disabled) {
            $d58050833617f0b2$var$addClassesToElement(div, itemDisabled);
            div.dataset.choiceDisabled = '';
            div.setAttribute('aria-disabled', 'true');
        } else {
            $d58050833617f0b2$var$addClassesToElement(div, itemSelectable);
            div.dataset.choiceSelectable = '';
            div.setAttribute('aria-selected', choice.selected ? 'true' : 'false');
        }
        return div;
    },
    input: function(_a, placeholderValue) {
        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned, labelId = _a.labelId;
        var inp = document.createElement('input');
        inp.type = 'search';
        $d58050833617f0b2$var$addClassesToElement(inp, input);
        $d58050833617f0b2$var$addClassesToElement(inp, inputCloned);
        inp.autocomplete = 'off';
        inp.autocapitalize = 'off';
        inp.spellcheck = false;
        inp.setAttribute('aria-autocomplete', 'list');
        if (placeholderValue) inp.setAttribute('aria-label', placeholderValue);
        else if (!labelId) $d58050833617f0b2$var$addAriaLabel(this._docRoot, this.passedElement.element.id, inp);
        return inp;
    },
    dropdown: function(_a, passedElementType) {
        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
        var div = document.createElement('div');
        $d58050833617f0b2$var$addClassesToElement(div, list);
        $d58050833617f0b2$var$addClassesToElement(div, listDropdown);
        if (passedElementType !== $d58050833617f0b2$var$PassedElementTypes.Text) div.setAttribute('aria-expanded', 'false');
        return div;
    },
    notice: function(_a, innerHTML, type) {
        var _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, addChoice = _b.addChoice, noResults = _b.noResults, noChoices = _b.noChoices, noticeItem = _b.notice;
        if (type === void 0) type = $d58050833617f0b2$var$NoticeTypes.generic;
        var notice = document.createElement('div');
        $d58050833617f0b2$var$setElementHtml(notice, true, innerHTML);
        $d58050833617f0b2$var$addClassesToElement(notice, item);
        $d58050833617f0b2$var$addClassesToElement(notice, itemChoice);
        $d58050833617f0b2$var$addClassesToElement(notice, noticeItem);
        // eslint-disable-next-line default-case
        switch(type){
            case $d58050833617f0b2$var$NoticeTypes.addChoice:
                $d58050833617f0b2$var$addClassesToElement(notice, addChoice);
                break;
            case $d58050833617f0b2$var$NoticeTypes.noResults:
                $d58050833617f0b2$var$addClassesToElement(notice, noResults);
                break;
            case $d58050833617f0b2$var$NoticeTypes.noChoices:
                $d58050833617f0b2$var$addClassesToElement(notice, noChoices);
                break;
        }
        if (type === $d58050833617f0b2$var$NoticeTypes.addChoice) {
            notice.dataset.choiceSelectable = '';
            notice.dataset.choice = '';
        }
        return notice;
    },
    option: function(choice) {
        // HtmlOptionElement's label value does not support HTML, so the avoid double escaping unwrap the untrusted string.
        var labelValue = $d58050833617f0b2$var$unwrapStringForRaw(choice.label);
        var opt = new Option(labelValue, choice.value, false, choice.selected);
        $d58050833617f0b2$var$assignCustomProperties(opt, choice, true);
        opt.disabled = choice.disabled;
        if (choice.selected) opt.setAttribute('selected', '');
        return opt;
    }
};
/** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var $d58050833617f0b2$var$IS_IE11 = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
var $d58050833617f0b2$var$USER_DEFAULTS = {};
var $d58050833617f0b2$var$parseDataSetId = function(element) {
    if (!element) return undefined;
    return element.dataset.id ? parseInt(element.dataset.id, 10) : undefined;
};
var $d58050833617f0b2$var$selectableChoiceIdentifier = '[data-choice-selectable]';
/**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var $d58050833617f0b2$export$2e2bcd8739ae039 = /** @class */ function() {
    function Choices(element, userConfig) {
        if (element === void 0) element = '[data-choice]';
        if (userConfig === void 0) userConfig = {};
        var _this = this;
        this.initialisedOK = undefined;
        this._hasNonChoicePlaceholder = false;
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        var defaults = Choices.defaults;
        this.config = $d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign({}, defaults.allOptions), defaults.options), userConfig);
        $d58050833617f0b2$var$ObjectsInConfig.forEach(function(key) {
            _this.config[key] = $d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign({}, defaults.allOptions[key]), defaults.options[key]), userConfig[key]);
        });
        var config = this.config;
        if (!config.silent) this._validateConfig();
        var docRoot = config.shadowRoot || document.documentElement;
        this._docRoot = docRoot;
        var passedElement = typeof element === 'string' ? docRoot.querySelector(element) : element;
        if (!passedElement || typeof passedElement !== 'object' || !($d58050833617f0b2$var$isHtmlInputElement(passedElement) || $d58050833617f0b2$var$isHtmlSelectElement(passedElement))) {
            if (!passedElement && typeof element === 'string') throw TypeError("Selector ".concat(element, " failed to find an element"));
            throw TypeError("Expected one of the following types text|select-one|select-multiple");
        }
        var elementType = passedElement.type;
        var isText = elementType === $d58050833617f0b2$var$PassedElementTypes.Text;
        if (isText || config.maxItemCount !== 1) config.singleModeForMultiSelect = false;
        if (config.singleModeForMultiSelect) elementType = $d58050833617f0b2$var$PassedElementTypes.SelectMultiple;
        var isSelectOne = elementType === $d58050833617f0b2$var$PassedElementTypes.SelectOne;
        var isSelectMultiple = elementType === $d58050833617f0b2$var$PassedElementTypes.SelectMultiple;
        var isSelect = isSelectOne || isSelectMultiple;
        this._elementType = elementType;
        this._isTextElement = isText;
        this._isSelectOneElement = isSelectOne;
        this._isSelectMultipleElement = isSelectMultiple;
        this._isSelectElement = isSelectOne || isSelectMultiple;
        this._canAddUserChoices = isText && config.addItems || isSelect && config.addChoices;
        if (typeof config.renderSelectedChoices !== 'boolean') config.renderSelectedChoices = config.renderSelectedChoices === 'always' || isSelectOne;
        if (config.closeDropdownOnSelect === 'auto') config.closeDropdownOnSelect = isText || isSelectOne || config.singleModeForMultiSelect;
        else config.closeDropdownOnSelect = $d58050833617f0b2$var$coerceBool(config.closeDropdownOnSelect);
        if (config.placeholder) {
            if (config.placeholderValue) this._hasNonChoicePlaceholder = true;
            else if (passedElement.dataset.placeholder) {
                this._hasNonChoicePlaceholder = true;
                config.placeholderValue = passedElement.dataset.placeholder;
            }
        }
        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
            config.addItemFilter = re.test.bind(re);
        }
        if (this._isTextElement) this.passedElement = new $d58050833617f0b2$var$WrappedInput({
            element: passedElement,
            classNames: config.classNames
        });
        else {
            var selectEl = passedElement;
            this.passedElement = new $d58050833617f0b2$var$WrappedSelect({
                element: selectEl,
                classNames: config.classNames,
                template: function(data) {
                    return _this._templates.option(data);
                },
                extractPlaceholder: config.placeholder && !this._hasNonChoicePlaceholder
            });
        }
        this.initialised = false;
        this._store = new $d58050833617f0b2$var$Store(config);
        this._currentValue = '';
        config.searchEnabled = !isText && config.searchEnabled;
        this._canSearch = config.searchEnabled;
        this._isScrollingOnIe = false;
        this._highlightPosition = 0;
        this._wasTap = true;
        this._placeholderValue = this._generatePlaceholderValue();
        this._baseId = $d58050833617f0b2$var$generateId(passedElement, 'choices-');
        /**
         * setting direction in cases where it's explicitly set on passedElement
         * or when calculated direction is different from the document
         */ this._direction = passedElement.dir;
        if (!this._direction) {
            var elementDirection = window.getComputedStyle(passedElement).direction;
            var documentDirection = window.getComputedStyle(document.documentElement).direction;
            if (elementDirection !== documentDirection) this._direction = elementDirection;
        }
        this._idNames = {
            itemChoice: 'item-choice'
        };
        this._templates = defaults.templates;
        this._render = this._render.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
        this._onMouseDown = this._onMouseDown.bind(this);
        this._onMouseOver = this._onMouseOver.bind(this);
        this._onFormReset = this._onFormReset.bind(this);
        this._onSelectKey = this._onSelectKey.bind(this);
        this._onEnterKey = this._onEnterKey.bind(this);
        this._onEscapeKey = this._onEscapeKey.bind(this);
        this._onDirectionKey = this._onDirectionKey.bind(this);
        this._onDeleteKey = this._onDeleteKey.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onInvalid = this._onInvalid.bind(this);
        // If element has already been initialised with Choices, fail silently
        if (this.passedElement.isActive) {
            if (!config.silent) console.warn('Trying to initialise Choices on element already initialised', {
                element: element
            });
            this.initialised = true;
            this.initialisedOK = false;
            return;
        }
        // Let's go
        this.init();
        // preserve the selected item list after setup for form reset
        this._initialItems = this._store.items.map(function(choice) {
            return choice.value;
        });
    }
    Object.defineProperty(Choices, "defaults", {
        get: function() {
            return Object.preventExtensions({
                get options () {
                    return $d58050833617f0b2$var$USER_DEFAULTS;
                },
                get allOptions () {
                    return $d58050833617f0b2$var$DEFAULT_CONFIG;
                },
                get templates () {
                    return $d58050833617f0b2$var$templates;
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Choices.prototype.init = function() {
        if (this.initialised || this.initialisedOK !== undefined) return;
        this._searcher = $d58050833617f0b2$var$getSearcher(this.config);
        this._loadChoices();
        this._createTemplates();
        this._createElements();
        this._createStructure();
        if (this._isTextElement && !this.config.addItems || this.passedElement.element.hasAttribute('disabled') || !!this.passedElement.element.closest('fieldset:disabled')) this.disable();
        else {
            this.enable();
            this._addEventListeners();
        }
        // should be triggered **after** disabled state to avoid additional re-draws
        this._initStore();
        this.initialised = true;
        this.initialisedOK = true;
        var callbackOnInit = this.config.callbackOnInit;
        // Run callback if it is a function
        if (typeof callbackOnInit === 'function') callbackOnInit.call(this);
    };
    Choices.prototype.destroy = function() {
        if (!this.initialised) return;
        this._removeEventListeners();
        this.passedElement.reveal();
        this.containerOuter.unwrap(this.passedElement.element);
        this._store._listeners = []; // prevents select/input value being wiped
        this.clearStore(false);
        this._stopSearch();
        this._templates = Choices.defaults.templates;
        this.initialised = false;
        this.initialisedOK = undefined;
    };
    Choices.prototype.enable = function() {
        if (this.passedElement.isDisabled) this.passedElement.enable();
        if (this.containerOuter.isDisabled) {
            this._addEventListeners();
            this.input.enable();
            this.containerOuter.enable();
        }
        return this;
    };
    Choices.prototype.disable = function() {
        if (!this.passedElement.isDisabled) this.passedElement.disable();
        if (!this.containerOuter.isDisabled) {
            this._removeEventListeners();
            this.input.disable();
            this.containerOuter.disable();
        }
        return this;
    };
    Choices.prototype.highlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || choice.highlighted) return this;
        this._store.dispatch($d58050833617f0b2$var$highlightItem(choice, true));
        if (runEvent) this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.highlightItem, $d58050833617f0b2$var$getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.unhighlightItem = function(item, runEvent) {
        if (runEvent === void 0) runEvent = true;
        if (!item || !item.id) return this;
        var choice = this._store.items.find(function(c) {
            return c.id === item.id;
        });
        if (!choice || !choice.highlighted) return this;
        this._store.dispatch($d58050833617f0b2$var$highlightItem(choice, false));
        if (runEvent) this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.unhighlightItem, $d58050833617f0b2$var$getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.highlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (!item.highlighted) {
                    _this._store.dispatch($d58050833617f0b2$var$highlightItem(item, true));
                    _this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.highlightItem, $d58050833617f0b2$var$getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.unhighlightAll = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.forEach(function(item) {
                if (item.highlighted) {
                    _this._store.dispatch($d58050833617f0b2$var$highlightItem(item, false));
                    _this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.highlightItem, $d58050833617f0b2$var$getChoiceForOutput(item));
                }
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItemsByValue = function(value) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(item) {
                return item.value === value;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeActiveItems = function(excludedId) {
        var _this = this;
        this._store.withTxn(function() {
            _this._store.items.filter(function(_a) {
                var id = _a.id;
                return id !== excludedId;
            }).forEach(function(item) {
                return _this._removeItem(item);
            });
        });
        return this;
    };
    Choices.prototype.removeHighlightedItems = function(runEvent) {
        var _this = this;
        if (runEvent === void 0) runEvent = false;
        this._store.withTxn(function() {
            _this._store.highlightedActiveItems.forEach(function(item) {
                _this._removeItem(item);
                // If this action was performed by the user
                // trigger the event
                if (runEvent) _this._triggerChange(item.value);
            });
        });
        return this;
    };
    Choices.prototype.showDropdown = function(preventInputFocus) {
        var _this = this;
        if (this.dropdown.isActive) return this;
        if (preventInputFocus === undefined) // eslint-disable-next-line no-param-reassign
        preventInputFocus = !this._canSearch;
        // to ensure a virtual keyboard trigger as expected, the focus/animation must be started from the input event and not an animation frame which
        this.dropdown.show();
        var rect = this.dropdown.element.getBoundingClientRect();
        this.containerOuter.open(rect.bottom, rect.height);
        if (!preventInputFocus) this.input.focus();
        requestAnimationFrame(function() {
            _this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.showDropdown);
            var activeElement = _this.choiceList.element.querySelector($d58050833617f0b2$var$getClassNamesSelector(_this.config.classNames.selectedState));
            if (activeElement !== null && !$d58050833617f0b2$var$isScrolledIntoView(activeElement, _this.choiceList.element)) // scrollIntoView can cause entire page scrolling, scrollToChildElement causes undesired animation
            _this.choiceList.element.scrollTop = activeElement.offsetTop;
        });
        return this;
    };
    Choices.prototype.hideDropdown = function(preventInputBlur) {
        var _this = this;
        if (!this.dropdown.isActive) return this;
        this._removeHighlightedChoices();
        requestAnimationFrame(function() {
            _this.dropdown.hide();
            _this.containerOuter.close();
            if (!preventInputBlur && _this._canSearch) {
                _this.input.removeActiveDescendant();
                _this.input.blur();
            }
            _this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.hideDropdown);
        });
        return this;
    };
    Choices.prototype.getValue = function(valueOnly) {
        var values = this._store.items.map(function(item) {
            return valueOnly ? item.value : $d58050833617f0b2$var$getChoiceForOutput(item);
        });
        return this._isSelectOneElement || this.config.singleModeForMultiSelect ? values[0] : values;
    };
    Choices.prototype.setValue = function(items) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setValue');
            return this;
        }
        this._store.withTxn(function() {
            items.forEach(function(value) {
                if (value) _this._addChoice($d58050833617f0b2$var$mapInputToChoice(value, false));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.setChoiceByValue = function(value) {
        var _this = this;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setChoiceByValue');
            return this;
        }
        if (this._isTextElement) return this;
        this._store.withTxn(function() {
            // If only one value has been passed, convert to array
            var choiceValue = Array.isArray(value) ? value : [
                value
            ];
            // Loop through each value and
            choiceValue.forEach(function(val) {
                return _this._findAndSelectChoiceByValue(val);
            });
            _this.unhighlightAll();
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    /**
     * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
     * a value field name and a label field name.
     * This behaves the same as passing items via the choices option but can be called after initialising Choices.
     * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
     * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
     *
     * **Input types affected:** select-one, select-multiple
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([
     *   {value: 'One', label: 'Label One', disabled: true},
     *   {value: 'Two', label: 'Label Two', selected: true},
     *   {value: 'Three', label: 'Label Three'},
     * ], 'value', 'label', false);
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices(async () => {
     *   try {
     *      const items = await fetch('/items');
     *      return items.json()
     *   } catch(err) {
     *      console.error(err)
     *   }
     * });
     * ```
     *
     * @example
     * ```js
     * const example = new Choices(element);
     *
     * example.setChoices([{
     *   label: 'Group one',
     *   id: 1,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child One', label: 'Child One', selected: true},
     *     {value: 'Child Two', label: 'Child Two',  disabled: true},
     *     {value: 'Child Three', label: 'Child Three'},
     *   ]
     * },
     * {
     *   label: 'Group two',
     *   id: 2,
     *   disabled: false,
     *   choices: [
     *     {value: 'Child Four', label: 'Child Four', disabled: true},
     *     {value: 'Child Five', label: 'Child Five'},
     *     {value: 'Child Six', label: 'Child Six', customProperties: {
     *       description: 'Custom description about child six',
     *       random: 'Another random custom property'
     *     }},
     *   ]
     * }], 'value', 'label', false);
     * ```
     */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices, clearSearchFlag, replaceItems) {
        var _this = this;
        if (value === void 0) value = 'value';
        if (label === void 0) label = 'label';
        if (replaceChoices === void 0) replaceChoices = false;
        if (clearSearchFlag === void 0) clearSearchFlag = true;
        if (replaceItems === void 0) replaceItems = false;
        if (!this.initialisedOK) {
            this._warnChoicesInitFailed('setChoices');
            return this;
        }
        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
        if (typeof value !== 'string' || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
        if (typeof choicesArrayOrFetcher === 'function') {
            // it's a choices fetcher function
            var fetcher_1 = choicesArrayOrFetcher(this);
            if (typeof Promise === 'function' && fetcher_1 instanceof Promise) // @ts-expect-error wonky typing
            // eslint-disable-next-line no-promise-executor-return
            return new Promise(function(resolve) {
                return requestAnimationFrame(resolve);
            }).then(function() {
                return _this._handleLoadingState(true);
            }).then(function() {
                return fetcher_1;
            }).then(function(data) {
                return _this.setChoices(data, value, label, replaceChoices, clearSearchFlag, replaceItems);
            }).catch(function(err) {
                if (!_this.config.silent) console.error(err);
            }).then(function() {
                return _this._handleLoadingState(false);
            }).then(function() {
                return _this;
            });
            // function returned something else than promise, let's check if it's an array of choices
            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
            // @ts-expect-error wonky typing
            // eslint-disable-next-line no-param-reassign
            choicesArrayOrFetcher = fetcher_1;
        }
        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
        this.containerOuter.removeLoadingState();
        this._store.withTxn(function() {
            if (clearSearchFlag) _this._isSearching = false;
            // Clear choices if needed
            if (replaceChoices) _this.clearChoices(true, replaceItems);
            var isDefaultValue = value === 'value';
            var isDefaultLabel = label === 'label';
            choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                if ('choices' in groupOrChoice) {
                    var group = groupOrChoice;
                    if (!isDefaultLabel) group = $d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign({}, group), {
                        label: group[label]
                    });
                    _this._addGroup($d58050833617f0b2$var$mapInputToChoice(group, true));
                } else {
                    var choice = groupOrChoice;
                    if (!isDefaultLabel || !isDefaultValue) choice = $d58050833617f0b2$var$__assign($d58050833617f0b2$var$__assign({}, choice), {
                        value: choice[value],
                        label: choice[label]
                    });
                    var choiceFull = $d58050833617f0b2$var$mapInputToChoice(choice, false);
                    _this._addChoice(choiceFull);
                    if (choiceFull.placeholder && !_this._hasNonChoicePlaceholder) _this._placeholderValue = $d58050833617f0b2$var$unwrapStringForEscaped(choiceFull.label);
                }
            });
            _this.unhighlightAll();
        });
        // ensure any notice is displayed as expected when the dropdown is open
        if (this.dropdown.isActive && this._canAddUserChoices) this._canCreateItem(this.input.value);
        // @todo integrate with Store
        this._searcher.reset();
        // @ts-expect-error wonky typing
        return this;
    };
    Choices.prototype.refresh = function(withEvents, selectFirstOption, deselectAll) {
        var _this = this;
        if (withEvents === void 0) withEvents = false;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (deselectAll === void 0) deselectAll = false;
        if (!this._isSelectElement) {
            if (!this.config.silent) console.warn('refresh method can only be used on choices backed by a <select> element');
            return this;
        }
        this._store.withTxn(function() {
            var choicesFromOptions = _this.passedElement.optionsAsChoices();
            // Build the list of items which require preserving
            var existingItems = {};
            if (!deselectAll) _this._store.items.forEach(function(choice) {
                if (choice.id && choice.active && choice.selected) existingItems[choice.value] = true;
            });
            _this.clearStore(false);
            var updateChoice = function(choice) {
                if (deselectAll) _this._store.dispatch($d58050833617f0b2$var$removeItem$1(choice));
                else if (existingItems[choice.value]) choice.selected = true;
            };
            choicesFromOptions.forEach(function(groupOrChoice) {
                if ('choices' in groupOrChoice) {
                    groupOrChoice.choices.forEach(updateChoice);
                    return;
                }
                updateChoice(groupOrChoice);
            });
            /* @todo only generate add events for the added options instead of all
            if (withEvents) {
              items.forEach((choice) => {
                if (existingItems[choice.value]) {
                  this.passedElement.triggerEvent(
                    EventType.removeItem,
                    this._getChoiceForEvent(choice),
                  );
                }
              });
            }
            */ // load new choices & items
            _this._addPredefinedChoices(choicesFromOptions, selectFirstOption, withEvents);
            // re-do search if required
            if (_this._isSearching) _this._searchChoices(_this.input.value);
        });
        return this;
    };
    Choices.prototype.removeChoice = function(value) {
        var choice = this._store.choices.find(function(c) {
            return c.value === value;
        });
        if (!choice) return this;
        this._clearNotice();
        this._store.dispatch($d58050833617f0b2$var$removeChoice(choice));
        // @todo integrate with Store
        this._searcher.reset();
        if (choice.selected) this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.removeItem, $d58050833617f0b2$var$getChoiceForOutput(choice));
        return this;
    };
    Choices.prototype.clearChoices = function(clearOptions, clearItems) {
        var _this = this;
        if (clearOptions === void 0) clearOptions = true;
        if (clearItems === void 0) clearItems = false;
        if (clearOptions) {
            if (clearItems) this.passedElement.element.replaceChildren('');
            else this.passedElement.element.querySelectorAll(':not([selected])').forEach(function(el) {
                el.remove();
            });
        }
        this.itemList.element.replaceChildren('');
        this.choiceList.element.replaceChildren('');
        this._clearNotice();
        this._store.withTxn(function() {
            var items = clearItems ? [] : _this._store.items;
            _this._store.reset();
            items.forEach(function(item) {
                _this._store.dispatch($d58050833617f0b2$var$addChoice(item));
                _this._store.dispatch($d58050833617f0b2$var$addItem(item));
            });
        });
        // @todo integrate with Store
        this._searcher.reset();
        return this;
    };
    Choices.prototype.clearStore = function(clearOptions) {
        if (clearOptions === void 0) clearOptions = true;
        this.clearChoices(clearOptions, true);
        this._stopSearch();
        this._lastAddedChoiceId = 0;
        this._lastAddedGroupId = 0;
        return this;
    };
    Choices.prototype.clearInput = function() {
        var shouldSetInputWidth = !this._isSelectOneElement;
        this.input.clear(shouldSetInputWidth);
        this._stopSearch();
        return this;
    };
    Choices.prototype._validateConfig = function() {
        var config = this.config;
        var invalidConfigOptions = $d58050833617f0b2$var$diff(config, $d58050833617f0b2$var$DEFAULT_CONFIG);
        if (invalidConfigOptions.length) console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
        if (config.allowHTML && config.allowHtmlUserInput) {
            if (config.addItems) console.warn('Warning: allowHTML/allowHtmlUserInput/addItems all being true is strongly not recommended and may lead to XSS attacks');
            if (config.addChoices) console.warn('Warning: allowHTML/allowHtmlUserInput/addChoices all being true is strongly not recommended and may lead to XSS attacks');
        }
    };
    Choices.prototype._render = function(changes) {
        if (changes === void 0) changes = {
            choices: true,
            groups: true,
            items: true
        };
        if (this._store.inTxn()) return;
        if (this._isSelectElement) {
            if (changes.choices || changes.groups) this._renderChoices();
        }
        if (changes.items) this._renderItems();
    };
    Choices.prototype._renderChoices = function() {
        var _this = this;
        if (!this._canAddItems()) return; // block rendering choices if the input limit is reached.
        var _a = this, config = _a.config, isSearching = _a._isSearching;
        var _b = this._store, activeGroups = _b.activeGroups, activeChoices = _b.activeChoices;
        var renderLimit = isSearching ? config.searchResultLimit : config.renderChoiceLimit;
        if (this._isSelectElement) {
            var backingOptions = activeChoices.filter(function(choice) {
                return !choice.element;
            });
            if (backingOptions.length) this.passedElement.addOptions(backingOptions);
        }
        var fragment = document.createDocumentFragment();
        var renderableChoices = function(choices) {
            return choices.filter(function(choice) {
                return !choice.placeholder && (isSearching ? (config.searchRenderSelectedChoices || !choice.selected) && !!choice.rank : config.renderSelectedChoices || !choice.selected);
            });
        };
        var showLabel = config.appendGroupInSearch && isSearching;
        var selectableChoices = false;
        var highlightedEl = null;
        var renderChoices = function(choices, withinGroup) {
            if (isSearching) // sortByRank is used to ensure stable sorting, as scores are non-unique
            // this additionally ensures fuseOptions.sortFn is not ignored
            choices.sort($d58050833617f0b2$var$sortByRank);
            else if (config.shouldSort) choices.sort(config.sorter);
            var choiceLimit = choices.length;
            choiceLimit = !withinGroup && renderLimit > 0 && choiceLimit > renderLimit ? renderLimit : choiceLimit;
            choiceLimit--;
            choices.every(function(choice, index) {
                // choiceEl being empty signals the contents has probably significantly changed
                var dropdownItem = choice.choiceEl || _this._templates.choice(config, choice, config.itemSelectText, showLabel && choice.group ? choice.group.label : undefined);
                choice.choiceEl = dropdownItem;
                fragment.appendChild(dropdownItem);
                if (isSearching || !choice.selected) selectableChoices = true;
                else if (!highlightedEl) highlightedEl = dropdownItem;
                return index < choiceLimit;
            });
        };
        if (activeChoices.length) {
            if (config.resetScrollPosition) requestAnimationFrame(function() {
                return _this.choiceList.scrollToTop();
            });
            if (!this._hasNonChoicePlaceholder && !isSearching && this._isSelectOneElement) // If we have a placeholder choice along with groups
            renderChoices(activeChoices.filter(function(choice) {
                return choice.placeholder && !choice.group;
            }), false);
            // If we have grouped options
            if (activeGroups.length && !isSearching) {
                if (config.shouldSort) activeGroups.sort(config.sorter);
                // render Choices without group first, regardless of sort, otherwise they won't be distinguishable
                // from the last group
                renderChoices(activeChoices.filter(function(choice) {
                    return !choice.placeholder && !choice.group;
                }), false);
                activeGroups.forEach(function(group) {
                    var groupChoices = renderableChoices(group.choices);
                    if (groupChoices.length) {
                        if (group.label) {
                            var dropdownGroup = group.groupEl || _this._templates.choiceGroup(_this.config, group);
                            group.groupEl = dropdownGroup;
                            dropdownGroup.remove();
                            fragment.appendChild(dropdownGroup);
                        }
                        renderChoices(groupChoices, true);
                    }
                });
            } else renderChoices(renderableChoices(activeChoices), false);
        }
        if (!selectableChoices && (isSearching || !fragment.children.length || !config.renderSelectedChoices)) {
            if (!this._notice) this._notice = {
                text: $d58050833617f0b2$var$resolveStringFunction(isSearching ? config.noResultsText : config.noChoicesText),
                type: isSearching ? $d58050833617f0b2$var$NoticeTypes.noResults : $d58050833617f0b2$var$NoticeTypes.noChoices
            };
            fragment.replaceChildren('');
        }
        this._renderNotice(fragment);
        this.choiceList.element.replaceChildren(fragment);
        this._highlightChoice(highlightedEl);
    };
    Choices.prototype._renderItems = function() {
        var _this = this;
        var items = this._store.items || [];
        var itemList = this.itemList.element;
        var config = this.config;
        var fragment = document.createDocumentFragment();
        var itemFromList = function(item) {
            return itemList.querySelector("[data-item][data-id=\"".concat(item.id, "\"]"));
        };
        var addItemToFragment = function(item) {
            var el = item.itemEl;
            if (el && el.parentElement) return;
            el = itemFromList(item) || _this._templates.item(config, item, config.removeItemButton);
            item.itemEl = el;
            fragment.appendChild(el);
        };
        // new items
        items.forEach(addItemToFragment);
        var addedItems = !!fragment.childNodes.length;
        if (this._isSelectOneElement) {
            var existingItems = itemList.children.length;
            if (addedItems || existingItems > 1) {
                var placeholder = itemList.querySelector($d58050833617f0b2$var$getClassNamesSelector(config.classNames.placeholder));
                if (placeholder) placeholder.remove();
            } else if (!addedItems && !existingItems && this._placeholderValue) {
                addedItems = true;
                addItemToFragment($d58050833617f0b2$var$mapInputToChoice({
                    selected: true,
                    value: '',
                    label: this._placeholderValue,
                    placeholder: true
                }, false));
            }
        }
        if (addedItems) {
            itemList.append(fragment);
            if (config.shouldSortItems && !this._isSelectOneElement) {
                items.sort(config.sorter);
                // push sorting into the DOM
                items.forEach(function(item) {
                    var el = itemFromList(item);
                    if (el) {
                        el.remove();
                        fragment.append(el);
                    }
                });
                itemList.append(fragment);
            }
        }
        if (this._isTextElement) // Update the value of the hidden input
        this.passedElement.value = items.map(function(_a) {
            var value = _a.value;
            return value;
        }).join(config.delimiter);
    };
    Choices.prototype._displayNotice = function(text, type, openDropdown) {
        if (openDropdown === void 0) openDropdown = true;
        var oldNotice = this._notice;
        if (oldNotice && (oldNotice.type === type && oldNotice.text === text || oldNotice.type === $d58050833617f0b2$var$NoticeTypes.addChoice && (type === $d58050833617f0b2$var$NoticeTypes.noResults || type === $d58050833617f0b2$var$NoticeTypes.noChoices))) {
            if (openDropdown) this.showDropdown(true);
            return;
        }
        this._clearNotice();
        this._notice = text ? {
            text: text,
            type: type
        } : undefined;
        this._renderNotice();
        if (openDropdown && text) this.showDropdown(true);
    };
    Choices.prototype._clearNotice = function() {
        if (!this._notice) return;
        var noticeElement = this.choiceList.element.querySelector($d58050833617f0b2$var$getClassNamesSelector(this.config.classNames.notice));
        if (noticeElement) noticeElement.remove();
        this._notice = undefined;
    };
    Choices.prototype._renderNotice = function(fragment) {
        var noticeConf = this._notice;
        if (noticeConf) {
            var notice = this._templates.notice(this.config, noticeConf.text, noticeConf.type);
            if (fragment) fragment.append(notice);
            else this.choiceList.prepend(notice);
        }
    };
    /**
     * @deprecated Use utils.getChoiceForOutput
     */ // eslint-disable-next-line class-methods-use-this
    Choices.prototype._getChoiceForOutput = function(choice, keyCode) {
        return $d58050833617f0b2$var$getChoiceForOutput(choice, keyCode);
    };
    Choices.prototype._triggerChange = function(value) {
        if (value === undefined || value === null) return;
        this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.change, {
            value: value
        });
    };
    Choices.prototype._handleButtonAction = function(element) {
        var _this = this;
        var items = this._store.items;
        if (!items.length || !this.config.removeItems || !this.config.removeItemButton) return;
        var id = element && $d58050833617f0b2$var$parseDataSetId(element.closest('[data-id]'));
        var itemToRemove = id && items.find(function(item) {
            return item.id === id;
        });
        if (!itemToRemove) return;
        this._store.withTxn(function() {
            // Remove item associated with button
            _this._removeItem(itemToRemove);
            _this._triggerChange(itemToRemove.value);
            if (_this._isSelectOneElement && !_this._hasNonChoicePlaceholder) {
                var placeholderChoice = (_this.config.shouldSort ? _this._store.choices.reverse() : _this._store.choices).find(function(choice) {
                    return choice.placeholder;
                });
                if (placeholderChoice) {
                    _this._addItem(placeholderChoice);
                    _this.unhighlightAll();
                    if (placeholderChoice.value) _this._triggerChange(placeholderChoice.value);
                }
            }
        });
    };
    Choices.prototype._handleItemAction = function(element, hasShiftKey) {
        var _this = this;
        if (hasShiftKey === void 0) hasShiftKey = false;
        var items = this._store.items;
        if (!items.length || !this.config.removeItems || this._isSelectOneElement) return;
        var id = $d58050833617f0b2$var$parseDataSetId(element);
        if (!id) return;
        // We only want to select one item with a click
        // so we deselect any items that aren't the target
        // unless shift is being pressed
        items.forEach(function(item) {
            if (item.id === id && !item.highlighted) _this.highlightItem(item);
            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
        });
        // Focus input as without focus, a user cannot do anything with a
        // highlighted item
        this.input.focus();
    };
    Choices.prototype._handleChoiceAction = function(element) {
        var _this = this;
        // If we are clicking on an option
        var id = $d58050833617f0b2$var$parseDataSetId(element);
        var choice = id && this._store.getChoiceById(id);
        if (!choice || choice.disabled) return false;
        var hasActiveDropdown = this.dropdown.isActive;
        if (!choice.selected) {
            if (!this._canAddItems()) return true; // causes _onEnterKey to early out
            this._store.withTxn(function() {
                _this._addItem(choice, true, true);
                _this.clearInput();
                _this.unhighlightAll();
            });
            this._triggerChange(choice.value);
        }
        // We want to close the dropdown if we are dealing with a single select box
        if (hasActiveDropdown && this.config.closeDropdownOnSelect) {
            this.hideDropdown(true);
            this.containerOuter.element.focus();
        }
        return true;
    };
    Choices.prototype._handleBackspace = function(items) {
        var config = this.config;
        if (!config.removeItems || !items.length) return;
        var lastItem = items[items.length - 1];
        var hasHighlightedItems = items.some(function(item) {
            return item.highlighted;
        });
        // If editing the last item is allowed and there are not other selected items,
        // we can edit the item value. Otherwise if we can remove items, remove all selected items
        if (config.editItems && !hasHighlightedItems && lastItem) {
            this.input.value = lastItem.value;
            this.input.setWidth();
            this._removeItem(lastItem);
            this._triggerChange(lastItem.value);
        } else {
            if (!hasHighlightedItems) // Highlight last item if none already highlighted
            this.highlightItem(lastItem, false);
            this.removeHighlightedItems(true);
        }
    };
    Choices.prototype._loadChoices = function() {
        var _a;
        var _this = this;
        var config = this.config;
        if (this._isTextElement) {
            // Assign preset items from passed object first
            this._presetChoices = config.items.map(function(e) {
                return $d58050833617f0b2$var$mapInputToChoice(e, false);
            });
            // Add any values passed from attribute
            if (this.passedElement.value) {
                var elementItems = this.passedElement.value.split(config.delimiter).map(function(e) {
                    return $d58050833617f0b2$var$mapInputToChoice(e, false, _this.config.allowHtmlUserInput);
                });
                this._presetChoices = this._presetChoices.concat(elementItems);
            }
            this._presetChoices.forEach(function(choice) {
                choice.selected = true;
            });
        } else if (this._isSelectElement) {
            // Assign preset choices from passed object
            this._presetChoices = config.choices.map(function(e) {
                return $d58050833617f0b2$var$mapInputToChoice(e, true);
            });
            // Create array of choices from option elements
            var choicesFromOptions = this.passedElement.optionsAsChoices();
            if (choicesFromOptions) (_a = this._presetChoices).push.apply(_a, choicesFromOptions);
        }
    };
    Choices.prototype._handleLoadingState = function(setLoading) {
        if (setLoading === void 0) setLoading = true;
        var el = this.itemList.element;
        if (setLoading) {
            this.disable();
            this.containerOuter.addLoadingState();
            if (this._isSelectOneElement) el.replaceChildren(this._templates.placeholder(this.config, this.config.loadingText));
            else this.input.placeholder = this.config.loadingText;
        } else {
            this.enable();
            this.containerOuter.removeLoadingState();
            if (this._isSelectOneElement) {
                el.replaceChildren('');
                this._render();
            } else this.input.placeholder = this._placeholderValue || '';
        }
    };
    Choices.prototype._handleSearch = function(value) {
        if (!this.input.isFocussed) return;
        // Check that we have a value to search and the input was an alphanumeric character
        if (value !== null && typeof value !== 'undefined' && value.length >= this.config.searchFloor) {
            var resultCount = this.config.searchChoices ? this._searchChoices(value) : 0;
            if (resultCount !== null) // Trigger search event
            this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.search, {
                value: value,
                resultCount: resultCount
            });
        } else if (this._store.choices.some(function(option) {
            return !option.active;
        })) this._stopSearch();
    };
    Choices.prototype._canAddItems = function() {
        var config = this.config;
        var maxItemCount = config.maxItemCount, maxItemText = config.maxItemText;
        if (!config.singleModeForMultiSelect && maxItemCount > 0 && maxItemCount <= this._store.items.length) {
            this.choiceList.element.replaceChildren('');
            this._notice = undefined;
            this._displayNotice(typeof maxItemText === 'function' ? maxItemText(maxItemCount) : maxItemText, $d58050833617f0b2$var$NoticeTypes.addChoice, false);
            return false;
        }
        if (this._notice && this._notice.type === $d58050833617f0b2$var$NoticeTypes.addChoice) this._clearNotice();
        return true;
    };
    Choices.prototype._canCreateItem = function(value) {
        var config = this.config;
        var canAddItem = true;
        var notice = '';
        if (canAddItem) {
            var foundChoice = this._store.choices.find(function(choice) {
                return config.valueComparer(choice.value, value);
            });
            if (foundChoice) {
                if (this._isSelectElement) {
                    // for exact matches, do not prompt to add it as a custom choice
                    this._displayNotice('', $d58050833617f0b2$var$NoticeTypes.addChoice);
                    return false;
                }
                if (!config.duplicateItemsAllowed) {
                    canAddItem = false;
                    notice = $d58050833617f0b2$var$resolveNoticeFunction(config.uniqueItemText, value, undefined);
                }
            }
        }
        if (canAddItem && typeof config.addItemFilter === 'function' && !config.addItemFilter(value)) {
            canAddItem = false;
            notice = $d58050833617f0b2$var$resolveNoticeFunction(config.customAddItemText, value, undefined);
        }
        if (canAddItem) notice = $d58050833617f0b2$var$resolveNoticeFunction(config.addItemText, value, undefined);
        if (notice) this._displayNotice(notice, $d58050833617f0b2$var$NoticeTypes.addChoice);
        return canAddItem;
    };
    Choices.prototype._searchChoices = function(value) {
        var newValue = value.trim().replace(/\s{2,}/, ' ');
        // signal input didn't change search
        if (!newValue.length || newValue === this._currentValue) return null;
        var searcher = this._searcher;
        if (searcher.isEmptyIndex()) searcher.index(this._store.searchableChoices);
        // If new value matches the desired length and is not the same as the current value with a space
        var results = searcher.search(newValue);
        this._currentValue = newValue;
        this._highlightPosition = 0;
        this._isSearching = true;
        var notice = this._notice;
        var noticeType = notice && notice.type;
        if (noticeType !== $d58050833617f0b2$var$NoticeTypes.addChoice) {
            if (!results.length) this._displayNotice($d58050833617f0b2$var$resolveStringFunction(this.config.noResultsText), $d58050833617f0b2$var$NoticeTypes.noResults);
            else this._clearNotice();
        }
        this._store.dispatch($d58050833617f0b2$var$filterChoices(results));
        return results.length;
    };
    Choices.prototype._stopSearch = function() {
        if (this._isSearching) {
            this._currentValue = '';
            this._isSearching = false;
            this._clearNotice();
            this._store.dispatch($d58050833617f0b2$var$activateChoices(true));
            this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.search, {
                value: '',
                resultCount: 0
            });
        }
    };
    Choices.prototype._addEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        var passedElement = this.passedElement.element;
        // capture events - can cancel event processing or propagation
        documentElement.addEventListener('touchend', this._onTouchEnd, true);
        outerElement.addEventListener('keydown', this._onKeyDown, true);
        outerElement.addEventListener('mousedown', this._onMouseDown, true);
        // passive events - doesn't call `preventDefault` or `stopPropagation`
        documentElement.addEventListener('click', this._onClick, {
            passive: true
        });
        documentElement.addEventListener('touchmove', this._onTouchMove, {
            passive: true
        });
        this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
            passive: true
        });
        if (this._isSelectOneElement) {
            outerElement.addEventListener('focus', this._onFocus, {
                passive: true
            });
            outerElement.addEventListener('blur', this._onBlur, {
                passive: true
            });
        }
        inputElement.addEventListener('keyup', this._onKeyUp, {
            passive: true
        });
        inputElement.addEventListener('input', this._onInput, {
            passive: true
        });
        inputElement.addEventListener('focus', this._onFocus, {
            passive: true
        });
        inputElement.addEventListener('blur', this._onBlur, {
            passive: true
        });
        if (inputElement.form) inputElement.form.addEventListener('reset', this._onFormReset, {
            passive: true
        });
        if (passedElement.hasAttribute('required')) {
            passedElement.addEventListener('change', this._onChange, {
                passive: true
            });
            passedElement.addEventListener('invalid', this._onInvalid, {
                passive: true
            });
        }
        this.input.addEventListeners();
    };
    Choices.prototype._removeEventListeners = function() {
        var documentElement = this._docRoot;
        var outerElement = this.containerOuter.element;
        var inputElement = this.input.element;
        var passedElement = this.passedElement.element;
        documentElement.removeEventListener('touchend', this._onTouchEnd, true);
        outerElement.removeEventListener('keydown', this._onKeyDown, true);
        outerElement.removeEventListener('mousedown', this._onMouseDown, true);
        documentElement.removeEventListener('click', this._onClick);
        documentElement.removeEventListener('touchmove', this._onTouchMove);
        this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
        if (this._isSelectOneElement) {
            outerElement.removeEventListener('focus', this._onFocus);
            outerElement.removeEventListener('blur', this._onBlur);
        }
        inputElement.removeEventListener('keyup', this._onKeyUp);
        inputElement.removeEventListener('input', this._onInput);
        inputElement.removeEventListener('focus', this._onFocus);
        inputElement.removeEventListener('blur', this._onBlur);
        if (inputElement.form) inputElement.form.removeEventListener('reset', this._onFormReset);
        if (passedElement.hasAttribute('required')) {
            passedElement.removeEventListener('change', this._onChange);
            passedElement.removeEventListener('invalid', this._onInvalid);
        }
        this.input.removeEventListeners();
    };
    Choices.prototype._onKeyDown = function(event) {
        var keyCode = event.keyCode;
        var hasActiveDropdown = this.dropdown.isActive;
        /*
        See:
        https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        https://en.wikipedia.org/wiki/UTF-16#Code_points_from_U+010000_to_U+10FFFF - UTF-16 surrogate pairs
        https://stackoverflow.com/a/70866532 - "Unidentified" for mobile
        http://www.unicode.org/versions/Unicode5.2.0/ch16.pdf#G19635 - U+FFFF is reserved (Section 16.7)
    
        Logic: when a key event is sent, `event.key` represents its printable value _or_ one
        of a large list of special values indicating meta keys/functionality. In addition,
        key events for compose functionality contain a value of `Dead` when mid-composition.
    
        I can't quite verify it, but non-English IMEs may also be able to generate key codes
        for code points in the surrogate-pair range, which could potentially be seen as having
        key.length > 1. Since `Fn` is one of the special keys, we can't distinguish by that
        alone.
    
        Here, key.length === 1 means we know for sure the input was printable and not a special
        `key` value. When the length is greater than 1, it could be either a printable surrogate
        pair or a special `key` value. We can tell the difference by checking if the _character
        code_ value (not code point!) is in the "surrogate pair" range or not.
    
        We don't use .codePointAt because an invalid code point would return 65535, which wouldn't
        pass the >= 0x10000 check we would otherwise use.
    
        > ...The Unicode Standard sets aside 66 noncharacter code points. The last two code points
        > of each plane are noncharacters: U+FFFE and U+FFFF on the BMP...
        */ var wasPrintableChar = event.key.length === 1 || event.key.length === 2 && event.key.charCodeAt(0) >= 0xd800 || event.key === 'Unidentified';
        /*
          We do not show the dropdown if focusing out with esc or navigating through input fields.
          An activated search can still be opened with any other key.
         */ if (!this._isTextElement && !hasActiveDropdown && keyCode !== $d58050833617f0b2$var$KeyCodeMap.ESC_KEY && keyCode !== $d58050833617f0b2$var$KeyCodeMap.TAB_KEY && keyCode !== $d58050833617f0b2$var$KeyCodeMap.SHIFT_KEY) {
            this.showDropdown();
            if (!this.input.isFocussed && wasPrintableChar) {
                /*
                  We update the input value with the pressed key as
                  the input was not focussed at the time of key press
                  therefore does not have the value of the key.
                */ this.input.value += event.key;
                // browsers interpret a space as pagedown
                if (event.key === ' ') event.preventDefault();
            }
        }
        switch(keyCode){
            case $d58050833617f0b2$var$KeyCodeMap.A_KEY:
                return this._onSelectKey(event, this.itemList.element.hasChildNodes());
            case $d58050833617f0b2$var$KeyCodeMap.ENTER_KEY:
                return this._onEnterKey(event, hasActiveDropdown);
            case $d58050833617f0b2$var$KeyCodeMap.ESC_KEY:
                return this._onEscapeKey(event, hasActiveDropdown);
            case $d58050833617f0b2$var$KeyCodeMap.UP_KEY:
            case $d58050833617f0b2$var$KeyCodeMap.PAGE_UP_KEY:
            case $d58050833617f0b2$var$KeyCodeMap.DOWN_KEY:
            case $d58050833617f0b2$var$KeyCodeMap.PAGE_DOWN_KEY:
                return this._onDirectionKey(event, hasActiveDropdown);
            case $d58050833617f0b2$var$KeyCodeMap.DELETE_KEY:
            case $d58050833617f0b2$var$KeyCodeMap.BACK_KEY:
                return this._onDeleteKey(event, this._store.items, this.input.isFocussed);
        }
    };
    Choices.prototype._onKeyUp = function() {
        this._canSearch = this.config.searchEnabled;
    };
    Choices.prototype._onInput = function() {
        var value = this.input.value;
        if (!value) {
            if (this._isTextElement) this.hideDropdown(true);
            else this._stopSearch();
            return;
        }
        if (!this._canAddItems()) return;
        if (this._canSearch) // do the search even if the entered text can not be added
        this._handleSearch(value);
        if (!this._canAddUserChoices) return;
        // determine if a notice needs to be displayed for why a search result can't be added
        this._canCreateItem(value);
        if (this._isSelectElement) {
            this._highlightPosition = 0; // reset to select the notice and/or exact match
            this._highlightChoice();
        }
    };
    Choices.prototype._onSelectKey = function(event, hasItems) {
        // If CTRL + A or CMD + A have been pressed and there are items to select
        if ((event.ctrlKey || event.metaKey) && hasItems) {
            this._canSearch = false;
            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
            if (shouldHightlightAll) this.highlightAll();
        }
    };
    Choices.prototype._onEnterKey = function(event, hasActiveDropdown) {
        var _this = this;
        var value = this.input.value;
        var target = event.target;
        event.preventDefault();
        if (target && target.hasAttribute('data-button')) {
            this._handleButtonAction(target);
            return;
        }
        if (!hasActiveDropdown) {
            if (this._isSelectElement || this._notice) this.showDropdown();
            return;
        }
        var highlightedChoice = this.dropdown.element.querySelector($d58050833617f0b2$var$getClassNamesSelector(this.config.classNames.highlightedState));
        if (highlightedChoice && this._handleChoiceAction(highlightedChoice)) return;
        if (!target || !value) {
            this.hideDropdown(true);
            return;
        }
        if (!this._canAddItems()) return;
        var addedItem = false;
        this._store.withTxn(function() {
            addedItem = _this._findAndSelectChoiceByValue(value, true);
            if (!addedItem) {
                if (!_this._canAddUserChoices) return;
                if (!_this._canCreateItem(value)) return;
                _this._addChoice($d58050833617f0b2$var$mapInputToChoice(value, false, _this.config.allowHtmlUserInput), true, true);
                addedItem = true;
            }
            _this.clearInput();
            _this.unhighlightAll();
        });
        if (!addedItem) return;
        this._triggerChange(value);
        if (this.config.closeDropdownOnSelect) this.hideDropdown(true);
    };
    Choices.prototype._onEscapeKey = function(event, hasActiveDropdown) {
        if (hasActiveDropdown) {
            event.stopPropagation();
            this.hideDropdown(true);
            this._stopSearch();
            this.containerOuter.element.focus();
        }
    };
    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
        var keyCode = event.keyCode;
        // If up or down key is pressed, traverse through options
        if (hasActiveDropdown || this._isSelectOneElement) {
            this.showDropdown();
            this._canSearch = false;
            var directionInt = keyCode === $d58050833617f0b2$var$KeyCodeMap.DOWN_KEY || keyCode === $d58050833617f0b2$var$KeyCodeMap.PAGE_DOWN_KEY ? 1 : -1;
            var skipKey = event.metaKey || keyCode === $d58050833617f0b2$var$KeyCodeMap.PAGE_DOWN_KEY || keyCode === $d58050833617f0b2$var$KeyCodeMap.PAGE_UP_KEY;
            var nextEl = void 0;
            if (skipKey) {
                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat($d58050833617f0b2$var$selectableChoiceIdentifier, ":last-of-type"));
                else nextEl = this.dropdown.element.querySelector($d58050833617f0b2$var$selectableChoiceIdentifier);
            } else {
                var currentEl = this.dropdown.element.querySelector($d58050833617f0b2$var$getClassNamesSelector(this.config.classNames.highlightedState)) || this.dropdown.element.querySelector($d58050833617f0b2$var$getClassNamesSelector(this.config.classNames.selectedState));
                if (currentEl) nextEl = $d58050833617f0b2$var$getAdjacentEl(currentEl, $d58050833617f0b2$var$selectableChoiceIdentifier, directionInt);
                else nextEl = this.dropdown.element.querySelector($d58050833617f0b2$var$selectableChoiceIdentifier);
            }
            if (nextEl) {
                // We prevent default to stop the cursor moving
                // when pressing the arrow
                if (!$d58050833617f0b2$var$isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                this._highlightChoice(nextEl);
            }
            // Prevent default to maintain cursor position whilst
            // traversing dropdown options
            event.preventDefault();
        }
    };
    Choices.prototype._onDeleteKey = function(event, items, hasFocusedInput) {
        // If backspace or delete key is pressed and the input has no value
        if (!this._isSelectOneElement && !event.target.value && hasFocusedInput) {
            this._handleBackspace(items);
            event.preventDefault();
        }
    };
    Choices.prototype._onTouchMove = function() {
        if (this._wasTap) this._wasTap = false;
    };
    Choices.prototype._onTouchEnd = function(event) {
        var target = (event || event.touches[0]).target;
        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
        if (touchWasWithinContainer) {
            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
            if (containerWasExactTarget) {
                if (this._isTextElement) this.input.focus();
                else if (this._isSelectMultipleElement) this.showDropdown();
            }
            // Prevents focus event firing
            event.stopPropagation();
        }
        this._wasTap = true;
    };
    /**
     * Handles mousedown event in capture mode for containetOuter.element
     */ Choices.prototype._onMouseDown = function(event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        // If we have our mouse down on the scrollbar and are on IE11...
        if ($d58050833617f0b2$var$IS_IE11 && this.choiceList.element.contains(target)) {
            // check if click was on a scrollbar area
            var firstChoice = this.choiceList.element.firstElementChild;
            this._isScrollingOnIe = this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
        }
        if (target === this.input.element) return;
        var item = target.closest('[data-button],[data-item],[data-choice]');
        if (item instanceof HTMLElement) {
            if ('button' in item.dataset) this._handleButtonAction(item);
            else if ('item' in item.dataset) this._handleItemAction(item, event.shiftKey);
            else if ('choice' in item.dataset) this._handleChoiceAction(item);
        }
        event.preventDefault();
    };
    /**
     * Handles mouseover event over this.dropdown
     * @param {MouseEvent} event
     */ Choices.prototype._onMouseOver = function(_a) {
        var target = _a.target;
        if (target instanceof HTMLElement && 'choice' in target.dataset) this._highlightChoice(target);
    };
    Choices.prototype._onClick = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var clickWasWithinContainer = containerOuter.element.contains(target);
        if (clickWasWithinContainer) {
            if (!this.dropdown.isActive && !containerOuter.isDisabled) {
                if (this._isTextElement) {
                    if (document.activeElement !== this.input.element) this.input.focus();
                } else {
                    containerOuter.element.focus();
                    this.showDropdown();
                }
            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
        } else {
            containerOuter.removeFocusState();
            this.hideDropdown(true);
            this.unhighlightAll();
        }
    };
    Choices.prototype._onFocus = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var focusWasWithinContainer = target && containerOuter.element.contains(target);
        if (!focusWasWithinContainer) return;
        var targetIsInput = target === this.input.element;
        if (this._isTextElement) {
            if (targetIsInput) containerOuter.addFocusState();
        } else if (this._isSelectMultipleElement) {
            if (targetIsInput) {
                this.showDropdown(true);
                // If element is a select box, the focused element is the container and the dropdown
                // isn't already open, focus and show dropdown
                containerOuter.addFocusState();
            }
        } else {
            containerOuter.addFocusState();
            if (targetIsInput) this.showDropdown(true);
        }
    };
    Choices.prototype._onBlur = function(_a) {
        var target = _a.target;
        var containerOuter = this.containerOuter;
        var blurWasWithinContainer = target && containerOuter.element.contains(target);
        if (blurWasWithinContainer && !this._isScrollingOnIe) {
            if (target === this.input.element) {
                containerOuter.removeFocusState();
                this.hideDropdown(true);
                if (this._isTextElement || this._isSelectMultipleElement) this.unhighlightAll();
            } else if (target === this.containerOuter.element) {
                // Remove the focus state when the past outerContainer was the target
                containerOuter.removeFocusState();
                // Also close the dropdown if search is disabled
                if (!this.config.searchEnabled) this.hideDropdown(true);
            }
        } else {
            // On IE11, clicking the scollbar blurs our input and thus
            // closes the dropdown. To stop this, we refocus our input
            // if we know we are on IE *and* are scrolling.
            this._isScrollingOnIe = false;
            this.input.element.focus();
        }
    };
    Choices.prototype._onFormReset = function() {
        var _this = this;
        this._store.withTxn(function() {
            _this.clearInput();
            _this.hideDropdown();
            _this.refresh(false, false, true);
            if (_this._initialItems.length) _this.setChoiceByValue(_this._initialItems);
        });
    };
    Choices.prototype._onChange = function(event) {
        if (!event.target.checkValidity()) return;
        this.containerOuter.removeInvalidState();
    };
    Choices.prototype._onInvalid = function() {
        this.containerOuter.addInvalidState();
    };
    /**
     * Removes any highlighted choice options
     */ Choices.prototype._removeHighlightedChoices = function() {
        var highlightedState = this.config.classNames.highlightedState;
        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll($d58050833617f0b2$var$getClassNamesSelector(highlightedState)));
        // Remove any highlighted choices
        highlightedChoices.forEach(function(choice) {
            $d58050833617f0b2$var$removeClassesFromElement(choice, highlightedState);
            choice.setAttribute('aria-selected', 'false');
        });
    };
    Choices.prototype._highlightChoice = function(el) {
        if (el === void 0) el = null;
        var choices = Array.from(this.dropdown.element.querySelectorAll($d58050833617f0b2$var$selectableChoiceIdentifier));
        if (!choices.length) return;
        var passedEl = el;
        var highlightedState = this.config.classNames.highlightedState;
        this._removeHighlightedChoices();
        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
        else {
            // Highlight choice based on last known highlight location
            if (choices.length > this._highlightPosition) // If we have an option to highlight
            passedEl = choices[this._highlightPosition];
            else // Otherwise highlight the option before
            passedEl = choices[choices.length - 1];
            if (!passedEl) passedEl = choices[0];
        }
        $d58050833617f0b2$var$addClassesToElement(passedEl, highlightedState);
        passedEl.setAttribute('aria-selected', 'true');
        this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.highlightChoice, {
            el: passedEl
        });
        if (this.dropdown.isActive) {
            // IE11 ignores aria-label and blocks virtual keyboard
            // if aria-activedescendant is set without a dropdown
            this.input.setActiveDescendant(passedEl.id);
            this.containerOuter.setActiveDescendant(passedEl.id);
        }
    };
    Choices.prototype._addItem = function(item, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (!item.id) throw new TypeError('item.id must be set before _addItem is called for a choice/item');
        if (this.config.singleModeForMultiSelect || this._isSelectOneElement) this.removeActiveItems(item.id);
        this._store.dispatch($d58050833617f0b2$var$addItem(item));
        if (withEvents) {
            var eventChoice = $d58050833617f0b2$var$getChoiceForOutput(item);
            this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.addItem, eventChoice);
            if (userTriggered) this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.choice, eventChoice);
        }
    };
    Choices.prototype._removeItem = function(item) {
        if (!item.id) return;
        this._store.dispatch($d58050833617f0b2$var$removeItem$1(item));
        var notice = this._notice;
        if (notice && notice.type === $d58050833617f0b2$var$NoticeTypes.noChoices) this._clearNotice();
        this.passedElement.triggerEvent($d58050833617f0b2$var$EventType.removeItem, $d58050833617f0b2$var$getChoiceForOutput(item));
    };
    Choices.prototype._addChoice = function(choice, withEvents, userTriggered) {
        if (withEvents === void 0) withEvents = true;
        if (userTriggered === void 0) userTriggered = false;
        if (choice.id) throw new TypeError('Can not re-add a choice which has already been added');
        var config = this.config;
        if (!config.duplicateItemsAllowed && this._store.choices.find(function(c) {
            return config.valueComparer(c.value, choice.value);
        })) return;
        // Generate unique id, in-place update is required so chaining _addItem works as expected
        this._lastAddedChoiceId++;
        choice.id = this._lastAddedChoiceId;
        choice.elementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choice.id);
        var prependValue = config.prependValue, appendValue = config.appendValue;
        if (prependValue) choice.value = prependValue + choice.value;
        if (appendValue) choice.value += appendValue.toString();
        if ((prependValue || appendValue) && choice.element) choice.element.value = choice.value;
        this._clearNotice();
        this._store.dispatch($d58050833617f0b2$var$addChoice(choice));
        if (choice.selected) this._addItem(choice, withEvents, userTriggered);
    };
    Choices.prototype._addGroup = function(group, withEvents) {
        var _this = this;
        if (withEvents === void 0) withEvents = true;
        if (group.id) throw new TypeError('Can not re-add a group which has already been added');
        this._store.dispatch($d58050833617f0b2$var$addGroup(group));
        if (!group.choices) return;
        // add unique id for the group(s), and do not store the full list of choices in this group
        this._lastAddedGroupId++;
        group.id = this._lastAddedGroupId;
        group.choices.forEach(function(item) {
            item.group = group;
            if (group.disabled) item.disabled = true;
            _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._createTemplates = function() {
        var _this = this;
        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
        var userTemplates = {};
        if (typeof callbackOnCreateTemplates === 'function') userTemplates = callbackOnCreateTemplates.call(this, $d58050833617f0b2$var$strToEl, $d58050833617f0b2$var$escapeForTemplate, $d58050833617f0b2$var$getClassNames);
        var templating = {};
        Object.keys(this._templates).forEach(function(name) {
            if (name in userTemplates) templating[name] = userTemplates[name].bind(_this);
            else templating[name] = _this._templates[name].bind(_this);
        });
        this._templates = templating;
    };
    Choices.prototype._createElements = function() {
        var templating = this._templates;
        var _a = this, config = _a.config, isSelectOneElement = _a._isSelectOneElement;
        var position = config.position, classNames = config.classNames;
        var elementType = this._elementType;
        this.containerOuter = new $d58050833617f0b2$var$Container({
            element: templating.containerOuter(config, this._direction, this._isSelectElement, isSelectOneElement, config.searchEnabled, elementType, config.labelId),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.containerInner = new $d58050833617f0b2$var$Container({
            element: templating.containerInner(config),
            classNames: classNames,
            type: elementType,
            position: position
        });
        this.input = new $d58050833617f0b2$var$Input({
            element: templating.input(config, this._placeholderValue),
            classNames: classNames,
            type: elementType,
            preventPaste: !config.paste
        });
        this.choiceList = new $d58050833617f0b2$var$List({
            element: templating.choiceList(config, isSelectOneElement)
        });
        this.itemList = new $d58050833617f0b2$var$List({
            element: templating.itemList(config, isSelectOneElement)
        });
        this.dropdown = new $d58050833617f0b2$var$Dropdown({
            element: templating.dropdown(config, elementType),
            classNames: classNames,
            type: elementType
        });
    };
    Choices.prototype._createStructure = function() {
        var _a = this, containerInner = _a.containerInner, containerOuter = _a.containerOuter, passedElement = _a.passedElement;
        var dropdownElement = this.dropdown.element;
        // Hide original element
        passedElement.conceal();
        // Wrap input in container preserving DOM ordering
        containerInner.wrap(passedElement.element);
        // Wrapper inner container with outer container
        containerOuter.wrap(containerInner.element);
        containerOuter.element.appendChild(containerInner.element);
        containerOuter.element.appendChild(dropdownElement);
        containerInner.element.appendChild(this.itemList.element);
        dropdownElement.appendChild(this.choiceList.element);
        if (this._isSelectOneElement) {
            this.input.placeholder = this.config.searchPlaceholderValue || '';
            if (this.config.searchEnabled) dropdownElement.insertBefore(this.input.element, dropdownElement.firstChild);
        } else {
            if (!this._isSelectMultipleElement || this.config.searchEnabled) containerInner.element.appendChild(this.input.element);
            if (this._placeholderValue) this.input.placeholder = this._placeholderValue;
            this.input.setWidth();
        }
        this._highlightPosition = 0;
        this._isSearching = false;
    };
    Choices.prototype._initStore = function() {
        var _this = this;
        this._store.subscribe(this._render).withTxn(function() {
            _this._addPredefinedChoices(_this._presetChoices, _this._isSelectOneElement && !_this._hasNonChoicePlaceholder, false);
        });
        if (!this._store.choices.length || this._isSelectOneElement && this._hasNonChoicePlaceholder) this._render();
    };
    Choices.prototype._addPredefinedChoices = function(choices, selectFirstOption, withEvents) {
        var _this = this;
        if (selectFirstOption === void 0) selectFirstOption = false;
        if (withEvents === void 0) withEvents = true;
        if (selectFirstOption) {
            /**
             * If there is a selected choice already or the choice is not the first in
             * the array, add each choice normally.
             *
             * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
             */ var noSelectedChoices = choices.findIndex(function(choice) {
                return choice.selected;
            }) === -1;
            if (noSelectedChoices) choices.some(function(choice) {
                if (choice.disabled || 'choices' in choice) return false;
                choice.selected = true;
                return true;
            });
        }
        choices.forEach(function(item) {
            if ('choices' in item) {
                if (_this._isSelectElement) _this._addGroup(item, withEvents);
            } else _this._addChoice(item, withEvents);
        });
    };
    Choices.prototype._findAndSelectChoiceByValue = function(value, userTriggered) {
        var _this = this;
        if (userTriggered === void 0) userTriggered = false;
        // Check 'value' property exists and the choice isn't already selected
        var foundChoice = this._store.choices.find(function(choice) {
            return _this.config.valueComparer(choice.value, value);
        });
        if (foundChoice && !foundChoice.disabled && !foundChoice.selected) {
            this._addItem(foundChoice, true, userTriggered);
            return true;
        }
        return false;
    };
    Choices.prototype._generatePlaceholderValue = function() {
        var config = this.config;
        if (!config.placeholder) return null;
        if (this._hasNonChoicePlaceholder) return config.placeholderValue;
        if (this._isSelectElement) {
            var placeholderOption = this.passedElement.placeholderOption;
            return placeholderOption ? placeholderOption.text : null;
        }
        return null;
    };
    Choices.prototype._warnChoicesInitFailed = function(caller) {
        if (this.config.silent) return;
        if (!this.initialised) throw new TypeError("".concat(caller, " called on a non-initialised instance of Choices"));
        else if (!this.initialisedOK) throw new TypeError("".concat(caller, " called for an element which has multiple instances of Choices initialised on it"));
    };
    Choices.version = '11.2.4';
    return Choices;
}();




function $f7fb1d849c5e003d$export$30cb81b6c3a8c536(select, index) {
    const options = {
        renderChoiceLimit: -1,
        searchEnabled: true,
        removeItemButton: false,
        addChoices: true,
        addItems: true,
        placeholderValue: null,
        placeholder: true,
        noResultsText: "Keine Ergebnisse gefunden",
        noChoicesText: "Keine Auswahlm\xf6glichkeiten",
        addItemText: (value, rawValue)=>{
            return 'Bitte dr\xfccken Sie die Eingabetaste, um "' + value + '" hinzuzuf\xfcgen';
        },
        searchPlaceholderValue: "Typen Sie, um nach dem Artikel zu suchen oder f\xfcgen Sie einen neuen Artikel hinzu",
        shouldSort: true,
        sorter: (a, b)=>{},
        searchResultLimit: -1,
        fuseOptions: {
            threshold: 0.2,
            includeScore: true
        }
    };
    if (index === 3) options.shouldSort = false;
    new (0, $d58050833617f0b2$export$2e2bcd8739ae039)(select, options);
}
function $f7fb1d849c5e003d$export$591c94f07dfa6ef8(articleSelects) {
    articleSelects.forEach((select, index)=>{
        $f7fb1d849c5e003d$export$30cb81b6c3a8c536(select, index);
    });
}
function $f7fb1d849c5e003d$export$3872f43ce732a9d5(category) {
    const groupedDevices = [
        {
            label: "Funktionserweiterung",
            choices: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).Funktionserweiterung
        },
        {
            label: "Gateways",
            choices: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).Gateway
        },
        {
            label: "Zubeh\xf6r",
            choices: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).Zubehoer1
        }
    ];
    const options = {
        indoorstations: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).indoorstations,
        outdoorstations: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).outdoorstations,
        controlUnits: (0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).controlUnits,
        others: groupedDevices,
        all: [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).indoorstations,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).outdoorstations,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($3a96b40d46ed4e44$exports))).controlUnits,
            ...groupedDevices.reduce((prev, curr)=>[
                    ...prev,
                    ...curr.choices
                ], [])
        ]
    };
    if (category === "others") return {
        optionsHtml: `<option value="" selected>${(0, $f4b2e904c7318400$export$a7357cdd1f0b0168).__("no_article")}</option>` + options[category]?.map((group)=>{
            const groupOptions = group.choices.map((article)=>`<option value="${article}">${article}</option>`).join("");
            return `<optgroup label="${group.label}">${groupOptions}</optgroup>`;
        }).join("") || "",
        options: options[category]
    };
    return {
        optionsHtml: `<option value="" selected>${(0, $f4b2e904c7318400$export$a7357cdd1f0b0168).__("no_article")}</option>` + options[category]?.map((article)=>`<option value="${article}">${article}</option>`).join("") || "",
        options: options[category]
    };
}




// Honeypot + time trap. The render time comes from the server (components/spam_guard.ejs),
// so there is no secret and no client clock involved.
// No imports and no Node APIs: browser bundles load withoutSpamFields() from here.
/** Form field names written by components/spam_guard.ejs. */ const $c8cb4cf178dae88a$export$7e0f6cb984e20985 = {
    honeypot: 'website',
    renderedAt: 'renderedAt'
};
const $c8cb4cf178dae88a$export$e94181bdd41e3bf0 = 3000;
function $c8cb4cf178dae88a$export$69796c5f4e8e10e9({ honeypot: honeypot, renderedAt: renderedAt }, now = Date.now(), minMs = $c8cb4cf178dae88a$export$e94181bdd41e3bf0) {
    if (honeypot !== undefined && honeypot !== null && honeypot !== '') return 'honeypot';
    const at = typeof renderedAt === 'string' && /^[0-9]+$/.test(renderedAt) ? Number(renderedAt) : renderedAt;
    if (typeof at !== 'number' || !Number.isSafeInteger(at) || at > now) return 'invalid';
    return now - at < minMs ? 'too-fast' : null;
}
function $c8cb4cf178dae88a$export$3e6dc96cc2e8d01(form) {
    const fields = {
        honeypot: form[$c8cb4cf178dae88a$export$7e0f6cb984e20985.honeypot],
        renderedAt: form[$c8cb4cf178dae88a$export$7e0f6cb984e20985.renderedAt]
    };
    delete form[$c8cb4cf178dae88a$export$7e0f6cb984e20985.honeypot];
    delete form[$c8cb4cf178dae88a$export$7e0f6cb984e20985.renderedAt];
    return fields;
}
function $c8cb4cf178dae88a$export$2cc4b46250830067(form) {
    const copy = {
        ...form
    };
    delete copy[$c8cb4cf178dae88a$export$7e0f6cb984e20985.honeypot];
    delete copy[$c8cb4cf178dae88a$export$7e0f6cb984e20985.renderedAt];
    return copy;
}
function $c8cb4cf178dae88a$export$a580603bb5ff6818({ onSpam: onSpam, read: read = (req)=>req.body, write: write, minMs: minMs = $c8cb4cf178dae88a$export$e94181bdd41e3bf0 }) {
    return (req, res, next)=>{
        const form = read(req);
        if (typeof form !== 'object' || form === null || Array.isArray(form)) return next(new Error('spamGuard: no form object; register the body parser first'));
        const reason = $c8cb4cf178dae88a$export$69796c5f4e8e10e9($c8cb4cf178dae88a$export$3e6dc96cc2e8d01(form), Date.now(), minMs);
        write?.(req, form);
        if (!reason) return next();
        // Only the reason: field values may contain personal data.
        console.warn(`Spam blocked: ${reason}`);
        return onSpam(req, res, reason);
    };
}


function $beb557a42cbb2a57$export$347161a4a36a2b6f() {
    const appointmentFields = document.getElementById("appointment-fields");
    const asapCheckbox = document.getElementById("asap");
    if (asapCheckbox.checked) appointmentFields.classList.add("hidden");
    else appointmentFields.classList.remove("hidden");
}
function $beb557a42cbb2a57$export$4286470bc35b4fd1() {
    const asapCheckbox = document.getElementById("asap");
    $beb557a42cbb2a57$export$347161a4a36a2b6f();
    asapCheckbox.addEventListener("change", $beb557a42cbb2a57$export$347161a4a36a2b6f);
}
function $beb557a42cbb2a57$export$8b4bfcba9f70a85b() {
    const guarantee = document.getElementById('guarantee');
    const info = document.createElement('p');
    info.classList.add('hidden', 'info');
    guarantee.addEventListener('change', ()=>{
        guarantee.parentNode.appendChild(info);
        info.textContent = guarantee.value === 'Nein' ? 'wenn kein Garantieanspruch besteht, ist dies kostenpflichtig' : '';
        info.classList.toggle('hidden', guarantee.value !== 'Nein');
    });
}
function $beb557a42cbb2a57$export$7f4e66689df92cc1() {
    const selects = document.querySelectorAll('.article-select');
    selects.forEach((select)=>(0, $f7fb1d849c5e003d$export$30cb81b6c3a8c536)(select));
}
function $beb557a42cbb2a57$export$680f9a367bb25d35() {
    const container = document.getElementById('defectDeviceList');
    const observer = new MutationObserver($beb557a42cbb2a57$export$55c558492fc41de5);
    observer.observe(container, {
        childList: true
    });
}
function $beb557a42cbb2a57$export$55c558492fc41de5(mutationsList) {
    for (const mutation of mutationsList)if (mutation.type === 'childList') {
        const newSelect = mutation.addedNodes[0]?.querySelector('.article-select');
        if (newSelect) (0, $f7fb1d849c5e003d$export$30cb81b6c3a8c536)(newSelect);
    }
}
function $beb557a42cbb2a57$export$2e1799c3dbece197() {
    const defectiveDeviceCount = document.getElementById('defectiveDeviceCount');
    defectiveDeviceCount.addEventListener('change', $beb557a42cbb2a57$export$cd0efc441b5d985e);
}
function $beb557a42cbb2a57$export$561a51a05113a0a7() {
    const addButtons = document.querySelectorAll('.add-item');
    addButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            $beb557a42cbb2a57$export$c733ef3e3a92fcc8(button.dataset.category);
        });
    });
}
function $beb557a42cbb2a57$export$e4d7d35369552863() {
    const hasNoCustomerNumberCheckbox = document.getElementById("hasNoCustomerNumber");
    (0, $2058487f4462c174$export$ddb7ed2d1bc6bc80)();
    hasNoCustomerNumberCheckbox.addEventListener("change", (0, $2058487f4462c174$export$ddb7ed2d1bc6bc80));
}
function $beb557a42cbb2a57$export$a300922648ad1a28() {
    const hasNoWarrantyNumberCheckbox = document.getElementById("hasNoWarrantyNumber");
    $beb557a42cbb2a57$export$eb512a3275ccccf2();
    hasNoWarrantyNumberCheckbox.addEventListener("change", $beb557a42cbb2a57$export$eb512a3275ccccf2);
}
function $beb557a42cbb2a57$export$eb512a3275ccccf2() {
    const hasNoWarrantyNumber = document.getElementById("hasNoWarrantyNumber").checked;
    const warrantyNumberGroup = document.getElementById("warrantyNumberGroup");
    const noWarrantyNumberFields = document.getElementById("noWarrantyNumberFields");
    warrantyNumberGroup.classList.toggle("hidden", hasNoWarrantyNumber);
    noWarrantyNumberFields.classList.toggle("hidden", !hasNoWarrantyNumber);
    document.getElementById("warrantyNumber").required = !hasNoWarrantyNumber;
}
function $beb557a42cbb2a57$export$34c4494f581a892f() {
    const radios = document.querySelectorAll('input[name="customerType"]');
    $beb557a42cbb2a57$export$37bfc5cdb35e9c12();
    radios.forEach((radio)=>radio.addEventListener("change", $beb557a42cbb2a57$export$37bfc5cdb35e9c12));
    document.getElementById("hasNoCustomerNumber").addEventListener("change", $beb557a42cbb2a57$export$37bfc5cdb35e9c12);
}
function $beb557a42cbb2a57$export$37bfc5cdb35e9c12() {
    const isNewCustomer = document.getElementById("hasNoCustomerNumber").checked;
    const isBusiness = isNewCustomer && document.querySelector('input[name="customerType"]:checked')?.value === "business";
    const vatId = document.getElementById("vatId");
    document.getElementById("customerTypeGroup").classList.toggle("hidden", !isNewCustomer);
    document.getElementById("vatIdGroup").classList.toggle("hidden", !isBusiness);
    vatId.required = isBusiness;
    if (!isBusiness) vatId.value = "";
    // Company fields are only shown for business customers
    [
        "customerCompany",
        "customerCompanyEmail"
    ].forEach((id)=>{
        const input = document.getElementById(id);
        input.closest(".form-group").classList.toggle("hidden", !isBusiness);
        if (!isBusiness) input.value = "";
    });
    if (isNewCustomer) document.getElementById("customerCompany").required = isBusiness;
}
function $beb557a42cbb2a57$export$1f0e4c0dc4a6e755(billingAutocomplete) {
    const checkbox = document.getElementById("billingAddressDiffers");
    $beb557a42cbb2a57$export$6598db6cd2089210();
    checkbox.addEventListener("change", ()=>{
        if (!checkbox.checked) billingAutocomplete.resetAllFields();
        $beb557a42cbb2a57$export$6598db6cd2089210();
    });
}
function $beb557a42cbb2a57$export$6598db6cd2089210() {
    const differs = document.getElementById("billingAddressDiffers").checked;
    document.getElementById("billingAddressGroup").classList.toggle("hidden", !differs);
}
function $beb557a42cbb2a57$export$5cf835be54910de3(category, index) {
    const row = document.createElement('div');
    const options = (0, $f7fb1d849c5e003d$export$3872f43ce732a9d5)(category);
    let optionsHtml = options.optionsHtml;
    row.className = 'item';
    row.innerHTML = `
    <div class="flex-column">
      <select data-index="${index}" name="${category}[${index}][articleNumber]" class="article-select">
          ${optionsHtml}
      </select>
      <input type="number" name="${category}Quantity[]" placeholder="Anzahl" min="0" />
      <button type="button" class="removeDevice">\u{274C} Entfernen</button>
    `;
    row.querySelector('.removeDevice').addEventListener('click', ()=>{
        row.remove();
    });
    return row;
}
function $beb557a42cbb2a57$export$c733ef3e3a92fcc8(containerId) {
    const container = document.getElementById(containerId);
    const newRow = $beb557a42cbb2a57$export$5cf835be54910de3(containerId);
    container.appendChild(newRow);
    (0, $f7fb1d849c5e003d$export$30cb81b6c3a8c536)(newRow.querySelector('.article-select'), container.querySelectorAll('.item').length - 1);
}
function $beb557a42cbb2a57$export$cd0efc441b5d985e() {
    let count = parseInt(document.getElementById('defectiveDeviceCount').value, 10);
    if (!count) count = 0;
    const container = document.getElementById('defectDeviceList');
    const options = (0, $f7fb1d849c5e003d$export$3872f43ce732a9d5)('all');
    const currentCount = container.children.length;
    // If more fields are needed → add new ones
    for(let i = currentCount + 1; i <= count; i++){
        const fieldGroup = document.createElement('div');
        fieldGroup.className = 'form-row grid-3';
        fieldGroup.innerHTML = `
            <div class="form-group">
                <select required data-index="${i}" class="article-select" name="defectiveDevice[${i}][articleNumber]">
                ${options.optionsHtml}
                </select>
                <label class="label">${(0, $f4b2e904c7318400$export$a7357cdd1f0b0168).__("article_number")}</label>
            </div>

            <div class="form-group">
                <input type="text" name="defectiveDevice[${i}][serialNumber]"/>
                <label class="label">Seriennummer*</label>
            </div>

            <div class="form-group">
                <label class="label">Fehlerbeschreibung*</label>
                <input required type="text" name="defectiveDevice[${i}][errorDescription]"/>
            </div>
            `;
        const select = fieldGroup.querySelector('.article-select');
        const serialInput = fieldGroup.querySelector(`input[name="defectiveDevice[${i}][serialNumber]"]`);
        select.addEventListener('change', ()=>{
            if ((0, $c9681686203b10f0$export$2b64365476b332f1).includes(select.value) || !options.options.includes(select.value)) {
                serialInput.parentNode.classList.add('hidden');
                serialInput.value = "";
            } else serialInput.parentNode.classList.remove('hidden');
        });
        container.appendChild(fieldGroup);
    }
    // If fewer fields are needed → remove extras
    while(container.children.length > count)container.removeChild(container.lastChild);
}
function $beb557a42cbb2a57$export$c2c2f88ebf8af328() {
    const devices = [];
    const categorySections = document.querySelectorAll('.category-group > div[id]');
    categorySections.forEach((section)=>{
        const items = section.querySelectorAll('.item');
        items.forEach((item)=>{
            const select = item.querySelector('select.article-select');
            const quantityInput = item.querySelector('input[type="number"]');
            const articleNumber = select?.value?.trim();
            const quantity = parseInt(quantityInput?.value || "0", 10);
            // Only include devices with a selected article number and quantity > 0
            if (articleNumber && quantity > 0) devices.push({
                articleNumber: articleNumber,
                quantity: quantity
            });
        });
    });
    return devices;
}
function $beb557a42cbb2a57$export$77b8125f8d3b40cd(autocompletes) {
    const form = document.querySelector('#customerServiceForm');
    form.addEventListener('submit', function(event) {
        console.log('Form submitted');
        event.preventDefault();
        $beb557a42cbb2a57$export$9ed8616c3160d4b(form, autocompletes);
    });
}
async function $beb557a42cbb2a57$export$9ed8616c3160d4b(form, autocompletes) {
    (0, $2058487f4462c174$export$d6c15b4620d0d3d1)(form);
    const submitButton = document.querySelector(".submit-button");
    const noWarrantyNumberFields = document.getElementById("noWarrantyNumberFields");
    const hasNoWarrantyNumber = document.getElementById("hasNoWarrantyNumber").checked;
    const formData = new FormData(form);
    if (!hasNoWarrantyNumber) {
        const noWarrantyInputs = noWarrantyNumberFields.querySelectorAll("input, select");
        noWarrantyInputs.forEach((element)=>formData.delete(element.name));
    } else if (hasNoWarrantyNumber) formData.set("warrantyNumber", "");
    if (!formData.has("hasNoCustomerNumber")) formData.delete("customerType");
    if (formData.get("customerType") !== "business") formData.delete("vatId");
    if (!formData.has("billingAddressDiffers")) [
        "billingName",
        "billingPostalCodeNumber",
        "billingCity",
        "billingStreet",
        "billingHouseNumber"
    ].forEach((name)=>formData.delete(name));
    const defectiveDevices = $beb557a42cbb2a57$export$dc8cfd49d3ca8b62(formData);
    const installedDevices = $beb557a42cbb2a57$export$c2c2f88ebf8af328();
    const data = (0, $2058487f4462c174$export$9643fd7297feaaf5)(formData);
    data.defectiveDevices = defectiveDevices;
    data.devices = installedDevices;
    submitButton.disabled = true;
    console.log('data', data);
    try {
        (0, $2058487f4462c174$export$b8ea446e31178845)();
        await (0, (/*@__PURE__*/$parcel$interopDefault($3827fbd00b732338$exports))).validateAsync((0, $c8cb4cf178dae88a$export$2cc4b46250830067)(data), {
            abortEarly: false
        });
        const response = await (0, $2058487f4462c174$export$97a0d29fe9cc5b08)(JSON.stringify(data), "/customer-service");
        if (response.success) {
            autocompletes.forEach((autocomplete)=>autocomplete.resetAllFields());
            form.reset();
            $beb557a42cbb2a57$export$37bfc5cdb35e9c12();
            $beb557a42cbb2a57$export$6598db6cd2089210();
            (0, $2058487f4462c174$export$6ba40ea41de383a1)(response.message, "success");
        } else throw new Error(response.message);
    } catch (error) {
        if (error.isJoi) {
            console.error("Validation error:", error.details);
            (0, $2058487f4462c174$export$f89084e6f067bb43)(error, form);
        } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
            console.error("Network error:", error.message);
            (0, $2058487f4462c174$export$6ba40ea41de383a1)("Netzwerkverbindung ist fehlgeschlagen", "error");
        } else {
            console.error("Unexpected error:", error);
            (0, $2058487f4462c174$export$6ba40ea41de383a1)(error.message, "error");
        }
    } finally{
        (0, $2058487f4462c174$export$80775798c6eb9d34)();
        submitButton.disabled = false;
        submitButton.classList.remove('running');
    }
}
function $beb557a42cbb2a57$export$dc8cfd49d3ca8b62(formData) {
    const count = parseInt(formData.get('defectiveDeviceCount'));
    const devices = [];
    for(let i = 1; i <= count; i++){
        const articleNumber = formData.get(`defectiveDevice[${i}][articleNumber]`) || "";
        const serialNumber = formData.get(`defectiveDevice[${i}][serialNumber]`) || "";
        const errorDescription = formData.get(`defectiveDevice[${i}][errorDescription]`) || "";
        devices.push({
            articleNumber: articleNumber,
            serialNumber: serialNumber,
            errorDescription: errorDescription
        });
        formData.delete(`defectiveDevice[${i}][articleNumber]`);
        formData.delete(`defectiveDevice[${i}][serialNumber]`);
        formData.delete(`defectiveDevice[${i}][errorDescription]`);
    }
    return devices;
}
function $beb557a42cbb2a57$export$248f46a759c7198d() {
    const serviceType = document.querySelector('[name=serviceType]');
    const onlineService = document.querySelector('.onlineServiceType');
    serviceType.addEventListener('change', ()=>{
        if (serviceType.value == "online") onlineService.classList.remove('hidden');
        else onlineService.classList.add('hidden');
    });
}


document.addEventListener('DOMContentLoaded', $a6f9caa51db60e70$var$init);
function $a6f9caa51db60e70$var$init() {
    (0, $beb557a42cbb2a57$export$7f4e66689df92cc1)();
    (0, $beb557a42cbb2a57$export$a300922648ad1a28)();
    (0, $beb557a42cbb2a57$export$e4d7d35369552863)();
    // initObserver();
    // initDefectiveDeviceCount();
    (0, $beb557a42cbb2a57$export$561a51a05113a0a7)();
    (0, $2058487f4462c174$export$5f87a80a990db1a0)();
    (0, $c35973a388b615f1$exports.setDateListenr)();
    (0, $beb557a42cbb2a57$export$8b4bfcba9f70a85b)();
    (0, $beb557a42cbb2a57$export$4286470bc35b4fd1)();
    const buildingAddressAutocomplete = new (0, $056aae7d860a8ad9$export$6c178f1eacc8aa12)('building');
    const customerAddressAutocomplete = new (0, $056aae7d860a8ad9$export$6c178f1eacc8aa12)('customer');
    const billingAddressAutocomplete = new (0, $056aae7d860a8ad9$export$6c178f1eacc8aa12)('billing');
    const autocompletes = [
        buildingAddressAutocomplete,
        customerAddressAutocomplete,
        billingAddressAutocomplete
    ];
    (0, $beb557a42cbb2a57$export$34c4494f581a892f)();
    (0, $beb557a42cbb2a57$export$1f0e4c0dc4a6e755)(billingAddressAutocomplete);
    (0, $beb557a42cbb2a57$export$77b8125f8d3b40cd)(autocompletes);
}

})();
//# sourceMappingURL=customerService.js.map
